export type Team = {
    number: Number;
    name: string;
    rookie_year: string;
    city: string;
    state: string;
    country: string;
    district: string;
}

export const TeamData: Team[] = [
    {
      "number": 1,
      "name": "The Juggernauts",
      "rookie_year": "1997",
      "city": "Pontiac",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4,
      "name": "Team 4 ELEMENT",
      "rookie_year": "1997",
      "city": "Van Nuys",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5,
      "name": "Robocards",
      "rookie_year": "1998",
      "city": "Melvindale",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6,
      "name": "The CogSquad",
      "rookie_year": "1994",
      "city": "Plymouth",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7,
      "name": "Team007",
      "rookie_year": "1997",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8,
      "name": "Paly Robotics",
      "rookie_year": "1996",
      "city": "Palo Alto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9,
      "name": "Roosevelt RoboRiders",
      "rookie_year": "1998",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 10,
      "name": "Red Knights",
      "rookie_year": "1998",
      "city": "St. Louis Park",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 11,
      "name": "MORT",
      "rookie_year": "1997",
      "city": "Flanders",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 13,
      "name": "Triskadekamanics",
      "rookie_year": "1996",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 14,
      "name": "The Rulers",
      "rookie_year": "1997",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 15,
      "name": "Mustechs",
      "rookie_year": "1997",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 16,
      "name": "Bomb Squad",
      "rookie_year": "1996",
      "city": "Mountain Home",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 17,
      "name": "The Brick Bombers",
      "rookie_year": "1998",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 18,
      "name": "Team 18",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 19,
      "name": "Big Red",
      "rookie_year": "1992",
      "city": "Greenwich",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 20,
      "name": "The Rocketeers",
      "rookie_year": "1992",
      "city": "Clifton Park",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 21,
      "name": "ComBBAT",
      "rookie_year": "1998",
      "city": "Titusville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 22,
      "name": "Double Deuce",
      "rookie_year": "1997",
      "city": "Chatsworth",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 23,
      "name": "PNTA Pilgrim Nuclear Technology Alliance",
      "rookie_year": "1995",
      "city": "Plymouth",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 24,
      "name": "Crusaders 2020",
      "rookie_year": "1997",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 25,
      "name": "Raider Robotix",
      "rookie_year": "1997",
      "city": "North Brunswick",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 27,
      "name": "Team RUSH",
      "rookie_year": "1997",
      "city": "Clarkston",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 28,
      "name": "Pierson Whalers",
      "rookie_year": "1996",
      "city": "Sag Harbor",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 29,
      "name": "Caught in a Brainstorm",
      "rookie_year": "1998",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 30,
      "name": "FURY",
      "rookie_year": "1998",
      "city": "Lincroft",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 31,
      "name": "Prime Movers",
      "rookie_year": "1997",
      "city": "Jenks",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 33,
      "name": "Killer Bees",
      "rookie_year": "1996",
      "city": "Auburn Hills",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 34,
      "name": "Rockets",
      "rookie_year": "1997",
      "city": "Athens",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 35,
      "name": "Sigma Squared",
      "rookie_year": "1997",
      "city": "Whitehall",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 37,
      "name": "Junior Plaids",
      "rookie_year": "1996",
      "city": "Coral Gables",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 38,
      "name": "Nonnebots",
      "rookie_year": "1998",
      "city": "Woodbury",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 39,
      "name": "The 39th Aero Squadron",
      "rookie_year": "1998",
      "city": "Gilbert",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 40,
      "name": "Checkmate",
      "rookie_year": "1998",
      "city": "Manchester",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 41,
      "name": "RoboWarriors",
      "rookie_year": "1997",
      "city": "Warren",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 42,
      "name": "P.A.R.T.S. (Precision Alvirne Robotics Team Systems)",
      "rookie_year": "1995",
      "city": "Hudson",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 45,
      "name": "TechnoKats Robotics Team",
      "rookie_year": "1992",
      "city": "Kokomo",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 46,
      "name": "Category5",
      "rookie_year": "1998",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 47,
      "name": "Chief Delphi",
      "rookie_year": "1996",
      "city": "Pontiac",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 48,
      "name": "Team E.L.I.T.E.",
      "rookie_year": "1998",
      "city": "Warren",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 49,
      "name": "Robotic Knights",
      "rookie_year": "1998",
      "city": "Saginaw",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 51,
      "name": "The Wings of Fire",
      "rookie_year": "1996",
      "city": "Pontiac",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 52,
      "name": "Robotworks Y",
      "rookie_year": "1997",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 53,
      "name": "Area 53",
      "rookie_year": "1998",
      "city": "Greenbelt",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 55,
      "name": "Team 55",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 56,
      "name": "R.O.B.B.E.",
      "rookie_year": "1997",
      "city": "Bound Brook",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 57,
      "name": "Leopards",
      "rookie_year": "1998",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 58,
      "name": "The Riot Crew",
      "rookie_year": "1996",
      "city": "South Portland",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 59,
      "name": "RamTech",
      "rookie_year": "1997",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 60,
      "name": "Kingman FIRST Robotics Team 60 (The Bionic Bulldogs)",
      "rookie_year": "1997",
      "city": "Kingman",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 61,
      "name": "The Intimidators",
      "rookie_year": "1995",
      "city": "Upton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 62,
      "name": "Team 62",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 63,
      "name": "McDowell Robotics Team 63",
      "rookie_year": "1997",
      "city": "Erie",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 64,
      "name": "Gila Monsters",
      "rookie_year": "1998",
      "city": "Mesa",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 65,
      "name": "The Huskie Brigade",
      "rookie_year": "1997",
      "city": "Pontiac",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 66,
      "name": "Grizzly Robotics",
      "rookie_year": "1998",
      "city": "Ypsilanti",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 67,
      "name": "The HOT Team",
      "rookie_year": "1997",
      "city": "Highland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 68,
      "name": "Truck Town Thunder",
      "rookie_year": "1998",
      "city": "Ortonville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 69,
      "name": "HYPER",
      "rookie_year": "1998",
      "city": "Quincy",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 70,
      "name": "More Martians",
      "rookie_year": "1998",
      "city": "Goodrich",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 71,
      "name": "Team Hammond",
      "rookie_year": "1996",
      "city": "Hammond",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 73,
      "name": "The Illumination",
      "rookie_year": "1995",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 74,
      "name": "Team CHAOS",
      "rookie_year": "1995",
      "city": "Holland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 75,
      "name": "RoboRaiders",
      "rookie_year": "1996",
      "city": "Hillsborough",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 77,
      "name": "Team 77",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 78,
      "name": "AIR STRIKE",
      "rookie_year": "1996",
      "city": "Newport",
      "state": "Rhode Island",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 79,
      "name": "Team Krunch",
      "rookie_year": "1998",
      "city": "Oldsmar",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 80,
      "name": "Robocolt",
      "rookie_year": "1994",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 81,
      "name": "MetalHeads",
      "rookie_year": "1994",
      "city": "Freeport",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 84,
      "name": "Chuck 84",
      "rookie_year": "1998",
      "city": "Towanda",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 85,
      "name": "B.O.B. (Built on Brains)",
      "rookie_year": "1996",
      "city": "Zeeland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 86,
      "name": "Team Resistance",
      "rookie_year": "1998",
      "city": "Jacksonville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 87,
      "name": "Diablo",
      "rookie_year": "1997",
      "city": "Mount Holly",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 88,
      "name": "TJ\u00b2",
      "rookie_year": "1996",
      "city": "Bridgewater",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 89,
      "name": "Team 89",
      "rookie_year": "1997",
      "city": "PA",
      "state": "USA",
      "country": "",
      "district": ""
    },
    {
      "number": 90,
      "name": "Team 90",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 92,
      "name": "RoboPats",
      "rookie_year": "1997",
      "city": "Lincolnshire",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 93,
      "name": "NEW Apple Corps",
      "rookie_year": "1997",
      "city": "Appleton",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 94,
      "name": "The  Ninetyfouriors",
      "rookie_year": "1998",
      "city": "Southfield",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 95,
      "name": "Grasshoppers",
      "rookie_year": "1997",
      "city": "White River Junction",
      "state": "Vermont",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 96,
      "name": "JESTER",
      "rookie_year": "1997",
      "city": "Springfield",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 97,
      "name": "Bionic Beef",
      "rookie_year": "1996",
      "city": "Cambridge",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 98,
      "name": "Team 98",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 100,
      "name": "The WildHats",
      "rookie_year": "1995",
      "city": "Woodside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 101,
      "name": "Striker",
      "rookie_year": "1997",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 102,
      "name": "The Gearheads",
      "rookie_year": "1998",
      "city": "Somerville",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 103,
      "name": "Cybersonics",
      "rookie_year": "1997",
      "city": "Kintnersville",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 104,
      "name": "Team Universal",
      "rookie_year": "1998",
      "city": "West Chester",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 105,
      "name": "Team 105",
      "rookie_year": "1996",
      "city": "CHARLTON",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 106,
      "name": "Team 106",
      "rookie_year": "1997",
      "city": "phila",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 107,
      "name": "Team R.O.B.O.T.I.C.S.",
      "rookie_year": "1997",
      "city": "Holland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 108,
      "name": "SigmaC@T Robotics Team",
      "rookie_year": "1995",
      "city": "Fort Lauderdale",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 109,
      "name": "Team 109",
      "rookie_year": "1998",
      "city": "Libertyville",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 111,
      "name": "WildStang",
      "rookie_year": "1996",
      "city": "Arlington Heights",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 112,
      "name": "Plus One",
      "rookie_year": "1998",
      "city": "Arlington Heights",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 114,
      "name": "Eaglestrike",
      "rookie_year": "1997",
      "city": "Los Altos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 115,
      "name": "MVRT",
      "rookie_year": "1998",
      "city": "Cupertino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 116,
      "name": "Epsilon Delta",
      "rookie_year": "1996",
      "city": "Herndon",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 117,
      "name": "Steel Dragons Robotics",
      "rookie_year": "1998",
      "city": "Pittsburgh",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 118,
      "name": "Robonauts",
      "rookie_year": "1997",
      "city": "League City",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 120,
      "name": "Cleveland's Team",
      "rookie_year": "1995",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 121,
      "name": "Rhode Warriors",
      "rookie_year": "1996",
      "city": "Middletown",
      "state": "Rhode Island",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 122,
      "name": "NASA Knights",
      "rookie_year": "1997",
      "city": "Hampton",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 123,
      "name": "Team - Cosmos",
      "rookie_year": "1997",
      "city": "Hamtramck",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 124,
      "name": "Team 124",
      "rookie_year": "1996",
      "city": "Waterford",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 125,
      "name": "NUTRONs",
      "rookie_year": "1998",
      "city": "Boston",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 126,
      "name": "Gael Force",
      "rookie_year": "1992",
      "city": "Clinton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 127,
      "name": "Royal Robotics",
      "rookie_year": "1998",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 128,
      "name": "The Botcats",
      "rookie_year": "1997",
      "city": "Grandview Heights",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 130,
      "name": "Brain Busters",
      "rookie_year": "1996",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 131,
      "name": "CHAOS",
      "rookie_year": "1992",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 132,
      "name": "Radioactive Mustangs",
      "rookie_year": "1998",
      "city": "Wilton Manors",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 133,
      "name": "B.E.R.T.",
      "rookie_year": "1997",
      "city": "Standish",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 134,
      "name": "Team Discovery",
      "rookie_year": "1997",
      "city": "Pembroke",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 135,
      "name": "Penn Robotics",
      "rookie_year": "1998",
      "city": "Mishawaka",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 136,
      "name": "Killer Kardinals",
      "rookie_year": "1997",
      "city": "Plainfield",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 138,
      "name": "Entropy",
      "rookie_year": "1996",
      "city": "Amherst",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 140,
      "name": "Tigers",
      "rookie_year": "1997",
      "city": "Tyngsboro",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 141,
      "name": "WOBOT",
      "rookie_year": "1995",
      "city": "Holland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 144,
      "name": "The R.O.C.K",
      "rookie_year": "1994",
      "city": "Cincinnati",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 145,
      "name": "T-Rx",
      "rookie_year": "1997",
      "city": "Norwich",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 146,
      "name": "Team 146",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 147,
      "name": "Deep Thunder",
      "rookie_year": "1997",
      "city": "St. Petersburg",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 148,
      "name": "Robowranglers",
      "rookie_year": "1992",
      "city": "Greenville",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 151,
      "name": "Tough Techs",
      "rookie_year": "1992",
      "city": "Nashua",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 153,
      "name": "Team 153",
      "rookie_year": "1997",
      "city": "Bridgewater",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 155,
      "name": "The TechnoNuts",
      "rookie_year": "1994",
      "city": "Berlin",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 156,
      "name": "RPM  - Robotics Plus Mayhem",
      "rookie_year": "1997",
      "city": "Fairview",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 157,
      "name": "AZTECHS",
      "rookie_year": "1992",
      "city": "Marlborough",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 158,
      "name": "The Cobras",
      "rookie_year": "1996",
      "city": "Milford",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 159,
      "name": "Alpine Robotics",
      "rookie_year": "1998",
      "city": "Fort Collins",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 161,
      "name": "Team 161",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 162,
      "name": "Team 162",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 163,
      "name": "Team 163",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 165,
      "name": "Das Goat",
      "rookie_year": "1998",
      "city": "Annapolis",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 166,
      "name": "Chop Shop",
      "rookie_year": "1995",
      "city": "Merrimack",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 167,
      "name": "Children of the Corn",
      "rookie_year": "1998",
      "city": "Iowa City",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 168,
      "name": "Flashbacks",
      "rookie_year": "1998",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 169,
      "name": "Team 169",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 171,
      "name": "Cheese Curd Herd",
      "rookie_year": "1995",
      "city": "Platteville",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 172,
      "name": "Northern Force",
      "rookie_year": "1996",
      "city": "Falmouth/Gorham",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 173,
      "name": "RAGE Robotics \u2699\ufe0f",
      "rookie_year": "1995",
      "city": "Tolland",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 174,
      "name": "Arctic Warriors",
      "rookie_year": "1998",
      "city": "Liverpool",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 175,
      "name": "Buzz Robotics",
      "rookie_year": "1996",
      "city": "Enfield",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 176,
      "name": "Aces High",
      "rookie_year": "1996",
      "city": "Windsor Locks",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 177,
      "name": "Bobcat Robotics",
      "rookie_year": "1995",
      "city": "South Windsor",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 178,
      "name": "The 2nd Law Enforcers",
      "rookie_year": "1997",
      "city": "Farmington",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 179,
      "name": "Children of the Swamp",
      "rookie_year": "1998",
      "city": "Riviera Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 180,
      "name": "S.P.A.M.",
      "rookie_year": "1998",
      "city": "Stuart",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 181,
      "name": "Birds Of Prey",
      "rookie_year": "1998",
      "city": "Hartford",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 182,
      "name": "ThunderQuest",
      "rookie_year": "1998",
      "city": "Dearborn",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 184,
      "name": "F.R.E.D.",
      "rookie_year": "1998",
      "city": "Dearborn",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 186,
      "name": "The Alliance",
      "rookie_year": "1998",
      "city": "Lake Buena Vista",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 188,
      "name": "Blizzard",
      "rookie_year": "1998",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 190,
      "name": "Gompei and the H.E.R.D.",
      "rookie_year": "1992",
      "city": "Worcester",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 191,
      "name": "X-CATS",
      "rookie_year": "1992",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 192,
      "name": "GRT",
      "rookie_year": "1997",
      "city": "Palo Alto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 193,
      "name": "MORT Beta",
      "rookie_year": "1997",
      "city": "Flanders",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 195,
      "name": "CyberKnights",
      "rookie_year": "1998",
      "city": "Southington",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 197,
      "name": "Team 197",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 199,
      "name": "Deep Blue",
      "rookie_year": "1998",
      "city": "Belmont",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 201,
      "name": "The FEDS",
      "rookie_year": "1998",
      "city": "Rochester",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 202,
      "name": "Team 202",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 203,
      "name": "SOUPer BOTS",
      "rookie_year": "1998",
      "city": "Sicklerville",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 204,
      "name": "Eastern Robotic Vikings",
      "rookie_year": "1998",
      "city": "Voorhees",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 207,
      "name": "METALCRAFTERS",
      "rookie_year": "1999",
      "city": "Hawthorne",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 209,
      "name": "DRRT",
      "rookie_year": "1999",
      "city": "North Dighton",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 211,
      "name": "MAK",
      "rookie_year": "1999",
      "city": "Rochester",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 212,
      "name": "Robotics And Creative Engineering",
      "rookie_year": "1999",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 213,
      "name": "The Dirty Birds",
      "rookie_year": "1999",
      "city": "Keene",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 215,
      "name": "Team 215",
      "rookie_year": "1999",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 216,
      "name": "More RoboDawgs",
      "rookie_year": "1999",
      "city": "Grandville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 217,
      "name": "ThunderChickens",
      "rookie_year": "1999",
      "city": "Sterling Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 219,
      "name": "Team Impact 219",
      "rookie_year": "1999",
      "city": "Washington",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 221,
      "name": "Team 221",
      "rookie_year": "1999",
      "city": "Houghton",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 222,
      "name": "Tigertrons",
      "rookie_year": "1999",
      "city": "Tunkhannock",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 223,
      "name": "Xtreme Heat",
      "rookie_year": "1999",
      "city": "Wanaque",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 224,
      "name": "The Tribe",
      "rookie_year": "1999",
      "city": "Piscataway",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 225,
      "name": "TechFire",
      "rookie_year": "1999",
      "city": "York",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 226,
      "name": "Hammerheads",
      "rookie_year": "1999",
      "city": "Troy",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 227,
      "name": "Team 227",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 228,
      "name": "GUS Robotics",
      "rookie_year": "1999",
      "city": "Meriden",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 229,
      "name": "Division By Zero",
      "rookie_year": "1999",
      "city": "Potsdam",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 230,
      "name": "Gaelhawks",
      "rookie_year": "1999",
      "city": "Shelton",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 231,
      "name": "High Voltage",
      "rookie_year": "1998",
      "city": "Pasadena",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 232,
      "name": "Team 232",
      "rookie_year": "1999",
      "city": "Napa",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 233,
      "name": "The Pink Team",
      "rookie_year": "1999",
      "city": "Rockledge",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 234,
      "name": "Cyber Blue",
      "rookie_year": "1999",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 235,
      "name": "Motown Live Wires",
      "rookie_year": "1999",
      "city": "Warren",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 236,
      "name": "Techno-Ticks",
      "rookie_year": "1999",
      "city": "Old Lyme",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 237,
      "name": "Black Magic Robotics",
      "rookie_year": "1999",
      "city": "Watertown",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 238,
      "name": "Crusaders",
      "rookie_year": "1999",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 239,
      "name": "Team 239",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 240,
      "name": "TEMPEST",
      "rookie_year": "1999",
      "city": "Newport",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 241,
      "name": "Astros",
      "rookie_year": "1999",
      "city": "Derry",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 244,
      "name": "RoboDawgs 3D",
      "rookie_year": "1999",
      "city": "Grandville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 245,
      "name": "Adambots",
      "rookie_year": "1999",
      "city": "Rochester Hills",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 246,
      "name": "Overclocked",
      "rookie_year": "1999",
      "city": "Boston",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 247,
      "name": "Da Bears",
      "rookie_year": "1999",
      "city": "Berkley",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 248,
      "name": "Team 248",
      "rookie_year": "1999",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 249,
      "name": "The Bulldogs",
      "rookie_year": "1999",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 250,
      "name": "The Dynamos",
      "rookie_year": "1999",
      "city": "Colonie",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 252,
      "name": "Team 252",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 253,
      "name": "Boba Bots",
      "rookie_year": "1999",
      "city": "Millbrae",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 254,
      "name": "The Cheesy Poofs",
      "rookie_year": "1999",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 255,
      "name": "Team 255",
      "rookie_year": "1999",
      "city": "San Jose",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 256,
      "name": "Robo-Rams",
      "rookie_year": "1999",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 257,
      "name": "Team 257",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 258,
      "name": "Sea Dawgs",
      "rookie_year": "1999",
      "city": "San Jose",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 259,
      "name": "LABRATs",
      "rookie_year": "1999",
      "city": "Bell",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 260,
      "name": "Team 260",
      "rookie_year": "1999",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 261,
      "name": "Team 261",
      "rookie_year": "1999",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 263,
      "name": "Aftershock",
      "rookie_year": "1999",
      "city": "Ronkonkoma",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 264,
      "name": "Team 264",
      "rookie_year": "1999",
      "city": "MI",
      "state": "USA",
      "country": "",
      "district": ""
    },
    {
      "number": 265,
      "name": "Moderate Heat",
      "rookie_year": "1999",
      "city": "Wanaque",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 266,
      "name": "Team 266",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 267,
      "name": "Demolition Squad",
      "rookie_year": "1999",
      "city": "Parkland",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 268,
      "name": "Team 268",
      "rookie_year": "1999",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 269,
      "name": "CooneyTech",
      "rookie_year": "1999",
      "city": "Oconomowoc",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 270,
      "name": "Falcons",
      "rookie_year": "1999",
      "city": "Deer Park",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 271,
      "name": "Mechanical Marauders",
      "rookie_year": "1999",
      "city": "Bay Shore",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 272,
      "name": "Cyber-Crusaders",
      "rookie_year": "1998",
      "city": "Lansdale",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 274,
      "name": "Rhodes Maniacs",
      "rookie_year": "1999",
      "city": "Cleveland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 276,
      "name": "Madcows!",
      "rookie_year": "1999",
      "city": "Youngstown",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 277,
      "name": "Team 277",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 278,
      "name": "Team 278",
      "rookie_year": "1999",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 279,
      "name": "Tech Fusion",
      "rookie_year": "1999",
      "city": "Maumee",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 280,
      "name": "TnT",
      "rookie_year": "1999",
      "city": "Taylor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 281,
      "name": "The GreenVillains",
      "rookie_year": "1999",
      "city": "Greenville",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 282,
      "name": "Team 282",
      "rookie_year": "1999",
      "city": "Winter Park",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 283,
      "name": "The Generals",
      "rookie_year": "1999",
      "city": "Greenville",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 284,
      "name": "The Crew",
      "rookie_year": "1999",
      "city": "Dimock",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 287,
      "name": "Floyd Robotics",
      "rookie_year": "1999",
      "city": "Mastic Beach",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 288,
      "name": "The RoboDawgs",
      "rookie_year": "1999",
      "city": "Grandville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 290,
      "name": "Team 290",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 291,
      "name": "CIA - Creativity In Action",
      "rookie_year": "1999",
      "city": "Erie",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 292,
      "name": "PantherTech",
      "rookie_year": "1999",
      "city": "Russiaville",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 293,
      "name": "SPIKE",
      "rookie_year": "1999",
      "city": "Pennington",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 294,
      "name": "Beach Cities Robotics",
      "rookie_year": "1999",
      "city": "Redondo Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 295,
      "name": "Grizzly Robotics Team",
      "rookie_year": "1999",
      "city": "Granite Bay",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 296,
      "name": "Northern Knights",
      "rookie_year": "1999",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 297,
      "name": "Dragons 2",
      "rookie_year": "1999",
      "city": "Lake Orion",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 298,
      "name": "Team 298",
      "rookie_year": "1999",
      "city": "Pleasanton",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 299,
      "name": "Valkyrie Robotics",
      "rookie_year": "1998",
      "city": "Cupertino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 300,
      "name": "AAME",
      "rookie_year": "1999",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 301,
      "name": "P.R.O.B.O.T.S.",
      "rookie_year": "1999",
      "city": "Dearborn",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 302,
      "name": "The Dragons",
      "rookie_year": "1999",
      "city": "Lake Orion",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 303,
      "name": "The T.E.S.T. Team",
      "rookie_year": "1999",
      "city": "Bridgewater",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 304,
      "name": "GWHS Robo Griffins",
      "rookie_year": "1999",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 306,
      "name": "CRT",
      "rookie_year": "1999",
      "city": "Corry",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 308,
      "name": "Monsters",
      "rookie_year": "1999",
      "city": "Walled Lake",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 309,
      "name": "RECHARGED",
      "rookie_year": "1999",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 311,
      "name": "Red Jammers",
      "rookie_year": "1999",
      "city": "Islip Terrace",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 312,
      "name": "HeatWave",
      "rookie_year": "1999",
      "city": "St. Petersburg",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 313,
      "name": "The Bionic Zebras",
      "rookie_year": "1999",
      "city": "Wayne",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 314,
      "name": "The Megatron Oracles",
      "rookie_year": "1999",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 315,
      "name": "Team 315",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 316,
      "name": "LUNATECS",
      "rookie_year": "1999",
      "city": "Carneys Point",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 317,
      "name": "Mechanical Geek Squad",
      "rookie_year": "1999",
      "city": "Fort Worth",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 319,
      "name": "Big Bad Bob",
      "rookie_year": "1999",
      "city": "Alton",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 321,
      "name": "RoboLancers",
      "rookie_year": "1999",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 322,
      "name": "Team F.I.R.E.",
      "rookie_year": "1999",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 323,
      "name": "Lights Out",
      "rookie_year": "1996",
      "city": "Mountain Home",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 324,
      "name": "Chips",
      "rookie_year": "1998",
      "city": "Friendswood",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 325,
      "name": "Respawn Robotics",
      "rookie_year": "1998",
      "city": "Hamilton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 326,
      "name": "Teamsuperpowermaticultramegasuperlativeawesometasticdelcioushowlingunieagles",
      "rookie_year": "1999",
      "city": "Romulus",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 329,
      "name": "Mohawks",
      "rookie_year": "1999",
      "city": "Medford",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 330,
      "name": "The Beach Bots",
      "rookie_year": "1999",
      "city": "Hermosa Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 331,
      "name": "The Bulldogs",
      "rookie_year": "1999",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 333,
      "name": "MEGALODONS",
      "rookie_year": "1999",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 334,
      "name": "TechKnights",
      "rookie_year": "1999",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 335,
      "name": "Skillz Tech Gear Botz",
      "rookie_year": "1999",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 337,
      "name": "Hard Working Hard Hats",
      "rookie_year": "2000",
      "city": "Logan",
      "state": "West Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 338,
      "name": "Pandemic",
      "rookie_year": "2000",
      "city": "West Jefferson",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 339,
      "name": "Kilroy Robotics",
      "rookie_year": "2000",
      "city": "Stafford",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 340,
      "name": "G.R.R. (Greater Rochester Robotics)",
      "rookie_year": "2000",
      "city": "Churchville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 341,
      "name": "Miss Daisy",
      "rookie_year": "2000",
      "city": "Ambler",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 342,
      "name": "Burning Magnetos",
      "rookie_year": "2000",
      "city": "North Charleston",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 343,
      "name": "Metal-In-Motion",
      "rookie_year": "2000",
      "city": "Seneca",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 345,
      "name": "NORSTAR",
      "rookie_year": "2000",
      "city": "Norfolk",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 346,
      "name": "RoboHawks",
      "rookie_year": "2000",
      "city": "Chesterfield",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 348,
      "name": "Norwell Robotics",
      "rookie_year": "2000",
      "city": "Norwell",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 349,
      "name": "Team 349",
      "rookie_year": "2000",
      "city": "Bloomfield Hills",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 350,
      "name": "Timberlane Robotics",
      "rookie_year": "2000",
      "city": "Plaistow",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 351,
      "name": "Team 351",
      "rookie_year": "2000",
      "city": "Green Cove Springs",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 352,
      "name": "The Green Machine",
      "rookie_year": "2000",
      "city": "Carle Place",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 353,
      "name": "POBots",
      "rookie_year": "2000",
      "city": "Plainview",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 354,
      "name": "G-House Pirates",
      "rookie_year": "2000",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 356,
      "name": "Enigma",
      "rookie_year": "2000",
      "city": "Little Rock",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 357,
      "name": "Royal Assault",
      "rookie_year": "2000",
      "city": "Drexel Hill",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 358,
      "name": "Robotic Eagles",
      "rookie_year": "2000",
      "city": "Hauppauge",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 359,
      "name": "Hawaiian Kids",
      "rookie_year": "2000",
      "city": "Waialua",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 360,
      "name": "The Revolution",
      "rookie_year": "2000",
      "city": "Tacoma",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 361,
      "name": "Team 361",
      "rookie_year": "2000",
      "city": "Farmindale",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 362,
      "name": "The Muses",
      "rookie_year": "2000",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 364,
      "name": "Team Fusion",
      "rookie_year": "2000",
      "city": "Gulfport",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 365,
      "name": "Miracle Workerz",
      "rookie_year": "2000",
      "city": "Wilmington",
      "state": "Delaware",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 367,
      "name": "Team 367",
      "rookie_year": "2000",
      "city": "Seaford",
      "state": "DE",
      "country": "USA",
      "district": ""
    },
    {
      "number": 368,
      "name": "Team Kika Mana",
      "rookie_year": "2000",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 369,
      "name": "High Voltage Robotics",
      "rookie_year": "2000",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 371,
      "name": "Cyber Warriors",
      "rookie_year": "2000",
      "city": "Staten Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 372,
      "name": "RoboKnights",
      "rookie_year": "2000",
      "city": "Mukilteo",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 373,
      "name": "Falcons ",
      "rookie_year": "2000",
      "city": "Locust Valley",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 374,
      "name": "The IceBreakers",
      "rookie_year": "2000",
      "city": "Anchorage",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 375,
      "name": "Robotic Plague",
      "rookie_year": "2000",
      "city": "Staten Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 376,
      "name": "Team 376",
      "rookie_year": "2000",
      "city": "Newark",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 378,
      "name": "The Circuit Stompers",
      "rookie_year": "2000",
      "city": "Newfane",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 379,
      "name": "The RoboCats",
      "rookie_year": "2000",
      "city": "Girard",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 380,
      "name": "G-FORCE",
      "rookie_year": "2000",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 381,
      "name": "Tornadoes",
      "rookie_year": "2000",
      "city": "Trenton",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 382,
      "name": "Twisted Blizzard",
      "rookie_year": "2000",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 383,
      "name": "Brazilian Machine",
      "rookie_year": "2000",
      "city": "Porto Alegre",
      "state": "Rio Grande do Sul",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 384,
      "name": "SPARKY 384",
      "rookie_year": "2000",
      "city": "Henrico",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 386,
      "name": "Team Voltage",
      "rookie_year": "2000",
      "city": "Melbourne",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 388,
      "name": "Maximum Oz",
      "rookie_year": "2000",
      "city": "Grundy",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 391,
      "name": "Titanium Rampage",
      "rookie_year": "2000",
      "city": "Grand Rapids",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 393,
      "name": "Full Metal Jackets (FMJ393)",
      "rookie_year": "2000",
      "city": "Morristown",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 394,
      "name": "Team 394",
      "rookie_year": "2000",
      "city": "Windsor",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 395,
      "name": "2 Train Robotics",
      "rookie_year": "2000",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 397,
      "name": "Knight Riders",
      "rookie_year": "2000",
      "city": "Flint",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 398,
      "name": "The Thundering Herd",
      "rookie_year": "2000",
      "city": "Ridgway",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 399,
      "name": "Eagle Robotics",
      "rookie_year": "2000",
      "city": "Lancaster",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 400,
      "name": "The Blue Dragons",
      "rookie_year": "2000",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 401,
      "name": "Copperhead Robotics",
      "rookie_year": "2000",
      "city": "Christiansburg",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 402,
      "name": "Team 402",
      "rookie_year": "2000",
      "city": "Woodbridge",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 404,
      "name": "Distant Rage",
      "rookie_year": "2000",
      "city": "Petersburg",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 405,
      "name": "The Chameleons",
      "rookie_year": "2000",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 406,
      "name": "Mumford Chargers",
      "rookie_year": "2000",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 407,
      "name": "Team 407",
      "rookie_year": "2000",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 408,
      "name": "The RoboTicks",
      "rookie_year": "2000",
      "city": "Pompano Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 409,
      "name": "Team 409",
      "rookie_year": "2000",
      "city": "San Jose",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 410,
      "name": "Psychos",
      "rookie_year": "2000",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 411,
      "name": "The Creeping Crawlers",
      "rookie_year": "2000",
      "city": "Rockhill",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 413,
      "name": "Team 413",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 414,
      "name": "Smokie and the Bandits",
      "rookie_year": "2000",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 415,
      "name": "RoBoCRAFT",
      "rookie_year": "2000",
      "city": "Williamston",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 416,
      "name": "Regs",
      "rookie_year": "2000",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 417,
      "name": "Stangbot",
      "rookie_year": "2000",
      "city": "Mt. Sinai",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 418,
      "name": "Purple Haze",
      "rookie_year": "2000",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 419,
      "name": "NDV Dragon Bots",
      "rookie_year": "2000",
      "city": "Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 420,
      "name": "Team 420",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 421,
      "name": "The Warriors",
      "rookie_year": "2000",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 422,
      "name": "The Mech Tech Dragons",
      "rookie_year": "2000",
      "city": "Richmond",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 423,
      "name": "Simple Machines",
      "rookie_year": "2000",
      "city": "Cheltenham",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 424,
      "name": "GRR (Greater Rochester Robotics)",
      "rookie_year": "2000",
      "city": "Churchville",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 425,
      "name": "Spartans",
      "rookie_year": "2000",
      "city": "Melbourne",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 426,
      "name": "Zombie Apocalypse Counter Task Force",
      "rookie_year": "2000",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 433,
      "name": "Firebirds",
      "rookie_year": "2000",
      "city": "Flourtown",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 434,
      "name": "Kraken",
      "rookie_year": "2000",
      "city": "Missouri City",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 435,
      "name": "Robodogs",
      "rookie_year": "2000",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 437,
      "name": "Talon Robotics",
      "rookie_year": "2000",
      "city": "Richardson",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 438,
      "name": "El Camino Creek Problem-Solving Programmers",
      "rookie_year": "2000",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 440,
      "name": "The Suspects",
      "rookie_year": "2000",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 441,
      "name": "DEVIL DOGS",
      "rookie_year": "2000",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 442,
      "name": "Redstone Robotics",
      "rookie_year": "2000",
      "city": "Huntsville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 443,
      "name": "Freelance Robotics",
      "rookie_year": "2000",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 444,
      "name": "Philly's Extreme Team",
      "rookie_year": "2000",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 446,
      "name": "Robodogs",
      "rookie_year": "2000",
      "city": "La Porte",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 447,
      "name": "Team Roboto",
      "rookie_year": "2000",
      "city": "Anderson",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 448,
      "name": "Crandroids",
      "rookie_year": "2000",
      "city": "Bloomfield Hills",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 449,
      "name": "The Blair Robot Project",
      "rookie_year": "2000",
      "city": "Silver Spring",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 451,
      "name": "The Cat Attack",
      "rookie_year": "2000",
      "city": "Maumee",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 453,
      "name": "Rockem Sockem Robotics",
      "rookie_year": "2000",
      "city": "Clinton Township",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 456,
      "name": "Siege Robotics",
      "rookie_year": "2000",
      "city": "Vicksburg",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 457,
      "name": "\u2699\ufe0f Grease Monkeys \u2699\ufe0f",
      "rookie_year": "2000",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 459,
      "name": "Rampage Robotics",
      "rookie_year": "2000",
      "city": "Gainesville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 460,
      "name": "Xavier Robotics",
      "rookie_year": "2000",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 461,
      "name": "Westside Boiler Invasion",
      "rookie_year": "2000",
      "city": "West Lafayette",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 462,
      "name": "The Rambunctious Rams",
      "rookie_year": "2000",
      "city": "Jackson",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 463,
      "name": "LEGObots",
      "rookie_year": "2000",
      "city": "San Jose",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 464,
      "name": "Team 464",
      "rookie_year": "2000",
      "city": "Rio Rancho",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 465,
      "name": "GearHeads",
      "rookie_year": "2000",
      "city": "Canton",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 466,
      "name": "LEGOndary",
      "rookie_year": "2000",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 467,
      "name": "Colonials",
      "rookie_year": "2000",
      "city": "Shrewsbury",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 468,
      "name": "Aftershock",
      "rookie_year": "2000",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 469,
      "name": "Las Guerrillas",
      "rookie_year": "2000",
      "city": "Bloomfield Hills",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 470,
      "name": "Grizzly Robotics",
      "rookie_year": "2000",
      "city": "Ypsilanti",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 471,
      "name": "Cyber Tigers",
      "rookie_year": "2000",
      "city": "Fenton",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 473,
      "name": "RoboDevils!!",
      "rookie_year": "2000",
      "city": "Corvallis",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 475,
      "name": "Team 475",
      "rookie_year": "2000",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 476,
      "name": "Wildcats",
      "rookie_year": "2000",
      "city": "Ponca City",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 478,
      "name": "Critical Mass",
      "rookie_year": "2000",
      "city": "Rosemead",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 480,
      "name": "Hybrid",
      "rookie_year": "2000",
      "city": "Oakland",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 481,
      "name": "The Hitchhikers",
      "rookie_year": "2000",
      "city": "San Pablo",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 484,
      "name": "Roboforce",
      "rookie_year": "2000",
      "city": "Havertown",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 486,
      "name": "Positronic Panthers",
      "rookie_year": "2000",
      "city": "Wallingford",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 487,
      "name": "Spartans",
      "rookie_year": "2000",
      "city": "Erdenheim",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 488,
      "name": "Team XBOT",
      "rookie_year": "2000",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 491,
      "name": "Technotics",
      "rookie_year": "2000",
      "city": "Bridgeport",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 492,
      "name": "Titan Robotics Club",
      "rookie_year": "2001",
      "city": "Bellevue",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 493,
      "name": "Team 493",
      "rookie_year": "2001",
      "city": "ALLIANCE",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 494,
      "name": "Martians",
      "rookie_year": "2001",
      "city": "Goodrich",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 495,
      "name": "Team 495",
      "rookie_year": "2001",
      "city": "Williamsburg",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 496,
      "name": "Royals",
      "rookie_year": "2001",
      "city": "Port Jefferson",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 497,
      "name": "Orange Crush",
      "rookie_year": "2001",
      "city": "Orange",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 498,
      "name": "The Cobra Commanders",
      "rookie_year": "2001",
      "city": "Glendale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 499,
      "name": "Toltechs",
      "rookie_year": "2001",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 500,
      "name": "Team 500/Team USA",
      "rookie_year": "2001",
      "city": "New London",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 501,
      "name": "The PowerKnights",
      "rookie_year": "2001",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 502,
      "name": "Robo Rockers",
      "rookie_year": "2001",
      "city": "Rockville Centre",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 503,
      "name": "Frog Force",
      "rookie_year": "2001",
      "city": "Novi",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 504,
      "name": "Team 504",
      "rookie_year": "2001",
      "city": "Little Silver",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 505,
      "name": "Team 505",
      "rookie_year": "2001",
      "city": "Yonkers",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 506,
      "name": "BroBots",
      "rookie_year": "2001",
      "city": "South Huntington",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 507,
      "name": "Solid Orange Academy of Robotics (SOAR)",
      "rookie_year": "2001",
      "city": "Greenville",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 508,
      "name": "Team 508",
      "rookie_year": "2001",
      "city": "Avon",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 509,
      "name": "Red Storm",
      "rookie_year": "2001",
      "city": "Bedford",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 510,
      "name": "Hawaii Five-10",
      "rookie_year": "2001",
      "city": "Highland Springs",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 511,
      "name": "The Robodox",
      "rookie_year": "2001",
      "city": "Granada Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 512,
      "name": "Team 512",
      "rookie_year": "2001",
      "city": "Hull",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 513,
      "name": "Renegade Robotics",
      "rookie_year": "2001",
      "city": "Oklahoma City",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 514,
      "name": "Entropy",
      "rookie_year": "2001",
      "city": "Miller Place",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 515,
      "name": "TechnoKnights",
      "rookie_year": "2001",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 517,
      "name": "Team 517",
      "rookie_year": "2001",
      "city": "New Providence",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 518,
      "name": "Blue Steel",
      "rookie_year": "2001",
      "city": "Grand Rapids",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 519,
      "name": "Robo Masters",
      "rookie_year": "2001",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 520,
      "name": "Team 520",
      "rookie_year": "2001",
      "city": "Deer Park",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 521,
      "name": "L33T CREW (\"leet crew\")",
      "rookie_year": "2001",
      "city": "Waterford",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 522,
      "name": "ROBO WIZARDS",
      "rookie_year": "2001",
      "city": "Staten Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 524,
      "name": "Team 524",
      "rookie_year": "2001",
      "city": "Bakersfield",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 525,
      "name": "Swartdogs",
      "rookie_year": "2001",
      "city": "Cedar Falls",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 527,
      "name": "Red Dragons",
      "rookie_year": "2001",
      "city": "Massapequa",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 528,
      "name": "The Persuaders",
      "rookie_year": "2001",
      "city": "Lansdale",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 529,
      "name": "The Mansfield Hornets",
      "rookie_year": "2001",
      "city": "Mansfield",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 533,
      "name": "The PSIcotics",
      "rookie_year": "2001",
      "city": "Lindenhurst",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 535,
      "name": "G-Force",
      "rookie_year": "2001",
      "city": "Markle",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 536,
      "name": "Team 536",
      "rookie_year": "2001",
      "city": "San Francisco",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 537,
      "name": "Charger Robotics",
      "rookie_year": "2001",
      "city": "Sussex",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 538,
      "name": "Dragon Slayers",
      "rookie_year": "2001",
      "city": "Arab",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 539,
      "name": "Titan Robotics",
      "rookie_year": "2001",
      "city": "Richmond",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 540,
      "name": "TALON 540",
      "rookie_year": "2001",
      "city": "Henrico",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 541,
      "name": "Surgeons of Steel",
      "rookie_year": "2001",
      "city": "Cleveland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 545,
      "name": "ROBO-DAWGS",
      "rookie_year": "2001",
      "city": "Levittown",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 546,
      "name": "Technotics",
      "rookie_year": "2001",
      "city": "Woodbridge",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 547,
      "name": "Falcon Engineering And Robotics",
      "rookie_year": "2001",
      "city": "Fayetteville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 548,
      "name": "Robostangs",
      "rookie_year": "2001",
      "city": "Northville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 549,
      "name": "DevilDawgs",
      "rookie_year": "2001",
      "city": "Leominster",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 550,
      "name": "NanKnights",
      "rookie_year": "2001",
      "city": "Washington",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 551,
      "name": "Team 551",
      "rookie_year": "2001",
      "city": "Belvidere",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 554,
      "name": "The Bluegrease Crew",
      "rookie_year": "2001",
      "city": "Ft. Thomas",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 555,
      "name": "Montclair Robotics",
      "rookie_year": "2001",
      "city": "Montclair",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 557,
      "name": "Flaming Cardinals",
      "rookie_year": "2001",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 558,
      "name": "Elm City Robo Squad",
      "rookie_year": "2001",
      "city": "New Haven",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 560,
      "name": "Camdenton 4-H LASER HWE #3",
      "rookie_year": "2001",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 561,
      "name": "Camdenton 4-H LASER HWE #4",
      "rookie_year": "2001",
      "city": "Phila",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 562,
      "name": "SPARK - Students Pursuing Applied Robotics Knowledge",
      "rookie_year": "2001",
      "city": "Fitchburg",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 563,
      "name": "Thrashers",
      "rookie_year": "2001",
      "city": "Phila",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 564,
      "name": "Longwood Robotics",
      "rookie_year": "2001",
      "city": "Middle Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 565,
      "name": "Camdenton 4-H LASER ORI #3",
      "rookie_year": "2001",
      "city": "Newark",
      "state": "DE",
      "country": "USA",
      "district": ""
    },
    {
      "number": 566,
      "name": "Hot Wired 566",
      "rookie_year": "2001",
      "city": "Centereach",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 568,
      "name": "Nerds of the North",
      "rookie_year": "2001",
      "city": "Anchorage",
      "state": "Alaska",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 569,
      "name": "Rambots",
      "rookie_year": "2001",
      "city": "Westbury",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 570,
      "name": "Team Phoenix",
      "rookie_year": "2001",
      "city": "Glen Cove",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 571,
      "name": "Team Paragon",
      "rookie_year": "2001",
      "city": "Windsor",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 573,
      "name": "Mech Warriors",
      "rookie_year": "2001",
      "city": "Bloomfield Hills",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 574,
      "name": "Team 574",
      "rookie_year": "2001",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 575,
      "name": "Frankfort First Lego League #1",
      "rookie_year": "2001",
      "city": "North Hills",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 576,
      "name": "Nerd Kings",
      "rookie_year": "2001",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 577,
      "name": "Tiger Techs",
      "rookie_year": "2001",
      "city": "Tujunga",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 578,
      "name": "R-cubed  - Red Raider Robotics",
      "rookie_year": "2001",
      "city": "Fairport",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 579,
      "name": "Team 579",
      "rookie_year": "2001",
      "city": "Laveen",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 580,
      "name": "Viking Robotics",
      "rookie_year": "2001",
      "city": "Studio City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 581,
      "name": "Blazing Bulldogs",
      "rookie_year": "2001",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 582,
      "name": "Viking Electros",
      "rookie_year": "2001",
      "city": "Jacksonville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 583,
      "name": "Team 583",
      "rookie_year": "2001",
      "city": "Seattle",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 585,
      "name": "Cyber Penguins",
      "rookie_year": "2001",
      "city": "Tehachapi",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 586,
      "name": "Robo Mustangs",
      "rookie_year": "2001",
      "city": "Alhambra",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 587,
      "name": "The Hedgehogs",
      "rookie_year": "2001",
      "city": "Hillsborough",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 588,
      "name": "Jagtronx",
      "rookie_year": "2001",
      "city": "Jacksonville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 589,
      "name": "Falkon Robotics",
      "rookie_year": "2001",
      "city": "La Crescenta",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 590,
      "name": "Chahta Warriors",
      "rookie_year": "2001",
      "city": "Choctaw",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 591,
      "name": "Power Surge",
      "rookie_year": "2001",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 592,
      "name": "Team 592",
      "rookie_year": "2001",
      "city": "Sacramento",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 593,
      "name": "Joe Walker - B.R.O.S. (Brothers Reaching Over Success)",
      "rookie_year": "2001",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 594,
      "name": "Joe Walker - Whiplash",
      "rookie_year": "2001",
      "city": "Flint",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 596,
      "name": "SciClones",
      "rookie_year": "2001",
      "city": "Hopkinton",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 597,
      "name": "The Wolverines",
      "rookie_year": "2001",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 598,
      "name": "Team Duct Tape",
      "rookie_year": "2001",
      "city": "Woodland Hills",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 599,
      "name": "The Robodox",
      "rookie_year": "2001",
      "city": "Granada Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 600,
      "name": "RamRod Robotics",
      "rookie_year": "2001",
      "city": "Lynchburg",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 601,
      "name": "BayBots",
      "rookie_year": "2001",
      "city": "Hampton Bays",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 602,
      "name": "MTC",
      "rookie_year": "2001",
      "city": "Leesburg",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 603,
      "name": "FBI - Fascinating Bot Intelligence",
      "rookie_year": "2001",
      "city": "Daytona Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 604,
      "name": "Quixilver",
      "rookie_year": "2001",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 605,
      "name": "Astromechs",
      "rookie_year": "2001",
      "city": "Hayward",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 606,
      "name": "Cyber Eagles",
      "rookie_year": "2001",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 607,
      "name": "Mindstorm Overlords",
      "rookie_year": "2001",
      "city": "Piney Woods",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 608,
      "name": "Team 608",
      "rookie_year": "2001",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 609,
      "name": "VentureBOTS",
      "rookie_year": "2001",
      "city": "Santa Rosa",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 610,
      "name": "Crescent Coyotes",
      "rookie_year": "2001",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 611,
      "name": "Saxons",
      "rookie_year": "2001",
      "city": "McLean",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 612,
      "name": "Chantilly Robotics",
      "rookie_year": "2001",
      "city": "Chantilly",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 613,
      "name": "NeoWarriors",
      "rookie_year": "2001",
      "city": "Somerset",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 614,
      "name": "Night Hawks",
      "rookie_year": "2001",
      "city": "Alexandria",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 615,
      "name": "Knights",
      "rookie_year": "2001",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 616,
      "name": "Southampton Indians",
      "rookie_year": "2001",
      "city": "Courtland",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 617,
      "name": "Enginerds",
      "rookie_year": "2001",
      "city": "Henrico",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 618,
      "name": "E.A.R.T.H. Squad (Edison Achieving Real Technological Heights)",
      "rookie_year": "2001",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 619,
      "name": "Cavalier Robotics",
      "rookie_year": "2001",
      "city": "Charlottesville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 620,
      "name": "Warbots",
      "rookie_year": "2001",
      "city": "Vienna",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 621,
      "name": "Team 621",
      "rookie_year": "2001",
      "city": "Falls Church",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 622,
      "name": "Team 622",
      "rookie_year": "2001",
      "city": "Manassas",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 623,
      "name": "Oakton Cougar Robotics",
      "rookie_year": "2001",
      "city": "Vienna",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 624,
      "name": "CRyptonite",
      "rookie_year": "2001",
      "city": "Katy",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 625,
      "name": "Team 625",
      "rookie_year": "2001",
      "city": "Palmer",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 627,
      "name": "Team 627",
      "rookie_year": "2001",
      "city": "Falls Church",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 628,
      "name": "Northern RobArctic",
      "rookie_year": "2001",
      "city": "Fairbanks",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 630,
      "name": "Team 630",
      "rookie_year": "2001",
      "city": "McLean",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 632,
      "name": "J-Lo",
      "rookie_year": "2001",
      "city": "Union City",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 633,
      "name": "Falcon Robotics",
      "rookie_year": "2001",
      "city": "Tacoma",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 634,
      "name": "Rage",
      "rookie_year": "2001",
      "city": "Van Nuys",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 635,
      "name": "Team 635",
      "rookie_year": "2001",
      "city": "Buda",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 636,
      "name": "Rascals",
      "rookie_year": "2001",
      "city": "Waipahu",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 637,
      "name": "MR. T",
      "rookie_year": "2001",
      "city": "Montville Township",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 638,
      "name": "Operation Oxidation",
      "rookie_year": "2001",
      "city": "Midlothian",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 639,
      "name": "Code Red Robotics",
      "rookie_year": "2001",
      "city": "Ithaca",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 640,
      "name": "Edison Robotics",
      "rookie_year": "2001",
      "city": "Jamaica",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 641,
      "name": "Team 641",
      "rookie_year": "2001",
      "city": "Sanborn",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 642,
      "name": "BRR(Big Red Robotics)",
      "rookie_year": "2001",
      "city": "Parkersburg",
      "state": "WV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 643,
      "name": "Team 643",
      "rookie_year": "2001",
      "city": "Allentown",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 644,
      "name": "Team Mambo",
      "rookie_year": "2001",
      "city": "Pearl River",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 645,
      "name": "Team 645",
      "rookie_year": "2001",
      "city": "San Rafael",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 646,
      "name": "Team 646",
      "rookie_year": "2001",
      "city": "West Sayville",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 647,
      "name": "CYBERWOLVES",
      "rookie_year": "2001",
      "city": "Killeen",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 648,
      "name": "QC ELITE - Flaming Squirrels",
      "rookie_year": "2001",
      "city": "Pleasant Valley",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 649,
      "name": "MSET Fish",
      "rookie_year": "2001",
      "city": "Saratoga",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 650,
      "name": "Hella's Angels",
      "rookie_year": "2001",
      "city": "Flora",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 651,
      "name": "Yo Bot",
      "rookie_year": "2001",
      "city": "Mar Lin",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 652,
      "name": "Bobcats",
      "rookie_year": "2001",
      "city": "Erie",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 653,
      "name": "NOSIDE",
      "rookie_year": "2001",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 654,
      "name": "Mechateuthis Dux",
      "rookie_year": "2001",
      "city": "Tallahassee",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 655,
      "name": "Team 655",
      "rookie_year": "2001",
      "city": "Brooklyn",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 658,
      "name": "B.E.A.S.T.  - Bringing Excitement and Science Together",
      "rookie_year": "2001",
      "city": "Wyoming",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 659,
      "name": "Team 659",
      "rookie_year": "2001",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 660,
      "name": "Dragons",
      "rookie_year": "2001",
      "city": "Round Rock",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 662,
      "name": "Rocky Mountain Robotics",
      "rookie_year": "2001",
      "city": "USAF Academy",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 663,
      "name": "Robonauts",
      "rookie_year": "2001",
      "city": "Whitinsville",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 664,
      "name": "Team 664",
      "rookie_year": "2001",
      "city": "Harvard",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 665,
      "name": "Motor Monkeys",
      "rookie_year": "2001",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 666,
      "name": "The TorMentors",
      "rookie_year": "2008",
      "city": "Hell",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 667,
      "name": "Team 667",
      "rookie_year": "2001",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 668,
      "name": "The Apes of Wrath",
      "rookie_year": "2001",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 670,
      "name": "Homestead Robotics",
      "rookie_year": "2001",
      "city": "Cupertino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 671,
      "name": "Team 671",
      "rookie_year": "2001",
      "city": "San Francisco",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 674,
      "name": "Team 674",
      "rookie_year": "2001",
      "city": "Manchester",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 675,
      "name": "Tech High Robotics",
      "rookie_year": "2001",
      "city": "Rohnert Park",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 676,
      "name": "Team 676",
      "rookie_year": "2001",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 677,
      "name": "Murphy's Outlaws",
      "rookie_year": "2001",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 679,
      "name": "Team 679",
      "rookie_year": "2001",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 681,
      "name": "Team 681",
      "rookie_year": "2001",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 684,
      "name": "Team 684",
      "rookie_year": "2001",
      "city": "Sylmar",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 685,
      "name": "Team 685",
      "rookie_year": "2001",
      "city": "Coconut Creek",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 686,
      "name": "Bovine Intervention",
      "rookie_year": "2001",
      "city": "Thurmont",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 687,
      "name": "The Nerd Herd",
      "rookie_year": "2001",
      "city": "Carson",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 688,
      "name": "Team 688",
      "rookie_year": "2001",
      "city": "Flint",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 690,
      "name": "Team 690",
      "rookie_year": "2001",
      "city": "Northampton",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 691,
      "name": "Project 691 Robotics",
      "rookie_year": "2001",
      "city": "Stevenson Ranch",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 692,
      "name": "The Fembots",
      "rookie_year": "2001",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 694,
      "name": "StuyPulse",
      "rookie_year": "2001",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 695,
      "name": "Bison Robotics",
      "rookie_year": "2001",
      "city": "Beachwood",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 696,
      "name": "Circuit Breakers",
      "rookie_year": "2001",
      "city": "La Crescenta",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 697,
      "name": "Panda Robotics",
      "rookie_year": "2001",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 698,
      "name": "Hamilton Microbots",
      "rookie_year": "2001",
      "city": "Chandler",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 699,
      "name": "Team 699",
      "rookie_year": "2001",
      "city": "Chatsworth",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 700,
      "name": "Team 700",
      "rookie_year": "2001",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 701,
      "name": "RoboVikes",
      "rookie_year": "2001",
      "city": "Fairfield",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 702,
      "name": "Bagel Bytes",
      "rookie_year": "2001",
      "city": "Culver City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 703,
      "name": "Team Phoenix",
      "rookie_year": "2001",
      "city": "Saginaw",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 704,
      "name": "Warriors",
      "rookie_year": "2001",
      "city": "Grand Prairie",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 706,
      "name": "Cyberhawks",
      "rookie_year": "2001",
      "city": "Hartland",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 708,
      "name": "Hatters Robotics",
      "rookie_year": "2001",
      "city": "Horsham",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 709,
      "name": "Femme Tech Fatale",
      "rookie_year": "2001",
      "city": "Bryn Mawr",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 710,
      "name": "Panther Bot",
      "rookie_year": "2001",
      "city": "Fort Lauderdale",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 711,
      "name": "Robeson full force",
      "rookie_year": "2001",
      "city": "Brooklyn",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 713,
      "name": "Steel Raiders",
      "rookie_year": "2001",
      "city": "New York City",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 714,
      "name": "Panthera",
      "rookie_year": "2001",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 715,
      "name": "Team 715",
      "rookie_year": "2001",
      "city": "NY",
      "state": "USA",
      "country": "",
      "district": ""
    },
    {
      "number": 716,
      "name": "Who'sCTEKS",
      "rookie_year": "2001",
      "city": "Falls Village",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 731,
      "name": "Team 731",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 743,
      "name": "Technobots",
      "rookie_year": "2002",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 744,
      "name": "Shark Attack",
      "rookie_year": "2002",
      "city": "Fort Lauderdale",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 746,
      "name": "Gearheads",
      "rookie_year": "2002",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 747,
      "name": "Flight Crew",
      "rookie_year": "2002",
      "city": "Middlesex",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 748,
      "name": "Kingsville CavalGears",
      "rookie_year": "2002",
      "city": "Kingsville",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 750,
      "name": "TechnoTide",
      "rookie_year": "2002",
      "city": "Picayune",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 751,
      "name": "barn2robotics",
      "rookie_year": "2002",
      "city": "Portola Valley",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 752,
      "name": "The Chargers",
      "rookie_year": "2002",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 753,
      "name": "High Desert Droids",
      "rookie_year": "2002",
      "city": "Bend",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 754,
      "name": "FROSTBYTE",
      "rookie_year": "2002",
      "city": "Marinette",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 755,
      "name": "Team 755",
      "rookie_year": "2002",
      "city": "Washington",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 758,
      "name": "South-Kent Youth Robotics",
      "rookie_year": "2002",
      "city": "Blenheim",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 759,
      "name": "Systemetric",
      "rookie_year": "2002",
      "city": "Cambridge",
      "state": "ENG",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 760,
      "name": "Team 760",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 762,
      "name": "Patriots",
      "rookie_year": "2002",
      "city": "Altamonte Springs",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 764,
      "name": "Scoopers",
      "rookie_year": "2002",
      "city": "Sturgis",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 765,
      "name": "Cobblers",
      "rookie_year": "2002",
      "city": "Rapid City",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 766,
      "name": "M-A Bears",
      "rookie_year": "2002",
      "city": "Atherton",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 768,
      "name": "TechnoWarriors",
      "rookie_year": "2002",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 769,
      "name": "Eaglebotics",
      "rookie_year": "2002",
      "city": "Virginia Beach",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 770,
      "name": "Team 770",
      "rookie_year": "2002",
      "city": "Rapid City",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 771,
      "name": "SWAT",
      "rookie_year": "2002",
      "city": "Oakville",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 772,
      "name": "Sabre Bytes Robotics",
      "rookie_year": "2002",
      "city": "LaSalle",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 773,
      "name": "Kingsville CavalGears",
      "rookie_year": "2002",
      "city": "Kingsville",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 776,
      "name": "SATech Saints",
      "rookie_year": "2002",
      "city": "Tecumseh",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 779,
      "name": "Team 779",
      "rookie_year": "2002",
      "city": "Cuyahoga Heights",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 780,
      "name": "TigerBots",
      "rookie_year": "2002",
      "city": "Bayamon",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 781,
      "name": "Kinetic Knights",
      "rookie_year": "2002",
      "city": "Kincardine",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 782,
      "name": "Kilowatts",
      "rookie_year": "2002",
      "city": "Hartford",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 783,
      "name": "Mobotics",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 800,
      "name": "The HazBots",
      "rookie_year": "2002",
      "city": "Redmond",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 801,
      "name": "Horsepower",
      "rookie_year": "2002",
      "city": "Merritt Island",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 802,
      "name": "Team 802",
      "rookie_year": "2002",
      "city": "Sudbury",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 803,
      "name": "Lowcountry Castaways",
      "rookie_year": "2002",
      "city": "Berkeley County",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 804,
      "name": "MetalMorphosis/Mad Scientists",
      "rookie_year": "2002",
      "city": "Rock Hill",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 805,
      "name": "Igniters",
      "rookie_year": "2002",
      "city": "Salem",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 806,
      "name": "The Brooklyn Blacksmiths",
      "rookie_year": "2002",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 807,
      "name": "Monster Mechanics",
      "rookie_year": "2002",
      "city": "Huntsville",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 808,
      "name": "Mechanical Mayhem",
      "rookie_year": "2002",
      "city": "Alliance",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 809,
      "name": "The TechnoWizards",
      "rookie_year": "2002",
      "city": "Manchester",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 810,
      "name": "The Mechanical Bulls",
      "rookie_year": "2002",
      "city": "Smithtown",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 811,
      "name": "Wild Cards",
      "rookie_year": "2002",
      "city": "Nashua",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 812,
      "name": "The Midnight Mechanics",
      "rookie_year": "2002",
      "city": "La Jolla",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 814,
      "name": "Megaforce",
      "rookie_year": "2002",
      "city": "Napa",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 815,
      "name": "Advanced Power",
      "rookie_year": "2002",
      "city": "Allen Park",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 816,
      "name": "Anomaly",
      "rookie_year": "2002",
      "city": "Mount Holly",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 818,
      "name": "The Steel Armadillos 818",
      "rookie_year": "2002",
      "city": "Warren",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 820,
      "name": "Team DeltaTech",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 822,
      "name": "Team 822",
      "rookie_year": "2002",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 824,
      "name": "SWAT Robotics",
      "rookie_year": "2002",
      "city": "Seattle",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 825,
      "name": "SWiVaGus Maximus",
      "rookie_year": "2002",
      "city": "Dublin",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 827,
      "name": "Robotics Eagle",
      "rookie_year": "2002",
      "city": "Fremont",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 829,
      "name": "The Digital Goats",
      "rookie_year": "2002",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 830,
      "name": "The RatPack",
      "rookie_year": "2002",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 831,
      "name": "Ka Mikini Hui O Mililani",
      "rookie_year": "2002",
      "city": "Mililani",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 832,
      "name": "Oscar",
      "rookie_year": "2002",
      "city": "Roswell",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 833,
      "name": "HPA Robotics",
      "rookie_year": "2002",
      "city": "Kamuela",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 834,
      "name": "SparTechs",
      "rookie_year": "2002",
      "city": "Center Valley",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 835,
      "name": "The Sting",
      "rookie_year": "2002",
      "city": "Beverly Hills",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 836,
      "name": "The RoboBees",
      "rookie_year": "2002",
      "city": "Hollywood",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 837,
      "name": "Webbinators",
      "rookie_year": "2002",
      "city": "Oxford",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 839,
      "name": "Rosie Robotics",
      "rookie_year": "2002",
      "city": "Agawam",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 840,
      "name": "Aragon Robotics Team",
      "rookie_year": "2002",
      "city": "San Mateo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 841,
      "name": "The BioMechs",
      "rookie_year": "2002",
      "city": "Richmond",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 842,
      "name": "Falcon Robotics",
      "rookie_year": "2002",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 843,
      "name": "Wildcats",
      "rookie_year": "2002",
      "city": "Oakville",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 845,
      "name": "Cutting Edge",
      "rookie_year": "2002",
      "city": "Pendleton",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 846,
      "name": "The Funky Monkeys",
      "rookie_year": "2002",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 847,
      "name": "PHRED",
      "rookie_year": "2002",
      "city": "Philomath",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 848,
      "name": "HuskyBots",
      "rookie_year": "2002",
      "city": "San Pedro",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 849,
      "name": "Wolfpack",
      "rookie_year": "2002",
      "city": "Unionville",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 850,
      "name": "Team 850",
      "rookie_year": "2002",
      "city": "La Canada",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 851,
      "name": "Froggers",
      "rookie_year": "2002",
      "city": "Torrance",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 852,
      "name": "Athenian Robotics Collective",
      "rookie_year": "2002",
      "city": "Danville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 853,
      "name": "Thunderstorms",
      "rookie_year": "2002",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 854,
      "name": "Iron Bears",
      "rookie_year": "2002",
      "city": "Etobicoke",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 857,
      "name": "Superior Roboworks",
      "rookie_year": "2002",
      "city": "Houghton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 858,
      "name": "Demons",
      "rookie_year": "2002",
      "city": "Wyoming",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 859,
      "name": "BOING",
      "rookie_year": "2002",
      "city": "Morgantown",
      "state": "WV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 861,
      "name": "Gondobots",
      "rookie_year": "2002",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 862,
      "name": "Lightning Robotics",
      "rookie_year": "2002",
      "city": "Canton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 863,
      "name": "The Queens of Modnar",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 865,
      "name": "WARP7",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 866,
      "name": "The SmartTeens of the Turabo Valley",
      "rookie_year": "2002",
      "city": "Caguas",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 867,
      "name": "Absolute Value",
      "rookie_year": "2002",
      "city": "Arcadia",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 868,
      "name": "TechHOUNDS",
      "rookie_year": "2002",
      "city": "Carmel",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 869,
      "name": "PowerCord",
      "rookie_year": "2002",
      "city": "Middlesex",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 870,
      "name": "TEAM  R. I. C. E.",
      "rookie_year": "2002",
      "city": "Southold",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 871,
      "name": "Robotechs",
      "rookie_year": "2002",
      "city": "West Islip",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 872,
      "name": "Techno-Devils",
      "rookie_year": "2002",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 873,
      "name": "Team 873",
      "rookie_year": "2002",
      "city": "Dickinson",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 874,
      "name": "Isis",
      "rookie_year": "2002",
      "city": "Alexander",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 875,
      "name": "Team FrostByte",
      "rookie_year": "2002",
      "city": "Hatton",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 876,
      "name": "Thunder Robotics",
      "rookie_year": "2002",
      "city": "Hatton-Northwood",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 877,
      "name": "Pi Rho 'botics @ North Star",
      "rookie_year": "2002",
      "city": "Cando",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 878,
      "name": "Metal Gear",
      "rookie_year": "2002",
      "city": "Rugby",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 879,
      "name": "Team 879",
      "rookie_year": "2002",
      "city": "New Town",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 880,
      "name": "Border Patrol",
      "rookie_year": "2002",
      "city": "Fairmount",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 881,
      "name": "Team 881",
      "rookie_year": "2002",
      "city": "Bismarck",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 883,
      "name": "Ironmen",
      "rookie_year": "2002",
      "city": "Cleveland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 884,
      "name": "Mechanical Mules",
      "rookie_year": "2002",
      "city": "Malverne",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 885,
      "name": "Ro-bovines",
      "rookie_year": "2002",
      "city": "Randolph Center",
      "state": "Vermont",
      "country": "USA",
      "district": ""
    },
    {
      "number": 886,
      "name": "Wildcats",
      "rookie_year": "2002",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 887,
      "name": "Team 887",
      "rookie_year": "2002",
      "city": "Goffstown",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 888,
      "name": "Robotiators",
      "rookie_year": "2002",
      "city": "Glenelg",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 889,
      "name": "The Cougars",
      "rookie_year": "2002",
      "city": "West Islip",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 891,
      "name": "Neverending Chaos",
      "rookie_year": "2002",
      "city": "Syracuse",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 892,
      "name": "Team ASCII",
      "rookie_year": "2002",
      "city": "Canal Winchester",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 894,
      "name": "The POWER CHARGERS",
      "rookie_year": "2002",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 896,
      "name": "Blue Steel",
      "rookie_year": "2002",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 897,
      "name": "Team 4",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 898,
      "name": "Team Desert Storm",
      "rookie_year": "2002",
      "city": "Glendale",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 899,
      "name": "Team 6",
      "rookie_year": "2002",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 900,
      "name": "The Zebracorns",
      "rookie_year": "2002",
      "city": "Durham",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 901,
      "name": "Team 8",
      "rookie_year": "2002",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 902,
      "name": "Delphi Heritage RoboHawks",
      "rookie_year": "2002",
      "city": "Saginaw",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 903,
      "name": "RoboTroopers",
      "rookie_year": "2002",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 904,
      "name": "D Cubed",
      "rookie_year": "2002",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 905,
      "name": "Platt Tech Panthers",
      "rookie_year": "2002",
      "city": "Milford",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 906,
      "name": "UMR",
      "rookie_year": "2002",
      "city": "Rolla",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 907,
      "name": "East York Cybernetics \"The Cybernauts\"",
      "rookie_year": "2002",
      "city": "East York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 908,
      "name": "Botz of Prey",
      "rookie_year": "2002",
      "city": "North Charleston",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 909,
      "name": "Junkyard Crew",
      "rookie_year": "2002",
      "city": "Lawrence",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 910,
      "name": "The Foley Freeze",
      "rookie_year": "2002",
      "city": "Madison Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 912,
      "name": "Iron Lyons",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 913,
      "name": "Bendale Robotics",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 914,
      "name": "NextGen",
      "rookie_year": "2002",
      "city": "Aurora",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 915,
      "name": "Team 915",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 917,
      "name": "Team 917",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 918,
      "name": "Team 918",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 919,
      "name": "Tiger Techs",
      "rookie_year": "2002",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 920,
      "name": "Team 920",
      "rookie_year": "2002",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 922,
      "name": "ULTIMATE:  United Longhorn Team Inspiring Mental Attitude Towards Engineering",
      "rookie_year": "2002",
      "city": "Laredo",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 925,
      "name": "Code Red",
      "rookie_year": "2002",
      "city": "China Grove",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 926,
      "name": "The Capacitors",
      "rookie_year": "2002",
      "city": "Raleigh",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 927,
      "name": "Team 927",
      "rookie_year": "2002",
      "city": "Reston",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 928,
      "name": "Hounds of Steel",
      "rookie_year": "2002",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 930,
      "name": "Mukwonago BEARs",
      "rookie_year": "2002",
      "city": "Mukwonago",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 931,
      "name": "Perpetual Chaos",
      "rookie_year": "2002",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 932,
      "name": "The Circuit Chargers",
      "rookie_year": "2002",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 933,
      "name": "Trigos",
      "rookie_year": "2002",
      "city": "Rockford",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 934,
      "name": "Team 934",
      "rookie_year": "2002",
      "city": "Lawrence",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 935,
      "name": "RaileRobotics",
      "rookie_year": "2002",
      "city": "Newton",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 936,
      "name": "Big Dogs",
      "rookie_year": "2002",
      "city": "Osborne",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 937,
      "name": "Nerd Herd",
      "rookie_year": "2002",
      "city": "Overland Park",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 938,
      "name": "Code Gold",
      "rookie_year": "2002",
      "city": "Richmond",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 939,
      "name": "Hiphopanonymous",
      "rookie_year": "2002",
      "city": "Sisseton",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 940,
      "name": "Digital Demolition",
      "rookie_year": "2002",
      "city": "Brookings",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 941,
      "name": "Arrow Robotics",
      "rookie_year": "2002",
      "city": "Watertown",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 942,
      "name": "Roboteers",
      "rookie_year": "2002",
      "city": "Woonsocket",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 943,
      "name": "Great Balls of Fire",
      "rookie_year": "2002",
      "city": "Volga",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 945,
      "name": "Team Banana",
      "rookie_year": "2002",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 946,
      "name": "Creepy Crafters",
      "rookie_year": "2002",
      "city": "Coral Springs",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 947,
      "name": "Hannibal Gear Gals",
      "rookie_year": "2002",
      "city": "Daytona Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 948,
      "name": "NRG (Newport Robotics Group)",
      "rookie_year": "2002",
      "city": "Bellevue",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 949,
      "name": "Wolverine Robotics",
      "rookie_year": "2002",
      "city": "Bellevue",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 950,
      "name": "Team 950",
      "rookie_year": "2002",
      "city": "Reno",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 953,
      "name": "Team Illuminati",
      "rookie_year": "2002",
      "city": "Reno",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 954,
      "name": "Scorpion Robotics",
      "rookie_year": "2002",
      "city": "Reno",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 955,
      "name": "CV Robotics",
      "rookie_year": "2002",
      "city": "Corvallis",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 956,
      "name": "Eagle Cybertechnology ",
      "rookie_year": "2002",
      "city": "Adair Village",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 957,
      "name": "SWARM - South and West Albany Robotics Maniacs",
      "rookie_year": "2002",
      "city": "Albany",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 959,
      "name": "Team 959",
      "rookie_year": "2002",
      "city": "Palmer",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 960,
      "name": "Circuit Breakers",
      "rookie_year": "2002",
      "city": "Anchorage",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 961,
      "name": "Buckaroo Brutes",
      "rookie_year": "2002",
      "city": "Winnemucca",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 962,
      "name": "Thunderbots",
      "rookie_year": "2002",
      "city": "Bullhead City",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 963,
      "name": "South Bulldogs Robotics",
      "rookie_year": "2002",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 964,
      "name": "Bearcat Robotics",
      "rookie_year": "2002",
      "city": "Bedford",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 966,
      "name": "Heights Tigers",
      "rookie_year": "2002",
      "city": "Cleveland Heights",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 967,
      "name": "Iron Lions",
      "rookie_year": "2002",
      "city": "Marion",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 968,
      "name": "RAWC (Robotics Alliance Of West Covina)",
      "rookie_year": "2002",
      "city": "West Covina",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 969,
      "name": "Hollis Lightning",
      "rookie_year": "2002",
      "city": "Lebanon",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 970,
      "name": "The Cardinals",
      "rookie_year": "2002",
      "city": "East Cleveland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 971,
      "name": "Spartan Robotics",
      "rookie_year": "2002",
      "city": "Mountain View",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 972,
      "name": "Iron Claw",
      "rookie_year": "2002",
      "city": "Los Gatos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 973,
      "name": "Greybots",
      "rookie_year": "2002",
      "city": "Atascadero",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 974,
      "name": "Nautae",
      "rookie_year": "2002",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 975,
      "name": "Synergy Robotics",
      "rookie_year": "2002",
      "city": "Midlothian",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 976,
      "name": "Circuit Breakerz",
      "rookie_year": "2002",
      "city": "Nottoway",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 977,
      "name": "Cometbots",
      "rookie_year": "2002",
      "city": "South Boston",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 979,
      "name": "Team 979",
      "rookie_year": "2002",
      "city": "Dayton",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 980,
      "name": "ThunderBots",
      "rookie_year": "2002",
      "city": "Sylmar",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 981,
      "name": "Snobotics",
      "rookie_year": "2002",
      "city": "Lebec",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 982,
      "name": "The Knights",
      "rookie_year": "2002",
      "city": "Sioux Falls",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 984,
      "name": "Team 984",
      "rookie_year": "2002",
      "city": "Wellesley",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 987,
      "name": "HIGHROLLERS",
      "rookie_year": "2002",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 988,
      "name": "Steel Phoenix",
      "rookie_year": "2002",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 989,
      "name": "Palo",
      "rookie_year": "2002",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 990,
      "name": "The Deadly Viper Assassination Squad",
      "rookie_year": "2002",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 991,
      "name": "BroncoBotics",
      "rookie_year": "2002",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 992,
      "name": "Oakwood Robotics",
      "rookie_year": "2002",
      "city": "North Hollywood",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 995,
      "name": "Monkey Wrenchers",
      "rookie_year": "2002",
      "city": "Alhambra",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 996,
      "name": "Mecha Knights",
      "rookie_year": "2002",
      "city": "Casa Grande",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 997,
      "name": "Spartan Robotics",
      "rookie_year": "2002",
      "city": "Corvallis",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 998,
      "name": "The Overcookers",
      "rookie_year": "2002",
      "city": "Soldotna",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 999,
      "name": "MechaRAMS",
      "rookie_year": "2002",
      "city": "Cheshire",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1000,
      "name": "Cybearcats",
      "rookie_year": "2003",
      "city": "Valparaiso",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1001,
      "name": "Hacksaw",
      "rookie_year": "2003",
      "city": "Lyndhurst",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1002,
      "name": "CircuitRunners Robotics",
      "rookie_year": "2003",
      "city": "Marietta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1005,
      "name": "Chaminade Robotics",
      "rookie_year": "2003",
      "city": "St. Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1006,
      "name": "Fast Eddie Robotics",
      "rookie_year": "2003",
      "city": "Port Perry",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1007,
      "name": "The Tyrants",
      "rookie_year": "2003",
      "city": "Snellville",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1008,
      "name": "Team Lugnut",
      "rookie_year": "2003",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1009,
      "name": "Bolt Action",
      "rookie_year": "2003",
      "city": "North York",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1010,
      "name": "B.C. Hawks",
      "rookie_year": "2003",
      "city": "Ortonville",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1011,
      "name": "CRUSH",
      "rookie_year": "2003",
      "city": "Tucson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1013,
      "name": "The Phoenix",
      "rookie_year": "2003",
      "city": "Queen Creek",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1014,
      "name": "Bad Robots",
      "rookie_year": "2003",
      "city": "Dublin",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1015,
      "name": "Pi Hi Samurai",
      "rookie_year": "2003",
      "city": "Ann Arbor",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1016,
      "name": "Evolution",
      "rookie_year": "2003",
      "city": "Darlington",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1017,
      "name": "Home Advantage",
      "rookie_year": "2003",
      "city": "Flint",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1018,
      "name": "Pike RoboDevils",
      "rookie_year": "2003",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1019,
      "name": "Sons Of The Beach",
      "rookie_year": "2003",
      "city": "Westhampton Beach",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1020,
      "name": "The Prank Monkeys",
      "rookie_year": "2003",
      "city": "Muncie",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1022,
      "name": "Archer GEeks",
      "rookie_year": "2003",
      "city": "Fort Wayne",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1023,
      "name": "Bedford Express",
      "rookie_year": "2003",
      "city": "Temperance",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1024,
      "name": "Kil-A-Bytes",
      "rookie_year": "2003",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1025,
      "name": "IMPI Robotics",
      "rookie_year": "2003",
      "city": "Ferndale",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1026,
      "name": "Cougars",
      "rookie_year": "2003",
      "city": "York",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1027,
      "name": "Mechatronic Maniacs",
      "rookie_year": "2003",
      "city": "West Springfield",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1028,
      "name": "UBERGEEKS",
      "rookie_year": "2003",
      "city": "Huntsville",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1029,
      "name": "Wolverine Robotics",
      "rookie_year": "2003",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1030,
      "name": "Combined Minds",
      "rookie_year": "2003",
      "city": "Groveport",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1031,
      "name": "The Boilermakers",
      "rookie_year": "2003",
      "city": "San Francisco",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1033,
      "name": "Team CLUTCH",
      "rookie_year": "2003",
      "city": "Richmond",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1034,
      "name": "Eclipse",
      "rookie_year": "2003",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1035,
      "name": "T12",
      "rookie_year": "2003",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1036,
      "name": "Central Tech Robotics",
      "rookie_year": "2003",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1037,
      "name": "The SCREAM Team",
      "rookie_year": "2003",
      "city": "Rochester Hills",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1038,
      "name": "Lakota Robotics",
      "rookie_year": "2003",
      "city": "Liberty Township",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1039,
      "name": "Chief Sealth Robotics",
      "rookie_year": "2003",
      "city": "Seattle",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1040,
      "name": "Pythons",
      "rookie_year": "2003",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1041,
      "name": "Impending Disaster",
      "rookie_year": "2003",
      "city": "Austell",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1042,
      "name": "Team 1042",
      "rookie_year": "2003",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1043,
      "name": "Batteries Not Included",
      "rookie_year": "2003",
      "city": "San Jose",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1045,
      "name": "MSJ Robotics",
      "rookie_year": "2003",
      "city": "Fremont",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1046,
      "name": "Aztechs",
      "rookie_year": "2003",
      "city": "Palm Desert",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1047,
      "name": "Team Echoes",
      "rookie_year": "2003",
      "city": "Irvine",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1048,
      "name": "Mustang Robotics",
      "rookie_year": "2003",
      "city": "Manville",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1049,
      "name": "Archangel Robotics",
      "rookie_year": "2003",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1051,
      "name": "Technical Terminators",
      "rookie_year": "2003",
      "city": "Mullins",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1052,
      "name": "Team 1052",
      "rookie_year": "2003",
      "city": "Pinole",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1053,
      "name": "Gears of Glebe",
      "rookie_year": "2003",
      "city": "Ottawa",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1054,
      "name": "Knightmares",
      "rookie_year": "2003",
      "city": "Buckingham",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1055,
      "name": "Frank's Garage",
      "rookie_year": "2003",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1056,
      "name": "Hot Rocks",
      "rookie_year": "2003",
      "city": "Hilo",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1057,
      "name": "The Blue Knights",
      "rookie_year": "2003",
      "city": "Sandersville",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1058,
      "name": "PVC Pirates",
      "rookie_year": "2003",
      "city": "Londonderry",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1059,
      "name": "Team 1059",
      "rookie_year": "2003",
      "city": "Simsbury",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1060,
      "name": "Dust Devils",
      "rookie_year": "2003",
      "city": "Mohave Valley",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1062,
      "name": "Storm Troopers",
      "rookie_year": "2003",
      "city": "Celebration",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1063,
      "name": "Team MG",
      "rookie_year": "2003",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1064,
      "name": "Wild Beast",
      "rookie_year": "2003",
      "city": "South Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1065,
      "name": "The Moose",
      "rookie_year": "2003",
      "city": "Kissimmee",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1067,
      "name": "Junior Billikens",
      "rookie_year": "2003",
      "city": "Saint Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1068,
      "name": "The Ninjaneers",
      "rookie_year": "2003",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1069,
      "name": "Technobots",
      "rookie_year": "2003",
      "city": "Greer",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1070,
      "name": "Royal Robotrons",
      "rookie_year": "2003",
      "city": "Woodland Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1071,
      "name": "Team MAX",
      "rookie_year": "2003",
      "city": "Wolcott",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1072,
      "name": "Harker Robotics",
      "rookie_year": "2003",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1073,
      "name": "The Force Team",
      "rookie_year": "2003",
      "city": "Hollis",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1074,
      "name": "Team 1074",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 1075,
      "name": "Sprockets",
      "rookie_year": "2003",
      "city": "Whitby",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1076,
      "name": "Pi Hi Samurai",
      "rookie_year": "2003",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1077,
      "name": "All Stars",
      "rookie_year": "2003",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1079,
      "name": "Chaparral Robotic Eng And Tech Explorers Murrieta Amazing Grace Inventors Coalit",
      "rookie_year": "2003",
      "city": "Temecula",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1080,
      "name": "Resurgence Robotics",
      "rookie_year": "2003",
      "city": "Henrico",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1081,
      "name": "Tech Warriors",
      "rookie_year": "2003",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1082,
      "name": "Railroaders",
      "rookie_year": "2003",
      "city": "Sparks",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1083,
      "name": "Team Emoticons",
      "rookie_year": "2003",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1084,
      "name": "IronColts",
      "rookie_year": "2003",
      "city": "Sarnia",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1085,
      "name": "Aquatic Robotics",
      "rookie_year": "2003",
      "city": "Avon",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1086,
      "name": "Blue Cheese",
      "rookie_year": "2003",
      "city": "Glen Allen",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1087,
      "name": "Titronics Digerati",
      "rookie_year": "2003",
      "city": "Salem",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1088,
      "name": "Scarborough Warriors At The Top",
      "rookie_year": "2003",
      "city": "West Hill / Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1089,
      "name": "Team Mercury",
      "rookie_year": "2003",
      "city": "Hightstown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1090,
      "name": "Team 1090",
      "rookie_year": "2003",
      "city": "St Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1091,
      "name": "Oriole Assault",
      "rookie_year": "2003",
      "city": "Hartford",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1092,
      "name": "The Rabid Rabbits",
      "rookie_year": "2003",
      "city": "Smyrna",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1093,
      "name": "Cougars",
      "rookie_year": "2003",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1094,
      "name": "Channel Cats",
      "rookie_year": "2003",
      "city": "O Fallon",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1095,
      "name": "Metal Minds",
      "rookie_year": "2003",
      "city": "Chatham",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1096,
      "name": "ZULU",
      "rookie_year": "2003",
      "city": "Radford",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1097,
      "name": "Site 3 Engineering",
      "rookie_year": "2003",
      "city": "Carmichael",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1098,
      "name": "Rockwood Robotics \"Rock-Bots\"",
      "rookie_year": "2003",
      "city": "Wildwood",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1099,
      "name": "DiscoTechs",
      "rookie_year": "2003",
      "city": "Brookfield",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1100,
      "name": "Inverse Polarity",
      "rookie_year": "2003",
      "city": "Northborough/Southborough",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1101,
      "name": "Mustangs",
      "rookie_year": "2003",
      "city": "Surrey",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1102,
      "name": "M'Aiken Magic",
      "rookie_year": "2003",
      "city": "Aiken",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1103,
      "name": "Frankenbots",
      "rookie_year": "2003",
      "city": "Delavan",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1104,
      "name": "TechnoEagles",
      "rookie_year": "2003",
      "city": "Axtell",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1105,
      "name": "The Prep",
      "rookie_year": "2003",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1106,
      "name": "patriots",
      "rookie_year": "2003",
      "city": "Mayville",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1108,
      "name": "Panther Robotics",
      "rookie_year": "2003",
      "city": "Paola",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1109,
      "name": "The RoboHawks",
      "rookie_year": "2003",
      "city": "Lively",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1110,
      "name": "Binary Bulldogs",
      "rookie_year": "2003",
      "city": "Palmdale",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1111,
      "name": "Power Hawks Robotics",
      "rookie_year": "2003",
      "city": "Edgewater",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1112,
      "name": "Huskies",
      "rookie_year": "2003",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1113,
      "name": "Urban Assault",
      "rookie_year": "2003",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1114,
      "name": "Simbotics",
      "rookie_year": "2003",
      "city": "St Catharines",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1115,
      "name": "Deus Ex Machina",
      "rookie_year": "2003",
      "city": "Santa Monica",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1116,
      "name": "Team 1116",
      "rookie_year": "2003",
      "city": "La Puente",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1118,
      "name": "NERDS INC.",
      "rookie_year": "2003",
      "city": "Knoxville",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1120,
      "name": "Milpitas Xtreme Robotics",
      "rookie_year": "2003",
      "city": "Milpitas",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1122,
      "name": "Railbots",
      "rookie_year": "2003",
      "city": "Cleveland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1123,
      "name": "AIM \u26df Robotics",
      "rookie_year": "2003",
      "city": "Fairfax",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1124,
      "name": "UberBots",
      "rookie_year": "2003",
      "city": "Avon",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1125,
      "name": "Broncos",
      "rookie_year": "2003",
      "city": "San Diego",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1126,
      "name": "SPARX",
      "rookie_year": "2003",
      "city": "Webster",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1127,
      "name": "Lotus Robotics",
      "rookie_year": "2003",
      "city": "Milton",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1129,
      "name": "Team 1129",
      "rookie_year": "2003",
      "city": "Montreal",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1130,
      "name": "Phantoms ",
      "rookie_year": "2003",
      "city": "Albany",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1131,
      "name": "Robo-Techs",
      "rookie_year": "2003",
      "city": "Hagerstown",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1132,
      "name": "R.A.P.T.A.R. (Robotics Adventure Professionals of Tidewater and Richmond)",
      "rookie_year": "2003",
      "city": "Ashland",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1133,
      "name": "The Hug A Bots",
      "rookie_year": "2003",
      "city": "Reno",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1135,
      "name": "Schmoebotics",
      "rookie_year": "2003",
      "city": "Cerritos",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1136,
      "name": "Nutty Genius's",
      "rookie_year": "2003",
      "city": "Spring Valley",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1137,
      "name": "Rocket Sauce",
      "rookie_year": "2003",
      "city": "Mathews",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1138,
      "name": "Eagle Engineering",
      "rookie_year": "2003",
      "city": "West Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1139,
      "name": "The Chamblee Gear Grinders",
      "rookie_year": "2003",
      "city": "Chamblee",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1140,
      "name": "MAGNADON",
      "rookie_year": "2003",
      "city": "Holly",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1141,
      "name": "TAS Megawatts",
      "rookie_year": "2003",
      "city": "Peterborough",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1142,
      "name": "SH Robo Uknighted",
      "rookie_year": "2003",
      "city": "Daytona Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1143,
      "name": "Cruzin' Comets",
      "rookie_year": "2003",
      "city": "Clarks Summit",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1144,
      "name": "COQUITRON",
      "rookie_year": "2003",
      "city": "San Lorenzo",
      "state": "Puerto Rico",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1146,
      "name": "Magic",
      "rookie_year": "2003",
      "city": "Labrador City",
      "state": "NL",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1147,
      "name": "The Herdinators",
      "rookie_year": "2003",
      "city": "Elk Grove",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1148,
      "name": "Wafflebots",
      "rookie_year": "2003",
      "city": "Studio City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1149,
      "name": "T. O. Robotics",
      "rookie_year": "2003",
      "city": "Thousand Oaks",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1150,
      "name": "Storm System",
      "rookie_year": "2003",
      "city": "Camp Verde",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1151,
      "name": "The Hitchhikers",
      "rookie_year": "2003",
      "city": "San Pablo",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1152,
      "name": "Blue Stars",
      "rookie_year": "2003",
      "city": "Hyde Park",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1153,
      "name": "Timberwolves",
      "rookie_year": "2003",
      "city": "Walpole",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1154,
      "name": "Harrisonburg High School Blue Streaks",
      "rookie_year": "2003",
      "city": "Harrisonburburg",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1155,
      "name": "SciBorgs",
      "rookie_year": "2003",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1156,
      "name": "Under Control",
      "rookie_year": "2003",
      "city": "Novo Hamburgo",
      "state": "Rio Grande do Sul",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 1157,
      "name": "Landsharks",
      "rookie_year": "2003",
      "city": "Boulder",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1158,
      "name": "The Corps",
      "rookie_year": "2003",
      "city": "Collbran",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1159,
      "name": "Ramona Rampage",
      "rookie_year": "2003",
      "city": "Alhambra",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1160,
      "name": "Titanium Robotics",
      "rookie_year": "2003",
      "city": "San Marino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1161,
      "name": "Highland 1",
      "rookie_year": "2003",
      "city": "Brighton",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1162,
      "name": "The Robotics Team",
      "rookie_year": "2003",
      "city": "Canutillo",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1163,
      "name": "Trojan Horses",
      "rookie_year": "2003",
      "city": "Faulkton",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1164,
      "name": "Project NEO",
      "rookie_year": "2003",
      "city": "Las Cruces",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 1165,
      "name": "Team Paradise",
      "rookie_year": "2003",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1166,
      "name": "Highlander Robotics",
      "rookie_year": "2003",
      "city": "Garden City",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1167,
      "name": "Knightmares",
      "rookie_year": "2003",
      "city": "Savannah",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1168,
      "name": "Malvern Robotics",
      "rookie_year": "2003",
      "city": "Malvern",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1169,
      "name": "Fairbanks Robarctics",
      "rookie_year": "2003",
      "city": "Fairbanks",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1172,
      "name": "We Tek Too",
      "rookie_year": "2003",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1177,
      "name": "MECHA-JAGS",
      "rookie_year": "2003",
      "city": "Stone Mountain",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1178,
      "name": "DURT  (De Smet Ultimate Robotics Team)",
      "rookie_year": "2003",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1180,
      "name": "Atomsmashers",
      "rookie_year": "2003",
      "city": "Thunderbolt",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1181,
      "name": "St Francis of Assisi Team 1",
      "rookie_year": "2003",
      "city": "Gilbert",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1182,
      "name": "Patriots",
      "rookie_year": "2003",
      "city": "Manchester",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1183,
      "name": "the peasants",
      "rookie_year": "2003",
      "city": "Suwanee",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1184,
      "name": "Cobra Robotics",
      "rookie_year": "2003",
      "city": "Bel Air",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1185,
      "name": "The X-Bots",
      "rookie_year": "2003",
      "city": "Pittsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1187,
      "name": "Brick City Flame",
      "rookie_year": "2003",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1188,
      "name": "Ravens",
      "rookie_year": "2003",
      "city": "Royal Oak",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1189,
      "name": "The Gearheads",
      "rookie_year": "2003",
      "city": "Grosse Pointe",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1190,
      "name": "ANONOBOTS",
      "rookie_year": "2003",
      "city": "Aurora",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1191,
      "name": "Eagles",
      "rookie_year": "2003",
      "city": "Pittsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1192,
      "name": "Team 1192",
      "rookie_year": "2003",
      "city": "Land O Lakes",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1195,
      "name": "S.O.A.R. (Students of Applied Robotics)",
      "rookie_year": "2003",
      "city": "Springdale",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1197,
      "name": "TorBots",
      "rookie_year": "2003",
      "city": "Torrance",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1199,
      "name": "Team 1199",
      "rookie_year": "2003",
      "city": "Pittsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1200,
      "name": "Team 1200",
      "rookie_year": "2003",
      "city": "New Stanton",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1201,
      "name": "CSI:Monroe",
      "rookie_year": "2003",
      "city": "Aberdeen",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1202,
      "name": "Ranger Robotics",
      "rookie_year": "2003",
      "city": "Sidman",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1203,
      "name": "PANDEMONIUM",
      "rookie_year": "2003",
      "city": "West Babylon",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1204,
      "name": "Eagles",
      "rookie_year": "2003",
      "city": "Lakewood",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1205,
      "name": "Badgerbots",
      "rookie_year": "2003",
      "city": "Bruni",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1206,
      "name": "Wrench Warriors",
      "rookie_year": "2003",
      "city": "Fairview Park",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1208,
      "name": "Metool Brigade",
      "rookie_year": "2003",
      "city": "O Fallon",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1209,
      "name": "Robo Hornets",
      "rookie_year": "2003",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1210,
      "name": "Team TACKLE",
      "rookie_year": "2003",
      "city": "St Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1211,
      "name": "Robotnics",
      "rookie_year": "2003",
      "city": "Brooklyn",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1212,
      "name": "Sentinels",
      "rookie_year": "2003",
      "city": "Chandler",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1213,
      "name": "GROVES",
      "rookie_year": "2003",
      "city": "Beverly  Hills",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1214,
      "name": "The Grizzlies",
      "rookie_year": "2003",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1215,
      "name": "Machine Tool",
      "rookie_year": "2003",
      "city": "Washington",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1216,
      "name": "Knights",
      "rookie_year": "2003",
      "city": "Oak Park",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1218,
      "name": "SCH Robotics",
      "rookie_year": "2003",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1219,
      "name": "Iron Eagles",
      "rookie_year": "2003",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1220,
      "name": "Team 1220",
      "rookie_year": "2003",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1221,
      "name": "Nerdbotics",
      "rookie_year": "2003",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1222,
      "name": "Falcons",
      "rookie_year": "2003",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1223,
      "name": "Twisted Dimension",
      "rookie_year": "2003",
      "city": "Mesa",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1224,
      "name": "Team 1224 - The Pius Princesses",
      "rookie_year": "2003",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1225,
      "name": "The Gorillas",
      "rookie_year": "2003",
      "city": "Hendersonville",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 1226,
      "name": "Team 1226",
      "rookie_year": "2003",
      "city": "Farmingdale",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1227,
      "name": "Techno-Gremlins",
      "rookie_year": "2003",
      "city": "Grand Rapids",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1228,
      "name": "RoboTribe",
      "rookie_year": "2003",
      "city": "Rahway",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1229,
      "name": "MASA",
      "rookie_year": "2003",
      "city": "Windsor",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1230,
      "name": "The Lehman Lionics",
      "rookie_year": "2003",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1232,
      "name": "RAMS ROBOTICS",
      "rookie_year": "2003",
      "city": "Stratford",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1235,
      "name": "Maximum Strength",
      "rookie_year": "2003",
      "city": "Columbus",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1236,
      "name": "Phoenix Rising",
      "rookie_year": "2003",
      "city": "Danville",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1237,
      "name": "Cybernetic Panthers",
      "rookie_year": "2003",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1238,
      "name": "EcoRobotics",
      "rookie_year": "2003",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1239,
      "name": "Vita Dogs",
      "rookie_year": "2004",
      "city": "Olmsted Falls",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1240,
      "name": "Sappers",
      "rookie_year": "2004",
      "city": "Manitowoc",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1241,
      "name": "THEORY6",
      "rookie_year": "2004",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1242,
      "name": "Team S.M.I.L.E.Y",
      "rookie_year": "2004",
      "city": "Plantation",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1243,
      "name": "Dragons",
      "rookie_year": "2004",
      "city": "Swartz Creek",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1244,
      "name": "Viking Robotics",
      "rookie_year": "2004",
      "city": "Goderich",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1245,
      "name": "Monarch Robotics",
      "rookie_year": "2004",
      "city": "Louisville",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1246,
      "name": "Agincourt Skunkworks",
      "rookie_year": "2004",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1247,
      "name": "Blood, Sweat, and Gears",
      "rookie_year": "2004",
      "city": "North Sutton",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1248,
      "name": "TITANium Allies",
      "rookie_year": "2004",
      "city": "Berea",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1249,
      "name": "Robo Rats",
      "rookie_year": "2004",
      "city": "Delbarton",
      "state": "West Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1250,
      "name": "Gator-Bots",
      "rookie_year": "2004",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1251,
      "name": "TechTigers Robotics",
      "rookie_year": "2004",
      "city": "Tamarac",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1254,
      "name": "Tech Force",
      "rookie_year": "2004",
      "city": "Lawrence",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1255,
      "name": "Blarglefish",
      "rookie_year": "2004",
      "city": "Baytown",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 1256,
      "name": "Highlanders",
      "rookie_year": "2004",
      "city": "Howell",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1257,
      "name": "Parallel Universe",
      "rookie_year": "2004",
      "city": "Scotch Plains",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1258,
      "name": "SeaBot",
      "rookie_year": "2004",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1259,
      "name": "Paradigm Shift",
      "rookie_year": "2004",
      "city": "Pewaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1260,
      "name": "Panthers",
      "rookie_year": "2004",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1261,
      "name": "Robo Lions",
      "rookie_year": "2004",
      "city": "Suwanee",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1262,
      "name": "the STAGS",
      "rookie_year": "2004",
      "city": "Martinsville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1263,
      "name": "Austin High School/Marshall Space Flight Center",
      "rookie_year": "2004",
      "city": "Decatur",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1266,
      "name": "The Devil Duckies",
      "rookie_year": "2004",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1268,
      "name": "Purgolder Robotics",
      "rookie_year": "2004",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1270,
      "name": "Red Dragons",
      "rookie_year": "2004",
      "city": "Cleveland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1272,
      "name": "Tyrannikal Mechanikal",
      "rookie_year": "2004",
      "city": "Bloomington",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1274,
      "name": "Wolf Bytes",
      "rookie_year": "2004",
      "city": "Berea",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1275,
      "name": "Pi-Robots",
      "rookie_year": "2004",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1276,
      "name": "Kaizen Blitz",
      "rookie_year": "2004",
      "city": "Rockland",
      "state": "ME",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1277,
      "name": "The Robotomies",
      "rookie_year": "2004",
      "city": "Groton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1278,
      "name": "B.E.A.R.S",
      "rookie_year": "2004",
      "city": "North Royalton",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1279,
      "name": "Cold Fusion",
      "rookie_year": "2004",
      "city": "Somerville",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1280,
      "name": "Ragin' C-Biscuits",
      "rookie_year": "2004",
      "city": "Danville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1281,
      "name": "Mustang Robotics",
      "rookie_year": "2004",
      "city": "Richmond Hill",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1284,
      "name": "DART",
      "rookie_year": "2004",
      "city": "Guntersville",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1285,
      "name": "The Big Bang",
      "rookie_year": "2004",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1286,
      "name": "Kevlar Cranes",
      "rookie_year": "2004",
      "city": "Royal Oak",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1287,
      "name": "Aluminum Assault",
      "rookie_year": "2004",
      "city": "Myrtle Beach",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1288,
      "name": "RAVEN Robotics",
      "rookie_year": "2004",
      "city": "Saint Charles",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1289,
      "name": "Gearheadz",
      "rookie_year": "2004",
      "city": "Lawrence",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1290,
      "name": "Robowolves",
      "rookie_year": "2004",
      "city": "Chandler",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1291,
      "name": "Circuit Breakers",
      "rookie_year": "2004",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1292,
      "name": "RNS Joysticks",
      "rookie_year": "2004",
      "city": "Rothesay",
      "state": "NB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1293,
      "name": "Pandamaniacs",
      "rookie_year": "2004",
      "city": "Columbia",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1294,
      "name": "Pack of Parts",
      "rookie_year": "2004",
      "city": "Sammamish",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1295,
      "name": "The Golems",
      "rookie_year": "2004",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1296,
      "name": "Full Metal Jackets",
      "rookie_year": "2004",
      "city": "Rockwall",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 1297,
      "name": "Team 1297",
      "rookie_year": "2004",
      "city": "Sylacauga",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1298,
      "name": "205 Terminators",
      "rookie_year": "2004",
      "city": "Birmingham",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1299,
      "name": "Dominators",
      "rookie_year": "2004",
      "city": "Jasper",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1300,
      "name": "EVO",
      "rookie_year": "2004",
      "city": "Oakville",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1301,
      "name": "The Robotic Raiders",
      "rookie_year": "2004",
      "city": "Seattle",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1302,
      "name": "Team Lionheart",
      "rookie_year": "2004",
      "city": "Sparta",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1303,
      "name": "WYOHAZARD",
      "rookie_year": "2004",
      "city": "Casper",
      "state": "Wyoming",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1304,
      "name": "N.O. Botics",
      "rookie_year": "2004",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1305,
      "name": "Ice Cubed",
      "rookie_year": "2004",
      "city": "North Bay",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1306,
      "name": "BadgerBOTS",
      "rookie_year": "2004",
      "city": "Middleton",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1307,
      "name": "Robosaints",
      "rookie_year": "2004",
      "city": "Dover",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1308,
      "name": "Saint Ignatius Robotics Team 1308",
      "rookie_year": "2004",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1309,
      "name": "Diamond Eagles",
      "rookie_year": "2004",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1310,
      "name": "Runnymede Robotics",
      "rookie_year": "2004",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1311,
      "name": "Kell Robotics",
      "rookie_year": "2004",
      "city": "Marietta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1312,
      "name": "Syntax Error",
      "rookie_year": "2004",
      "city": "Walkerton",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1315,
      "name": "Robo-Knights",
      "rookie_year": "2004",
      "city": "Pacific",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1317,
      "name": "Digital Fusion",
      "rookie_year": "2004",
      "city": "Westerville",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1318,
      "name": "Issaquah Robotics Society",
      "rookie_year": "2004",
      "city": "Issaquah",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1319,
      "name": "Flash",
      "rookie_year": "2004",
      "city": "Mauldin",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1320,
      "name": "\"Beltway: The Learning Machine\"",
      "rookie_year": "2004",
      "city": "St. Stephen",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1322,
      "name": "Genesee Robotics Area Youth Team (GRAYT)",
      "rookie_year": "2004",
      "city": "Fenton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1323,
      "name": "MadTown Robotics",
      "rookie_year": "2004",
      "city": "Madera",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1324,
      "name": "Sporks",
      "rookie_year": "2004",
      "city": "Sedona",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1325,
      "name": "Inverse Paradox",
      "rookie_year": "2004",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1326,
      "name": "Cy-Ridge Robotics",
      "rookie_year": "2004",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1327,
      "name": "SBOTZ",
      "rookie_year": "2004",
      "city": "South Bend",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1329,
      "name": "ViPrs",
      "rookie_year": "2004",
      "city": "St. Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1330,
      "name": "Quiet Riot",
      "rookie_year": "2004",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1331,
      "name": "Broot Force",
      "rookie_year": "2004",
      "city": "Bloomington",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1332,
      "name": "SWIFT",
      "rookie_year": "2004",
      "city": "Collbran",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1334,
      "name": "Red Devils",
      "rookie_year": "2004",
      "city": "Oakville",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1335,
      "name": "Cognitive Hazard",
      "rookie_year": "2004",
      "city": "Raymond",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1336,
      "name": "The Untouchables",
      "rookie_year": "2004",
      "city": "Lexington",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1337,
      "name": "Team 1337",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 1338,
      "name": "Birds of Prey",
      "rookie_year": "2004",
      "city": "Aurora",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1339,
      "name": "AngelBotics",
      "rookie_year": "2004",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1340,
      "name": "Spartan Robotics",
      "rookie_year": "2004",
      "city": "Queens",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1341,
      "name": "The Renegades",
      "rookie_year": "2004",
      "city": "Sarasota",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1342,
      "name": "Lord of the Bots",
      "rookie_year": "2004",
      "city": "Seattle",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1343,
      "name": "DV ROBOTICS",
      "rookie_year": "2004",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1345,
      "name": "Platinum Dragons",
      "rookie_year": "2004",
      "city": "Ft. Lauderdale",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1346,
      "name": "Trobotics",
      "rookie_year": "2004",
      "city": "Vancouver",
      "state": "BC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1347,
      "name": "E-Robotics",
      "rookie_year": "2004",
      "city": "Ottawa",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1348,
      "name": "Electric Anarchy",
      "rookie_year": "2004",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1349,
      "name": "Inter-tribal Robotics Group",
      "rookie_year": "2004",
      "city": "Flandreau",
      "state": "SD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1350,
      "name": "The Rambots",
      "rookie_year": "2004",
      "city": "Providence",
      "state": "Rhode Island",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1351,
      "name": "TKO",
      "rookie_year": "2004",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1352,
      "name": "Huskie Robotics",
      "rookie_year": "2004",
      "city": "Stratford",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1353,
      "name": "The Spartans",
      "rookie_year": "2004",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1355,
      "name": "Stallions",
      "rookie_year": "2004",
      "city": "Wingham",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1356,
      "name": "\u00c9coles secondaires l'Essor et Lajeunesse",
      "rookie_year": "2004",
      "city": "Tecumseh",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1357,
      "name": "High Voltage",
      "rookie_year": "2004",
      "city": "Loveland",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1358,
      "name": "The Generals",
      "rookie_year": "2004",
      "city": "Levittown",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1359,
      "name": "Scalawags",
      "rookie_year": "2004",
      "city": "Lebanon",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1360,
      "name": "Orbit Robotics",
      "rookie_year": "2004",
      "city": "Oakville",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1361,
      "name": "Nightmare Robotics",
      "rookie_year": "2004",
      "city": "Colorado Springs",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1364,
      "name": "Team 1364",
      "rookie_year": "2004",
      "city": "Kennesaw",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1365,
      "name": "The Bot Docs",
      "rookie_year": "2004",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1366,
      "name": "Roughriders",
      "rookie_year": "2004",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1367,
      "name": "Blue Bears",
      "rookie_year": "2004",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1368,
      "name": "Perpetual Motion",
      "rookie_year": "2004",
      "city": "Clearwater",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1369,
      "name": "Minotaur",
      "rookie_year": "2004",
      "city": "Tampa",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1370,
      "name": "Thermogenesis",
      "rookie_year": "2004",
      "city": "Middletown",
      "state": "Delaware",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1371,
      "name": "Cosmic Gold",
      "rookie_year": "2004",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1372,
      "name": "Lambda^3",
      "rookie_year": "2004",
      "city": "San Diego",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1373,
      "name": "Spontaneous Combustion",
      "rookie_year": "2004",
      "city": "Storrs",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1374,
      "name": "Amped Up",
      "rookie_year": "2004",
      "city": "Oakville",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 1375,
      "name": "Trobots",
      "rookie_year": "2004",
      "city": "Aurora",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1376,
      "name": "The Spaceballs",
      "rookie_year": "2004",
      "city": "Snellville",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1377,
      "name": "Adams 12 Aliens",
      "rookie_year": "2004",
      "city": "Thornton",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1378,
      "name": "Hilo Viking Robotics (HVR 1378)",
      "rookie_year": "2004",
      "city": "Hilo",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1379,
      "name": "Gear Devils",
      "rookie_year": "2004",
      "city": "Norcross",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1380,
      "name": "Steel Dragons",
      "rookie_year": "2004",
      "city": "Lilburn",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1382,
      "name": "ETEP Team",
      "rookie_year": "2004",
      "city": "S\u00e3o Jos\u00e9 dos Campos",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 1384,
      "name": "Vineland High School Fighting Clan",
      "rookie_year": "2004",
      "city": "Vineland",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1385,
      "name": "The Brainstormers",
      "rookie_year": "2004",
      "city": "Waterloo",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1386,
      "name": "The Trobots",
      "rookie_year": "2004",
      "city": "Canton",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1387,
      "name": "Rudy's Rangers",
      "rookie_year": "2004",
      "city": "Fair Oaks",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1388,
      "name": "Eagle Robotics",
      "rookie_year": "2004",
      "city": "Arroyo Grande",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1389,
      "name": "The Body Electric",
      "rookie_year": "2004",
      "city": "Bethesda",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1390,
      "name": "MEKHEADS",
      "rookie_year": "2004",
      "city": "St. Cloud & Harmony",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1391,
      "name": "The Metal Moose",
      "rookie_year": "2004",
      "city": "West Chester",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1392,
      "name": "KINEMATRIX",
      "rookie_year": "2004",
      "city": "Ajax",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1393,
      "name": "Nordic Legions",
      "rookie_year": "2004",
      "city": "Albuquerque",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1394,
      "name": "The Juggernaut",
      "rookie_year": "2004",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1395,
      "name": "Los Picachos",
      "rookie_year": "2004",
      "city": "Commerce City",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1396,
      "name": "Pyrobots",
      "rookie_year": "2004",
      "city": "Staten Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1397,
      "name": "Oh!  know",
      "rookie_year": "2004",
      "city": "Ajax",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1398,
      "name": "Robo-Raiders",
      "rookie_year": "2004",
      "city": "Columbia",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1401,
      "name": "Mekanicats",
      "rookie_year": "2004",
      "city": "Naucalpan",
      "state": "MEX",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 1402,
      "name": "Freedom FORCE",
      "rookie_year": "2004",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1403,
      "name": "Cougar Robotics",
      "rookie_year": "2004",
      "city": "Skillman",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1404,
      "name": "Shocks",
      "rookie_year": "2004",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1405,
      "name": "Finney Falcons",
      "rookie_year": "2004",
      "city": "Penfield",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1406,
      "name": "Team Robius",
      "rookie_year": "2004",
      "city": "Roswell",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1407,
      "name": "The ElectroCats",
      "rookie_year": "2004",
      "city": "Winder",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1408,
      "name": "The Saintinators",
      "rookie_year": "2004",
      "city": "Edgewater",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1409,
      "name": "Team 1409",
      "rookie_year": "2004",
      "city": "Great Barrington",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1410,
      "name": "The Kraken",
      "rookie_year": "2004",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1411,
      "name": "Trojens",
      "rookie_year": "2004",
      "city": "Brampton",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1412,
      "name": "The Comet Warriors",
      "rookie_year": "2004",
      "city": "Hackensack",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1413,
      "name": "Skrappy 1413",
      "rookie_year": "2004",
      "city": "Skipwith",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1414,
      "name": "IHOT",
      "rookie_year": "2004",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1415,
      "name": "The Flying Pumpkins",
      "rookie_year": "2004",
      "city": "Columbus",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1416,
      "name": "Overlake Robotics Branch",
      "rookie_year": "2004",
      "city": "Redmond",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1417,
      "name": "Titans",
      "rookie_year": "2004",
      "city": "Roanoke",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1418,
      "name": "Vae Victis",
      "rookie_year": "2004",
      "city": "Falls Church",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1419,
      "name": "Rustic Roboteers",
      "rookie_year": "2004",
      "city": "Courtice",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1420,
      "name": "Dept. of Exceptional Robots",
      "rookie_year": "2004",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1421,
      "name": "Team Chaos",
      "rookie_year": "2004",
      "city": "Picayune",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1422,
      "name": "The Neon Knights",
      "rookie_year": "2004",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1425,
      "name": "Error Code Xero",
      "rookie_year": "2004",
      "city": "Wilsonville",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1426,
      "name": "Cougartronics",
      "rookie_year": "2004",
      "city": "Las Cruces",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1427,
      "name": "Team 1427",
      "rookie_year": "2004",
      "city": "Reno",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1428,
      "name": "T-Birds",
      "rookie_year": "2004",
      "city": "Zuni",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1429,
      "name": "TEAM KAOS",
      "rookie_year": "2004",
      "city": "Galena Park",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1430,
      "name": "WRONG Doers",
      "rookie_year": "2004",
      "city": "Anchorage",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1432,
      "name": "Metal Beavers",
      "rookie_year": "2004",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1433,
      "name": "Tiger Techies",
      "rookie_year": "2004",
      "city": "Newberg",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1435,
      "name": "The pi-Rats",
      "rookie_year": "2004",
      "city": "Maryland Heights",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1436,
      "name": "Jackets",
      "rookie_year": "2004",
      "city": "Fort Mill",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1437,
      "name": "Robot Rams",
      "rookie_year": "2004",
      "city": "St. Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1438,
      "name": "The A Team",
      "rookie_year": "2004",
      "city": "Anaheim",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1439,
      "name": "Mays RBOT",
      "rookie_year": "2004",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1440,
      "name": "Warriors",
      "rookie_year": "2004",
      "city": "Savannah",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1441,
      "name": "RAVENS",
      "rookie_year": "2004",
      "city": "Bellevue",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1442,
      "name": "Ehecatl",
      "rookie_year": "2004",
      "city": "Juarez",
      "state": "CHH",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 1444,
      "name": "Lightning",
      "rookie_year": "2004",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1446,
      "name": "Robo Knights",
      "rookie_year": "2004",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1447,
      "name": "Panther Robotics",
      "rookie_year": "2004",
      "city": "Center Line",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1448,
      "name": "Parsons Vikings",
      "rookie_year": "2004",
      "city": "Parsons",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1449,
      "name": "Robocats",
      "rookie_year": "2004",
      "city": "Williamsport",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1450,
      "name": "XQ Robotix",
      "rookie_year": "2004",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1451,
      "name": "RoboKnights",
      "rookie_year": "2004",
      "city": "Troy",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1452,
      "name": "Omnicats",
      "rookie_year": "2004",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1453,
      "name": "RoboCubs",
      "rookie_year": "2004",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1455,
      "name": "NEC",
      "rookie_year": "2004",
      "city": "Wyncote",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1456,
      "name": "GrizzlyBots",
      "rookie_year": "2004",
      "city": "Chandler",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1457,
      "name": "TRONN",
      "rookie_year": "2004",
      "city": "Reno",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1458,
      "name": "Red Tie Robotics",
      "rookie_year": "2004",
      "city": "Danville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1459,
      "name": "Bearcats",
      "rookie_year": "2004",
      "city": "Pilot Point",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1460,
      "name": "Robolution",
      "rookie_year": "2004",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1461,
      "name": "Golden Hawks",
      "rookie_year": "2004",
      "city": "Miami Springs",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1462,
      "name": "Tekeez",
      "rookie_year": "2004",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1463,
      "name": "Transformers",
      "rookie_year": "2004",
      "city": "Burke",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1464,
      "name": " Wolves",
      "rookie_year": "2004",
      "city": "Westminster",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1465,
      "name": "Code Breakers",
      "rookie_year": "2004",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1466,
      "name": "Webb Robotics",
      "rookie_year": "2004",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1467,
      "name": "HSRO",
      "rookie_year": "2004",
      "city": "Midlothian",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1468,
      "name": "Hicksville J-Birds",
      "rookie_year": "2004",
      "city": "Hicksville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1469,
      "name": "The Labcoats",
      "rookie_year": "2004",
      "city": "Greensboro",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1470,
      "name": "DA Bears",
      "rookie_year": "2004",
      "city": "Pittsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1472,
      "name": "GENESIS",
      "rookie_year": "2004",
      "city": "Baton Rouge",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1474,
      "name": "Titans",
      "rookie_year": "2004",
      "city": "Tewksbury",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1475,
      "name": "LOOSE CONNECTIONS",
      "rookie_year": "2004",
      "city": "Leo",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1476,
      "name": "Der Eisenflug",
      "rookie_year": "2004",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1477,
      "name": "Texas Torque",
      "rookie_year": "2004",
      "city": "Conroe",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 1478,
      "name": "The OZ Men",
      "rookie_year": "2004",
      "city": "Seneca",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1479,
      "name": "SWAT Team",
      "rookie_year": "2004",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1480,
      "name": "Robatos Locos",
      "rookie_year": "2004",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1481,
      "name": "The Riveters",
      "rookie_year": "2004",
      "city": "Farmington",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1482,
      "name": "Grizzlies",
      "rookie_year": "2004",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1484,
      "name": "Hoggzilla",
      "rookie_year": "2004",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1485,
      "name": "Team 1485",
      "rookie_year": "2004",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1486,
      "name": "Knight Robotics",
      "rookie_year": "2004",
      "city": "Calgary",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1489,
      "name": "Blood Sweat Gears",
      "rookie_year": "2004",
      "city": "Birmingham",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1490,
      "name": "Sparta's Rockets",
      "rookie_year": "2004",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1492,
      "name": "Team CAUTION",
      "rookie_year": "2004",
      "city": "Tempe",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1493,
      "name": "Falcons",
      "rookie_year": "2004",
      "city": "Albany",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1495,
      "name": "Red Devils",
      "rookie_year": "2004",
      "city": "West Grove",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1496,
      "name": "IGUANA #1496",
      "rookie_year": "2004",
      "city": "Quito",
      "state": "P",
      "country": "Ecuador",
      "district": ""
    },
    {
      "number": 1497,
      "name": "Ram Robotics",
      "rookie_year": "2004",
      "city": "Jacksonville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1500,
      "name": "Metal-Morphose",
      "rookie_year": "2005",
      "city": "Hudsonville",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1501,
      "name": "Team THRUST",
      "rookie_year": "2005",
      "city": "Huntington",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1502,
      "name": "Technical Difficulties",
      "rookie_year": "2005",
      "city": "Chelsea",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1503,
      "name": "Spartonics",
      "rookie_year": "2005",
      "city": "Niagara Falls",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1504,
      "name": "Desperate Penguins",
      "rookie_year": "2005",
      "city": "Okemos",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1505,
      "name": "Roybotics",
      "rookie_year": "2005",
      "city": "Roy",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1506,
      "name": "Metal Muscle",
      "rookie_year": "2005",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1507,
      "name": "Warlocks",
      "rookie_year": "2005",
      "city": "Lockport",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1508,
      "name": "RoboWizards",
      "rookie_year": "2005",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1509,
      "name": "Screamin Eagles",
      "rookie_year": "2005",
      "city": "Ferndale",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1510,
      "name": "Wildcats",
      "rookie_year": "2005",
      "city": "Beaverton",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1511,
      "name": "Rolling Thunder",
      "rookie_year": "2005",
      "city": "Penfield",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1512,
      "name": "The Big Red",
      "rookie_year": "2005",
      "city": "Concord",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1513,
      "name": "Cyclones",
      "rookie_year": "2005",
      "city": "Spring",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1514,
      "name": "The Vikes",
      "rookie_year": "2005",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1515,
      "name": "MorTorq",
      "rookie_year": "2005",
      "city": "Beverly Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1516,
      "name": "Fightin' Grizzlies",
      "rookie_year": "2005",
      "city": "San Ramon",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1517,
      "name": "AMP'D UP",
      "rookie_year": "2005",
      "city": "Concord",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1518,
      "name": "Raider Robotics",
      "rookie_year": "2005",
      "city": "Palmyra",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1519,
      "name": "Mechanical Mayhem",
      "rookie_year": "2005",
      "city": "currently meeting in Bedford",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1520,
      "name": "Omega - 13",
      "rookie_year": "2005",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1522,
      "name": "DOTM - Defenders of the Multiverse  : Hanover High School",
      "rookie_year": "2005",
      "city": "Mechanicsville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1523,
      "name": "MARS (Mega Awesome Robotic Systems)",
      "rookie_year": "2005",
      "city": "Palm Beach Gardens",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1524,
      "name": "Gladiators",
      "rookie_year": "2005",
      "city": "New Britain",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1525,
      "name": "Deerfield High School Warriors",
      "rookie_year": "2005",
      "city": "Deerfield",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1527,
      "name": "Bionic Battalion",
      "rookie_year": "2005",
      "city": "El Cajon",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1528,
      "name": "MTR (Monroe Trojan Robotics)",
      "rookie_year": "2005",
      "city": "Monroe",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1529,
      "name": "CyberCards",
      "rookie_year": "2005",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1530,
      "name": "Vikings",
      "rookie_year": "2005",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1531,
      "name": "Team Lake Effect",
      "rookie_year": "2005",
      "city": "Mexico",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1532,
      "name": "Royals",
      "rookie_year": "2005",
      "city": "Cleveland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1533,
      "name": "Triple Strange",
      "rookie_year": "2005",
      "city": "Greensboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 1534,
      "name": "Abramson Robotic Soldiers",
      "rookie_year": "2005",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1535,
      "name": "Knights of Alloy",
      "rookie_year": "2005",
      "city": "Sault Ste Marie",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1537,
      "name": "Robotic Knights",
      "rookie_year": "2005",
      "city": "Uniondale",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1538,
      "name": "The Holy Cows",
      "rookie_year": "2005",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1539,
      "name": "Clover Eagle Robotics",
      "rookie_year": "2005",
      "city": "Clover",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1540,
      "name": "Flaming Chickens",
      "rookie_year": "2005",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1541,
      "name": "MidloCanics",
      "rookie_year": "2005",
      "city": "Midlothian",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1542,
      "name": "Heart of London",
      "rookie_year": "2005",
      "city": "London",
      "state": "ENG",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 1543,
      "name": "The Riddler Revolution",
      "rookie_year": "2005",
      "city": "Kissimmee",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1544,
      "name": "One Byte Short",
      "rookie_year": "2005",
      "city": "Anchorage",
      "state": "Alaska",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1545,
      "name": "DSF Robotics",
      "rookie_year": "2005",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1546,
      "name": "Chaos, Inc.",
      "rookie_year": "2005",
      "city": "Baldwin",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1547,
      "name": "\"Where's Waldo?\"",
      "rookie_year": "2005",
      "city": "Whitby",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1548,
      "name": "Highlanders",
      "rookie_year": "2005",
      "city": "Anchorage",
      "state": "AK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1549,
      "name": "Fire TraXX",
      "rookie_year": "2005",
      "city": "Ann Arbor",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1550,
      "name": "The Botics Squad",
      "rookie_year": "2005",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1551,
      "name": "The Grapes of Wrath",
      "rookie_year": "2005",
      "city": "Naples",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1552,
      "name": "CougarBots",
      "rookie_year": "2005",
      "city": "Niwot",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1553,
      "name": "KC Robotics Team",
      "rookie_year": "2005",
      "city": "Lugoff",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1554,
      "name": "Oceanside Robotics",
      "rookie_year": "2005",
      "city": "Oceanside",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1555,
      "name": "Cryonics",
      "rookie_year": "2005",
      "city": "Elkhart",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1556,
      "name": "Robo Raiders",
      "rookie_year": "2005",
      "city": "North Hills",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1557,
      "name": "12 Volt Bolt",
      "rookie_year": "2005",
      "city": "Eustis",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1558,
      "name": "ACCIdent",
      "rookie_year": "2005",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1559,
      "name": "Devil Tech",
      "rookie_year": "2005",
      "city": "Victor",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1560,
      "name": "RoboPanthers",
      "rookie_year": "2005",
      "city": "Los Altos Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1561,
      "name": "ROBODUCKS",
      "rookie_year": "2005",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1562,
      "name": "RMSEL Robotics",
      "rookie_year": "2005",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1563,
      "name": "ROBO-CATS",
      "rookie_year": "2005",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1564,
      "name": "J.A.G.S.",
      "rookie_year": "2005",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1565,
      "name": "Think Tank Technologies (T3)",
      "rookie_year": "2005",
      "city": "Cambridge",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1566,
      "name": "AMMOKNIGHTS",
      "rookie_year": "2005",
      "city": "Idaho Falls",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1567,
      "name": "Shock-a-bots",
      "rookie_year": "2005",
      "city": "Rochester",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1568,
      "name": "Mechanicatz",
      "rookie_year": "2005",
      "city": "Pawtucket",
      "state": "RI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1569,
      "name": "Haywire Robotics",
      "rookie_year": "2005",
      "city": "Pocatello",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1570,
      "name": "Demons",
      "rookie_year": "2005",
      "city": "Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1571,
      "name": "CALibrate Robotics",
      "rookie_year": "2005",
      "city": "Gresham",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1572,
      "name": "The Hammer Heads",
      "rookie_year": "2005",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1573,
      "name": "Kfar Galim",
      "rookie_year": "2005",
      "city": "Kfar Galim",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1574,
      "name": "MisCar",
      "rookie_year": "2005",
      "city": "Misgav",
      "state": "HaZafon",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1575,
      "name": "Team 1575",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 1576,
      "name": "Voltrix",
      "rookie_year": "2005",
      "city": "Tel Aviv",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1577,
      "name": "Steampunk",
      "rookie_year": "2005",
      "city": "Raanana",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1578,
      "name": "The Purple RoboSnails",
      "rookie_year": "2005",
      "city": "Tel Aviv",
      "state": "TA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1579,
      "name": "Shevach-Mofet",
      "rookie_year": "2005",
      "city": "Tel Aviv",
      "state": "TA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1580,
      "name": "The Blue Monkeys",
      "rookie_year": "2005",
      "city": "Ashkelon",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1581,
      "name": "Team 1581",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 1582,
      "name": "Dantziger",
      "rookie_year": "2005",
      "city": "Kiryat Shmona",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1583,
      "name": "Ridge View Academy Rambotics",
      "rookie_year": "2005",
      "city": "Watkins",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1584,
      "name": "Pirates",
      "rookie_year": "2005",
      "city": "Nederland",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1585,
      "name": "Scitobor Robotics",
      "rookie_year": "2005",
      "city": "Shortsville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1588,
      "name": "The Crunken Masters",
      "rookie_year": "2005",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1589,
      "name": "DYNAMIC (Desgin Young New Advance Minds In Competition) BOTICS",
      "rookie_year": "2005",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1590,
      "name": "Titaniums",
      "rookie_year": "2005",
      "city": "Lorain",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1591,
      "name": "Greece Gladiators",
      "rookie_year": "2005",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1592,
      "name": "Bionic Tigers",
      "rookie_year": "2005",
      "city": "Cocoa",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1593,
      "name": "2 Hot 2 Trot",
      "rookie_year": "2005",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1594,
      "name": "Double X",
      "rookie_year": "2005",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1595,
      "name": "The Dragons",
      "rookie_year": "2005",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1596,
      "name": "The Instigators",
      "rookie_year": "2005",
      "city": "Sault Sainte Marie",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1597,
      "name": "BxAero",
      "rookie_year": "2005",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1598,
      "name": "TeamTalon 1598",
      "rookie_year": "2005",
      "city": "Danville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1599,
      "name": "CircuiTree",
      "rookie_year": "2005",
      "city": "Mechanicsville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1600,
      "name": "ROBO KINGS AND QUEENS",
      "rookie_year": "2005",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1601,
      "name": "Quantum Samurai",
      "rookie_year": "2005",
      "city": "Long Island City",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1602,
      "name": "CougarBots",
      "rookie_year": "2005",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1603,
      "name": "Libas",
      "rookie_year": "2005",
      "city": "Novo Hamburgo",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 1604,
      "name": "Mekheads",
      "rookie_year": "2005",
      "city": "Harmony",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1605,
      "name": "RoboHawks",
      "rookie_year": "2005",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1606,
      "name": "Division Dragons",
      "rookie_year": "2005",
      "city": "Levittown",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1607,
      "name": "Rough Riders",
      "rookie_year": "2005",
      "city": "Roosevelt",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1609,
      "name": "West Allied Robotics -W.A.R.",
      "rookie_year": "2005",
      "city": "Ballwin",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1610,
      "name": "\u26f4 Blackwater Robotics \u26f4",
      "rookie_year": "2005",
      "city": "Franklin",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1611,
      "name": "NOS",
      "rookie_year": "2005",
      "city": "Guyton",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1612,
      "name": "Robo-Sharks",
      "rookie_year": "2005",
      "city": "Brooksville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1613,
      "name": "StARC",
      "rookie_year": "2005",
      "city": "San Diego",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1616,
      "name": "weequahic indians",
      "rookie_year": "2005",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1617,
      "name": "The Mighty Bulldogs",
      "rookie_year": "2005",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1618,
      "name": "Capital Robotics ",
      "rookie_year": "2005",
      "city": "Columbia",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1619,
      "name": "Up-A-Creek Robotics",
      "rookie_year": "2005",
      "city": "Longmont",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1620,
      "name": "Robolution",
      "rookie_year": "2005",
      "city": "Pickering",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1621,
      "name": "Eniac",
      "rookie_year": "2005",
      "city": "Guarulhos",
      "state": "SP",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 1622,
      "name": "Team Spyder",
      "rookie_year": "2005",
      "city": "Poway",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1623,
      "name": "Banner Bots",
      "rookie_year": "2005",
      "city": "Faribault",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1624,
      "name": "The Green Grinches",
      "rookie_year": "2005",
      "city": "Vancouver",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1625,
      "name": "Winnovation",
      "rookie_year": "2005",
      "city": "Winnebago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1626,
      "name": "Falcon Robotics",
      "rookie_year": "2005",
      "city": "Metuchen",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1628,
      "name": "SENAI Mechatronics",
      "rookie_year": "2005",
      "city": "Caxias Do Sul",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 1629,
      "name": "Garrett Coalition (GaCo)",
      "rookie_year": "2005",
      "city": "Accident",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1631,
      "name": "Rockin Robots",
      "rookie_year": "2005",
      "city": "Henderson",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1633,
      "name": "RoboBuffs",
      "rookie_year": "2005",
      "city": "Tempe",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1634,
      "name": "Wreckers",
      "rookie_year": "2005",
      "city": "Weatherly",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1635,
      "name": "TECHNOTICS",
      "rookie_year": "2005",
      "city": "Elmhurst",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1636,
      "name": "Reds Robotics",
      "rookie_year": "2005",
      "city": "Arvada",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1640,
      "name": "Sab-BOT-age",
      "rookie_year": "2005",
      "city": "Downingtown",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1641,
      "name": "Where's Waldo?",
      "rookie_year": "2005",
      "city": "Mojave",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1642,
      "name": "Techno-Cats",
      "rookie_year": "2005",
      "city": "Ft. Worth",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1643,
      "name": "Bob's Builders in Black",
      "rookie_year": "2005",
      "city": "Tallmadge",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1644,
      "name": "The Robo-Skunks",
      "rookie_year": "2005",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1645,
      "name": "Butte Bot Builders",
      "rookie_year": "2005",
      "city": "Butte",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1646,
      "name": "Precision Guessworks",
      "rookie_year": "2005",
      "city": "Lafayette",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1647,
      "name": "Iron Devils",
      "rookie_year": "2005",
      "city": "Vincentown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1648,
      "name": "G3 Robotics",
      "rookie_year": "2005",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1649,
      "name": "Lakerbotics",
      "rookie_year": "2005",
      "city": "Windermere",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1650,
      "name": "Prodigies of Technology",
      "rookie_year": "2005",
      "city": "Columbia",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1651,
      "name": "TBA",
      "rookie_year": "2005",
      "city": "Palm Beach County",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1652,
      "name": "LakeView Legends",
      "rookie_year": "2005",
      "city": "Pleasant Prairie",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1653,
      "name": "Washington High School RoboKatz",
      "rookie_year": "2005",
      "city": "Kansas City",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1654,
      "name": "The Non Conformants",
      "rookie_year": "2005",
      "city": "Holland",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1655,
      "name": "Screaming Eagles",
      "rookie_year": "2005",
      "city": "Marion",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1656,
      "name": "Angry Scotsmen",
      "rookie_year": "2005",
      "city": "Haverford",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1657,
      "name": "Hamosad",
      "rookie_year": "2005",
      "city": "Kibutz E'in Shemer",
      "state": "HaZafon",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1658,
      "name": "Tech Heads",
      "rookie_year": "2005",
      "city": "St. Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1660,
      "name": "Harlem Knights",
      "rookie_year": "2005",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1661,
      "name": "Griffitrons",
      "rookie_year": "2005",
      "city": "Sherman Oaks",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1662,
      "name": "Raptor Force Engineering",
      "rookie_year": "2005",
      "city": "Lodi",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1665,
      "name": "Weapons of Mass Construction",
      "rookie_year": "2005",
      "city": "Hudson",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1666,
      "name": "REDSKINS",
      "rookie_year": "2005",
      "city": "Liberal",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1667,
      "name": "Broncobotix",
      "rookie_year": "2005",
      "city": "Spring Hill",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1669,
      "name": "The Jaganators",
      "rookie_year": "2005",
      "city": "Long Beach",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1670,
      "name": "FHJCC  Eagles",
      "rookie_year": "2005",
      "city": "Manhattan",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1671,
      "name": "Buchanan Bird Brains",
      "rookie_year": "2005",
      "city": "Clovis",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1672,
      "name": "Robo-T-Birds",
      "rookie_year": "2005",
      "city": "Mahwah",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1674,
      "name": "Lake Effect ",
      "rookie_year": "2005",
      "city": "Onekama",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1675,
      "name": "UPS (Ultimate Protection Squad)",
      "rookie_year": "2005",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1676,
      "name": "The Pascack PI-oneers",
      "rookie_year": "2005",
      "city": "Montvale",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1677,
      "name": "Qunatum Ninjas",
      "rookie_year": "2005",
      "city": "Kalamazoo",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1678,
      "name": "Citrus Circuits",
      "rookie_year": "2005",
      "city": "Davis",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1680,
      "name": "Fort Erie Secondary School",
      "rookie_year": "2005",
      "city": "Fort Erie",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1682,
      "name": "Eye Bots",
      "rookie_year": "2005",
      "city": "Riverside",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1683,
      "name": "Techno Titans",
      "rookie_year": "2005",
      "city": "Johns Creek",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1684,
      "name": "The Chimeras",
      "rookie_year": "2005",
      "city": "Lapeer",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1685,
      "name": "Tech-Know Commandos",
      "rookie_year": "2005",
      "city": "Worcester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1686,
      "name": "Team Navigator",
      "rookie_year": "2005",
      "city": "Worcester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1687,
      "name": "Highlander Robotics",
      "rookie_year": "2005",
      "city": "Worcester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1688,
      "name": "Team Stick Shift",
      "rookie_year": "2005",
      "city": "Staten Island",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1689,
      "name": "Blazing Bengals",
      "rookie_year": "2005",
      "city": "Bloomfield",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1690,
      "name": "Orbit",
      "rookie_year": "2005",
      "city": "Binyamina",
      "state": "HaZafon",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1691,
      "name": "EaglesBots",
      "rookie_year": "2005",
      "city": "Sidney",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1692,
      "name": "CougarBots",
      "rookie_year": "2005",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1693,
      "name": "Robo Lobos",
      "rookie_year": "2005",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1694,
      "name": "Walt Disney Robo Warriors",
      "rookie_year": "2005",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1695,
      "name": "Bearly Robotics- \"Your Best Alloy\"",
      "rookie_year": "2005",
      "city": "Helena",
      "state": "Montana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1696,
      "name": "RoboRevolution",
      "rookie_year": "2005",
      "city": "Sun River",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1697,
      "name": "Gyros",
      "rookie_year": "2005",
      "city": "Long Beach",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1698,
      "name": "Metal Cougars (MC^2)",
      "rookie_year": "2005",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1699,
      "name": "Robocats",
      "rookie_year": "2005",
      "city": "Colchester",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1700,
      "name": "Gatorbotics",
      "rookie_year": "2005",
      "city": "Palo Alto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1701,
      "name": "RoboCubs",
      "rookie_year": "2005",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1702,
      "name": "None",
      "rookie_year": "2005",
      "city": "Ingelwood",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1703,
      "name": "RAT's ",
      "rookie_year": "2005",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1704,
      "name": "Steelers",
      "rookie_year": "2005",
      "city": "Fontana",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1705,
      "name": "Vikings",
      "rookie_year": "2005",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1706,
      "name": "Ratchet Rockers",
      "rookie_year": "2005",
      "city": "Wentzville",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1707,
      "name": "NH Indians",
      "rookie_year": "2005",
      "city": "Pghp",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1708,
      "name": "AMP'D Robotics",
      "rookie_year": "2005",
      "city": "McKeesport",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1709,
      "name": "Sparks",
      "rookie_year": "2005",
      "city": "Poway",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1710,
      "name": "The Ravonics Revolution",
      "rookie_year": "2006",
      "city": "Olathe",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1711,
      "name": "RAPTORS",
      "rookie_year": "2006",
      "city": "Traverse City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1712,
      "name": "Dawgma",
      "rookie_year": "2006",
      "city": "Ardmore",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1713,
      "name": "Gears",
      "rookie_year": "2006",
      "city": "Cape Vincent / Clayton",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1714,
      "name": "MORE Robotics",
      "rookie_year": "2006",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1715,
      "name": "RDA",
      "rookie_year": "2006",
      "city": "Moore",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1716,
      "name": "Redbird Robotics",
      "rookie_year": "2006",
      "city": "De Pere",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1717,
      "name": "D'Penguineers",
      "rookie_year": "2006",
      "city": "Goleta",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1718,
      "name": "The Fighting Pi",
      "rookie_year": "2006",
      "city": "Armada",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1719,
      "name": "The Umbrella Corporation",
      "rookie_year": "2006",
      "city": "Baltimore",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1720,
      "name": "PhyXTGears",
      "rookie_year": "2006",
      "city": "Matthews",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1721,
      "name": "Tidal Force",
      "rookie_year": "2006",
      "city": "Concord",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1722,
      "name": "Rebel Innovators",
      "rookie_year": "2006",
      "city": "La Canada",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1723,
      "name": "The FBI - FIRST Bots of Independence",
      "rookie_year": "2006",
      "city": "Independence",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1724,
      "name": "Weber Fever",
      "rookie_year": "2006",
      "city": "Pleasant View",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1725,
      "name": "Worcester Public School Girls All Star",
      "rookie_year": "2006",
      "city": "Worcester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1726,
      "name": "N.E.R.D.S. (Nifty Engineering Robotics Design Squad)",
      "rookie_year": "2006",
      "city": "Sierra Vista",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1727,
      "name": "REX",
      "rookie_year": "2006",
      "city": "Lutherville Timonium",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1728,
      "name": "B.L.I.N.G.  (Bausch & Lomb Inspires & Nurtures Growth)",
      "rookie_year": "2006",
      "city": "Rochester",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1729,
      "name": "Team Inconceivable!",
      "rookie_year": "2006",
      "city": "Peterborough",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1730,
      "name": "Team Driven",
      "rookie_year": "2006",
      "city": "Lees Summit",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1731,
      "name": "Fresta Valley Robotics Club",
      "rookie_year": "2006",
      "city": "Warrenton",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1732,
      "name": "Hilltopper Robotics",
      "rookie_year": "2006",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1733,
      "name": "PolarBots",
      "rookie_year": "2006",
      "city": "Worcester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1734,
      "name": "1734 Sesame Street",
      "rookie_year": "2006",
      "city": "Fort Walton Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1735,
      "name": "Green Reapers",
      "rookie_year": "2006",
      "city": "Worcester",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1736,
      "name": "Robot Casserole",
      "rookie_year": "2006",
      "city": "Peoria",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1737,
      "name": "Project X",
      "rookie_year": "2006",
      "city": "Excelsior Springs",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1738,
      "name": "Team 1738",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 1739,
      "name": "Chicago Knights Robotics",
      "rookie_year": "2006",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1740,
      "name": "Cyber Colonels",
      "rookie_year": "2006",
      "city": "Ledyard",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1741,
      "name": "Red Alert",
      "rookie_year": "2006",
      "city": "Greenwood",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1742,
      "name": "Shockwave",
      "rookie_year": "2006",
      "city": "Norman",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1743,
      "name": "Short Circuits",
      "rookie_year": "2006",
      "city": "Pittsburgh",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1744,
      "name": "Robo Rays",
      "rookie_year": "2006",
      "city": "Naples",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1745,
      "name": "The P-51 Mustangs",
      "rookie_year": "2006",
      "city": "Richardson",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 1746,
      "name": "OTTO",
      "rookie_year": "2006",
      "city": "Cumming",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1747,
      "name": "Harrison Boiler Robotics",
      "rookie_year": "2006",
      "city": "West Lafayette",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 1748,
      "name": "Lab Rats",
      "rookie_year": "2006",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1749,
      "name": "Wapack Renaissance Robotics",
      "rookie_year": "2006",
      "city": "Peterborough",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1750,
      "name": "ThunderStorm Robotics",
      "rookie_year": "2006",
      "city": "Stillwater",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1751,
      "name": "The Warriors",
      "rookie_year": "2006",
      "city": "Port Jefferson Station",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1752,
      "name": "Tonka",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1753,
      "name": "Goz-Bot",
      "rookie_year": "2006",
      "city": "Watertown",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1754,
      "name": "Nitro Knights",
      "rookie_year": "2006",
      "city": "Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1755,
      "name": "Jaguarbotics",
      "rookie_year": "2006",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1756,
      "name": "Argos",
      "rookie_year": "2006",
      "city": "Peoria",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1757,
      "name": "Wolverines",
      "rookie_year": "2006",
      "city": "Westwood",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1758,
      "name": "Technomancers",
      "rookie_year": "2006",
      "city": "Florence",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1759,
      "name": "Potatoes",
      "rookie_year": "2006",
      "city": "El Segundo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1760,
      "name": "Robo-Titans",
      "rookie_year": "2006",
      "city": "Kokomo",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1761,
      "name": "STEAMpunk Tigers",
      "rookie_year": "2006",
      "city": "Lynn",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1763,
      "name": "Paseliens",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1764,
      "name": "Liberty Robotics",
      "rookie_year": "2006",
      "city": "Liberty",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1765,
      "name": "E1Bots",
      "rookie_year": "2006",
      "city": "Buffalo",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1766,
      "name": "TM",
      "rookie_year": "2006",
      "city": "Columbus",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1767,
      "name": "Widget Warriors",
      "rookie_year": "2006",
      "city": "Howell",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1768,
      "name": "Nashoba Robotics",
      "rookie_year": "2006",
      "city": "Bolton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1769,
      "name": "Digital Hawks",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1770,
      "name": "Alpha Woverines",
      "rookie_year": "2006",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1771,
      "name": "North Gwinnett Robotics",
      "rookie_year": "2006",
      "city": "Suwanee",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1772,
      "name": "The Brazilian Trail Blazers",
      "rookie_year": "2006",
      "city": "Gravatai",
      "state": "Rio Grande do Sul",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 1774,
      "name": "Athena's Engineers",
      "rookie_year": "2012",
      "city": "Pittsburg",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1775,
      "name": "Tigerbytes",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1776,
      "name": "Declaration",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1777,
      "name": "Viking Robotics",
      "rookie_year": "2006",
      "city": "Overland Park",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1778,
      "name": "Chill Out",
      "rookie_year": "2006",
      "city": "Mountlake Terrace",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1779,
      "name": "G. St. Techies",
      "rookie_year": "2006",
      "city": "South Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1780,
      "name": "Wolves Robotics",
      "rookie_year": "2006",
      "city": "Henderson",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1781,
      "name": "Lindblom Electric Eagles",
      "rookie_year": "2006",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1782,
      "name": "RADICAL RAYTOWN ROBOTICS",
      "rookie_year": "2006",
      "city": "RAYTOWN",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1783,
      "name": "Falcon Firebots",
      "rookie_year": "2006",
      "city": "West Branch",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1784,
      "name": "Litchbots",
      "rookie_year": "2006",
      "city": "Litchfield",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1785,
      "name": "Blue Springs Robocats",
      "rookie_year": "2006",
      "city": "Blue Springs",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1786,
      "name": "The Robotics Team",
      "rookie_year": "2006",
      "city": "Dublin",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1787,
      "name": "Flying Circuits",
      "rookie_year": "2006",
      "city": "Pepper Pike",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1788,
      "name": "Ravage",
      "rookie_year": "2006",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1789,
      "name": "Cliffhangers",
      "rookie_year": "2006",
      "city": "Kremmling",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1790,
      "name": "Team 1881",
      "rookie_year": "2006",
      "city": "Paterson",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1791,
      "name": "Voyagers",
      "rookie_year": "2006",
      "city": "Clayton",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1792,
      "name": "Round Table Robotics",
      "rookie_year": "2006",
      "city": "Oak Creek",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1793,
      "name": "The Aviators",
      "rookie_year": "2006",
      "city": "Norfolk",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1794,
      "name": "N.I.R.D.",
      "rookie_year": "2006",
      "city": "St. Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1795,
      "name": "Team Clutch",
      "rookie_year": "2006",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 1796,
      "name": "RoboTigers",
      "rookie_year": "2006",
      "city": "Queens",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1797,
      "name": "Phoenix",
      "rookie_year": "2006",
      "city": "London",
      "state": "England",
      "country": "United Kingdom",
      "district": ""
    },
    {
      "number": 1798,
      "name": "RoboKnights",
      "rookie_year": "2006",
      "city": "Tucson",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1799,
      "name": "Wired Up!",
      "rookie_year": "2006",
      "city": "Littleton",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1800,
      "name": "Bravebotics",
      "rookie_year": "2006",
      "city": "Bonner Springs",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1801,
      "name": "The Dapper Dans",
      "rookie_year": "2006",
      "city": "Kountze",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1802,
      "name": "Team Stealth",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1803,
      "name": "Vikings",
      "rookie_year": "2006",
      "city": "Port Washington",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1804,
      "name": "Northmen",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1805,
      "name": "HOT BOTS",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1806,
      "name": "S.W.A.T.",
      "rookie_year": "2006",
      "city": "Smithville",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1807,
      "name": "Redbird Robotics",
      "rookie_year": "2006",
      "city": "Allentown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1808,
      "name": "Red Devil Robotics",
      "rookie_year": "2006",
      "city": "Freeport",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1809,
      "name": "The MidKnight Inventors",
      "rookie_year": "2006",
      "city": "Plainsboro",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1810,
      "name": "Jaguar Robotics",
      "rookie_year": "2006",
      "city": "Shawnee",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1811,
      "name": "FRESH",
      "rookie_year": "2006",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1813,
      "name": "Roboegal",
      "rookie_year": "2006",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1814,
      "name": "Phoenix In Fight",
      "rookie_year": "2006",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1815,
      "name": "Black Scots",
      "rookie_year": "2006",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1816,
      "name": "\"The Green Machine\"",
      "rookie_year": "2006",
      "city": "Edina",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1817,
      "name": "Llano Estacado RoboRaiders",
      "rookie_year": "2006",
      "city": "Lubbock",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1818,
      "name": "Team Talos",
      "rookie_year": "2006",
      "city": "Shreveport",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1820,
      "name": "Havoc",
      "rookie_year": "2006",
      "city": "Rockville",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1823,
      "name": "The New Victorians",
      "rookie_year": "2006",
      "city": "portland",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1824,
      "name": "1824",
      "rookie_year": "2006",
      "city": "Peterborough",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1825,
      "name": "The Cyborgs",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1826,
      "name": "Team 1826, The Fuse",
      "rookie_year": "2006",
      "city": "Golden",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1827,
      "name": "THE HIVE",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1828,
      "name": "BoxerBots",
      "rookie_year": "2006",
      "city": "Vail",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1829,
      "name": "Carbonauts",
      "rookie_year": "2006",
      "city": "Accomack County",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1830,
      "name": "Mighty Bookers",
      "rookie_year": "2006",
      "city": "Norfolk",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1831,
      "name": "Screaming Eagles",
      "rookie_year": "2006",
      "city": "Gilford",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1834,
      "name": "Evolution",
      "rookie_year": "2006",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1835,
      "name": "Wreckless Creation",
      "rookie_year": "2006",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1836,
      "name": "The MilkenKnights",
      "rookie_year": "2006",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1837,
      "name": "Madi",
      "rookie_year": "2006",
      "city": "Tallulah",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1838,
      "name": "Bobcats",
      "rookie_year": "2006",
      "city": "Rexburg",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1839,
      "name": "Techattack",
      "rookie_year": "2006",
      "city": "Saint Anthony",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1840,
      "name": "Diggers",
      "rookie_year": "2006",
      "city": "Sugar City",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1841,
      "name": "Crazy Bred......Yeeeeaah!!",
      "rookie_year": "2006",
      "city": "plantation",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1842,
      "name": "Twisted E.G.O.",
      "rookie_year": "2006",
      "city": "Fort Pierce",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1843,
      "name": "Trobots",
      "rookie_year": "2006",
      "city": "Rigby",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1845,
      "name": "Cyber Panthers",
      "rookie_year": "2006",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1846,
      "name": "Le Vortex",
      "rookie_year": "2006",
      "city": "Sarnia",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1847,
      "name": "W.R.A.T.H (Wyandotte Robotics and Technology Hackers)",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1848,
      "name": "SOUP",
      "rookie_year": "2006",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1849,
      "name": "Griffins",
      "rookie_year": "2006",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1850,
      "name": "Mechanicats",
      "rookie_year": "2006",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1851,
      "name": "Manic Mechanics",
      "rookie_year": "2006",
      "city": "Sun Valley",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1852,
      "name": "Team Amore",
      "rookie_year": "2006",
      "city": "Scottsdale",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1853,
      "name": "Ruskin Eagles",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1855,
      "name": "MagnoBots",
      "rookie_year": "2006",
      "city": "Reseda",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1856,
      "name": "Gear Heads",
      "rookie_year": "2006",
      "city": "Redford",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1858,
      "name": "Spartans",
      "rookie_year": "2006",
      "city": "Slidell",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1859,
      "name": "RoboJacks",
      "rookie_year": "2006",
      "city": "Bogalusa",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1860,
      "name": "Alphabots",
      "rookie_year": "2006",
      "city": "Sao Jose dos Campos",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 1861,
      "name": "SHARC",
      "rookie_year": "2006",
      "city": "Aurora",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1862,
      "name": "Red Raiders ",
      "rookie_year": "2006",
      "city": "Cliffside Park",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1863,
      "name": "Titan it up!",
      "rookie_year": "2006",
      "city": "Tulsa",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1864,
      "name": "Automata",
      "rookie_year": "2006",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1865,
      "name": "RoboBuffs",
      "rookie_year": "2006",
      "city": "Missouri City",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1866,
      "name": "The Cardinals",
      "rookie_year": "2006",
      "city": "Swansea",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1867,
      "name": "The Prowlers",
      "rookie_year": "2006",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1868,
      "name": "Space Cookies",
      "rookie_year": "2006",
      "city": "Mountain View",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1870,
      "name": "The Lightning Arx",
      "rookie_year": "2006",
      "city": "Red Deer",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1871,
      "name": "Panter Machine",
      "rookie_year": "2006",
      "city": "CHarles City",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1872,
      "name": "Steel Lions",
      "rookie_year": "2006",
      "city": "San Juan",
      "state": "Puerto Rico",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1873,
      "name": "CRT",
      "rookie_year": "2006",
      "city": "Columbia",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1875,
      "name": "Purple Haze",
      "rookie_year": "2006",
      "city": "Cocoa",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1876,
      "name": "Beachbotics",
      "rookie_year": "2006",
      "city": "Hilton Head Island",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1877,
      "name": "Mechanical Mafia",
      "rookie_year": "2006",
      "city": "Dahlonega",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1879,
      "name": "Minor High School",
      "rookie_year": "2006",
      "city": "Adamsville",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1880,
      "name": "Warriors of East Harlem",
      "rookie_year": "2006",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1881,
      "name": "Gamma Elite",
      "rookie_year": "2006",
      "city": "Paterson",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1882,
      "name": "Rebel Robotics",
      "rookie_year": "2006",
      "city": "Farmingdale",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1883,
      "name": "Dragons",
      "rookie_year": "2006",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1884,
      "name": "Griffins",
      "rookie_year": "2006",
      "city": "London",
      "state": "England",
      "country": "United Kingdom",
      "district": ""
    },
    {
      "number": 1885,
      "name": "ILITE Robotics",
      "rookie_year": "2006",
      "city": "Haymarket",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1886,
      "name": "Hawks",
      "rookie_year": "2006",
      "city": "Ijamsville",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1887,
      "name": "Russet Robotix",
      "rookie_year": "2006",
      "city": "Shelley",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1888,
      "name": "West Robotics",
      "rookie_year": "2006",
      "city": "plano",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1889,
      "name": "Haze",
      "rookie_year": "2006",
      "city": "Wellington",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1890,
      "name": "EOT",
      "rookie_year": "2006",
      "city": "Nashville",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1891,
      "name": "Bullbots",
      "rookie_year": "2006",
      "city": "Boise",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1893,
      "name": "High Tech Parrots",
      "rookie_year": "2006",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1894,
      "name": "The Elite",
      "rookie_year": "2006",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1895,
      "name": "Lambda Corps",
      "rookie_year": "2006",
      "city": "Manassas",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1896,
      "name": "Concussive Engineers",
      "rookie_year": "2006",
      "city": "Traverse City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1897,
      "name": "Red Hot Chile Dragons",
      "rookie_year": "2006",
      "city": "Albuquerque",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1898,
      "name": "Westside Wolves",
      "rookie_year": "2006",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1899,
      "name": "Saints Robotics",
      "rookie_year": "2006",
      "city": "Bellevue",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1900,
      "name": "Rough Riders",
      "rookie_year": "2006",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1901,
      "name": "Ramrod",
      "rookie_year": "2006",
      "city": "St. Marys",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1902,
      "name": "Exploding Bacon",
      "rookie_year": "2006",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1904,
      "name": "Warbots",
      "rookie_year": "2006",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1905,
      "name": "KCbotics",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1906,
      "name": "WeBeRoyBotics",
      "rookie_year": "2006",
      "city": "Roy",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1907,
      "name": "Birds of Prey",
      "rookie_year": "2006",
      "city": "Farmville",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1908,
      "name": "ShoreBots",
      "rookie_year": "2006",
      "city": "Eastville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1909,
      "name": "G-Tech",
      "rookie_year": "2006",
      "city": "Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1910,
      "name": "Hawlets",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1911,
      "name": "Techno-Horns",
      "rookie_year": "2006",
      "city": "Fort Benton",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1912,
      "name": "Team Combustion",
      "rookie_year": "2006",
      "city": "Slidell",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1913,
      "name": "Livewire",
      "rookie_year": "2006",
      "city": "Covington",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1914,
      "name": "The MidKnight Inventors",
      "rookie_year": "2006",
      "city": "Plainsboro",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1915,
      "name": "MTHS Firebird Robotics",
      "rookie_year": "2006",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 1916,
      "name": "MP Robotics",
      "rookie_year": "2006",
      "city": "Roxbury",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1917,
      "name": "T.O.M. (Teckies Operating Machinery)",
      "rookie_year": "2006",
      "city": "Prescott",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1918,
      "name": "NC GEARS",
      "rookie_year": "2006",
      "city": "Fremont",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1919,
      "name": "Knights of the Heights",
      "rookie_year": "2006",
      "city": "South Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1920,
      "name": "McMain Hurricanes",
      "rookie_year": "2006",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1922,
      "name": "Oz-Ram",
      "rookie_year": "2006",
      "city": "Contoocook",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1923,
      "name": "The MidKnight Inventors",
      "rookie_year": "2006",
      "city": "Plainsboro",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1925,
      "name": "Jags",
      "rookie_year": "2006",
      "city": "West Hills",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1926,
      "name": "Team 8-Bit",
      "rookie_year": "2006",
      "city": "Mesa",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1927,
      "name": "Tempest",
      "rookie_year": "2006",
      "city": "Biloxi",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1929,
      "name": "FoxyBots",
      "rookie_year": "2006",
      "city": "Montclair",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1930,
      "name": "Comets",
      "rookie_year": "2006",
      "city": "Henrietta",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1931,
      "name": "Hornets",
      "rookie_year": "2006",
      "city": "Little Falls",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1932,
      "name": "RoboRustlers",
      "rookie_year": "2006",
      "city": "Great Falls",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1933,
      "name": "Doncaster Destroyers",
      "rookie_year": "2006",
      "city": "Doncaster",
      "state": "ENG",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 1934,
      "name": "AI",
      "rookie_year": "2006",
      "city": "London",
      "state": "ENG",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 1935,
      "name": "Team Happycat",
      "rookie_year": "2006",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 1937,
      "name": "Elysium",
      "rookie_year": "2006",
      "city": "Modi'in-Maccabim Reu't",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1938,
      "name": "Manhattan High School",
      "rookie_year": "2006",
      "city": "Manhattan",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1939,
      "name": "THE KUHNIGITS",
      "rookie_year": "2006",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1940,
      "name": "Tech Tigers",
      "rookie_year": "2006",
      "city": "Benton Harbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 1941,
      "name": "Detroit Rocks Robotics",
      "rookie_year": "2006",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1942,
      "name": "Cinderella Tel-Nof",
      "rookie_year": "2006",
      "city": "Gadera",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1943,
      "name": "Neat Team",
      "rookie_year": "2006",
      "city": "Rosh Hayin",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1944,
      "name": "Airforce High School",
      "rookie_year": "2006",
      "city": "Haifa",
      "state": "Haifa",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1945,
      "name": "Most Wanted Robotics",
      "rookie_year": "2006",
      "city": "Nazareth",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1946,
      "name": " FG",
      "rookie_year": "2006",
      "city": "Tamra GLIL",
      "state": "HaZafon (Northern)",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1947,
      "name": "BlacKnight Robotics",
      "rookie_year": "2006",
      "city": "Hadera",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1948,
      "name": "GreenGang",
      "rookie_year": "2006",
      "city": "Kfar Saba",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1949,
      "name": "shapira",
      "rookie_year": "2006",
      "city": "Natanya",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1950,
      "name": "Emek Hefer",
      "rookie_year": "2006",
      "city": "Emek Hefer",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1951,
      "name": "Ort Singolovsky",
      "rookie_year": "2006",
      "city": "Tel Aviv",
      "state": "TA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1952,
      "name": "Arming High School",
      "rookie_year": "2006",
      "city": "tzrifin",
      "state": "HaMerkaz (Central)",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1954,
      "name": "ElectroBunny",
      "rookie_year": "2006",
      "city": "Beer Sheva",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 1955,
      "name": "Beit Yerah",
      "rookie_year": "2006",
      "city": "Emek Hayarden",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1956,
      "name": "UA",
      "rookie_year": "2006",
      "city": "Umm Alfahem",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1957,
      "name": "LighTeam",
      "rookie_year": "2006",
      "city": "Katzrin",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 1959,
      "name": "Bengal Bots",
      "rookie_year": "2006",
      "city": "Blythewood",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1960,
      "name": "GO DARBY!",
      "rookie_year": "2006",
      "city": "Darby",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1961,
      "name": "GreenvilleSeniorHigh",
      "rookie_year": "2006",
      "city": "Greenville",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1962,
      "name": "Zilch",
      "rookie_year": "2006",
      "city": "Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1963,
      "name": "PSC Robotics",
      "rookie_year": "2006",
      "city": "Winchester",
      "state": "ENG",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 1965,
      "name": "Firebirds",
      "rookie_year": "2006",
      "city": "Allston",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1966,
      "name": "Knights",
      "rookie_year": "2006",
      "city": "Missoula",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1967,
      "name": "The Janksters",
      "rookie_year": "2006",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1970,
      "name": "Bulldogs",
      "rookie_year": "2006",
      "city": "Menlo Park",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1972,
      "name": "Searing Engineering",
      "rookie_year": "2006",
      "city": "El Centro",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1973,
      "name": "Burning Tiger   #1973",
      "rookie_year": "2006",
      "city": "Boston",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1974,
      "name": "Weber Tech",
      "rookie_year": "2006",
      "city": "Stockton",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1975,
      "name": "Team QUEEN",
      "rookie_year": "2006",
      "city": "Millton",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1976,
      "name": "The Missing Lynx",
      "rookie_year": "2006",
      "city": "Eden",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1977,
      "name": "The PowerSquids",
      "rookie_year": "2006",
      "city": "Loveland",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1978,
      "name": "Bulldogs",
      "rookie_year": "2006",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1980,
      "name": "The Brigade",
      "rookie_year": "2006",
      "city": "Aberdeen",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1981,
      "name": "The Gearheads",
      "rookie_year": "2007",
      "city": "Independence",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1982,
      "name": "Cougar Robotics",
      "rookie_year": "2007",
      "city": "Shawnee",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1983,
      "name": "Skunk Works Robotics",
      "rookie_year": "2007",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 1984,
      "name": "Jawas",
      "rookie_year": "2007",
      "city": "Overland Park",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1985,
      "name": "Robohawks",
      "rookie_year": "2007",
      "city": "Florissant",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1986,
      "name": "Team Titanium",
      "rookie_year": "2007",
      "city": "Lees Summit",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1987,
      "name": "Broncobots",
      "rookie_year": "2007",
      "city": "Lees Summit",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1988,
      "name": "The Sweetie Pies",
      "rookie_year": "2007",
      "city": "Wales",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1989,
      "name": "Viking Robotics",
      "rookie_year": "2007",
      "city": "Vernon",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 1990,
      "name": "Colts",
      "rookie_year": "2007",
      "city": "Lodi",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1991,
      "name": "Dragons",
      "rookie_year": "2007",
      "city": "Hartford",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 1992,
      "name": "Raytown South Robocards",
      "rookie_year": "2007",
      "city": "Raytown",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1994,
      "name": "Quixote",
      "rookie_year": "2007",
      "city": "Kansas City",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1995,
      "name": "Fatal Error",
      "rookie_year": "2007",
      "city": "Bangor",
      "state": "ME",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1996,
      "name": "Wildcat Robotics",
      "rookie_year": "2007",
      "city": "Blue Springs",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1997,
      "name": "STAG Robotics",
      "rookie_year": "2007",
      "city": "Roeland Park",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1998,
      "name": "Robodogz",
      "rookie_year": "2007",
      "city": "Dearborn Heights",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 1999,
      "name": "O.U.T.E.R L.I.M.I.T.",
      "rookie_year": "2007",
      "city": "Fort Walton Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2000,
      "name": "TEAM ROCK",
      "rookie_year": "2007",
      "city": "Dorr",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2001,
      "name": "HERMES",
      "rookie_year": "2007",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2002,
      "name": "Tualatin Robotics",
      "rookie_year": "2007",
      "city": "Tualatin",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2004,
      "name": "Thunderducks",
      "rookie_year": "2007",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2005,
      "name": "Aerobotechs",
      "rookie_year": "2007",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2007,
      "name": "Robots of the Round Table",
      "rookie_year": "2007",
      "city": "Duluth",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2008,
      "name": "VTEC",
      "rookie_year": "2007",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2009,
      "name": "Robo-Titans",
      "rookie_year": "2007",
      "city": "Roxbury",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2010,
      "name": "The Lightning Bots",
      "rookie_year": "2007",
      "city": "Warren",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2011,
      "name": "SMH Robotics",
      "rookie_year": "2007",
      "city": "Independence",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2012,
      "name": "@ Zenith",
      "rookie_year": "2007",
      "city": "North Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2013,
      "name": "Cybergnomes",
      "rookie_year": "2007",
      "city": "Clearview Twp.",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2014,
      "name": "Spartans",
      "rookie_year": "2007",
      "city": "St. Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2015,
      "name": "Static shock",
      "rookie_year": "2007",
      "city": "Holland",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2016,
      "name": "Mighty Monkey Wrenches",
      "rookie_year": "2007",
      "city": "Ewing",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2017,
      "name": "Trojans",
      "rookie_year": "2007",
      "city": "Etobicoke",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2019,
      "name": "Robo Runners",
      "rookie_year": "2007",
      "city": "El Cajon",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2021,
      "name": "F.A.R. ",
      "rookie_year": "2007",
      "city": "Fredericksburg",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2022,
      "name": "Titan Robotics",
      "rookie_year": "2007",
      "city": "Aurora",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2023,
      "name": "PiraTech",
      "rookie_year": "2007",
      "city": "Melbourne",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2024,
      "name": "Warrior Pride",
      "rookie_year": "2007",
      "city": "Hilo",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2025,
      "name": "Aztecs",
      "rookie_year": "2007",
      "city": "Barstow",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2026,
      "name": "Senai",
      "rookie_year": "2007",
      "city": "Porto Alegre",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2027,
      "name": "Robotic Dragons",
      "rookie_year": "2007",
      "city": "Old Westbury",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2028,
      "name": "Phantom Robotics",
      "rookie_year": "2007",
      "city": "Hampton",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2029,
      "name": "Neo-Tech Robotics",
      "rookie_year": "2007",
      "city": "Ramona",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2030,
      "name": "RoboTigers",
      "rookie_year": "2007",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2031,
      "name": "Brainy-Actz",
      "rookie_year": "2007",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2032,
      "name": "Funky Monkeys",
      "rookie_year": "2007",
      "city": "San Diego",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2033,
      "name": "Eagles",
      "rookie_year": "2007",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2034,
      "name": "IncrediBULLS",
      "rookie_year": "2007",
      "city": "North Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2035,
      "name": "Robo Rockin' Bots",
      "rookie_year": "2007",
      "city": "Carmel",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2036,
      "name": "The Black Knights",
      "rookie_year": "2007",
      "city": "Boulder",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2037,
      "name": "Oranje Lions",
      "rookie_year": "2007",
      "city": "Brunssum",
      "state": "LI",
      "country": "Netherlands",
      "district": ""
    },
    {
      "number": 2038,
      "name": "Sky Bandits",
      "rookie_year": "2007",
      "city": "Griffin",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2039,
      "name": "Rockford Robotics",
      "rookie_year": "2007",
      "city": "Rockford",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2040,
      "name": "DERT - Dunlap Eagles Robotics Team",
      "rookie_year": "2007",
      "city": "Dunlap",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2041,
      "name": "(RC)2",
      "rookie_year": "2007",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2042,
      "name": "Robo-trees",
      "rookie_year": "2007",
      "city": "Santa Clarita",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2043,
      "name": "Frequency 2043",
      "rookie_year": "2007",
      "city": "Roxbury",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2044,
      "name": "Big Red Robotics",
      "rookie_year": "2007",
      "city": "Papillion",
      "state": "NE",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2045,
      "name": "Robo-Techs",
      "rookie_year": "2007",
      "city": "Oklahoma City",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2046,
      "name": "Bear Metal",
      "rookie_year": "2007",
      "city": "Maple Valley",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2047,
      "name": "Team Challenger",
      "rookie_year": "2007",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2048,
      "name": "The Pink Panthers",
      "rookie_year": "2007",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2049,
      "name": "Sartech",
      "rookie_year": "2007",
      "city": "Gravata\u00ed",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2050,
      "name": "SEB",
      "rookie_year": "2007",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2051,
      "name": "The Beattie Bulldogs",
      "rookie_year": "2007",
      "city": "Allison Park",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2052,
      "name": "KnightKrawler",
      "rookie_year": "2007",
      "city": "New Brighton",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2053,
      "name": "Southern Tier Robotics",
      "rookie_year": "2007",
      "city": "Vestal",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2054,
      "name": "Tech Vikes",
      "rookie_year": "2007",
      "city": "Hopkins",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2055,
      "name": "RoboForce",
      "rookie_year": "2007",
      "city": "Cary",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2056,
      "name": "OP Robotics",
      "rookie_year": "2007",
      "city": "Stoney Creek",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2057,
      "name": "AV CyberBulls",
      "rookie_year": "2007",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2059,
      "name": "The Hitchhikers",
      "rookie_year": "2007",
      "city": "Apex",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 2060,
      "name": "ECHS Robotics",
      "rookie_year": "2007",
      "city": "Tulsa",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2061,
      "name": "Pioneers",
      "rookie_year": "2007",
      "city": "N Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2062,
      "name": "CORE 2062",
      "rookie_year": "2007",
      "city": "Waukesha",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2063,
      "name": "Green Machine",
      "rookie_year": "2007",
      "city": "Turlock",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2064,
      "name": "The Panther Project",
      "rookie_year": "2007",
      "city": "Southbury / Middlebury",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2065,
      "name": "The Lions",
      "rookie_year": "2007",
      "city": "Holly Springs",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2066,
      "name": "PFTB of Doom",
      "rookie_year": "2007",
      "city": "El Centro",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2067,
      "name": "Apple Pi",
      "rookie_year": "2007",
      "city": "Guilford",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2068,
      "name": "Metal Jackets",
      "rookie_year": "2007",
      "city": "Manassas",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2069,
      "name": "Black Widow",
      "rookie_year": "2007",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2070,
      "name": "Royals",
      "rookie_year": "2007",
      "city": "Ridgefield",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2071,
      "name": "Autonomous Eagles",
      "rookie_year": "2007",
      "city": "Arimo",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2072,
      "name": "Carver RoboTechs",
      "rookie_year": "2007",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2073,
      "name": "EagleForce",
      "rookie_year": "2007",
      "city": "Elk Grove",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2074,
      "name": "Robohoundz",
      "rookie_year": "2007",
      "city": "Portsmouth",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2075,
      "name": "Enigma Robotics",
      "rookie_year": "2007",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2076,
      "name": " Scots",
      "rookie_year": "2007",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2077,
      "name": "Laser Robotics",
      "rookie_year": "2007",
      "city": "Wales",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2078,
      "name": "Robotic Wolves",
      "rookie_year": "2007",
      "city": "Covington",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2079,
      "name": "4H ALARM Robotics",
      "rookie_year": "2007",
      "city": "Franklin",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2080,
      "name": "Torbotics",
      "rookie_year": "2007",
      "city": "Hammond",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2081,
      "name": "Icarus",
      "rookie_year": "2007",
      "city": "Peoria",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2083,
      "name": "Team Blitz",
      "rookie_year": "2007",
      "city": "Conifer",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2084,
      "name": "Robots by the C",
      "rookie_year": "2007",
      "city": "Manchester",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2085,
      "name": "RoboDogs",
      "rookie_year": "2007",
      "city": "Vacaville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2087,
      "name": "BFG (Building Future Generations)",
      "rookie_year": "2007",
      "city": "Canby",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2089,
      "name": "IO",
      "rookie_year": "2007",
      "city": "Lajeado",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2090,
      "name": "Buff 'n Blue",
      "rookie_year": "2007",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2091,
      "name": "Olympians",
      "rookie_year": "2007",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2092,
      "name": "Beaufort Robotics ",
      "rookie_year": "2007",
      "city": "Beaufort",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2093,
      "name": "Bowtie Brigade",
      "rookie_year": "2007",
      "city": "Portland",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2095,
      "name": "Direct Current",
      "rookie_year": "2007",
      "city": "Newtown Square",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2096,
      "name": "RoboActive",
      "rookie_year": "2007",
      "city": "Dimona",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 2097,
      "name": "Phoenix Force Robotics",
      "rookie_year": "2007",
      "city": "Tukwila",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2098,
      "name": "Bulldogs",
      "rookie_year": "2007",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2099,
      "name": "Blue on Blue",
      "rookie_year": "2007",
      "city": "Jamaica Plain",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2100,
      "name": "M Squared",
      "rookie_year": "2007",
      "city": "Port St. Lucie",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2102,
      "name": "Team Paradox",
      "rookie_year": "2007",
      "city": "Encinitas",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2103,
      "name": "Fisherman",
      "rookie_year": "2007",
      "city": "Gloucester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2104,
      "name": "The Colonels",
      "rookie_year": "2007",
      "city": "Worcester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2105,
      "name": "University Park",
      "rookie_year": "2007",
      "city": "Worcester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2106,
      "name": "The Junkyard Dogs",
      "rookie_year": "2007",
      "city": "Goochland",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2107,
      "name": "Angry Bots",
      "rookie_year": "2007",
      "city": "Norfolk",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2108,
      "name": "Team Awkward Turtle",
      "rookie_year": "2007",
      "city": "Cary",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2109,
      "name": "Knight Vision",
      "rookie_year": "2007",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2110,
      "name": "CHS",
      "rookie_year": "2007",
      "city": "Charlestown",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2111,
      "name": "Eagles",
      "rookie_year": "2007",
      "city": "Gilbert",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2112,
      "name": "PHP Robo Warriors",
      "rookie_year": "2007",
      "city": "Pembroke Twnshp",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2115,
      "name": "Nightmares",
      "rookie_year": "2007",
      "city": "Mundelein",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2116,
      "name": "Rock County Robotics",
      "rookie_year": "2007",
      "city": "Stoughton",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2117,
      "name": "The West Georgia Wolvotics",
      "rookie_year": "2007",
      "city": "Carrollton",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2119,
      "name": "SCAR (Sequoyah Computer Animation and Robotics)",
      "rookie_year": "2007",
      "city": "Canton",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2120,
      "name": "doncaster ",
      "rookie_year": "2007",
      "city": "doncaster",
      "state": "ENG",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 2121,
      "name": "Mecha Clerks",
      "rookie_year": "2007",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2122,
      "name": "Team Tators",
      "rookie_year": "2007",
      "city": "Boise",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2124,
      "name": "X-Factor",
      "rookie_year": "2007",
      "city": "Hyde Park",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2125,
      "name": "Urban Science",
      "rookie_year": "2007",
      "city": "West Roxbury",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2126,
      "name": "BCLA",
      "rookie_year": "2007",
      "city": "Brighton",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2127,
      "name": "JQUS",
      "rookie_year": "2007",
      "city": "Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2128,
      "name": "SciTech",
      "rookie_year": "2007",
      "city": "Laveen",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2129,
      "name": "Ultraviolet",
      "rookie_year": "2007",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2130,
      "name": "Alpha+",
      "rookie_year": "2007",
      "city": "Bonners Ferry",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2132,
      "name": "Mustangs",
      "rookie_year": "2007",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2133,
      "name": "H.E.A.T.",
      "rookie_year": "2007",
      "city": "Hohenwald",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2134,
      "name": "Aztecs",
      "rookie_year": "2007",
      "city": "Tempe",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2135,
      "name": "Presentation Invasion",
      "rookie_year": "2007",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2136,
      "name": "Impossible Mission Force",
      "rookie_year": "2007",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2137,
      "name": "The Oxford RoboCats",
      "rookie_year": "2007",
      "city": "Oxford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2139,
      "name": "Road Runners",
      "rookie_year": "2007",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2140,
      "name": "Team Synergy",
      "rookie_year": "2007",
      "city": "Pemberton",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2141,
      "name": "Spartonics",
      "rookie_year": "2007",
      "city": "Concord",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2142,
      "name": "Lakeview",
      "rookie_year": "2007",
      "city": "Laleview",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2143,
      "name": "Team Tobor",
      "rookie_year": "2007",
      "city": "Eau Claire",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2144,
      "name": "Gators",
      "rookie_year": "2007",
      "city": "Atherton",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2145,
      "name": "HAZMATs",
      "rookie_year": "2007",
      "city": "Linden",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2147,
      "name": "CHUCK",
      "rookie_year": "2007",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2148,
      "name": "Mechaknights",
      "rookie_year": "2007",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2149,
      "name": "CV Bearbots",
      "rookie_year": "2007",
      "city": "Veradale",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2150,
      "name": "W-Squared",
      "rookie_year": "2007",
      "city": "Palos Verdes Peninsula",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2151,
      "name": "Monty Pythons",
      "rookie_year": "2007",
      "city": "Forest Park",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2152,
      "name": "S*M*A*S*H",
      "rookie_year": "2007",
      "city": "Port Orange",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2153,
      "name": "Chassell Robotics",
      "rookie_year": "2007",
      "city": "Chassell",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2154,
      "name": "AzTechs",
      "rookie_year": "2007",
      "city": "Calexico",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2156,
      "name": "Wire Freaks",
      "rookie_year": "2007",
      "city": "Sacramento",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2157,
      "name": "Apollo ",
      "rookie_year": "2007",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2158,
      "name": "ausTIN CANs",
      "rookie_year": "2007",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2159,
      "name": "RoboPirates",
      "rookie_year": "2007",
      "city": "San Leandro",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2161,
      "name": "Robocats",
      "rookie_year": "2007",
      "city": "Huntington Station",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2162,
      "name": "MacAttacks",
      "rookie_year": "2007",
      "city": "Boston",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2163,
      "name": "ChromePanthers",
      "rookie_year": "2007",
      "city": "Lapeer",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2164,
      "name": "The Core",
      "rookie_year": "2007",
      "city": "Harrisonville",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2165,
      "name": "BisonBots",
      "rookie_year": "2007",
      "city": "Bartlesville",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2166,
      "name": "Bluebotics",
      "rookie_year": "2007",
      "city": "Oakville",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2167,
      "name": "Radical Tech",
      "rookie_year": "2007",
      "city": "Maryville",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2168,
      "name": "Aluminum Falcons",
      "rookie_year": "2007",
      "city": "Groton",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2169,
      "name": "KING TeC",
      "rookie_year": "2007",
      "city": "Savage",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2170,
      "name": "Galvanized Guardians",
      "rookie_year": "2007",
      "city": "Glastonbury",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2171,
      "name": "RoboDogs",
      "rookie_year": "2007",
      "city": "Crown Point",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 2172,
      "name": "Steel Unit-E",
      "rookie_year": "2007",
      "city": "Lakewood",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2173,
      "name": "Robo Rocks",
      "rookie_year": "2007",
      "city": "Bay St. Louis",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2174,
      "name": "Iron Eagles",
      "rookie_year": "2007",
      "city": "Watts",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2175,
      "name": "The Fighting Calculators",
      "rookie_year": "2007",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2176,
      "name": "MAD SCIENTIST ASSOCIATION",
      "rookie_year": "2007",
      "city": "Starkville",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2177,
      "name": "The Robettes",
      "rookie_year": "2007",
      "city": "Mendota Heights",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2178,
      "name": "RioBotics",
      "rookie_year": "2007",
      "city": "Oxnard",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2180,
      "name": "Zero Gravity",
      "rookie_year": "2007",
      "city": "Hamilton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2181,
      "name": "G.E.A.R.s (Great Engineers Awesome Robots)",
      "rookie_year": "2007",
      "city": "Blaine",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2182,
      "name": "Tyborgs",
      "rookie_year": "2007",
      "city": "Slidell",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2183,
      "name": "Tigerbots",
      "rookie_year": "2007",
      "city": "Boutte",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2184,
      "name": "Team Injun Ingenuity",
      "rookie_year": "2007",
      "city": "Whiteriver",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2185,
      "name": "RAMAZOIDZ",
      "rookie_year": "2007",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2186,
      "name": "Dogs of Steel",
      "rookie_year": "2007",
      "city": "Chantilly",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2187,
      "name": "Team Volt",
      "rookie_year": "2007",
      "city": "Conway",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2188,
      "name": "Critical Mass",
      "rookie_year": "2007",
      "city": "Belding",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2189,
      "name": "woodland Robotics",
      "rookie_year": "2007",
      "city": "Woodland",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2190,
      "name": "Team Hero",
      "rookie_year": "2007",
      "city": "Petal",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2191,
      "name": "Flux Core",
      "rookie_year": "2007",
      "city": "Hamilton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2192,
      "name": "YAK Attack",
      "rookie_year": "2007",
      "city": "Newport",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2193,
      "name": "EPIC Robotics",
      "rookie_year": "2007",
      "city": "Chula Vista",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2194,
      "name": "Fondy Fire",
      "rookie_year": "2007",
      "city": "Fond du Lac",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2196,
      "name": "B\u00e9\u00e9sh B\u00e1'\u00e1h Alchini",
      "rookie_year": "2007",
      "city": "Shiprock",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2197,
      "name": "Las Pumas",
      "rookie_year": "2007",
      "city": "New Carlisle",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 2198,
      "name": "Paradigm Shift Robotics",
      "rookie_year": "2007",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2199,
      "name": "Robo-Lions",
      "rookie_year": "2007",
      "city": "Finksburg",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2200,
      "name": "MMRambotics",
      "rookie_year": "2007",
      "city": "Burlington",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2201,
      "name": "TGM",
      "rookie_year": "2007",
      "city": "Grandview",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2202,
      "name": "BEAST Robotics",
      "rookie_year": "2007",
      "city": "Brookfield",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2203,
      "name": "Cyber-Eagles",
      "rookie_year": "2007",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2204,
      "name": "Rambots",
      "rookie_year": "2007",
      "city": "Hayward",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2205,
      "name": "Juggernauts",
      "rookie_year": "2007",
      "city": "Mount Vernon",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2206,
      "name": "Ehret Patriots",
      "rookie_year": "2007",
      "city": "Marrero",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2207,
      "name": "Bright Bears",
      "rookie_year": "2007",
      "city": "White Bear Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2208,
      "name": "Makif Dalet",
      "rookie_year": "2007",
      "city": "Ashdod",
      "state": "D",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2209,
      "name": "Rabin HS",
      "rookie_year": "2007",
      "city": "Beer Sheva",
      "state": "D",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2210,
      "name": "Yarka High School",
      "rookie_year": "2007",
      "city": "Yarka",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2211,
      "name": "Ort IAI",
      "rookie_year": "2007",
      "city": "Lod",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2212,
      "name": "The Spikes",
      "rookie_year": "2007",
      "city": "Lod",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 2213,
      "name": "AXIOM",
      "rookie_year": "2007",
      "city": "Nahariya",
      "state": "HaZafon (Northern)",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2214,
      "name": "ASSIT",
      "rookie_year": "2007",
      "city": "Yemin Orde",
      "state": "HA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2215,
      "name": " Akkoleon",
      "rookie_year": "2007",
      "city": "Akko",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2216,
      "name": "robodim",
      "rookie_year": "2007",
      "city": "Dimona",
      "state": "HaDarom (Southern)",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2217,
      "name": "Kiryat Motzkin",
      "rookie_year": "2007",
      "city": "Kiryat Motzkin",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2219,
      "name": "Megahurts",
      "rookie_year": "2007",
      "city": "Carbondale",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2220,
      "name": "Blue Twilight",
      "rookie_year": "2007",
      "city": "Eagan",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2221,
      "name": "FHS Robodawgs",
      "rookie_year": "2007",
      "city": "Mandeville",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2222,
      "name": "Abes",
      "rookie_year": "2007",
      "city": "Tacoma",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2223,
      "name": "B-ROC",
      "rookie_year": "2007",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2224,
      "name": "RoboPhoenix",
      "rookie_year": "2007",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2225,
      "name": "R.U.S.T",
      "rookie_year": "2007",
      "city": "Brooklyn Park",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2226,
      "name": "Bronco's",
      "rookie_year": "2007",
      "city": "Blanding",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2227,
      "name": "Tigers",
      "rookie_year": "2007",
      "city": "Fridley",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2228,
      "name": "CougarTech",
      "rookie_year": "2007",
      "city": "Honeoye Falls",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2229,
      "name": "ROBOSHOP",
      "rookie_year": "2007",
      "city": "Plymouth Meeting",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2230,
      "name": "General Angels",
      "rookie_year": "2007",
      "city": "Herzliya",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 2231,
      "name": "OnyxTronix",
      "rookie_year": "2007",
      "city": "Shoham",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 2232,
      "name": "Deus ex Machina",
      "rookie_year": "2007",
      "city": "Anoka",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2234,
      "name": "Alternating Current",
      "rookie_year": "2007",
      "city": "Newtown Square",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2235,
      "name": "Abraxas Metal Heads",
      "rookie_year": "2007",
      "city": "Poway",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2236,
      "name": "Genese Team",
      "rookie_year": "2007",
      "city": "Sao Paulo",
      "state": "SP",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2237,
      "name": "The Junkyard Robo's",
      "rookie_year": "2007",
      "city": "Beckley",
      "state": "WV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2239,
      "name": "Technocrats",
      "rookie_year": "2007",
      "city": "Hopkins",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2240,
      "name": "Brute Force",
      "rookie_year": "2007",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2241,
      "name": "SWAT team",
      "rookie_year": "2007",
      "city": "Coon Rapids",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2242,
      "name": "Cyber Claw",
      "rookie_year": "2007",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2243,
      "name": "BRATECC",
      "rookie_year": "2007",
      "city": "Campinas",
      "state": "SP",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2244,
      "name": "The Chips",
      "rookie_year": "2007",
      "city": "Osasco",
      "state": "SP",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2245,
      "name": "PANTHERS",
      "rookie_year": "2007",
      "city": "Frankfort",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2246,
      "name": "The Army of Sum",
      "rookie_year": "2007",
      "city": "Johannesburg",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2247,
      "name": "FB HT",
      "rookie_year": "2007",
      "city": "Gravata\u00ed",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2249,
      "name": "KISS",
      "rookie_year": "2007",
      "city": "Billings",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2250,
      "name": "Lancerbotics",
      "rookie_year": "2007",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2251,
      "name": "Hawks",
      "rookie_year": "2007",
      "city": "Bozeman",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2252,
      "name": "The Mavericks",
      "rookie_year": "2007",
      "city": "Milan",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2254,
      "name": "Twisted Transistors",
      "rookie_year": "2007",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2257,
      "name": "Afula High School",
      "rookie_year": "2007",
      "city": "Afula",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2259,
      "name": "1/4 Twenties",
      "rookie_year": "2007",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2260,
      "name": "Transformers",
      "rookie_year": "2007",
      "city": "Edwards",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2261,
      "name": "Casa Robotics",
      "rookie_year": "2007",
      "city": "Longmont",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2262,
      "name": "Robo-Panthers",
      "rookie_year": "2007",
      "city": "Holliston",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2264,
      "name": "Trojan Robotics",
      "rookie_year": "2007",
      "city": "Plymouth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2265,
      "name": "Fe Maidens",
      "rookie_year": "2007",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2266,
      "name": "Colegio Sacramentinas",
      "rookie_year": "2007",
      "city": "Salvador",
      "state": "BA",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2269,
      "name": "Dragons",
      "rookie_year": "2007",
      "city": "Lindale",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2272,
      "name": "Metalheads",
      "rookie_year": "2007",
      "city": "Thousand Oaks",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2273,
      "name": "The Mechanix Coalition",
      "rookie_year": "2007",
      "city": "Surrey",
      "state": "BC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2274,
      "name": "Fuego",
      "rookie_year": "2007",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2275,
      "name": "Bello Bots",
      "rookie_year": "2007",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2276,
      "name": "STARS of Cypress ",
      "rookie_year": "2007",
      "city": "Cypress",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2278,
      "name": "AVENGING PLUTO",
      "rookie_year": "2007",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2279,
      "name": "The Butlers",
      "rookie_year": "2007",
      "city": "Butler",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2280,
      "name": "YWCA DELTA F.O.R.C.E.",
      "rookie_year": "2007",
      "city": "Pittsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2283,
      "name": "Panteras",
      "rookie_year": "2007",
      "city": "Mexico City",
      "state": "Distrito Federal",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 2285,
      "name": "Irvington Blue Knights 4-H",
      "rookie_year": "2007",
      "city": "Irvington",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2287,
      "name": "RoboTech Pirates",
      "rookie_year": "2007",
      "city": "Sinton",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2288,
      "name": "Hydra Robotics",
      "rookie_year": "2007",
      "city": "Vacaville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2330,
      "name": "F-Tech",
      "rookie_year": "2008",
      "city": "Fletcher",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2332,
      "name": "Team Lucky",
      "rookie_year": "2008",
      "city": "Fairview",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2333,
      "name": "S.C.R.E.E.C.H.",
      "rookie_year": "2008",
      "city": "Sapulpa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2334,
      "name": "Blue Valley CAPS Robotics",
      "rookie_year": "2008",
      "city": "Stilwell",
      "state": "KS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2335,
      "name": "Sargon",
      "rookie_year": "2008",
      "city": "Prairie Village",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2336,
      "name": "Titan Crusaders",
      "rookie_year": "2008",
      "city": "Midlothian",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2337,
      "name": "EngiNERDs",
      "rookie_year": "2008",
      "city": "Grand Blanc",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2338,
      "name": "Gear It Forward",
      "rookie_year": "2008",
      "city": "Oswego",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2339,
      "name": "Robolopes",
      "rookie_year": "2008",
      "city": "Lancaster",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2340,
      "name": "Xcentrics",
      "rookie_year": "2008",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2341,
      "name": "Sprockets",
      "rookie_year": "2008",
      "city": "Shawnee",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2342,
      "name": "Team Phoenix",
      "rookie_year": "2008",
      "city": "Nashua",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2343,
      "name": "Technohorns",
      "rookie_year": "2008",
      "city": "Inola",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2344,
      "name": "The Saunders Droid Factory",
      "rookie_year": "2008",
      "city": "Yonkers",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2345,
      "name": "Animal Control",
      "rookie_year": "2008",
      "city": "Kearney",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2346,
      "name": "Cel-Techs",
      "rookie_year": "2008",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2347,
      "name": "Trial and Error",
      "rookie_year": "2008",
      "city": "Copiague",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2348,
      "name": "Cool Geeks",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2349,
      "name": "Hurriquake",
      "rookie_year": "2008",
      "city": "Wayland",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2350,
      "name": "Region 1 Robotics",
      "rookie_year": "2008",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2352,
      "name": "Metal Mayhem",
      "rookie_year": "2008",
      "city": "Ada",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2353,
      "name": "The Legion",
      "rookie_year": "2008",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2354,
      "name": "Red River Robotics",
      "rookie_year": "2008",
      "city": "Duncan",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2357,
      "name": "System Meltdown",
      "rookie_year": "2008",
      "city": "Peculiar",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2358,
      "name": "Bearbotics",
      "rookie_year": "2008",
      "city": "Lake Zurich",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2359,
      "name": "RoboLobos",
      "rookie_year": "2008",
      "city": "Edmond",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2360,
      "name": "Tech Titan's POWER-Storm",
      "rookie_year": "2008",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2361,
      "name": "PACE Invaders",
      "rookie_year": "2008",
      "city": "Richmond Hill",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2362,
      "name": "Olympic Robotics",
      "rookie_year": "2008",
      "city": "Charlotte",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2363,
      "name": "Triple Helix",
      "rookie_year": "2008",
      "city": "Newport News",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2364,
      "name": "Oregon RoboHawks",
      "rookie_year": "2008",
      "city": "Oregon",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2365,
      "name": "Lions",
      "rookie_year": "2008",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2366,
      "name": "Tesla Robotics",
      "rookie_year": "2008",
      "city": "Independence",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2367,
      "name": "Lancer Robotics",
      "rookie_year": "2008",
      "city": "Mountain View",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2368,
      "name": "South Robotics",
      "rookie_year": "2008",
      "city": "Terre Haute",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2369,
      "name": "Maximus Roboticus",
      "rookie_year": "2008",
      "city": "Stillwater",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2370,
      "name": "IBOTS",
      "rookie_year": "2008",
      "city": "Rutland",
      "state": "Vermont",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2371,
      "name": "Eagle Pride",
      "rookie_year": "2008",
      "city": "Morris",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2372,
      "name": "Robo-Hooters",
      "rookie_year": "2008",
      "city": "Elgin",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2373,
      "name": "The Crickets",
      "rookie_year": "2008",
      "city": "Fort Cobb",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2374,
      "name": "Crusader Bots",
      "rookie_year": "2008",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2375,
      "name": "Dragon Robotics",
      "rookie_year": "2008",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2376,
      "name": "RoboCOMETS",
      "rookie_year": "2008",
      "city": "Tulsa",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2377,
      "name": "C Company",
      "rookie_year": "2008",
      "city": "Pasadena",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2378,
      "name": "Team Mako 2378",
      "rookie_year": "2008",
      "city": "Taloga",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2380,
      "name": "Jag Robotics",
      "rookie_year": "2008",
      "city": "Mesa",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2381,
      "name": "The Ark",
      "rookie_year": "2008",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2382,
      "name": "Colbert Roboleopards",
      "rookie_year": "2008",
      "city": "Colbert",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2383,
      "name": "Ninjineers",
      "rookie_year": "2008",
      "city": "Fort Lauderdale",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2385,
      "name": "Obelisk Trio",
      "rookie_year": "2008",
      "city": "Tulsa",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2386,
      "name": "Trojans",
      "rookie_year": "2008",
      "city": "Burlington",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2387,
      "name": "Alternative Robotics",
      "rookie_year": "2008",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2388,
      "name": "Pirate Robotics",
      "rookie_year": "2008",
      "city": "Sperry",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2389,
      "name": "Oklahoma STORM",
      "rookie_year": "2008",
      "city": "Drumright",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2390,
      "name": "Wildcats",
      "rookie_year": "2008",
      "city": "San Ramon",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2391,
      "name": "Tiger Drive",
      "rookie_year": "2008",
      "city": "Broken Arrow",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2392,
      "name": "Pagwire",
      "rookie_year": "2008",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2393,
      "name": "Robotichauns",
      "rookie_year": "2008",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2394,
      "name": "Eagles",
      "rookie_year": "2008",
      "city": "Watonga",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2395,
      "name": "OKC 4-H Robotics - Ninja Munkees",
      "rookie_year": "2008",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2396,
      "name": "SeeHawks",
      "rookie_year": "2008",
      "city": "Yukon",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2397,
      "name": "Cyborgs",
      "rookie_year": "2008",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2398,
      "name": "Tech Walkers 2398",
      "rookie_year": "2008",
      "city": "Tahlequah",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2399,
      "name": "The Fighting Unicorns",
      "rookie_year": "2008",
      "city": "Shaker Heights",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2400,
      "name": "Wyoming!?",
      "rookie_year": "2008",
      "city": "Sheridan",
      "state": "WY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2401,
      "name": "PATRIOTS",
      "rookie_year": "2008",
      "city": "MAYVILLE",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2402,
      "name": "RoboJackets",
      "rookie_year": "2008",
      "city": "Fredericksburg",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2403,
      "name": "Plasma Robotics",
      "rookie_year": "2008",
      "city": "Mesa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2404,
      "name": "TNT",
      "rookie_year": "2008",
      "city": "Altadena",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2405,
      "name": "Techno Trojans",
      "rookie_year": "2008",
      "city": "Fruitport",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2406,
      "name": "CowDogs",
      "rookie_year": "2008",
      "city": "Camp Verde",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2407,
      "name": "Roaring Bears",
      "rookie_year": "2008",
      "city": "Leetonia",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2408,
      "name": "Shrapnel Sergeants",
      "rookie_year": "2008",
      "city": "Hazelwood",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2409,
      "name": "Da Bears",
      "rookie_year": "2008",
      "city": "New Bedford",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2410,
      "name": "Blue Valley CAPS Metal Mustang Robotics",
      "rookie_year": "2008",
      "city": "Overland Park",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2411,
      "name": "Rebel Alliance",
      "rookie_year": "2008",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2412,
      "name": "Robototes",
      "rookie_year": "2008",
      "city": "Bellevue",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2413,
      "name": "Panthers",
      "rookie_year": "2008",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2414,
      "name": "Spartans",
      "rookie_year": "2008",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2415,
      "name": "WiredCats",
      "rookie_year": "2008",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 2417,
      "name": "RoboCougars",
      "rookie_year": "2008",
      "city": "Crewe",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2418,
      "name": "tomahawks",
      "rookie_year": "2008",
      "city": "Minot",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2419,
      "name": "Team MonRobot",
      "rookie_year": "2008",
      "city": "Brea",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2420,
      "name": "RoboTitans",
      "rookie_year": "2008",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2421,
      "name": "RTR Team Robotics",
      "rookie_year": "2008",
      "city": "Burke",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2422,
      "name": "Bucket O' Bolts",
      "rookie_year": "2008",
      "city": "Davenport",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2423,
      "name": "The KwarQs",
      "rookie_year": "2008",
      "city": "Watertown",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2424,
      "name": "Robot Mafia",
      "rookie_year": "2008",
      "city": "Bixby",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2425,
      "name": "Hydra",
      "rookie_year": "2008",
      "city": "Tampa",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2427,
      "name": "Techno Beavers",
      "rookie_year": "2008",
      "city": "Westmount",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2428,
      "name": "Panthers",
      "rookie_year": "2008",
      "city": "Sewickley",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2429,
      "name": "La Canada Engineering Club",
      "rookie_year": "2008",
      "city": "La Canada Flintridge",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2430,
      "name": "CyberStorm",
      "rookie_year": "2008",
      "city": "Greenwood",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2431,
      "name": "TechnoColts",
      "rookie_year": "2008",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2432,
      "name": "RoboSpartans",
      "rookie_year": "2008",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2433,
      "name": "Tech Tigers",
      "rookie_year": "2008",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2434,
      "name": "Blue Devils Gear Heads",
      "rookie_year": "2008",
      "city": "Hopewell",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2435,
      "name": "Soldiers of Technology",
      "rookie_year": "2008",
      "city": "Lawton",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2436,
      "name": "Bearacudas",
      "rookie_year": "2008",
      "city": "Noble",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2437,
      "name": "Lancer Robotics",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2438,
      "name": "'Iobotics",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2439,
      "name": "Bearbotics",
      "rookie_year": "2008",
      "city": "Wailuku",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2440,
      "name": "Saints",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2441,
      "name": "Spartechs",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2443,
      "name": "Blue Thunder",
      "rookie_year": "2008",
      "city": "Kahului",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2444,
      "name": "Kamehameha RoboWarriors",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2445,
      "name": "RoboKAP",
      "rookie_year": "2008",
      "city": "Kapolei",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2446,
      "name": "Pleasanton Slingshots",
      "rookie_year": "2008",
      "city": "Pleasanton",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2447,
      "name": "Vikes",
      "rookie_year": "2008",
      "city": "Hanover",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2448,
      "name": "SLT",
      "rookie_year": "2008",
      "city": "London",
      "state": "ENG",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 2449,
      "name": "Out of Orbit Robotics",
      "rookie_year": "2008",
      "city": "Chandler",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2450,
      "name": "Wind Chill",
      "rookie_year": "2008",
      "city": "St. Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2451,
      "name": "PWNAGE",
      "rookie_year": "2008",
      "city": "Saint Charles",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2453,
      "name": "Soaring Eagles",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2454,
      "name": "Rambotx",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2455,
      "name": "HRC 2455",
      "rookie_year": "2008",
      "city": "Honoka'a",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2456,
      "name": "Team Recycle It!",
      "rookie_year": "2008",
      "city": "San Rafael",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2457,
      "name": "The Law",
      "rookie_year": "2008",
      "city": "Lawson",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2458,
      "name": "Team Chaos",
      "rookie_year": "2008",
      "city": "Gladstone",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2459,
      "name": "Golden Hawks",
      "rookie_year": "2008",
      "city": "Waianae",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2460,
      "name": "Na Paniolo",
      "rookie_year": "2008",
      "city": "Kapaau",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2461,
      "name": "METAL-SKINS",
      "rookie_year": "2008",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2462,
      "name": "Digi Bots",
      "rookie_year": "2008",
      "city": "CHICAGO",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2463,
      "name": "The Siege ",
      "rookie_year": "2008",
      "city": "Lexington",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2464,
      "name": "Trojans",
      "rookie_year": "2008",
      "city": "Pahrump",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2465,
      "name": "Kauaibots",
      "rookie_year": "2008",
      "city": "Lihue",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2466,
      "name": "Menehune Robots",
      "rookie_year": "2008",
      "city": "Waimea",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2467,
      "name": "Sabertron",
      "rookie_year": "2008",
      "city": "Ewa Beach",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2468,
      "name": "Team Appreciate",
      "rookie_year": "2008",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2469,
      "name": "Idabots",
      "rookie_year": "2008",
      "city": "Idabel",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2470,
      "name": "Team BJORG",
      "rookie_year": "2008",
      "city": "Bloomington",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2471,
      "name": "Team Mean Machine",
      "rookie_year": "2008",
      "city": "Camas",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2472,
      "name": "Centurions",
      "rookie_year": "2008",
      "city": "Circle Pines",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2473,
      "name": "Goldstrikers",
      "rookie_year": "2008",
      "city": "Cupertino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2474,
      "name": "Excel",
      "rookie_year": "2008",
      "city": "Niles",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2475,
      "name": "Caution!",
      "rookie_year": "2008",
      "city": "Kamuela",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2476,
      "name": "The Limited",
      "rookie_year": "2008",
      "city": "Floral Park",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2477,
      "name": "Marauder Rascals",
      "rookie_year": "2008",
      "city": "Waipahu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2478,
      "name": "Westwood Robotics",
      "rookie_year": "2008",
      "city": "Mesa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2479,
      "name": "Phoenix",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2480,
      "name": "Roosevelt Robotics",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2481,
      "name": "Roboteers",
      "rookie_year": "2008",
      "city": "Tremont",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2483,
      "name": "Clawbotz",
      "rookie_year": "2008",
      "city": "Fayetteville",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2484,
      "name": "Team Implosion",
      "rookie_year": "2008",
      "city": "Woods Cross",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2485,
      "name": "W.A.R. Lords",
      "rookie_year": "2008",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2486,
      "name": "CocoNuts",
      "rookie_year": "2008",
      "city": "Flagstaff",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2487,
      "name": "Mechanical Animals",
      "rookie_year": "2008",
      "city": "West Sayville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2488,
      "name": "Plasma Pumas",
      "rookie_year": "2008",
      "city": "Rochester",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2489,
      "name": "The Insomniacs",
      "rookie_year": "2008",
      "city": "Fremont",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2490,
      "name": "eagles",
      "rookie_year": "2008",
      "city": "chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2491,
      "name": "NoMythic",
      "rookie_year": "2008",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2493,
      "name": "Robokong",
      "rookie_year": "2008",
      "city": "Riverside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2495,
      "name": "Hive Mind",
      "rookie_year": "2008",
      "city": "Hamilton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2496,
      "name": "Tru Blu Patriots",
      "rookie_year": "2008",
      "city": "Irvine",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2497,
      "name": "RoboNatick",
      "rookie_year": "2008",
      "city": "Natick",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2498,
      "name": "BearBotics",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2499,
      "name": "Industrial Revolution 2499",
      "rookie_year": "2008",
      "city": "Hibbing",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2500,
      "name": "Herobotics",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2501,
      "name": "Bionic Polars",
      "rookie_year": "2008",
      "city": "North St. Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2502,
      "name": "Talon Robotics",
      "rookie_year": "2008",
      "city": "Eden Prairie",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2503,
      "name": "Warrior Robotics",
      "rookie_year": "2008",
      "city": "Brainerd",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2504,
      "name": "The Governors",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2505,
      "name": "The Electric Sheep",
      "rookie_year": "2008",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2506,
      "name": "Saber Robotics",
      "rookie_year": "2008",
      "city": "Franklin",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2508,
      "name": "Armada",
      "rookie_year": "2008",
      "city": "Stillwater",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2509,
      "name": "Tigerbots",
      "rookie_year": "2008",
      "city": "Hutchinson ",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2510,
      "name": "anishinaabe",
      "rookie_year": "2008",
      "city": "Cloquet",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2511,
      "name": "Cougars",
      "rookie_year": "2008",
      "city": "Lakeville",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2512,
      "name": "Duluth East Daredevils",
      "rookie_year": "2008",
      "city": "Duluth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2513,
      "name": "T.E.R.T.O.L.A.",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2514,
      "name": "3M MHS",
      "rookie_year": "2008",
      "city": "Mahtomedi",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2515,
      "name": "Marshall Robotics and Engineering",
      "rookie_year": "2008",
      "city": "Marshall",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2517,
      "name": "Green Wrenches",
      "rookie_year": "2008",
      "city": "Vancouver",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2518,
      "name": "Spartan Robotics",
      "rookie_year": "2008",
      "city": "Inver Grove Heights",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2520,
      "name": "Robotics 9000",
      "rookie_year": "2008",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2521,
      "name": "SERT",
      "rookie_year": "2008",
      "city": "Eugene",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2522,
      "name": "Royal Robotics",
      "rookie_year": "2008",
      "city": "Bothell",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2523,
      "name": "Tech Storm",
      "rookie_year": "2008",
      "city": "Saint Johnsbury",
      "state": "Vermont",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2524,
      "name": "Roosevelt Rough Riders",
      "rookie_year": "2008",
      "city": "Yonkers",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2525,
      "name": "The pHalcons",
      "rookie_year": "2008",
      "city": "Plymouth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2526,
      "name": "Crimson Robotics",
      "rookie_year": "2008",
      "city": "Osseo",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2528,
      "name": "RoboDoves",
      "rookie_year": "2008",
      "city": "Baltimore",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2529,
      "name": "Open Circuits",
      "rookie_year": "2008",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2530,
      "name": "Inconceivable",
      "rookie_year": "2008",
      "city": "Rochester",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2531,
      "name": "RoboHawks",
      "rookie_year": "2008",
      "city": "Chaska",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2532,
      "name": "FLASH Power",
      "rookie_year": "2008",
      "city": "Forest Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2533,
      "name": "Juarez Aztec Eagles",
      "rookie_year": "2008",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2534,
      "name": "Lumberjack Robotics",
      "rookie_year": "2008",
      "city": "Baltimore ",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2535,
      "name": "TIGEARS",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2536,
      "name": "Carver Bears",
      "rookie_year": "2008",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2537,
      "name": "Space RAIDers",
      "rookie_year": "2008",
      "city": "Columbia",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2538,
      "name": "The Plaid Pillagers",
      "rookie_year": "2008",
      "city": "Morris",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2539,
      "name": "Krypton Cougars",
      "rookie_year": "2008",
      "city": "Palmyra",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2540,
      "name": "SPARC",
      "rookie_year": "2008",
      "city": "Pontotoc",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2542,
      "name": "Go4bots",
      "rookie_year": "2008",
      "city": "Gresham",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2543,
      "name": "TitanBot",
      "rookie_year": "2008",
      "city": "Chula Vista",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2544,
      "name": "HCRC",
      "rookie_year": "2008",
      "city": "Harborcreek",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2545,
      "name": "Quantum Mechanics",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2546,
      "name": "Electric Sheep",
      "rookie_year": "2008",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2547,
      "name": "Redcat Robos",
      "rookie_year": "2008",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2549,
      "name": "Millerbots",
      "rookie_year": "2008",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2550,
      "name": "Skynet",
      "rookie_year": "2008",
      "city": "Oregon City",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2551,
      "name": "Penguin Empire",
      "rookie_year": "2008",
      "city": "Novato",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2553,
      "name": "Pirates",
      "rookie_year": "2008",
      "city": "Pearl",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2554,
      "name": "The WarHawks",
      "rookie_year": "2008",
      "city": "Edison",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2555,
      "name": "RoboRams",
      "rookie_year": "2008",
      "city": "Tacoma",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2556,
      "name": "RadioActive Roaches",
      "rookie_year": "2008",
      "city": "Niceville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2557,
      "name": "SOTAbots",
      "rookie_year": "2008",
      "city": "Tacoma",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2558,
      "name": "SciBot",
      "rookie_year": "2008",
      "city": "Harrisburg",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2559,
      "name": "Normality Zero",
      "rookie_year": "2008",
      "city": "Harrisburg",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2560,
      "name": "RoboDog",
      "rookie_year": "2008",
      "city": "Grandview",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2561,
      "name": "St Paul East Side RobEASTs",
      "rookie_year": "2008",
      "city": "Saint Paul",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2562,
      "name": "Robinson",
      "rookie_year": "2008",
      "city": "San Juan",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2563,
      "name": "Toros",
      "rookie_year": "2008",
      "city": "Caguas",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2564,
      "name": "Red Hawks",
      "rookie_year": "2008",
      "city": "San Juan",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2565,
      "name": "Technovations",
      "rookie_year": "2008",
      "city": "Cupey",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2566,
      "name": "Universitiers",
      "rookie_year": "2008",
      "city": "San Juan",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2567,
      "name": "Miguel",
      "rookie_year": "2008",
      "city": "San Juan",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2568,
      "name": "STORM",
      "rookie_year": "2008",
      "city": "Carolina",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2569,
      "name": "Artist Engineers",
      "rookie_year": "2008",
      "city": "San Juan",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2570,
      "name": "SHS",
      "rookie_year": "2008",
      "city": "Sahuarita",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2571,
      "name": "Chief robot",
      "rookie_year": "2008",
      "city": "Haileyville",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2572,
      "name": "governors",
      "rookie_year": "2008",
      "city": "Saint Paul",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2573,
      "name": "Mustang",
      "rookie_year": "2008",
      "city": "Brooklyn",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2574,
      "name": "RoboHuskie",
      "rookie_year": "2008",
      "city": "St. Anthony",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2575,
      "name": "White Hurricane",
      "rookie_year": "2008",
      "city": "Santa Branca",
      "state": "SP",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2576,
      "name": "Chilean Heart",
      "rookie_year": "2008",
      "city": "Santiago",
      "state": "Regi\u00f3n Metropolitana de Santiago",
      "country": "Chile",
      "district": ""
    },
    {
      "number": 2577,
      "name": "Pingry Robotics",
      "rookie_year": "2008",
      "city": "Basking Ridge",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2579,
      "name": "LIC Robodogs",
      "rookie_year": "2008",
      "city": "Astoria",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2580,
      "name": "Mecha-Knights",
      "rookie_year": "2008",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2581,
      "name": "Bulldog Robotic Team",
      "rookie_year": "2008",
      "city": "Monroe",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2582,
      "name": "PantherBots",
      "rookie_year": "2008",
      "city": "Lufkin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2583,
      "name": "Orange Dynamite",
      "rookie_year": "2008",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2584,
      "name": "Flame of The West",
      "rookie_year": "2008",
      "city": "Calabasas",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2585,
      "name": "Impact",
      "rookie_year": "2008",
      "city": "Bellaire",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2586,
      "name": "Copper Bots",
      "rookie_year": "2008",
      "city": "Calumet",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2587,
      "name": "DiscoBots",
      "rookie_year": "2008",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2588,
      "name": "JAVA",
      "rookie_year": "2008",
      "city": "Pomona",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2589,
      "name": "The Codebandits",
      "rookie_year": "2008",
      "city": "Byfield",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2590,
      "name": "Nemesis",
      "rookie_year": "2008",
      "city": "Robbinsville",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2591,
      "name": "RedTails",
      "rookie_year": "2008",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2592,
      "name": "Hawks",
      "rookie_year": "2008",
      "city": "Rio Rico",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2593,
      "name": "Brobot",
      "rookie_year": "2008",
      "city": "Peabody",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2594,
      "name": "Naskcorpions",
      "rookie_year": "2008",
      "city": "Nampa",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2595,
      "name": "Illuminati",
      "rookie_year": "2008",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2596,
      "name": "Ferrous Bulldog Inovations ",
      "rookie_year": "2008",
      "city": "Jersey City",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2597,
      "name": "Raider bots",
      "rookie_year": "2008",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2598,
      "name": "Neofighters",
      "rookie_year": "2008",
      "city": "Hercules",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2599,
      "name": "FULL THROTTLE",
      "rookie_year": "2008",
      "city": "CHULA VISTA",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2600,
      "name": "Team Falcon",
      "rookie_year": "2008",
      "city": "Oak Ridge",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2601,
      "name": "Steel Hawks",
      "rookie_year": "2008",
      "city": "Flushing",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2602,
      "name": "Falcons",
      "rookie_year": "2008",
      "city": "Henderson",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2603,
      "name": "Steel Stingers",
      "rookie_year": "2008",
      "city": "Medina",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2604,
      "name": "Metal and Soul",
      "rookie_year": "2008",
      "city": "Capac",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2605,
      "name": "Seamonsters ",
      "rookie_year": "2008",
      "city": "Bellingham",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2606,
      "name": "Irish Robotics",
      "rookie_year": "2008",
      "city": "Rosemount",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2607,
      "name": "The Fighting RoboVikings",
      "rookie_year": "2008",
      "city": "Warminster ",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2608,
      "name": "MiGHT",
      "rookie_year": "2008",
      "city": "Farmington Hills",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2609,
      "name": "BeaverworX",
      "rookie_year": "2008",
      "city": "Guelph",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2611,
      "name": "Jacktown Vectors",
      "rookie_year": "2008",
      "city": "Jackson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2612,
      "name": "The Corsairs",
      "rookie_year": "2008",
      "city": "Waterford",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2613,
      "name": "Protobots",
      "rookie_year": "2008",
      "city": "Van Horn",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2614,
      "name": "Mountaineer Area RoboticS (MARS)",
      "rookie_year": "2008",
      "city": "Morgantown",
      "state": "West Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2617,
      "name": "Robo Reds",
      "rookie_year": "2008",
      "city": "Lansing",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2618,
      "name": "The Mad Hatters",
      "rookie_year": "2008",
      "city": "Pittsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2619,
      "name": "The Charge",
      "rookie_year": "2008",
      "city": "Midland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2620,
      "name": "Titans",
      "rookie_year": "2008",
      "city": "Southgate",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2621,
      "name": "Bucs",
      "rookie_year": "2008",
      "city": "Bedford",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2622,
      "name": "Team 1",
      "rookie_year": "2008",
      "city": "San Diego",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2623,
      "name": "lovenpeace",
      "rookie_year": "2008",
      "city": "Antioch",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2624,
      "name": "BotCatz",
      "rookie_year": "2008",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2625,
      "name": "ARC Robotics",
      "rookie_year": "2008",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2626,
      "name": "Evolution",
      "rookie_year": "2008",
      "city": "Sherbrooke",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2627,
      "name": "Techies",
      "rookie_year": "2008",
      "city": "Ann Arbor",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2628,
      "name": "Pirates",
      "rookie_year": "2008",
      "city": "San Francisco",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2629,
      "name": "Halcones",
      "rookie_year": "2008",
      "city": "QUERETARO",
      "state": "OAX",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 2630,
      "name": "Thunderbolts",
      "rookie_year": "2008",
      "city": "Emek hefer",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 2632,
      "name": "SteeleBots",
      "rookie_year": "2008",
      "city": "Amherst",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2633,
      "name": "Pittsburg Pirates",
      "rookie_year": "2008",
      "city": "Pittsburg",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2634,
      "name": "The Gryphons",
      "rookie_year": "2008",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2635,
      "name": "Lake Monsters",
      "rookie_year": "2008",
      "city": "Lake Oswego",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2637,
      "name": "Phantom Catz",
      "rookie_year": "2008",
      "city": "Rolling Hills Estates",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2638,
      "name": "Rebel Robotics",
      "rookie_year": "2008",
      "city": "Great Neck",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2640,
      "name": "HOTBOTZ",
      "rookie_year": "2008",
      "city": "Wentworth",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 2641,
      "name": "PCCR",
      "rookie_year": "2008",
      "city": "Pittsburgh",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2642,
      "name": "Pitt Pirates",
      "rookie_year": "2008",
      "city": "Greenville",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 2643,
      "name": "Dark Matter",
      "rookie_year": "2008",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2644,
      "name": "Trojans",
      "rookie_year": "2008",
      "city": "Pittsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2645,
      "name": "PowerSurge",
      "rookie_year": "2008",
      "city": "Muskegon",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2647,
      "name": "Cyborg Mustangs",
      "rookie_year": "2008",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2648,
      "name": "Infinite Loop",
      "rookie_year": "2008",
      "city": "Oakland",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2649,
      "name": "Meyer Robotics",
      "rookie_year": "2008",
      "city": "Porto Alegre",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2650,
      "name": "ELAHLYA",
      "rookie_year": "2008",
      "city": "Om- Elfahem",
      "state": "HA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2652,
      "name": "Highlander Engineering and Technology",
      "rookie_year": "2008",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2653,
      "name": "Master Robotics",
      "rookie_year": "2008",
      "city": "Aracaju",
      "state": "SE",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2654,
      "name": "Polar Rams",
      "rookie_year": "2008",
      "city": "Roseau",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2655,
      "name": "The Flying Platypi",
      "rookie_year": "2008",
      "city": "Greensboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 2656,
      "name": "Quasics",
      "rookie_year": "2008",
      "city": "Monroeville",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2657,
      "name": "Team Thundercats",
      "rookie_year": "2008",
      "city": "Deming",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2658,
      "name": "\u03a3-Motion",
      "rookie_year": "2008",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2659,
      "name": "RoboWarriors",
      "rookie_year": "2008",
      "city": "Mission Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2660,
      "name": "Pengbots",
      "rookie_year": "2008",
      "city": "Tulalip",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2661,
      "name": "Trailblazers",
      "rookie_year": "2008",
      "city": "Chatsworth",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2662,
      "name": "RoboKrew",
      "rookie_year": "2008",
      "city": "Tolleson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2663,
      "name": "The Foothillers",
      "rookie_year": "2008",
      "city": "El Cajon",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2664,
      "name": "Lobos",
      "rookie_year": "2008",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2665,
      "name": "CougarBots",
      "rookie_year": "2008",
      "city": "Dayton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2667,
      "name": "Knights of the Valley",
      "rookie_year": "2008",
      "city": "Apple Valley",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2668,
      "name": "North Montco Vortex",
      "rookie_year": "2008",
      "city": "Lansdale",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2669,
      "name": "KY Bots",
      "rookie_year": "2008",
      "city": "Kiryat Yam",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2670,
      "name": "Absent Algorithms",
      "rookie_year": "2008",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2672,
      "name": "Osfia",
      "rookie_year": "2008",
      "city": "Osfia",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2673,
      "name": "Tenacious Technicians",
      "rookie_year": "2008",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2674,
      "name": "Nilton Lins",
      "rookie_year": "2008",
      "city": "Manaus",
      "state": "AM",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2675,
      "name": "ABCTech",
      "rookie_year": "2008",
      "city": "Canoas",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2676,
      "name": "Ecorse Robo Raiders",
      "rookie_year": "2008",
      "city": "Ecorse",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2678,
      "name": "Brauder",
      "rookie_year": "2008",
      "city": "Jerusalem",
      "state": "JM",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2679,
      "name": "Tiger Team",
      "rookie_year": "2008",
      "city": "Jerusalem",
      "state": "Yerushalayim",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 2680,
      "name": "Vex Minas",
      "rookie_year": "2008",
      "city": "Minas do Le\u00e3o",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 2681,
      "name": "Lady G-House Pirates",
      "rookie_year": "2008",
      "city": "Brooklyn",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2682,
      "name": "Boneyard Robotics 2682",
      "rookie_year": "2008",
      "city": "Farmville",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2685,
      "name": "Team Haven",
      "rookie_year": "2008",
      "city": "Byfield",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2686,
      "name": "The Memphis MechWarriors",
      "rookie_year": "2008",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2687,
      "name": "Team Apprentice",
      "rookie_year": "2008",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2688,
      "name": "'Iolani Robotics",
      "rookie_year": "2008",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2689,
      "name": "Team Alpha",
      "rookie_year": "2008",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2702,
      "name": "Rebels",
      "rookie_year": "2009",
      "city": "Kitchener",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2703,
      "name": "fire fox",
      "rookie_year": "2009",
      "city": "ben shemen y.v.",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 2704,
      "name": "Roaring Robotics",
      "rookie_year": "2009",
      "city": "Naperville",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2705,
      "name": "WE ROBOT",
      "rookie_year": "2009",
      "city": "Eden Prairie",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2706,
      "name": "Merge Robotics",
      "rookie_year": "2009",
      "city": "Kanata",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2707,
      "name": "Viking Robotics",
      "rookie_year": "2009",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2708,
      "name": "Lake Effect Robotics",
      "rookie_year": "2009",
      "city": "Kingston",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2709,
      "name": "Iron Wolves",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2710,
      "name": "JetStream 2710",
      "rookie_year": "2009",
      "city": "Rancho Palos Verdes",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2711,
      "name": "Centaurus Robotics",
      "rookie_year": "2009",
      "city": "Lafayette",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2712,
      "name": "Power Surge 4-H Robotics",
      "rookie_year": "2009",
      "city": "Waterbury",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2713,
      "name": "iRaiders",
      "rookie_year": "2009",
      "city": "Melrose",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2714,
      "name": "\u2668\ufe0f BBQ \u2668\ufe0f",
      "rookie_year": "2009",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2716,
      "name": "Ranger Force",
      "rookie_year": "2009",
      "city": "Spencerport",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2718,
      "name": "Team OKC",
      "rookie_year": "2009",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2719,
      "name": "Ketronix Robotix",
      "rookie_year": "2009",
      "city": "Monroe",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2720,
      "name": "Red Watch Robotics",
      "rookie_year": "2009",
      "city": "Medford",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2721,
      "name": "Fang",
      "rookie_year": "2009",
      "city": "Lasara",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2722,
      "name": "Charge Robotics",
      "rookie_year": "2009",
      "city": "Marlton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 2723,
      "name": "Team Rocket",
      "rookie_year": "2009",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2725,
      "name": "Ice Princesses",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2729,
      "name": "Storm Robotics Team",
      "rookie_year": "2009",
      "city": "Marlton",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2733,
      "name": "Pigmice",
      "rookie_year": "2009",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2735,
      "name": "RoBobcats",
      "rookie_year": "2009",
      "city": "Fruitvale",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2737,
      "name": "Wizards",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2739,
      "name": "Bucket of Bolts",
      "rookie_year": "2009",
      "city": "Gilberts",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2741,
      "name": "Method 2 Madness",
      "rookie_year": "2009",
      "city": "Batavia",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2743,
      "name": "Berkner Rambots ",
      "rookie_year": "2009",
      "city": "Richardson",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2745,
      "name": "Incognito",
      "rookie_year": "2009",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2747,
      "name": "Turner Lions",
      "rookie_year": "2009",
      "city": "Carrollton",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2749,
      "name": "The 7th Direction",
      "rookie_year": "2009",
      "city": "Connersville",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2751,
      "name": "SPARK Robotics",
      "rookie_year": "2009",
      "city": "Pendleton",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2753,
      "name": "Team Overdrive",
      "rookie_year": "2009",
      "city": "Bridgewater",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2757,
      "name": "B.A.D. (Built And Dangerous!)",
      "rookie_year": "2009",
      "city": "Longwood",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2759,
      "name": "Roboneers",
      "rookie_year": "2009",
      "city": "Stillwater",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2761,
      "name": "IronHorse Robotics",
      "rookie_year": "2009",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2763,
      "name": "Tigers",
      "rookie_year": "2009",
      "city": "Sterling",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2765,
      "name": "Radioactive Robotics",
      "rookie_year": "2009",
      "city": "Norman",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2767,
      "name": "Stryke Force",
      "rookie_year": "2009",
      "city": "Kalamazoo",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2769,
      "name": "ROBOTS IN MOTION",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2771,
      "name": "Code Red Robotics the Stray Dogs",
      "rookie_year": "2009",
      "city": "Grandville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2773,
      "name": "IronDogz",
      "rookie_year": "2009",
      "city": "Edmond",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2775,
      "name": "Jackson Area Robotics",
      "rookie_year": "2009",
      "city": "Jackson",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2777,
      "name": "Blackwell Resistance",
      "rookie_year": "2009",
      "city": "Blackwell",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2779,
      "name": "CH1RP",
      "rookie_year": "2009",
      "city": "Claremore",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2781,
      "name": "RoboPRIDE",
      "rookie_year": "2009",
      "city": "Burbank",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2783,
      "name": "Engineers of Tomorrow",
      "rookie_year": "2009",
      "city": "La Grange",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2785,
      "name": "Prometheus",
      "rookie_year": "2009",
      "city": "Kent",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2787,
      "name": "Team Chaos",
      "rookie_year": "2009",
      "city": "Corpus Christi",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2789,
      "name": "TEXPLOSION",
      "rookie_year": "2009",
      "city": "Manor",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2791,
      "name": "Shaker Robotics",
      "rookie_year": "2009",
      "city": "Latham",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2793,
      "name": "Sabercats",
      "rookie_year": "2009",
      "city": "Moore",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2795,
      "name": "Ohm's Claw",
      "rookie_year": "2009",
      "city": "Broken Arrow",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2797,
      "name": "Knight & Nerdy",
      "rookie_year": "2009",
      "city": "Clermont",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2799,
      "name": "The Teslas",
      "rookie_year": "2009",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2803,
      "name": "Firebirds",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2805,
      "name": "Ghost in the Machine",
      "rookie_year": "2009",
      "city": "Waxahachie",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2809,
      "name": "K-Botics",
      "rookie_year": "2009",
      "city": "Kingston",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2811,
      "name": "StormBots",
      "rookie_year": "2009",
      "city": "Vancouver",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2813,
      "name": "Gear Heads",
      "rookie_year": "2009",
      "city": "Saratoga",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2815,
      "name": "Blue Devil Mechanics",
      "rookie_year": "2009",
      "city": "Columbia",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2817,
      "name": "Bluff City Bots",
      "rookie_year": "2009",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2819,
      "name": "Team Dynamite",
      "rookie_year": "2009",
      "city": "Oxon Hill",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2821,
      "name": "TASER",
      "rookie_year": "2009",
      "city": "Preston",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2823,
      "name": "The Automatons",
      "rookie_year": "2009",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2825,
      "name": "Roc Robotics",
      "rookie_year": "2009",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2826,
      "name": "Wave Robotics",
      "rookie_year": "2009",
      "city": "Oshkosh",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2827,
      "name": "Crown City Robotics",
      "rookie_year": "2009",
      "city": "Coronado",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2829,
      "name": "Knights of Sir MacHinery",
      "rookie_year": "2009",
      "city": "Norman",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2830,
      "name": "Riverside RoboTigers",
      "rookie_year": "2009",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2831,
      "name": "Warriors",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2832,
      "name": "The Livonia  Warriors",
      "rookie_year": "2009",
      "city": "Livonia",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2833,
      "name": "Roboscorpions",
      "rookie_year": "2009",
      "city": "Brownsville",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2834,
      "name": "Bionic Black Hawks",
      "rookie_year": "2009",
      "city": "Bloomfield Twp",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2835,
      "name": "Shazbotz",
      "rookie_year": "2009",
      "city": "Youngstown",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2836,
      "name": "Team Beta",
      "rookie_year": "2009",
      "city": "Woodbury",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2837,
      "name": "Freebirds",
      "rookie_year": "2009",
      "city": "Gilbert",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2838,
      "name": "Eaglebots",
      "rookie_year": "2009",
      "city": "Chesterfield",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2839,
      "name": "Daedalus",
      "rookie_year": "2009",
      "city": "Escondido",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2840,
      "name": "PCDS Blue Tide",
      "rookie_year": "2009",
      "city": "Paradise Valley",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2841,
      "name": "NECHS",
      "rookie_year": "2009",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2842,
      "name": "Mustangs",
      "rookie_year": "2009",
      "city": "Bokchito",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2843,
      "name": "Metal Heads",
      "rookie_year": "2009",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2844,
      "name": "Stampede Robotics",
      "rookie_year": "2009",
      "city": "Laveen",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2845,
      "name": "O'Botics",
      "rookie_year": "2009",
      "city": "Osseo",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2846,
      "name": "FireBears",
      "rookie_year": "2009",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2847,
      "name": "The MegaHertz",
      "rookie_year": "2009",
      "city": "Fairmont",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2848,
      "name": "Rangers",
      "rookie_year": "2009",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2849,
      "name": "Ursa Major",
      "rookie_year": "2009",
      "city": "Columbia",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2850,
      "name": "Cyberwolves",
      "rookie_year": "2009",
      "city": "Coeur d'Alene",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2851,
      "name": "Crevolution",
      "rookie_year": "2009",
      "city": "Sterling Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2852,
      "name": "DM High Voltage",
      "rookie_year": "2009",
      "city": "St Catharines",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2853,
      "name": "Hot Spot Robotics",
      "rookie_year": "2009",
      "city": "Mililani",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2854,
      "name": "The Prototypes",
      "rookie_year": "2009",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2855,
      "name": "BEASTBOT",
      "rookie_year": "2009",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2856,
      "name": "Planetary Drive",
      "rookie_year": "2009",
      "city": "Lexington",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2857,
      "name": "Black Ops",
      "rookie_year": "2009",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2859,
      "name": "Blasterbots",
      "rookie_year": "2009",
      "city": "Golden",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2861,
      "name": "Infinity's End",
      "rookie_year": "2009",
      "city": "Lake City",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2862,
      "name": "UTC Westhill Vikings",
      "rookie_year": "2009",
      "city": "Stamford",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2864,
      "name": "Sigma Phoenix",
      "rookie_year": "2009",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2865,
      "name": "ROBOTEKNIX",
      "rookie_year": "2009",
      "city": "Post Falls",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2866,
      "name": "Phoenix Robotics",
      "rookie_year": "2009",
      "city": "Owings Mills",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2867,
      "name": "ElkLogics",
      "rookie_year": "2009",
      "city": "Elkhart",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 2869,
      "name": "Regal Eagles",
      "rookie_year": "2009",
      "city": "Bethpage",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2871,
      "name": "Beantown Botz",
      "rookie_year": "2009",
      "city": "Roxbury",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2872,
      "name": "CyberCats",
      "rookie_year": "2009",
      "city": "Old Westbury",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2873,
      "name": "NWR",
      "rookie_year": "2009",
      "city": "Flowood",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2874,
      "name": "Iron Eagles",
      "rookie_year": "2009",
      "city": "Grain Valley",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2875,
      "name": "CyberHawks",
      "rookie_year": "2009",
      "city": "Cold Spring Harbor",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2876,
      "name": "Devilbotz",
      "rookie_year": "2009",
      "city": "Burlington",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2877,
      "name": "LigerBots",
      "rookie_year": "2009",
      "city": "Newton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 2879,
      "name": "Oriole Robotics",
      "rookie_year": "2009",
      "city": "Saint Louis Park",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2880,
      "name": "Finger Puppet Mafia",
      "rookie_year": "2009",
      "city": "Galveston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2881,
      "name": "Lady Cans",
      "rookie_year": "2009",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2882,
      "name": "Nuts n' Boltz",
      "rookie_year": "2009",
      "city": "Katy",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2883,
      "name": "F.R.E.D (FIRST Robotics Engineering and Design)",
      "rookie_year": "2009",
      "city": "Warroad",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2884,
      "name": "EngiKnights",
      "rookie_year": "2009",
      "city": "Caguas",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2885,
      "name": "Falcons",
      "rookie_year": "2009",
      "city": "San Juan",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2887,
      "name": "Blue Bots",
      "rookie_year": "2009",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2888,
      "name": "The Beaverbots",
      "rookie_year": "2009",
      "city": "Chestnut Hill",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2890,
      "name": "The Hawk Collective",
      "rookie_year": "2009",
      "city": "Chesapeake",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2892,
      "name": "Hottie Botties",
      "rookie_year": "2009",
      "city": "Sacramento",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2893,
      "name": "Parkway North Robohobos",
      "rookie_year": "2009",
      "city": "Saint Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2894,
      "name": "ACE Robotics",
      "rookie_year": "2009",
      "city": "Kansas City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2895,
      "name": "Blazenbots",
      "rookie_year": "2009",
      "city": "Far Rockaway",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2896,
      "name": "MechaMonarchs",
      "rookie_year": "2009",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2897,
      "name": "R3 - Rapoport Raven Robotics",
      "rookie_year": "2009",
      "city": "Waco",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2898,
      "name": "Flying Hedgehogs",
      "rookie_year": "2009",
      "city": "Beaverton",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2900,
      "name": "The Mighty Penguins",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2901,
      "name": "Rocket Sock'em Robots",
      "rookie_year": "2009",
      "city": "Cortland",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2902,
      "name": "NYACK",
      "rookie_year": "2009",
      "city": "Saint Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2903,
      "name": "NeoBots",
      "rookie_year": "2009",
      "city": "Arlington",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2904,
      "name": "PlaZmachines",
      "rookie_year": "2009",
      "city": "Monroe",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2905,
      "name": "Sultans of Turkiye",
      "rookie_year": "2009",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 2906,
      "name": "Sentinel Prime Robotics",
      "rookie_year": "2009",
      "city": "Spanaway",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2907,
      "name": "Lion Robotics",
      "rookie_year": "2009",
      "city": "Auburn",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2908,
      "name": "DeceptiKangs",
      "rookie_year": "2009",
      "city": "Kirkland",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2909,
      "name": "Zebra Bots",
      "rookie_year": "2009",
      "city": "Rochester",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2910,
      "name": "Jack in the Bot",
      "rookie_year": "2009",
      "city": "Bothell",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2911,
      "name": "CoolBots",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2912,
      "name": "Panther Robotics",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2913,
      "name": "ROBOT RAMBLER ",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2914,
      "name": "TIGER PRIDE",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2915,
      "name": "Pandamonium",
      "rookie_year": "2009",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2916,
      "name": "Bionic Bears",
      "rookie_year": "2009",
      "city": "Palm Bay",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2917,
      "name": "Woodward RoboDogs",
      "rookie_year": "2009",
      "city": "Cincinnati",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2918,
      "name": "Gearheads",
      "rookie_year": "2009",
      "city": "Jasper",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2919,
      "name": "Night Wolves",
      "rookie_year": "2009",
      "city": "L.A.",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2920,
      "name": "Robo-Hawks",
      "rookie_year": "2009",
      "city": "Holly Springs",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2921,
      "name": "Falcon",
      "rookie_year": "2009",
      "city": "Tacoma",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2922,
      "name": "RoboCon",
      "rookie_year": "2009",
      "city": "Concrete",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2923,
      "name": "Aggies",
      "rookie_year": "2009",
      "city": "Rosalia",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2924,
      "name": "2924 Murphy's Lawyers",
      "rookie_year": "2009",
      "city": "Chimacum",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2925,
      "name": "North Central Tech Center",
      "rookie_year": "2009",
      "city": "Wenatchee",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2926,
      "name": "Robo Sparks",
      "rookie_year": "2009",
      "city": "Wapato",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2927,
      "name": "GKHS Pi Rho Techs",
      "rookie_year": "2009",
      "city": "Graham",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2928,
      "name": "Viking Robotics",
      "rookie_year": "2009",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2929,
      "name": "JAGBOTS",
      "rookie_year": "2009",
      "city": "Puyallup",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2930,
      "name": "Sonic Squirrels",
      "rookie_year": "2009",
      "city": "Snohomish",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2932,
      "name": "Pueo Power Engineering",
      "rookie_year": "2009",
      "city": "Honolulu",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2933,
      "name": "BASH",
      "rookie_year": "2009",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2934,
      "name": "Tech Tigers ",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2935,
      "name": "NACI Robotics",
      "rookie_year": "2009",
      "city": "Etobicoke",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 2936,
      "name": "Gatorzillas",
      "rookie_year": "2009",
      "city": "Dickinson",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2938,
      "name": "HSE Tigers",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2940,
      "name": "The Alternative Experience",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2941,
      "name": "BLURR-Ben Logan Ultra Raider Robotics",
      "rookie_year": "2009",
      "city": "Bellefontaine",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2942,
      "name": "Panda Robotics",
      "rookie_year": "2009",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2943,
      "name": "ROBO Dynamics",
      "rookie_year": "2009",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2944,
      "name": "Titanium Tigers",
      "rookie_year": "2009",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2945,
      "name": "Steel Mustangs",
      "rookie_year": "2009",
      "city": "Manitou Springs",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2946,
      "name": "Novas",
      "rookie_year": "2009",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2947,
      "name": "ROBO-TIGERS",
      "rookie_year": "2009",
      "city": "EL PASO",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2948,
      "name": "Prototype",
      "rookie_year": "2009",
      "city": "Fort Worth",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2949,
      "name": "pwnage",
      "rookie_year": "2009",
      "city": "Batavia",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2950,
      "name": "Devastators",
      "rookie_year": "2009",
      "city": "Waco",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2951,
      "name": "Benson High Robotics Club",
      "rookie_year": "2009",
      "city": "Portland",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2952,
      "name": "Brackenbots",
      "rookie_year": "2009",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2953,
      "name": "South Dallas Bots",
      "rookie_year": "2009",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2956,
      "name": "E-STEM EAGLES",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2957,
      "name": "Knights",
      "rookie_year": "2009",
      "city": "Alden",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2958,
      "name": "Grizzly's",
      "rookie_year": "2009",
      "city": "Canton",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2959,
      "name": "Robotarians",
      "rookie_year": "2009",
      "city": "Coloma",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2960,
      "name": "Automation Nation",
      "rookie_year": "2009",
      "city": "Birmingham",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 2961,
      "name": "Crimson Tide Engineers",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2962,
      "name": "EagleBots",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2963,
      "name": "AnaDroids",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2964,
      "name": "Robopanthers",
      "rookie_year": "2009",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2965,
      "name": "Iron Vikings",
      "rookie_year": "2009",
      "city": "Lubbock",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2966,
      "name": "Tiger Tech",
      "rookie_year": "2009",
      "city": "Pharr",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2967,
      "name": "Columbus IronWorks",
      "rookie_year": "2009",
      "city": "Columbus",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2969,
      "name": "Aftermath",
      "rookie_year": "2009",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 2970,
      "name": "eSchool eBots",
      "rookie_year": "2009",
      "city": "Kenosha",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2971,
      "name": "ROBO-IDAHO",
      "rookie_year": "2009",
      "city": "Coeur d'Alene",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2972,
      "name": "RC Dawson",
      "rookie_year": "2009",
      "city": "Lafayette",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2973,
      "name": "Mad Rockers",
      "rookie_year": "2009",
      "city": "Madison",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2974,
      "name": "Walton Robotics",
      "rookie_year": "2009",
      "city": "Marietta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 2975,
      "name": "Team Viral",
      "rookie_year": "2009",
      "city": "Central",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2976,
      "name": "The Spartabots",
      "rookie_year": "2009",
      "city": "Sammamish",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2977,
      "name": "Sir Lancer Bots",
      "rookie_year": "2009",
      "city": "La Crescent",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2978,
      "name": "Cavaliers",
      "rookie_year": "2009",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2979,
      "name": "RO-BEAUMONT",
      "rookie_year": "2009",
      "city": "Beaumont",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2980,
      "name": "Whidbey Island Wildcats",
      "rookie_year": "2009",
      "city": "Oak Harbor",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2981,
      "name": "Bulldogs",
      "rookie_year": "2009",
      "city": "Waco",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2982,
      "name": "Phoenix Metal",
      "rookie_year": "2009",
      "city": "Laredo",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2983,
      "name": "Robo-Noles",
      "rookie_year": "2009",
      "city": "Fairburn",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2984,
      "name": "NASA, Lockheed, Qualcomm Vikings Robotics",
      "rookie_year": "2009",
      "city": "La Jolla",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2985,
      "name": "Tech Know Logic",
      "rookie_year": "2009",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2986,
      "name": "Cyber Comets",
      "rookie_year": "2009",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2987,
      "name": "Rogue Robotics",
      "rookie_year": "2009",
      "city": "Farmington",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2988,
      "name": "RoboGenesis",
      "rookie_year": "2009",
      "city": "Berryville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2989,
      "name": "Star Tech",
      "rookie_year": "2009",
      "city": "Richfield",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2990,
      "name": "Hotwire",
      "rookie_year": "2009",
      "city": "Turner",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 2991,
      "name": "Boxer Bots",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2992,
      "name": "The S.S. Prometheus",
      "rookie_year": "2009",
      "city": "Mandeville",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2993,
      "name": "InTech MegaBots",
      "rookie_year": "2009",
      "city": "Logan",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2994,
      "name": "ASTECHZ",
      "rookie_year": "2009",
      "city": "Ottawa",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 2995,
      "name": "\"Mountain Force Robotics\"",
      "rookie_year": "2009",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2996,
      "name": "Cougars Gone Wired",
      "rookie_year": "2009",
      "city": "Colorado Springs",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 2998,
      "name": "VikingBots",
      "rookie_year": "2009",
      "city": "Richmond",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 2999,
      "name": "TJHS",
      "rookie_year": "2009",
      "city": "Rochester",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3000,
      "name": "Jeffersontown Robochargers",
      "rookie_year": "2009",
      "city": "Louisville",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3001,
      "name": "Chieftain Robotics",
      "rookie_year": "2009",
      "city": "Santa Fe Springs",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3002,
      "name": "Roboblazers",
      "rookie_year": "2009",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3003,
      "name": "TAN(X)",
      "rookie_year": "2009",
      "city": "Canandaigua",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3004,
      "name": "Bronx Knights",
      "rookie_year": "2009",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3005,
      "name": "RoboChargers",
      "rookie_year": "2009",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3006,
      "name": "Red Rock Robotics",
      "rookie_year": "2009",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3007,
      "name": "Robotitans",
      "rookie_year": "2009",
      "city": "Oakdale",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3008,
      "name": "Team Magma",
      "rookie_year": "2009",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3009,
      "name": "High Scalers",
      "rookie_year": "2009",
      "city": "Boulder City",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3010,
      "name": "The Red Plague",
      "rookie_year": "2009",
      "city": "Centerburg",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3011,
      "name": "RoboWarriors",
      "rookie_year": "2009",
      "city": "APO",
      "state": "Hessen",
      "country": "Germany",
      "district": ""
    },
    {
      "number": 3012,
      "name": "Spartans",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3013,
      "name": "Zombots",
      "rookie_year": "2009",
      "city": "Vallejo ",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3014,
      "name": "Tech Heads",
      "rookie_year": "2009",
      "city": "Albuquerque",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3015,
      "name": "Ranger Robotics",
      "rookie_year": "2009",
      "city": "Spencerport",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3016,
      "name": "CyCreek Crusaders",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3017,
      "name": "Patriots",
      "rookie_year": "2009",
      "city": "Fresh Meadows",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3018,
      "name": "Nordic Storm",
      "rookie_year": "2009",
      "city": "Saint Peter",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3019,
      "name": "Firebirds",
      "rookie_year": "2009",
      "city": "Scottsdale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3020,
      "name": "SMbled",
      "rookie_year": "2009",
      "city": "Rancho Santa Margarita",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3021,
      "name": "The  Agency",
      "rookie_year": "2009",
      "city": "Escondido",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3022,
      "name": "MKS Explosion",
      "rookie_year": "2009",
      "city": "San Jose",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3023,
      "name": "STARK Industries",
      "rookie_year": "2009",
      "city": "Elk River",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3024,
      "name": "My Favorite Team",
      "rookie_year": "2009",
      "city": "Ashland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3025,
      "name": "DARC",
      "rookie_year": "2009",
      "city": "Decatur",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3026,
      "name": "Orange Crush Robotics",
      "rookie_year": "2009",
      "city": "Delano",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3027,
      "name": "Seraphim Systems",
      "rookie_year": "2009",
      "city": "Ventura",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3028,
      "name": "Robot Commando Squad",
      "rookie_year": "2009",
      "city": "Hidalgo",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3029,
      "name": "Mecha Titans",
      "rookie_year": "2009",
      "city": "Pharr",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3032,
      "name": "Master Team",
      "rookie_year": "2009",
      "city": "Aracaju",
      "state": "SE",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 3034,
      "name": "Galileo",
      "rookie_year": "2009",
      "city": "Kefar Blum",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3035,
      "name": "Droid Rage",
      "rookie_year": "2009",
      "city": "Corpus Christi",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3036,
      "name": "DROBA Warriors",
      "rookie_year": "2009",
      "city": "Deer River",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3037,
      "name": "LOBOTS",
      "rookie_year": "2009",
      "city": "Longview",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3038,
      "name": "ICE",
      "rookie_year": "2009",
      "city": "North Branch",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3039,
      "name": "Wildcat Robotics",
      "rookie_year": "2009",
      "city": "Destrehan",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3040,
      "name": "red knights",
      "rookie_year": "2009",
      "city": "toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3041,
      "name": "Spartans Robotics Club",
      "rookie_year": "2009",
      "city": "Chula Vista",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3042,
      "name": "Cobalt Catalysts",
      "rookie_year": "2009",
      "city": "Apple Valley",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3043,
      "name": "Da Vinci Dragons & Cathedral HS ",
      "rookie_year": "2009",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3044,
      "name": "Team 0xBE4",
      "rookie_year": "2009",
      "city": "Ballston Spa",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3045,
      "name": "Gear Gremlins",
      "rookie_year": "2009",
      "city": "San Mateo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3046,
      "name": "GWHS RoboFanatics",
      "rookie_year": "2009",
      "city": "Charmco",
      "state": "WV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3048,
      "name": "EVIT Robotics 2017",
      "rookie_year": "2009",
      "city": "Mesa ",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3049,
      "name": "BremerTron",
      "rookie_year": "2009",
      "city": "Bremerton",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3052,
      "name": "Makif Yud",
      "rookie_year": "2009",
      "city": "Rishon Lezion",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3053,
      "name": "VB Stingers",
      "rookie_year": "2009",
      "city": "Queens Village",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3054,
      "name": "IceStorm",
      "rookie_year": "2009",
      "city": "Grand Marais",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3055,
      "name": "Furious George",
      "rookie_year": "2009",
      "city": "Austin",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3056,
      "name": "Pirates",
      "rookie_year": "2009",
      "city": "Crookston",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3057,
      "name": "MHS Jaquers",
      "rookie_year": "2009",
      "city": "Rochester",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3058,
      "name": "AnnDroids",
      "rookie_year": "2009",
      "city": "Annandale",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3059,
      "name": "Riverside Envirobotics",
      "rookie_year": "2009",
      "city": "Yonkers",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3060,
      "name": "The Narcoleptic Doxins",
      "rookie_year": "2009",
      "city": "Birmingham",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3061,
      "name": "Huskie Robotics",
      "rookie_year": "2009",
      "city": "Naperville",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3062,
      "name": "Spartan Robotics",
      "rookie_year": "2009",
      "city": "Natrona Heights",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3063,
      "name": "HOLTZ-STARS",
      "rookie_year": "2009",
      "city": "Tel Aviv",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3064,
      "name": "Tichon Tel Aviv",
      "rookie_year": "2009",
      "city": "Tichon Tel Aviv",
      "state": "HA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3065,
      "name": "Jatt High School",
      "rookie_year": "2009",
      "city": "Jatt",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3067,
      "name": "Robovikes",
      "rookie_year": "2009",
      "city": "Geneva",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3069,
      "name": "TarNation",
      "rookie_year": "2009",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3070,
      "name": "Team Pronto",
      "rookie_year": "2009",
      "city": "Shoreline",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3071,
      "name": "Certified NOOBS",
      "rookie_year": "2009",
      "city": "Humble",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3072,
      "name": "Backwoods Bots",
      "rookie_year": "2009",
      "city": "Wytheville",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3073,
      "name": "firstinlod",
      "rookie_year": "2009",
      "city": "LOD",
      "state": "TA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3074,
      "name": "New School Robotics",
      "rookie_year": "2009",
      "city": "Kennebunk",
      "state": "ME",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3075,
      "name": "Ha-Dream Team",
      "rookie_year": "2009",
      "city": "Hod-Ha'Sharon",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3076,
      "name": "Ort Arad",
      "rookie_year": "2009",
      "city": "Arad",
      "state": "D",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3077,
      "name": "Robobrain",
      "rookie_year": "2009",
      "city": "Jerusalem",
      "state": "JM",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3079,
      "name": "The RoboWarriors",
      "rookie_year": "2009",
      "city": "Richmond",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3080,
      "name": "So-Called Robotics",
      "rookie_year": "2009",
      "city": "Rio Grande City",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3081,
      "name": "RoboEagles",
      "rookie_year": "2009",
      "city": "Bloomington",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3082,
      "name": "Chicken Bot Pie",
      "rookie_year": "2009",
      "city": "Minnetonka",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3083,
      "name": "Artemis",
      "rookie_year": "2009",
      "city": "Maagan Michael",
      "state": "HaZafon",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3084,
      "name": "PatriORT",
      "rookie_year": "2009",
      "city": "Hazor",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3086,
      "name": "Broncoweiss",
      "rookie_year": "2009",
      "city": "Kyriat Shmona",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3087,
      "name": "Ben Shemen",
      "rookie_year": "2009",
      "city": "Ben Shemen",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3088,
      "name": "Kill-O-Bites",
      "rookie_year": "2009",
      "city": "Kiryat Bialik",
      "state": "HA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3089,
      "name": "Bot-N",
      "rookie_year": "2009",
      "city": "Haifa",
      "state": "HA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3090,
      "name": "Ramhawks",
      "rookie_year": "2009",
      "city": "Winona",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3091,
      "name": "100 Scholars",
      "rookie_year": "2009",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 3092,
      "name": "Nazareth Ilit",
      "rookie_year": "2009",
      "city": "Nazareth Ilit",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3093,
      "name": "Bearcats",
      "rookie_year": "2009",
      "city": "Monroe",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3094,
      "name": "Blich",
      "rookie_year": "2009",
      "city": "Ramat Gan",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3095,
      "name": "Pilots",
      "rookie_year": "2009",
      "city": "Warren",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3096,
      "name": "The Village Bulldogs",
      "rookie_year": "2009",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3097,
      "name": "Blue Lightning",
      "rookie_year": "2009",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3098,
      "name": "Waterford Robotics",
      "rookie_year": "2009",
      "city": "Waterford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3100,
      "name": "Lightning Turtles",
      "rookie_year": "2009",
      "city": "Mendota Heights",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3102,
      "name": "Tech-No-Tigers",
      "rookie_year": "2009",
      "city": "Nevis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3103,
      "name": "Iron Plaid",
      "rookie_year": "2009",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3104,
      "name": "The Cyber Rams",
      "rookie_year": "2009",
      "city": "Stamford",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3105,
      "name": " Lagablab",
      "rookie_year": "2009",
      "city": "Manila",
      "state": "00",
      "country": "Philippines",
      "district": ""
    },
    {
      "number": 3106,
      "name": "The Contenders",
      "rookie_year": "2009",
      "city": "Farmersville",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3107,
      "name": "Tilden Techers",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3108,
      "name": "PR9",
      "rookie_year": "2009",
      "city": "pttsburgh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3109,
      "name": "GA Robotics",
      "rookie_year": "2009",
      "city": "Memphis",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3110,
      "name": "DragonBot",
      "rookie_year": "2009",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3111,
      "name": "RoboCougars",
      "rookie_year": "2009",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3112,
      "name": "GSERT Falcons",
      "rookie_year": "2009",
      "city": "Bronx",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3114,
      "name": "To be determined",
      "rookie_year": "2009",
      "city": "Southfield",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3115,
      "name": "Robo-Panthers",
      "rookie_year": "2009",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3116,
      "name": "Phoenix",
      "rookie_year": "2009",
      "city": "Memphis",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3117,
      "name": "Harfangs",
      "rookie_year": "2009",
      "city": "Sherbrooke",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3119,
      "name": "Rockets",
      "rookie_year": "2009",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3120,
      "name": "RoboKnights",
      "rookie_year": "2009",
      "city": "Sherman Oaks",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3121,
      "name": "Alloy Fingerprints",
      "rookie_year": "2009",
      "city": "Portage County",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3122,
      "name": "The Alluminators",
      "rookie_year": "2009",
      "city": "New Ulm",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3123,
      "name": "Wildcogs",
      "rookie_year": "2010",
      "city": "Pottstown",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3124,
      "name": "Cyberian Huskies",
      "rookie_year": "2010",
      "city": "Edmond",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3125,
      "name": "Pirates of the Pythagorean",
      "rookie_year": "2010",
      "city": "Hartford",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3126,
      "name": "FlashPoint",
      "rookie_year": "2010",
      "city": "Hollis",
      "state": "NH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3128,
      "name": "Aluminum Narwhals",
      "rookie_year": "2010",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3129,
      "name": "Green MacHHHHine",
      "rookie_year": "2010",
      "city": "Mountain View",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3130,
      "name": "The ERRORs",
      "rookie_year": "2010",
      "city": "Woodbury",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3131,
      "name": "Gladiators",
      "rookie_year": "2010",
      "city": "Gladstone",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3132,
      "name": "Thunder Down Under",
      "rookie_year": "2010",
      "city": "Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 3133,
      "name": "Coronado Robotics",
      "rookie_year": "2010",
      "city": "Scottsdale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3134,
      "name": "The Accelerators",
      "rookie_year": "2010",
      "city": "Cass Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3135,
      "name": "Robotic Colonels",
      "rookie_year": "2010",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3136,
      "name": "Official Robotics Constructors of Ashland",
      "rookie_year": "2010",
      "city": "Ashland",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3137,
      "name": "T-Birds",
      "rookie_year": "2010",
      "city": "Bohemia",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3138,
      "name": "Innovators Robotics",
      "rookie_year": "2010",
      "city": "Dayton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3139,
      "name": "Omega",
      "rookie_year": "2010",
      "city": "Oxford",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3140,
      "name": "Flagship",
      "rookie_year": "2010",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3141,
      "name": "PiBots",
      "rookie_year": "2010",
      "city": "Torrington",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3142,
      "name": "Aperture",
      "rookie_year": "2010",
      "city": "Newton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 3143,
      "name": "NTC Night Hawks",
      "rookie_year": "2010",
      "city": "Norfolk",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3144,
      "name": "KRYPTO-KNIGHTS",
      "rookie_year": "2010",
      "city": "2801 N.W. 27TH",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3145,
      "name": "TeraViks",
      "rookie_year": "2010",
      "city": "Coeur D Alene",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3146,
      "name": "GRANBY GRUNTS",
      "rookie_year": "2010",
      "city": "Granby",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3147,
      "name": "Munster Horsepower",
      "rookie_year": "2010",
      "city": "Munster",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3148,
      "name": "Joltz",
      "rookie_year": "2010",
      "city": "Dorchester",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3149,
      "name": "PANDAMONIUM!",
      "rookie_year": "2010",
      "city": "Lakeland",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3150,
      "name": "Mustangs",
      "rookie_year": "2010",
      "city": "Marriottsville",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3151,
      "name": "Cyberstorm",
      "rookie_year": "2010",
      "city": "Sewell",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3152,
      "name": "KTC-Monsters",
      "rookie_year": "2010",
      "city": "Idabel",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3154,
      "name": "Robo-Razzaitore \"THE RAZZ\"",
      "rookie_year": "2010",
      "city": "Baltimore",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3155,
      "name": "Globots",
      "rookie_year": "2010",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3156,
      "name": "Solista",
      "rookie_year": "2010",
      "city": "Fremont",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3157,
      "name": "Iron Lancers",
      "rookie_year": "2010",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3158,
      "name": "PrepaTec - TECBOT",
      "rookie_year": "2010",
      "city": "Toluca",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3160,
      "name": "F. R. O. G. - FIRST Robotics Organization of Grove",
      "rookie_year": "2010",
      "city": "Grove",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3161,
      "name": "Tronic Titans",
      "rookie_year": "2010",
      "city": "Oakville",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 3162,
      "name": "RoBoComm-X",
      "rookie_year": "2010",
      "city": "Rochester",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3163,
      "name": "ROARBOTS",
      "rookie_year": "2010",
      "city": "Henryetta",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3164,
      "name": "Stealth Tigers",
      "rookie_year": "2010",
      "city": "Tampa",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3165,
      "name": "NewBots",
      "rookie_year": "2010",
      "city": "Newberg",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3166,
      "name": "First Year Ravens",
      "rookie_year": "2010",
      "city": "Sandy",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3167,
      "name": "Mechanical Misfits",
      "rookie_year": "2010",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3168,
      "name": "Warriors",
      "rookie_year": "2010",
      "city": "Suffolk",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3169,
      "name": "Saint-Borgs",
      "rookie_year": "2010",
      "city": "Edmond",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3170,
      "name": "Bearded Dragons",
      "rookie_year": "2010",
      "city": "Buckeye",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3171,
      "name": "HURRICANES",
      "rookie_year": "2010",
      "city": "Westhampton Beach",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3172,
      "name": "HorsePOWER",
      "rookie_year": "2010",
      "city": "Salina",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3173,
      "name": "IgKnighters",
      "rookie_year": "2010",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3174,
      "name": "ROBODAWGS",
      "rookie_year": "2010",
      "city": "ANNISTON",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3175,
      "name": "Knight Vision",
      "rookie_year": "2010",
      "city": "Grosse Pointe Woods",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3176,
      "name": "Purple Precision",
      "rookie_year": "2010",
      "city": "Brownsburg",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3177,
      "name": "Fearless Falcons",
      "rookie_year": "2010",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3179,
      "name": "The A.N.T.",
      "rookie_year": "2010",
      "city": "Adair",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3180,
      "name": "MECHAlosaurs",
      "rookie_year": "2010",
      "city": "Trafalgar",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3181,
      "name": "Pittsford Panthers",
      "rookie_year": "2010",
      "city": "Pittsford",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3182,
      "name": "Athena's Warriors",
      "rookie_year": "2010",
      "city": "Hartford",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3183,
      "name": "EPIC",
      "rookie_year": "2010",
      "city": "Burlington",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3184,
      "name": "Blaze Robotics",
      "rookie_year": "2010",
      "city": "Burnsville",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3185,
      "name": "Super Gurus",
      "rookie_year": "2010",
      "city": "Cookeville",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3186,
      "name": "DECAbotz",
      "rookie_year": "2010",
      "city": "Dayton",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3187,
      "name": "Arcadia Titan Robotics",
      "rookie_year": "2010",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3188,
      "name": "The Robotics Factory",
      "rookie_year": "2010",
      "city": "Portland",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3189,
      "name": "Circuit Breakers",
      "rookie_year": "2010",
      "city": "Placerville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3190,
      "name": "Mecha-51",
      "rookie_year": "2010",
      "city": "St Lazare",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3191,
      "name": "The Wingnuts",
      "rookie_year": "2010",
      "city": "Salt Lake City",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3192,
      "name": "High Visibility",
      "rookie_year": "2010",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3193,
      "name": "Falco Tech",
      "rookie_year": "2010",
      "city": "Austintown",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3194,
      "name": "The BRAINS",
      "rookie_year": "2010",
      "city": "Tucson",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3195,
      "name": "Robo Ninjas",
      "rookie_year": "2010",
      "city": "La Mesa",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3196,
      "name": "Team SPORK",
      "rookie_year": "2010",
      "city": "Mooresville",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3197,
      "name": "HexHounds",
      "rookie_year": "2010",
      "city": "Cedarburg",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3198,
      "name": "Robotomy",
      "rookie_year": "2010",
      "city": "Granby",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3200,
      "name": "Raptacon",
      "rookie_year": "2010",
      "city": "Centennial",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3201,
      "name": "Ross Rambotics",
      "rookie_year": "2010",
      "city": "Hamilton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3202,
      "name": "KnightBots",
      "rookie_year": "2010",
      "city": "St. Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3203,
      "name": "The Unlikely Mix",
      "rookie_year": "2010",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3204,
      "name": "Steampunk Penguins",
      "rookie_year": "2010",
      "city": "Jamaica Estates",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3205,
      "name": "Patriots",
      "rookie_year": "2010",
      "city": "Concord",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3206,
      "name": "Royal T-Wrecks",
      "rookie_year": "2010",
      "city": "Woodbury ",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3207,
      "name": "Fighting Scots",
      "rookie_year": "2010",
      "city": "Ogden",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3208,
      "name": "WildBots",
      "rookie_year": "2010",
      "city": "Clifton",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3209,
      "name": "NHS Robotics",
      "rookie_year": "2010",
      "city": "Niles",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3210,
      "name": "Falcons",
      "rookie_year": "2010",
      "city": "Hillsboro",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3211,
      "name": "The Y Team",
      "rookie_year": "2010",
      "city": "Yeruham",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3212,
      "name": "YME Stingbots",
      "rookie_year": "2010",
      "city": "Granite Falls",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3213,
      "name": "Thunder Tech",
      "rookie_year": "2010",
      "city": "Tacoma",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3214,
      "name": "High Tech Hounds",
      "rookie_year": "2010",
      "city": "Memphis",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3215,
      "name": "Apollo",
      "rookie_year": "2010",
      "city": "Greensboro",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3216,
      "name": "Missoula Robotics Team (MRT)",
      "rookie_year": "2010",
      "city": "Missoula",
      "state": "Montana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3217,
      "name": "L&M",
      "rookie_year": "2010",
      "city": "Edcouch",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3218,
      "name": "Panther Robotics",
      "rookie_year": "2010",
      "city": "Bonney Lake",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3219,
      "name": "TREAD (Trojan Robotics, Engineering, Art, & Design)",
      "rookie_year": "2010",
      "city": "Auburn",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3220,
      "name": "Mechanics of Mayhem",
      "rookie_year": "2010",
      "city": "Spangle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3221,
      "name": "KM Royals",
      "rookie_year": "2010",
      "city": "Kent",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3222,
      "name": "Robot Bantam",
      "rookie_year": "2010",
      "city": "Clarkston",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3223,
      "name": "Robotics Of Central Kitsap",
      "rookie_year": "2010",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3224,
      "name": "Lion Hit Squad",
      "rookie_year": "2010",
      "city": "Locust Grove",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3225,
      "name": "Wolverine Robotics",
      "rookie_year": "2010",
      "city": "West Valley City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3226,
      "name": "Eagle Tech",
      "rookie_year": "2010",
      "city": "Chula Vista",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3227,
      "name": "RoboWolves",
      "rookie_year": "2010",
      "city": "Cordova",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3228,
      "name": "Rocket",
      "rookie_year": "2010",
      "city": "Metairie",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3229,
      "name": "Hawktimus Prime",
      "rookie_year": "2010",
      "city": "Holly Springs",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3230,
      "name": "PrototypeX",
      "rookie_year": "2010",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3231,
      "name": "PioTech",
      "rookie_year": "2010",
      "city": "Clifton",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3232,
      "name": "South Bend's Finest",
      "rookie_year": "2010",
      "city": "South Bend",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3233,
      "name": "Bots of the Round Table",
      "rookie_year": "2010",
      "city": "Satellite Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3234,
      "name": "Red Arrows",
      "rookie_year": "2010",
      "city": "Lowell",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3235,
      "name": "Mustang",
      "rookie_year": "2010",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3236,
      "name": "TRIFORCE",
      "rookie_year": "2010",
      "city": "Franklin",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3237,
      "name": "Event Horizon",
      "rookie_year": "2010",
      "city": "Spanaway",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3238,
      "name": "Cyborg Ferrets",
      "rookie_year": "2010",
      "city": "Anacortes",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3239,
      "name": "Birds of Prey",
      "rookie_year": "2010",
      "city": "Layton",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3240,
      "name": "Team Orion",
      "rookie_year": "2010",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3241,
      "name": "Ogden Dragon Army",
      "rookie_year": "2010",
      "city": "Ogden",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3242,
      "name": "ILLUMICATS",
      "rookie_year": "2010",
      "city": "Ocala",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3243,
      "name": "Amperes",
      "rookie_year": "2010",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3244,
      "name": "Granite City Gear Heads",
      "rookie_year": "2010",
      "city": "Saint Cloud",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3245,
      "name": "Ravens",
      "rookie_year": "2010",
      "city": "Sandy",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3246,
      "name": "Vandals",
      "rookie_year": "2010",
      "city": "Eureka",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3247,
      "name": "Robopack",
      "rookie_year": "2010",
      "city": "Shawnee",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3250,
      "name": "Kennedy Robotics",
      "rookie_year": "2010",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3251,
      "name": "Savage Pride",
      "rookie_year": "2010",
      "city": "Salmon",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3253,
      "name": "Rustlers",
      "rookie_year": "2010",
      "city": "Great Falls",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3255,
      "name": "SuperNURDs",
      "rookie_year": "2010",
      "city": "Escondido",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3256,
      "name": "WarriorBorgs",
      "rookie_year": "2010",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3257,
      "name": "Vortechs",
      "rookie_year": "2010",
      "city": "Roseville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3258,
      "name": "MADAWGS",
      "rookie_year": "2010",
      "city": "Martinsville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3259,
      "name": "Thoroughbots",
      "rookie_year": "2010",
      "city": "Somerset",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3260,
      "name": "SHARP",
      "rookie_year": "2010",
      "city": "Pittsburgh",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3261,
      "name": "Bears Robotics",
      "rookie_year": "2010",
      "city": "Clearbrook",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3262,
      "name": "Luggernauts",
      "rookie_year": "2010",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3263,
      "name": "The Elites G3",
      "rookie_year": "2010",
      "city": "Coleraine",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3264,
      "name": "nerd nation",
      "rookie_year": "2010",
      "city": "Norwalk",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3265,
      "name": "Arrowheads",
      "rookie_year": "2010",
      "city": "Powder Springs",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3266,
      "name": "Robots-R-Us",
      "rookie_year": "2010",
      "city": "Eaton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3267,
      "name": "Mariner Robotics",
      "rookie_year": "2010",
      "city": "Silver Bay",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3268,
      "name": "Vahallabots",
      "rookie_year": "2010",
      "city": "Kenmore",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3270,
      "name": "CATA-BOTS",
      "rookie_year": "2010",
      "city": "Monoe",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3271,
      "name": "Dragonbots",
      "rookie_year": "2010",
      "city": "Ventura",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3272,
      "name": "Ravage Robotics",
      "rookie_year": "2010",
      "city": "Carrollton",
      "state": "KY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3273,
      "name": "Cybercats",
      "rookie_year": "2010",
      "city": "Springfield",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3274,
      "name": "Rocktown Robotics",
      "rookie_year": "2010",
      "city": "Harrisonburg",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3275,
      "name": "The Regulators",
      "rookie_year": "2010",
      "city": "Cass Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3276,
      "name": "TOOLCATS",
      "rookie_year": "2010",
      "city": "New London",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3277,
      "name": "ProDigi",
      "rookie_year": "2010",
      "city": "Thief River Falls",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3278,
      "name": "QWERTY Robotics",
      "rookie_year": "2010",
      "city": "Detroit Lakes",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3279,
      "name": "Spingarn Senior High School",
      "rookie_year": "2010",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3280,
      "name": "Rhode Rebels",
      "rookie_year": "2010",
      "city": "Providence",
      "state": "RI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3281,
      "name": "VBots",
      "rookie_year": "2010",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3282,
      "name": "Dallas Robo Tigers",
      "rookie_year": "2010",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3283,
      "name": "3283 Coyote Robotix",
      "rookie_year": "2010",
      "city": "Clarksburg",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3284,
      "name": "Camdenton  LASER 3284",
      "rookie_year": "2010",
      "city": "Camdenton",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3286,
      "name": "the rocket surgeons",
      "rookie_year": "2010",
      "city": "Yakima",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3288,
      "name": "Punchers",
      "rookie_year": "2010",
      "city": "Big Piney",
      "state": "Wyoming",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3289,
      "name": "Soaring Eagle",
      "rookie_year": "2010",
      "city": "Draper",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3290,
      "name": "Robo Bears LOWbotics",
      "rookie_year": "2010",
      "city": "Baudette",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3291,
      "name": "Golden Pirates",
      "rookie_year": "2010",
      "city": "Brooklyn Park",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3292,
      "name": "The Aluminum Falcon",
      "rookie_year": "2010",
      "city": "Benson",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3293,
      "name": "OtterBots",
      "rookie_year": "2010",
      "city": "Fergus Falls",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3294,
      "name": "Backwoods Engineers",
      "rookie_year": "2010",
      "city": "Pine River",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3295,
      "name": "STEMdroids",
      "rookie_year": "2010",
      "city": "Mentone",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3296,
      "name": "Neon Knights",
      "rookie_year": "2010",
      "city": "Fresno",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3297,
      "name": "Full Metal Jackets",
      "rookie_year": "2010",
      "city": "Perham",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3298,
      "name": "ArrowBots",
      "rookie_year": "2010",
      "city": "Pipestone",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3299,
      "name": "The Warehouse Crew",
      "rookie_year": "2010",
      "city": "Chaska",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3300,
      "name": "Midwest WARRIORS",
      "rookie_year": "2010",
      "city": "Ortonville",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3301,
      "name": "Patriots",
      "rookie_year": "2010",
      "city": "Portland",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3302,
      "name": "TurboTrojans",
      "rookie_year": "2010",
      "city": "Clawson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3303,
      "name": "Metallic Thunder",
      "rookie_year": "2010",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3305,
      "name": "Matbotz",
      "rookie_year": "2010",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3306,
      "name": "Trojans",
      "rookie_year": "2010",
      "city": "Pahala",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3307,
      "name": "Robo Dawgs",
      "rookie_year": "2010",
      "city": "Luray",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3308,
      "name": "JHS Beavers",
      "rookie_year": "2010",
      "city": "Jamaica",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3309,
      "name": "Friarbots",
      "rookie_year": "2010",
      "city": "Anaheim",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3310,
      "name": "Black Hawk Robotics",
      "rookie_year": "2010",
      "city": "Heath",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3311,
      "name": "KB-BOT",
      "rookie_year": "2010",
      "city": "Klamath Falls",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3312,
      "name": "EagleBots",
      "rookie_year": "2010",
      "city": "Bena",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3313,
      "name": "Mechatronics",
      "rookie_year": "2010",
      "city": "Alexandria",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3314,
      "name": "Mechanical Mustangs",
      "rookie_year": "2010",
      "city": "Clifton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 3315,
      "name": "Mountaineers",
      "rookie_year": "2010",
      "city": "Spirit Lake",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3316,
      "name": "D-Bug",
      "rookie_year": "2010",
      "city": "Tel Aviv",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3317,
      "name": "Q & E Robotics",
      "rookie_year": "2010",
      "city": "Hollandale",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3318,
      "name": "RoboDragons",
      "rookie_year": "2010",
      "city": "Lawrenceville",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3319,
      "name": "Galactic Geeks Robotics",
      "rookie_year": "2010",
      "city": "Huntsville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3320,
      "name": "Miracles & Machines (M&Ms)",
      "rookie_year": "2010",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3321,
      "name": "Superior Robotics",
      "rookie_year": "2010",
      "city": "Superior",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3322,
      "name": "Skyline Robotics",
      "rookie_year": "2010",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3323,
      "name": "Potential Energy",
      "rookie_year": "2010",
      "city": "Litchfield",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3324,
      "name": "The Metrobots",
      "rookie_year": "2010",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3325,
      "name": "Valle Verde Robotics",
      "rookie_year": "2010",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3326,
      "name": "DATC",
      "rookie_year": "2010",
      "city": "Kaysville",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3328,
      "name": "NohoRobo",
      "rookie_year": "2010",
      "city": "North Hollywood",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3329,
      "name": "Wildbots",
      "rookie_year": "2010",
      "city": "Kingsland",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 3330,
      "name": "System of the Corn ",
      "rookie_year": "2010",
      "city": "Saint Charles",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3331,
      "name": "Tar Heel Robots",
      "rookie_year": "2010",
      "city": "Chapel Hill",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3332,
      "name": "HustlerTech",
      "rookie_year": "2010",
      "city": "Melbourne",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3333,
      "name": "Cougars",
      "rookie_year": "2010",
      "city": "Julesburg",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3334,
      "name": "Eagle Robotics",
      "rookie_year": "2010",
      "city": "Salt Lake",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3335,
      "name": "Cy-Borgs",
      "rookie_year": "2010",
      "city": "Cypress",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3336,
      "name": "Zimanators",
      "rookie_year": "2010",
      "city": "Swansboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3337,
      "name": "Panthrobotics",
      "rookie_year": "2010",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3339,
      "name": "BumbleB",
      "rookie_year": "2010",
      "city": "Kfar Yona",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3340,
      "name": "Union City MagneGeeks",
      "rookie_year": "2010",
      "city": "Union City",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3341,
      "name": "Option 16",
      "rookie_year": "2010",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3343,
      "name": "HSA-Recon",
      "rookie_year": "2010",
      "city": "LAREDO",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3344,
      "name": "Space Dragons",
      "rookie_year": "2010",
      "city": "Fayetteville",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 3345,
      "name": "Metal Jackets",
      "rookie_year": "2010",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3346,
      "name": "Kamikaze Comets",
      "rookie_year": "2010",
      "city": "Asheboro",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3350,
      "name": "T-BOTS",
      "rookie_year": "2010",
      "city": "Texarkana",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3351,
      "name": "Ratchet",
      "rookie_year": "2010",
      "city": "Beer-Sheva",
      "state": "D",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3352,
      "name": "3352 Flaming Monkeys 4-H Robotics Club",
      "rookie_year": "2010",
      "city": "Belvidere",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3353,
      "name": "Freer Robotics Team",
      "rookie_year": "2010",
      "city": "Freer",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3354,
      "name": "PrepaTec-TecDroid",
      "rookie_year": "2010",
      "city": "Queretaro",
      "state": "Quer\u00e9taro",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3355,
      "name": "Purple Vipers",
      "rookie_year": "2010",
      "city": "Arlington",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3356,
      "name": "MC2STEM Maniacs",
      "rookie_year": "2010",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3357,
      "name": "COMETS",
      "rookie_year": "2010",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3358,
      "name": "Y.T.P.T - J.E.T.S",
      "rookie_year": "2010",
      "city": "Petach Tikva",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3359,
      "name": "Royal Robotics",
      "rookie_year": "2010",
      "city": "Portsmouth",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3360,
      "name": "Hyperion",
      "rookie_year": "2010",
      "city": "Sherbrooke",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3361,
      "name": "Governators",
      "rookie_year": "2010",
      "city": "Fishersville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3362,
      "name": "Eagle Robotics",
      "rookie_year": "2010",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3363,
      "name": "Eagle",
      "rookie_year": "2010",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3364,
      "name": "Panhandle Pirates",
      "rookie_year": "2010",
      "city": "Tallahassee",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3366,
      "name": "Plowbots",
      "rookie_year": "2010",
      "city": "Roscoe",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3367,
      "name": "Ogichidaa Robotics",
      "rookie_year": "2010",
      "city": "White Earth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3368,
      "name": "Spirit of the United Neretva",
      "rookie_year": "2010",
      "city": "Mostar",
      "state": "Hercegova?ko-neretvanski kanton",
      "country": "Bosnia-Herzegovina",
      "district": ""
    },
    {
      "number": 3369,
      "name": "TIGERS",
      "rookie_year": "2010",
      "city": "Pflugerville",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3370,
      "name": "Aftershock",
      "rookie_year": "2010",
      "city": "Irving",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3371,
      "name": "The Bonds ThunderBolts",
      "rookie_year": "2010",
      "city": "Greer",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3373,
      "name": "Team RoboHawk",
      "rookie_year": "2010",
      "city": "Warrenton",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3374,
      "name": "Jackson Hole RoboBroncs",
      "rookie_year": "2010",
      "city": "Jackson",
      "state": "Wyoming",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3375,
      "name": "North Stars",
      "rookie_year": "2010",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3376,
      "name": "RoboScorps",
      "rookie_year": "2010",
      "city": "Satellite Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3377,
      "name": "Raiders",
      "rookie_year": "2010",
      "city": "Lumberton",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3378,
      "name": "OD-BS",
      "rookie_year": "2010",
      "city": "Beit-Shean",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3379,
      "name": "M\u00e9cani-Wolf",
      "rookie_year": "2010",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3380,
      "name": "Alchesay Falcon Team",
      "rookie_year": "2010",
      "city": "Whiteriver",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3381,
      "name": "Droid Rage",
      "rookie_year": "2010",
      "city": "Valders",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3382,
      "name": "Les B\u00e9liers",
      "rookie_year": "2010",
      "city": "Montr\u00e9al",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3383,
      "name": "makif omer",
      "rookie_year": "2010",
      "city": "omer",
      "state": "D",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3384,
      "name": "Sunset BisonBots",
      "rookie_year": "2010",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3385,
      "name": "RoboticST",
      "rookie_year": "2010",
      "city": "gesher haziv",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3386,
      "name": "Tornades",
      "rookie_year": "2010",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3387,
      "name": "Les Aigles d'Or",
      "rookie_year": "2010",
      "city": "Montr\u00e9al",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3388,
      "name": "Flash",
      "rookie_year": "2010",
      "city": "Gan Yavne",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3389,
      "name": "TEC Tigers",
      "rookie_year": "2010",
      "city": "Salisbury",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3390,
      "name": "ANATOLIAN EAGLEBOTS",
      "rookie_year": "2010",
      "city": "Ankara",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 3392,
      "name": "T-Robots",
      "rookie_year": "2010",
      "city": "Grand Prairie",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3393,
      "name": "Horns of Havoc",
      "rookie_year": "2010",
      "city": "Puyallup ",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3394,
      "name": "Knight Riders",
      "rookie_year": "2010",
      "city": "Hudson",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3396,
      "name": "Imperium Machinamentum",
      "rookie_year": "2010",
      "city": "Richmond Hill",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3397,
      "name": "Robolions",
      "rookie_year": "2010",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3398,
      "name": "Crushing Crusaders",
      "rookie_year": "2010",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3399,
      "name": "Lions",
      "rookie_year": "2010",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3400,
      "name": "RCTC",
      "rookie_year": "2010",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3401,
      "name": "Eagletrons",
      "rookie_year": "2010",
      "city": "Orchard Lake",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3402,
      "name": "ROBOMonkeys",
      "rookie_year": "2010",
      "city": "Lenoir",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3403,
      "name": "Cyber Wolf Robotics",
      "rookie_year": "2010",
      "city": "Colorado Springs",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3404,
      "name": "Robo Bibb",
      "rookie_year": "2010",
      "city": "Macon",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3405,
      "name": "ALChemists",
      "rookie_year": "2010",
      "city": "Salem",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3406,
      "name": "Ottoman RoboTecnics",
      "rookie_year": "2010",
      "city": "Istanbul",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 3407,
      "name": "Wild Cards",
      "rookie_year": "2010",
      "city": "Arden Hills",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3408,
      "name": "cyberCubs",
      "rookie_year": "2010",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3409,
      "name": "Boiling Point",
      "rookie_year": "2010",
      "city": "Cedar Hill",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3410,
      "name": "Miami MEngs",
      "rookie_year": "2010",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3411,
      "name": "Team Intrepid",
      "rookie_year": "2010",
      "city": "Horn Lake",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3412,
      "name": "The Flo-Falcons",
      "rookie_year": "2010",
      "city": "Wilbraham",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3413,
      "name": "Mad Cows",
      "rookie_year": "2010",
      "city": "Coppell",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3414,
      "name": "Hackbots",
      "rookie_year": "2010",
      "city": "Farmington",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3415,
      "name": "The RAMS ",
      "rookie_year": "2010",
      "city": "Montrose",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3416,
      "name": "YCLA Eagles",
      "rookie_year": "2010",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3417,
      "name": "Akins Robotoics",
      "rookie_year": "2010",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3418,
      "name": "RoboRiot",
      "rookie_year": "2010",
      "city": "Sheboygan Falls",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3419,
      "name": "RoHawks",
      "rookie_year": "2010",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3420,
      "name": "Team 3420",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 3421,
      "name": "Tachyon TECs",
      "rookie_year": "2010",
      "city": "Marysville",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3422,
      "name": "Robo Champs",
      "rookie_year": "2010",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3423,
      "name": "The Raider",
      "rookie_year": "2010",
      "city": "Farmington",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3450,
      "name": "Random Nuts",
      "rookie_year": "2011",
      "city": "Flint",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3451,
      "name": "The ANOMALY",
      "rookie_year": "2011",
      "city": "Sanford",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3452,
      "name": "GreengineerZ",
      "rookie_year": "2011",
      "city": "Berrien Springs",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3453,
      "name": "DEM BOTS",
      "rookie_year": "2011",
      "city": "Winchester",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3454,
      "name": "Z Bots",
      "rookie_year": "2011",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3455,
      "name": "Robot Revolution",
      "rookie_year": "2011",
      "city": "Alexandria",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3456,
      "name": "LiveWire",
      "rookie_year": "2011",
      "city": "Pocatello",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3457,
      "name": "MacBotics",
      "rookie_year": "2011",
      "city": "Lawton",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3458,
      "name": "Code Blue",
      "rookie_year": "2011",
      "city": "Holland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3459,
      "name": "Team PyroTech",
      "rookie_year": "2011",
      "city": "Cary",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3460,
      "name": "Brentwood Indians",
      "rookie_year": "2011",
      "city": "Brentwood",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3461,
      "name": "Operation PEACCE Robotics",
      "rookie_year": "2011",
      "city": "Bristol",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3462,
      "name": "FERVOT",
      "rookie_year": "2011",
      "city": "Toluca",
      "state": "MEX",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3463,
      "name": "Red Neck Robotics",
      "rookie_year": "2011",
      "city": "Salina",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3464,
      "name": "Sim-City",
      "rookie_year": "2011",
      "city": "Simsbury",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3465,
      "name": "The Omega Factor",
      "rookie_year": "2011",
      "city": "Mustang",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3466,
      "name": "VIKINGS ROBOTICS",
      "rookie_year": "2011",
      "city": "Westford",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3467,
      "name": "Windham Windup",
      "rookie_year": "2011",
      "city": "Windham",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3468,
      "name": "MAGNAtech",
      "rookie_year": "2011",
      "city": "West Monroe",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3469,
      "name": "The Spanish Inquisition",
      "rookie_year": "2011",
      "city": "Mobile",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3470,
      "name": "Cyborg Zombies",
      "rookie_year": "2011",
      "city": "Temecula",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3471,
      "name": "Jagbots",
      "rookie_year": "2011",
      "city": "Gretna",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3472,
      "name": "PrepaTec - Buluk",
      "rookie_year": "2011",
      "city": "Atizapan de Zaragoza",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3473,
      "name": "Team Sprocket",
      "rookie_year": "2011",
      "city": "Diamond Bar",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3474,
      "name": "BAYMEN",
      "rookie_year": "2011",
      "city": "Hampton Bays",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3475,
      "name": "The Crop?",
      "rookie_year": "2011",
      "city": "Charleston",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3476,
      "name": "Code Orange",
      "rookie_year": "2011",
      "city": "Irvine",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3477,
      "name": "Chaos Vortex",
      "rookie_year": "2011",
      "city": "Chula Vista",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3478,
      "name": "PrepaTec - LamBot",
      "rookie_year": "2011",
      "city": "San Luis Potos\u00ed",
      "state": "San Luis Potos\u00ed",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3479,
      "name": "crimson tide",
      "rookie_year": "2011",
      "city": "everett",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3480,
      "name": "PrepaTec - ABTOMAT",
      "rookie_year": "2011",
      "city": "Le\u00f3n",
      "state": "Guanajuato",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3481,
      "name": "Bronc Botz",
      "rookie_year": "2011",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3482,
      "name": "Arrowbotics",
      "rookie_year": "2011",
      "city": "Campbell",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3483,
      "name": "Cold Smoke",
      "rookie_year": "2011",
      "city": "Bozeman",
      "state": "MT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3484,
      "name": "Short Circuit",
      "rookie_year": "2011",
      "city": "Marysville",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3485,
      "name": "Cyclone Robotics",
      "rookie_year": "2011",
      "city": "Kansas City",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3486,
      "name": "STEM&m's",
      "rookie_year": "2011",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3487,
      "name": "Red Pride Robotics",
      "rookie_year": "2011",
      "city": "Plainfield",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3488,
      "name": "Eagle Army",
      "rookie_year": "2011",
      "city": "Orland Park",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3489,
      "name": "Category 5",
      "rookie_year": "2011",
      "city": "North Charleston",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3490,
      "name": "Viper Drive",
      "rookie_year": "2011",
      "city": "Summerville",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3491,
      "name": "FUTURE Dinos",
      "rookie_year": "2011",
      "city": "Holtville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3492,
      "name": "Putnam Area Robotics Team (P.A.R.T.s)",
      "rookie_year": "2011",
      "city": "Winfield",
      "state": "West Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3493,
      "name": "RETRO ROBOT SQUAD",
      "rookie_year": "2011",
      "city": "EDENTON",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3494,
      "name": "The Quadrangles",
      "rookie_year": "2011",
      "city": "Bloomington",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3495,
      "name": "MindCraft Robotics",
      "rookie_year": "2011",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3496,
      "name": "The RoboTech Collection",
      "rookie_year": "2011",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3497,
      "name": " THIS IS NOT THE TEAM-Go to 9381 ",
      "rookie_year": "2011",
      "city": "Midland",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3498,
      "name": "Jankopotamus",
      "rookie_year": "2011",
      "city": "Edmond",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3499,
      "name": "River's Edge Robotics",
      "rookie_year": "2011",
      "city": "Durham",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3500,
      "name": "Roboteenz",
      "rookie_year": "2011",
      "city": "Perris",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3501,
      "name": "Firebots",
      "rookie_year": "2011",
      "city": "Sunnyvale",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3502,
      "name": "Octo(PI)Rates",
      "rookie_year": "2011",
      "city": "Tallahassee ",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3503,
      "name": "WRX",
      "rookie_year": "2011",
      "city": "Fair Oaks",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3504,
      "name": "Girls of Steel",
      "rookie_year": "2011",
      "city": "Pittsburgh",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3505,
      "name": "Fighting Z-Bots",
      "rookie_year": "2011",
      "city": "Lincoln",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3506,
      "name": "YETI Robotics",
      "rookie_year": "2011",
      "city": "Charlotte",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3507,
      "name": "Ubotics",
      "rookie_year": "2011",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3508,
      "name": "Archimedes",
      "rookie_year": "2011",
      "city": "Pittsburg",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3509,
      "name": "Team Fallout",
      "rookie_year": "2011",
      "city": "Niles",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3510,
      "name": "PrepaTec - Tectronic",
      "rookie_year": "2011",
      "city": "Celaya",
      "state": "Guanajuato",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3511,
      "name": "Road Dogs",
      "rookie_year": "2011",
      "city": "New Stanton",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3512,
      "name": "Spartatroniks",
      "rookie_year": "2011",
      "city": "Orcutt",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3513,
      "name": "Misfit Toys",
      "rookie_year": "2011",
      "city": "Rathdrum",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3514,
      "name": "Wayne High Robotics",
      "rookie_year": "2011",
      "city": "Wayne",
      "state": "WV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3515,
      "name": "Pneubotic Mustangs",
      "rookie_year": "2011",
      "city": "Iselin",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 3516,
      "name": "RoboChiefs",
      "rookie_year": "2011",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3517,
      "name": "S.E.V.E.R.E.",
      "rookie_year": "2011",
      "city": "Queen Creek",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3518,
      "name": "LHS Panthers",
      "rookie_year": "2011",
      "city": "3810 W Educational Path",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3519,
      "name": "Hannibal Robo Pirates",
      "rookie_year": "2011",
      "city": "Hannibal",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3520,
      "name": "RoboColts",
      "rookie_year": "2011",
      "city": "Coral Springs",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3521,
      "name": "Noble Nuts",
      "rookie_year": "2011",
      "city": "Indio",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3522,
      "name": "CBoT\u00b4S4",
      "rookie_year": "2011",
      "city": "Toluca",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3524,
      "name": "The Blizzard",
      "rookie_year": "2011",
      "city": "Minneapolis",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3525,
      "name": "The Nuts & Bolts of Fury",
      "rookie_year": "2011",
      "city": "Waterbury",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3526,
      "name": "PrepaTec - Blue Ignition",
      "rookie_year": "2011",
      "city": "Saltillo",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3527,
      "name": "PrepaTec - Balam Esmeralda",
      "rookie_year": "2011",
      "city": "Atizapan de Zaragoza",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3528,
      "name": "Up Next",
      "rookie_year": "2011",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3529,
      "name": "Kobayashi Maru",
      "rookie_year": "2011",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3530,
      "name": "Patriotix",
      "rookie_year": "2011",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3531,
      "name": "2XR",
      "rookie_year": "2011",
      "city": "Montreal",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3532,
      "name": "Piranhas",
      "rookie_year": "2011",
      "city": "Saint-Hubert",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3533,
      "name": "Mekano",
      "rookie_year": "2011",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3534,
      "name": "House of Cards",
      "rookie_year": "2011",
      "city": "Davison",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3535,
      "name": "Galaktech Invaders",
      "rookie_year": "2011",
      "city": "Lapeer County",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3536,
      "name": "Electro Eagles",
      "rookie_year": "2011",
      "city": "Hartland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3537,
      "name": "Delta Force",
      "rookie_year": "2011",
      "city": "Indian River",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3538,
      "name": "RoboJackets",
      "rookie_year": "2011",
      "city": "Auburn Hills",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3539,
      "name": "Byting Bulldogs",
      "rookie_year": "2011",
      "city": "Romeo",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3540,
      "name": "Wildcats",
      "rookie_year": "2011",
      "city": "Mooresville",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3541,
      "name": "Brebotics",
      "rookie_year": "2011",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3542,
      "name": "S.P.E.E.D",
      "rookie_year": "2011",
      "city": "Temperance",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3543,
      "name": "C4 Robotics",
      "rookie_year": "2011",
      "city": "Arnprior",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 3544,
      "name": "Spartiates",
      "rookie_year": "2011",
      "city": "Montreal-Nord",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3545,
      "name": "Bots in Blue",
      "rookie_year": "2011",
      "city": "Lackland Air Force Base",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3546,
      "name": "Buc'n'Gears",
      "rookie_year": "2011",
      "city": "Grand Haven",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3547,
      "name": "VIRUS",
      "rookie_year": "2011",
      "city": "Monroe",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3548,
      "name": "Royal Oak Kenwood Academy",
      "rookie_year": "2011",
      "city": "Royal Oak",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3549,
      "name": "Straughn Robotics 3549",
      "rookie_year": "2011",
      "city": "Andalusia",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3550,
      "name": "Robotronix",
      "rookie_year": "2011",
      "city": "Lasalle",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3552,
      "name": "The T-Birds",
      "rookie_year": "2011",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3553,
      "name": "South Philly Rambots",
      "rookie_year": "2011",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3554,
      "name": "LC Botkickers",
      "rookie_year": "2011",
      "city": "Elk Grove",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3555,
      "name": "Aluminati",
      "rookie_year": "2011",
      "city": "Storrs Mansfield",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3556,
      "name": "GET SMART",
      "rookie_year": "2011",
      "city": "Lake City",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3557,
      "name": "Robo-Sharks",
      "rookie_year": "2011",
      "city": "Brandon",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3558,
      "name": "FBR Techno Tarheels",
      "rookie_year": "2011",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3559,
      "name": "Thundercats",
      "rookie_year": "2011",
      "city": "Jasper",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3560,
      "name": "Chingbotics",
      "rookie_year": "2011",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 3561,
      "name": "RoboRaiders",
      "rookie_year": "2011",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3562,
      "name": "LiveWire Robotics 3562",
      "rookie_year": "2011",
      "city": "Pocatello",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3563,
      "name": "Nantyr Bot-aneers",
      "rookie_year": "2011",
      "city": "Innisfil",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3564,
      "name": "EGL Robotics",
      "rookie_year": "2011",
      "city": "Wausau",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3565,
      "name": "Team T.R.E.A.D.S. (Tomorrows Robotic Engineering And Design Specialists)",
      "rookie_year": "2011",
      "city": "Connersville",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3566,
      "name": "Gone Fishin'",
      "rookie_year": "2011",
      "city": "Southborough",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3567,
      "name": "The Aviators",
      "rookie_year": "2011",
      "city": "Armagh",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3568,
      "name": "RoboEagles",
      "rookie_year": "2011",
      "city": "Linden",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3569,
      "name": "The Patrionator",
      "rookie_year": "2011",
      "city": "Fresno",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3570,
      "name": "Pheonix 3570",
      "rookie_year": "2011",
      "city": "Alma",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3571,
      "name": "Mustang Robotics",
      "rookie_year": "2011",
      "city": "Milton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3572,
      "name": "Wavelength",
      "rookie_year": "2011",
      "city": "Norton Shores",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3573,
      "name": "The Ohms",
      "rookie_year": "2011",
      "city": "Conyers",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3574,
      "name": "HIGH TEKERZ",
      "rookie_year": "2011",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3575,
      "name": "Okanogan FFA ",
      "rookie_year": "2011",
      "city": "Okanogan",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3576,
      "name": "Clover Park High School Warriors",
      "rookie_year": "2011",
      "city": "Lakewood",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3577,
      "name": "Saint's Robotics",
      "rookie_year": "2011",
      "city": "Scottsdale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3578,
      "name": "NASA/JCPenney/FSA HS *STAR*",
      "rookie_year": "2011",
      "city": "Alpharetta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3580,
      "name": "Marinerds",
      "rookie_year": "2011",
      "city": "Cape Coral",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3581,
      "name": "THINC Robotics Alliance",
      "rookie_year": "2011",
      "city": "Lagrange",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 3582,
      "name": "Phobots",
      "rookie_year": "2011",
      "city": "Mission",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3583,
      "name": "Saints",
      "rookie_year": "2011",
      "city": "San Juan",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3585,
      "name": "Rogue Robots of 4-H",
      "rookie_year": "2011",
      "city": "Charlestown",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3586,
      "name": "Pride in the Tribe-Caveman Robotics",
      "rookie_year": "2011",
      "city": "Reardan",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3587,
      "name": "Gorilla Gearheads",
      "rookie_year": "2011",
      "city": "Davenport",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3588,
      "name": "the Talon",
      "rookie_year": "2011",
      "city": "Renton",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3589,
      "name": "Cape Coral",
      "rookie_year": "2011",
      "city": "Cape Coral",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3590,
      "name": "Root Two",
      "rookie_year": "2011",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3591,
      "name": "Wild WarBots \"WWB\"",
      "rookie_year": "2011",
      "city": "Westerville",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3592,
      "name": "Sharks",
      "rookie_year": "2011",
      "city": "Port Orange",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3593,
      "name": "Invictus",
      "rookie_year": "2011",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3594,
      "name": "Techtonics",
      "rookie_year": "2011",
      "city": "Roanoke",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3595,
      "name": "Massive Attack",
      "rookie_year": "2011",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3596,
      "name": "Rocket Robotics",
      "rookie_year": "2011",
      "city": "South Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3597,
      "name": "Robo-Rangers",
      "rookie_year": "2011",
      "city": "Kittery",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3598,
      "name": "SEStematic Eliminators",
      "rookie_year": "2011",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3599,
      "name": "Dolphin Robotics",
      "rookie_year": "2011",
      "city": "Beaufort",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3600,
      "name": "Clockwork",
      "rookie_year": "2011",
      "city": "Madison",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3601,
      "name": "Spartan Sprockets",
      "rookie_year": "2011",
      "city": "Webberville",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3602,
      "name": "RoboMos",
      "rookie_year": "2011",
      "city": "Escanaba",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3603,
      "name": "Cyber Coyotes",
      "rookie_year": "2011",
      "city": "Reed City ",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3604,
      "name": "Goon Squad",
      "rookie_year": "2011",
      "city": "Brownstown",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3605,
      "name": "black storm",
      "rookie_year": "2011",
      "city": "dearborn",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3606,
      "name": "BearMetal",
      "rookie_year": "2011",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3607,
      "name": "TECHNOLOGIC",
      "rookie_year": "2011",
      "city": "Lambertville",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3608,
      "name": "Jaguars",
      "rookie_year": "2011",
      "city": "Sherwood",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3609,
      "name": "Duct Tape Dragons",
      "rookie_year": "2011",
      "city": "Portland",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3610,
      "name": "Islanders",
      "rookie_year": "2011",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3611,
      "name": "Team Tidy Cats",
      "rookie_year": "2011",
      "city": "Lynn Haven",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3612,
      "name": "GearHogs",
      "rookie_year": "2011",
      "city": "Springdale",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3613,
      "name": "Spartans",
      "rookie_year": "2011",
      "city": "Greece",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3614,
      "name": "The Love Machine",
      "rookie_year": "2011",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3615,
      "name": "Reavers",
      "rookie_year": "2011",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3616,
      "name": "Team Phenomena 3616",
      "rookie_year": "2011",
      "city": "Lafayette",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3617,
      "name": "Cold Logic",
      "rookie_year": "2011",
      "city": "Marquette",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3618,
      "name": "Petoskey Paladins",
      "rookie_year": "2011",
      "city": "Petoskey",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3619,
      "name": "Blackhawks",
      "rookie_year": "2011",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3620,
      "name": "Average Joes",
      "rookie_year": "2011",
      "city": "Saint Joseph",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3621,
      "name": "Rocket Robotics",
      "rookie_year": "2011",
      "city": "New Haven",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3622,
      "name": "r",
      "rookie_year": "2011",
      "city": "Boca Raton",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3623,
      "name": "TerrorBots",
      "rookie_year": "2011",
      "city": "Leominster",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3624,
      "name": "ThunderColts",
      "rookie_year": "2011",
      "city": "Huntington Station",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3625,
      "name": "Some Assembly Required",
      "rookie_year": "2011",
      "city": "Virginia Beach",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3626,
      "name": "Parish Robotics",
      "rookie_year": "2011",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3627,
      "name": "The Jungle Robotics",
      "rookie_year": "2011",
      "city": "Sarasota",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3628,
      "name": "Scott's Bros",
      "rookie_year": "2011",
      "city": "Scottsboro",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3629,
      "name": "PACERobotics- Philly ALL CITY Engineers",
      "rookie_year": "2011",
      "city": "Philadelphia area",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3630,
      "name": "Stampede",
      "rookie_year": "2011",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3631,
      "name": "The Vincents",
      "rookie_year": "2011",
      "city": "Hot Springs",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3632,
      "name": "D-Techs",
      "rookie_year": "2011",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3633,
      "name": "Catalyst 3633",
      "rookie_year": "2011",
      "city": "Albert Lea",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3634,
      "name": "Spark City",
      "rookie_year": "2011",
      "city": "Bridgeport",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3635,
      "name": "Flying Legion",
      "rookie_year": "2011",
      "city": "Warner Robins",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 3636,
      "name": "Generals",
      "rookie_year": "2011",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3637,
      "name": "The Daleks",
      "rookie_year": "2011",
      "city": "Flemington",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 3638,
      "name": "TigerTrons",
      "rookie_year": "2011",
      "city": "Belleville",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3639,
      "name": "Cogs",
      "rookie_year": "2011",
      "city": "Mesick",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3640,
      "name": "Panthers",
      "rookie_year": "2011",
      "city": "Portage",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3641,
      "name": "The Flying Toasters",
      "rookie_year": "2011",
      "city": "South Lyon",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3642,
      "name": "Huskies",
      "rookie_year": "2011",
      "city": "Jackson",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3643,
      "name": "Thunderbots",
      "rookie_year": "2011",
      "city": "Henderson",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3644,
      "name": "Warriors",
      "rookie_year": "2011",
      "city": "Taylorsville",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3645,
      "name": "Runtime Error",
      "rookie_year": "2011",
      "city": "Forest Hills",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3646,
      "name": "INTEGRA BAHCESEHIR",
      "rookie_year": "2011",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 3647,
      "name": "Millennium Falcons",
      "rookie_year": "2011",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3648,
      "name": "Sparta Robotica",
      "rookie_year": "2011",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3649,
      "name": "I-Robotics",
      "rookie_year": "2011",
      "city": "Chandler",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3650,
      "name": "RoboRaptors",
      "rookie_year": "2011",
      "city": "La Plata",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3651,
      "name": "TRIBE",
      "rookie_year": "2011",
      "city": "Travelers Rest",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3652,
      "name": "xKRT",
      "rookie_year": "2011",
      "city": "Kenton",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3653,
      "name": "Botcats",
      "rookie_year": "2011",
      "city": "Hollywood",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3654,
      "name": "TechTigers",
      "rookie_year": "2011",
      "city": "Middletown",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3655,
      "name": "Tractor Technicians",
      "rookie_year": "2011",
      "city": "Mason",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3656,
      "name": "Dreadbots",
      "rookie_year": "2011",
      "city": "Dexter",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3657,
      "name": "Lincoln Cyborgs",
      "rookie_year": "2011",
      "city": "Warren",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3658,
      "name": "Robo - Beavers",
      "rookie_year": "2011",
      "city": "Battle Creek",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3659,
      "name": "Mighty Patriots",
      "rookie_year": "2011",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3660,
      "name": "LIGHTSABERS",
      "rookie_year": "2011",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3661,
      "name": "RoboWolves",
      "rookie_year": "2011",
      "city": "Wadesboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3662,
      "name": "FrostByte  ",
      "rookie_year": "2011",
      "city": "Everett",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3663,
      "name": "CPR - Cedar Park Robotics",
      "rookie_year": "2011",
      "city": "Bothell",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3664,
      "name": "Lions",
      "rookie_year": "2011",
      "city": "Burlington",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3665,
      "name": "Titans",
      "rookie_year": "2011",
      "city": "Salt Lake City",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3666,
      "name": "Bolton Bear Bots",
      "rookie_year": "2011",
      "city": "Alexandria",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3667,
      "name": "Mecanum Knights",
      "rookie_year": "2011",
      "city": "Port Huron",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3668,
      "name": "TroBots",
      "rookie_year": "2011",
      "city": "Whitmore Lake",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3669,
      "name": "RoboKnights",
      "rookie_year": "2011",
      "city": "Ripon",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3670,
      "name": "Wolverines",
      "rookie_year": "2011",
      "city": "Richmond Hill",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3672,
      "name": "Robo TORS",
      "rookie_year": "2011",
      "city": "Sulphur",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3673,
      "name": "C.Y.B.O.R.G. Seagulls",
      "rookie_year": "2011",
      "city": "Seaside",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3674,
      "name": "CloverBots",
      "rookie_year": "2011",
      "city": "Battle Ground",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3675,
      "name": "Eagletrons",
      "rookie_year": "2011",
      "city": "Seymour",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3676,
      "name": "Redshift Robotics",
      "rookie_year": "2011",
      "city": "Arlington",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3677,
      "name": "Don Bots",
      "rookie_year": "2011",
      "city": "Pico Rivera",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3679,
      "name": "rattlers",
      "rookie_year": "2011",
      "city": "San Marcos",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3680,
      "name": "Elemental Dragons",
      "rookie_year": "2011",
      "city": "Statesville",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3681,
      "name": "Robo-Raiders",
      "rookie_year": "2011",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3682,
      "name": "DATC",
      "rookie_year": "2011",
      "city": "Kaysville",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3683,
      "name": "Team DAVE",
      "rookie_year": "2011",
      "city": "Waterloo",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 3684,
      "name": "Electric Eagles",
      "rookie_year": "2011",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3685,
      "name": "Searider Robotics",
      "rookie_year": "2011",
      "city": "Waianae",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3686,
      "name": "Turkeybots",
      "rookie_year": "2011",
      "city": "Memphis",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3687,
      "name": "The Patriots",
      "rookie_year": "2011",
      "city": "Schenectady",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3688,
      "name": "Norsemen",
      "rookie_year": "2011",
      "city": "Suttons Bay",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3690,
      "name": "GORT",
      "rookie_year": "2011",
      "city": "st. louis park",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3691,
      "name": "RoboRaiders",
      "rookie_year": "2011",
      "city": "Northfield",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3692,
      "name": "Rock N' Robotics",
      "rookie_year": "2011",
      "city": "Janesville",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3693,
      "name": "GearHead Pirates",
      "rookie_year": "2011",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3694,
      "name": "NAHS Warbotz",
      "rookie_year": "2011",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3695,
      "name": "Foximus Prime",
      "rookie_year": "2011",
      "city": "Yorkville",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3696,
      "name": "C.A.R.D.S",
      "rookie_year": "2011",
      "city": "North Richland Hills",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3697,
      "name": "Devil Bots",
      "rookie_year": "2011",
      "city": "Mt. Pleasant",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3698,
      "name": "Panthers",
      "rookie_year": "2011",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3699,
      "name": "Panthinators",
      "rookie_year": "2011",
      "city": "Spring Lake Park",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3700,
      "name": "The Metalling Kids",
      "rookie_year": "2011",
      "city": "Rio Hondo",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3701,
      "name": "Royal Robotics",
      "rookie_year": "2011",
      "city": "Gastonia",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3703,
      "name": "MechSperts",
      "rookie_year": "2011",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3704,
      "name": "Robosapiens",
      "rookie_year": "2011",
      "city": "National City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3705,
      "name": "Arrowbots",
      "rookie_year": "2011",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3706,
      "name": "Railsplitters",
      "rookie_year": "2011",
      "city": "Lincoln Park",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3707,
      "name": "Brighton TechnoDogs",
      "rookie_year": "2011",
      "city": "Brighton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3708,
      "name": "Lumberjacks",
      "rookie_year": "2011",
      "city": "Saginaw",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3709,
      "name": "RTC Megalodons",
      "rookie_year": "2011",
      "city": "Richmond",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3710,
      "name": "FSS Cyber Falcons",
      "rookie_year": "2011",
      "city": "Kingston",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3711,
      "name": "Iron Mustang",
      "rookie_year": "2011",
      "city": "Trout Lake",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3712,
      "name": "RoboCats",
      "rookie_year": "2011",
      "city": "Union",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3713,
      "name": "War Eagle Robotics",
      "rookie_year": "2011",
      "city": "Conroe",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3714,
      "name": "Flowers S.O.A.R.",
      "rookie_year": "2011",
      "city": "Springdale",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3715,
      "name": "CRAVEN COUNTY ROBOTICS",
      "rookie_year": "2011",
      "city": "NEW BERN",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3716,
      "name": "WARP (Wasatch Academy Robotics Program)",
      "rookie_year": "2011",
      "city": "Mount Pleasant",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3717,
      "name": "Hitchhikers",
      "rookie_year": "2011",
      "city": "San Pablo",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3718,
      "name": "Junkyard Battalion",
      "rookie_year": "2011",
      "city": "New Britain",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3719,
      "name": "STEM Whalers",
      "rookie_year": "2011",
      "city": "New London ",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3720,
      "name": "Cougears",
      "rookie_year": "2011",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3721,
      "name": "Charger Robotics",
      "rookie_year": "2011",
      "city": "Pearl CIty",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3722,
      "name": "Green Wave Robotics",
      "rookie_year": "2011",
      "city": "East Grand Forks",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3723,
      "name": "TEKnights",
      "rookie_year": "2011",
      "city": "Spring Valley",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3724,
      "name": "Mansfield Robotics",
      "rookie_year": "2011",
      "city": "Mansfield",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3725,
      "name": "Bionic Bulldogs",
      "rookie_year": "2011",
      "city": "Lyford",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3726,
      "name": "Thunder Cats",
      "rookie_year": "2011",
      "city": "Splendora",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3727,
      "name": "Gadgeteers",
      "rookie_year": "2011",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3728,
      "name": "Momentum",
      "rookie_year": "2011",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3729,
      "name": "The Raiders",
      "rookie_year": "2011",
      "city": "Aurora",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3730,
      "name": "Nu-Bots",
      "rookie_year": "2011",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3731,
      "name": "MoHawk Warriors",
      "rookie_year": "2011",
      "city": "houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3732,
      "name": "The Raging Tornadoes",
      "rookie_year": "2011",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3733,
      "name": "Kings",
      "rookie_year": "2011",
      "city": "Bowie",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3734,
      "name": "Caxys",
      "rookie_year": "2011",
      "city": "Lake Forest",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3735,
      "name": "VorTX",
      "rookie_year": "2011",
      "city": "Spring",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3737,
      "name": "Roto Raptors",
      "rookie_year": "2011",
      "city": "Goldsboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3738,
      "name": "xx^3 xy^2 ",
      "rookie_year": "2011",
      "city": "Yanceyville",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3739,
      "name": "Oakbotics",
      "rookie_year": "2011",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 3740,
      "name": "Storm Robotics",
      "rookie_year": "2011",
      "city": "Sauk Rapids",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3741,
      "name": "CORE G IX",
      "rookie_year": "2011",
      "city": "Rio Grande City",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3742,
      "name": "Gold Hawks",
      "rookie_year": "2011",
      "city": "Flushing",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3743,
      "name": "Eagle Bots",
      "rookie_year": "2011",
      "city": "Salado",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3744,
      "name": "robobulls",
      "rookie_year": "2011",
      "city": "Durham",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3745,
      "name": "Governors",
      "rookie_year": "2011",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3746,
      "name": "Retribution",
      "rookie_year": "2011",
      "city": "Huntersville",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3747,
      "name": "Chaotech",
      "rookie_year": "2011",
      "city": "Mankato",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3748,
      "name": "Ragnarok Robotics",
      "rookie_year": "2011",
      "city": "Ellicott City",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3749,
      "name": "Team Optix",
      "rookie_year": "2011",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3750,
      "name": "Gator Robotics",
      "rookie_year": "2011",
      "city": "Badger",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3751,
      "name": "Tower View Robotics",
      "rookie_year": "2011",
      "city": "Red Wing",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3752,
      "name": "Roaring Robo-Panthers",
      "rookie_year": "2011",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3753,
      "name": "BulahBots!",
      "rookie_year": "2011",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3754,
      "name": "TrekNorth First City Robotics",
      "rookie_year": "2011",
      "city": "Bemidji",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3755,
      "name": "Dragon Robotics",
      "rookie_year": "2011",
      "city": "Litchfield",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3756,
      "name": "RamFerno",
      "rookie_year": "2011",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3757,
      "name": "Adom Ajans Robotics",
      "rookie_year": "2011",
      "city": "Istanbul",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 3758,
      "name": "Anonymous Robotics",
      "rookie_year": "2011",
      "city": "Bryan",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3759,
      "name": "SMARTBOTS",
      "rookie_year": "2011",
      "city": "INGLEWOOD",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3760,
      "name": "AeroBots",
      "rookie_year": "2011",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3761,
      "name": "Sinton Robotics Team",
      "rookie_year": "2011",
      "city": "Sinton",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3762,
      "name": "Spartans",
      "rookie_year": "2011",
      "city": "Stafford",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3763,
      "name": "4-H WildCards",
      "rookie_year": "2011",
      "city": "Jacksonville",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3764,
      "name": "Guardian of Greene",
      "rookie_year": "2011",
      "city": "Springfield",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3765,
      "name": "The TerraBots",
      "rookie_year": "2011",
      "city": "St. Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3766,
      "name": "ort",
      "rookie_year": "2011",
      "city": "bet-shean",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3767,
      "name": "Titans",
      "rookie_year": "2011",
      "city": "Traverse City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3768,
      "name": "ASTRO DOGS",
      "rookie_year": "2011",
      "city": "Southfield",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3769,
      "name": "Droids",
      "rookie_year": "2011",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3770,
      "name": "BlitzCreek",
      "rookie_year": "2011",
      "city": "Midland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3771,
      "name": "Yooper Troopers",
      "rookie_year": "2011",
      "city": "Dollar Bay",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3772,
      "name": "DITEC ARME",
      "rookie_year": "2011",
      "city": "Kingsford",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3773,
      "name": "Arrowhead Robotics",
      "rookie_year": "2011",
      "city": "Tecumseh",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3774,
      "name": "RoboTeam",
      "rookie_year": "2011",
      "city": "Ramat Hasharon",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3775,
      "name": "NOFARIM",
      "rookie_year": "2011",
      "city": "tiberya",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3776,
      "name": "3W (Woodland Wildcat What-cha-ma-call-its)",
      "rookie_year": "2011",
      "city": "Cartersville",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3777,
      "name": "Bean City Bots",
      "rookie_year": "2011",
      "city": "Lima",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3778,
      "name": "Tech Squad",
      "rookie_year": "2011",
      "city": "Corpus Christi",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3779,
      "name": "The Hope Hoopsters",
      "rookie_year": "2011",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3780,
      "name": "Robot Unicorns",
      "rookie_year": "2011",
      "city": "Providence",
      "state": "Rhode Island",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3781,
      "name": "Cardinal Robotics",
      "rookie_year": "2011",
      "city": "Tacoma",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3782,
      "name": "Bot-tanicals",
      "rookie_year": "2011",
      "city": "Panama City",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3783,
      "name": "Robo Wildcats",
      "rookie_year": "2011",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3784,
      "name": "Bit by Bit Robotics Team",
      "rookie_year": "2011",
      "city": "Monett",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3785,
      "name": "ROCK'EM SHOCK'EM ROBOTICS",
      "rookie_year": "2011",
      "city": "Yuma",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3786,
      "name": "Chargers",
      "rookie_year": "2011",
      "city": "Kent",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3787,
      "name": "Wild Robotocats",
      "rookie_year": "2011",
      "city": "Westport",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3788,
      "name": "MekaMustangs",
      "rookie_year": "2011",
      "city": "Northome",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3789,
      "name": "On Track Robotics",
      "rookie_year": "2011",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3790,
      "name": "Toxic Sushi",
      "rookie_year": "2011",
      "city": "Bradenton",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3791,
      "name": "ATEMS",
      "rookie_year": "2011",
      "city": "Abilene",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3792,
      "name": "Army Ants",
      "rookie_year": "2011",
      "city": "Columbia",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3793,
      "name": "CyberTitans",
      "rookie_year": "2011",
      "city": "Frederick",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3794,
      "name": "Tecmilenio WinT",
      "rookie_year": "2011",
      "city": "METEPEC",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3795,
      "name": "Knight Owls",
      "rookie_year": "2011",
      "city": "Garland",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3796,
      "name": "Technical Assassins",
      "rookie_year": "2011",
      "city": "Windsor",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3797,
      "name": "Robo Dragons",
      "rookie_year": "2011",
      "city": "Bowling Green",
      "state": "KY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3798,
      "name": "Rangers",
      "rookie_year": "2011",
      "city": "Salina",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3799,
      "name": "Electric Fire",
      "rookie_year": "2011",
      "city": "Elmira",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3800,
      "name": "Mustangs",
      "rookie_year": "2011",
      "city": "Kailua",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3801,
      "name": "RAMbots 4-H Club",
      "rookie_year": "2011",
      "city": "Wenatchee",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3802,
      "name": "\u2728RoboPOP\u2728",
      "rookie_year": "2011",
      "city": "Carrollton",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3803,
      "name": "Lightning Robotics",
      "rookie_year": "2011",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3804,
      "name": "BroncoBots",
      "rookie_year": "2011",
      "city": "League City",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3805,
      "name": "North Spokane Yetis",
      "rookie_year": "2011",
      "city": "Spokane",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3806,
      "name": "Tigers",
      "rookie_year": "2011",
      "city": "Prescott",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3807,
      "name": "Overland BlazerBots",
      "rookie_year": "2011",
      "city": "Aurora",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3808,
      "name": "Phoenix Robos",
      "rookie_year": "2011",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3809,
      "name": "AcRT",
      "rookie_year": "2011",
      "city": "Columbia",
      "state": "KY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3810,
      "name": "Pirates",
      "rookie_year": "2011",
      "city": "Magna",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3811,
      "name": "\tChargerbots",
      "rookie_year": "2011",
      "city": "Weldon",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3812,
      "name": "Bits & Bots",
      "rookie_year": "2011",
      "city": "Longview",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3813,
      "name": "The Three Ring Circuits",
      "rookie_year": "2011",
      "city": "Puyallup",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3814,
      "name": "PiBotics",
      "rookie_year": "2011",
      "city": "Erlanger",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3815,
      "name": "NF Raiders",
      "rookie_year": "2011",
      "city": "Cumming",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 3817,
      "name": "Project Viking",
      "rookie_year": "2011",
      "city": "Bossier City",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3818,
      "name": "Bloctopus Crime",
      "rookie_year": "2011",
      "city": "Metairie",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3819,
      "name": "Roboticons",
      "rookie_year": "2011",
      "city": "Arlington",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3820,
      "name": "Robo-Raptors",
      "rookie_year": "2011",
      "city": "Live Oak",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3821,
      "name": "Pirabots",
      "rookie_year": "2011",
      "city": "Belfry",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3822,
      "name": "Neon Kracken",
      "rookie_year": "2011",
      "city": "Siler City",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 3823,
      "name": "TechTamers",
      "rookie_year": "2011",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3824,
      "name": "HVA RoHAWKtics",
      "rookie_year": "2011",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3825,
      "name": "Tri-Botics",
      "rookie_year": "2011",
      "city": "Pasco",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3826,
      "name": "Sequim Robotics Federation \"SRF\"",
      "rookie_year": "2011",
      "city": "Sequim",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3827,
      "name": "Ort Hilmi Shafe",
      "rookie_year": "2011",
      "city": "Acco",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 3828,
      "name": "12 Pretty Duckies",
      "rookie_year": "2011",
      "city": "Eveleth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3829,
      "name": "AmpAces",
      "rookie_year": "2011",
      "city": "Soddy-Daisy",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3830,
      "name": "Hopkinsville/Christian County 4-H Robotics Team",
      "rookie_year": "2011",
      "city": "Hopkinsville",
      "state": "KY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3831,
      "name": "Da Bears",
      "rookie_year": "2011",
      "city": "Brewster",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3832,
      "name": "Muddrew's Crew",
      "rookie_year": "2011",
      "city": "Jackson",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3833,
      "name": "The FIRST 3833",
      "rookie_year": "2011",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3834,
      "name": "Crab-bots",
      "rookie_year": "2011",
      "city": "Port Lavaca",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3835,
      "name": "Vulcan",
      "rookie_year": "2011",
      "city": "Tel Aviv",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 3836,
      "name": "Titans",
      "rookie_year": "2011",
      "city": "Gadsden",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3837,
      "name": "808 Robotics",
      "rookie_year": "2011",
      "city": "Pukalani",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3838,
      "name": "Roc City Robotix",
      "rookie_year": "2011",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3839,
      "name": "SWOLVERINES",
      "rookie_year": "2011",
      "city": "Wadena",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3840,
      "name": "Teens 'Nto Technology",
      "rookie_year": "2011",
      "city": "Isanti",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3841,
      "name": "Gresham Robo Rats",
      "rookie_year": "2011",
      "city": "Gresham",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3842,
      "name": "Shock-a-Bots",
      "rookie_year": "2011",
      "city": "Rochester",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3843,
      "name": "ROBO RACERS",
      "rookie_year": "2011",
      "city": "Murray",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3844,
      "name": "Kentucky Wildbots",
      "rookie_year": "2011",
      "city": "Corbin",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3845,
      "name": "Yellow Jackets",
      "rookie_year": "2011",
      "city": "Winston-Salem",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3846,
      "name": "The First Robotic Cardinals",
      "rookie_year": "2011",
      "city": "Staples",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3847,
      "name": "Spectrum   -\u25b3\u25c5",
      "rookie_year": "2011",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 3848,
      "name": "Bots in Shining Armour",
      "rookie_year": "2011",
      "city": "Kenyon",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3849,
      "name": "Absolute Zero",
      "rookie_year": "2010",
      "city": "San Diego",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3851,
      "name": "The Short Circuits ",
      "rookie_year": "2011",
      "city": "Canoga Park",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3853,
      "name": "Pridetronics",
      "rookie_year": "2011",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3854,
      "name": "Robo Warrios",
      "rookie_year": "2011",
      "city": "Seminole",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3855,
      "name": "The Mighty Trojans",
      "rookie_year": "2011",
      "city": "Bellingham",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3856,
      "name": "Kingsbury Falcons",
      "rookie_year": "2011",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3857,
      "name": "McKinney Masterminds",
      "rookie_year": "2011",
      "city": "McKinney",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3858,
      "name": "MetalStorm",
      "rookie_year": "2011",
      "city": "Greater Saint Louis",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3859,
      "name": "Wolfpack Robotics",
      "rookie_year": "2011",
      "city": "Elk Grove",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3860,
      "name": "Random Genetics",
      "rookie_year": "2011",
      "city": "Sunnyside",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3861,
      "name": "Steel Talon",
      "rookie_year": "2011",
      "city": "Signal Mountain",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3862,
      "name": "Iron Scorpion 4-H Robotics",
      "rookie_year": "2011",
      "city": "Farmington",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3863,
      "name": "Pantherbotics",
      "rookie_year": "2011",
      "city": "Newbury Park",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3864,
      "name": "Deus Volt",
      "rookie_year": "2011",
      "city": "Paramus",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3865,
      "name": "Riley WildBots",
      "rookie_year": "2011",
      "city": "South Bend",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3866,
      "name": "Blazing Eagles",
      "rookie_year": "2011",
      "city": "McClellan",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3867,
      "name": "Timberwolves Robotics",
      "rookie_year": "2011",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3868,
      "name": "Mechanized Mustangs",
      "rookie_year": "2011",
      "city": "Paducah",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3869,
      "name": "Tyler Lee",
      "rookie_year": "2011",
      "city": "Tyler",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3870,
      "name": "Fighting Gobblers",
      "rookie_year": "2011",
      "city": "Broadway",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3871,
      "name": "Trojan Robotics",
      "rookie_year": "2011",
      "city": "Worthington",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3872,
      "name": "Pan-Tech",
      "rookie_year": "2011",
      "city": "Shenandoah",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3873,
      "name": "Broward Bulldogs",
      "rookie_year": "2011",
      "city": "Pompano Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3874,
      "name": "Lightening Wave",
      "rookie_year": "2011",
      "city": "Columbus",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3875,
      "name": "Red Storm Robotics",
      "rookie_year": "2011",
      "city": "Kentwood",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 3876,
      "name": "Mabton LugNutz",
      "rookie_year": "2011",
      "city": "Mabton",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 3877,
      "name": "DABOT",
      "rookie_year": "2011",
      "city": "Madrid",
      "state": "MD",
      "country": "Spain",
      "district": ""
    },
    {
      "number": 3878,
      "name": "Wildcats",
      "rookie_year": "2011",
      "city": "Kealakekua ",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3879,
      "name": "Charter Bots",
      "rookie_year": "2011",
      "city": "Kihei",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3880,
      "name": "Tiki Techs",
      "rookie_year": "2011",
      "city": "Kailua Kona",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3881,
      "name": "WHEA Sharkbots",
      "rookie_year": "2011",
      "city": "Kailua Kona",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3882,
      "name": "Lunas",
      "rookie_year": "2011",
      "city": "Lahaina",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3883,
      "name": "Data Bits",
      "rookie_year": "2011",
      "city": "Cottage Grove",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3884,
      "name": "Spartans #2",
      "rookie_year": "2011",
      "city": "Denver",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3885,
      "name": "Shockers",
      "rookie_year": "2011",
      "city": "Bonne Terre",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3886,
      "name": "More Titans",
      "rookie_year": "2011",
      "city": "Traverse City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3888,
      "name": "3484",
      "rookie_year": "2011",
      "city": "Marysville",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3889,
      "name": "Leptechons",
      "rookie_year": "2011",
      "city": "Yuma",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3925,
      "name": "Circuit of Life",
      "rookie_year": "2012",
      "city": "Ventura",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3926,
      "name": "MPArors",
      "rookie_year": "2012",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3927,
      "name": "RAW-Robotics ",
      "rookie_year": "2012",
      "city": "Weymouth",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3928,
      "name": "Team Neutrino",
      "rookie_year": "2012",
      "city": "Ames",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3929,
      "name": "Atomic Dragons",
      "rookie_year": "2012",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3930,
      "name": "SMART  Spruce Mountain Area Robotics Team",
      "rookie_year": "2012",
      "city": "Jay",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3931,
      "name": "Cockadoodle Dominators",
      "rookie_year": "2012",
      "city": "Chickasha",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3932,
      "name": "The Dirty Mechanics",
      "rookie_year": "2012",
      "city": "Boca Raton",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3933,
      "name": "PrepaTec - Taman Keet",
      "rookie_year": "2012",
      "city": "Mexico",
      "state": "Distrito Federal",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3934,
      "name": "Robats",
      "rookie_year": "2012",
      "city": "Corona",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3936,
      "name": "RoboBlitz 3936",
      "rookie_year": "2012",
      "city": "Michigan City",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3937,
      "name": "Breakaway",
      "rookie_year": "2012",
      "city": "Searcy",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3938,
      "name": "Radix Robotics",
      "rookie_year": "2012",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3939,
      "name": "Botetourt 4-H Robotics",
      "rookie_year": "2012",
      "city": "Buchanan",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 3940,
      "name": "CyberTooth",
      "rookie_year": "2012",
      "city": "Kokomo",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 3941,
      "name": "FRC TEAM 3941 Absolute Zero Electricity - Northern Chesapeake STEM, Inc.",
      "rookie_year": "2012",
      "city": "Aberdeen Proving Ground",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3942,
      "name": "Northark Pioneers",
      "rookie_year": "2012",
      "city": "Harrison",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3943,
      "name": "Bulltronics",
      "rookie_year": "2012",
      "city": "Monterrey",
      "state": "NLE",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3944,
      "name": "All Knights",
      "rookie_year": "2012",
      "city": "Tempe",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3945,
      "name": "Cobratics, Inc",
      "rookie_year": "2012",
      "city": "Whites Creek",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3946,
      "name": "Tiger Robotics",
      "rookie_year": "2012",
      "city": "Slidell",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3947,
      "name": "The Last Crusaders",
      "rookie_year": "2012",
      "city": "Knightstown",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3948,
      "name": "BAWSS",
      "rookie_year": "2012",
      "city": "Lebanon",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3949,
      "name": "d'Y Robotics",
      "rookie_year": "2012",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3950,
      "name": "RoboGym Robotics",
      "rookie_year": "2012",
      "city": "Glen Head",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3951,
      "name": "SUITS",
      "rookie_year": "2012",
      "city": "Honeoye",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3952,
      "name": "Troy Robotics",
      "rookie_year": "2012",
      "city": "Fullerton",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3953,
      "name": "ROBATS",
      "rookie_year": "2012",
      "city": "Eastvale",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3954,
      "name": "4-H Electrotechs",
      "rookie_year": "2012",
      "city": "Emlenton",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3955,
      "name": "4-H Gears",
      "rookie_year": "2012",
      "city": "Greensburg",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3956,
      "name": "Itamitas",
      "rookie_year": "2012",
      "city": "Mexico City",
      "state": "DIF",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 3957,
      "name": "4-H Robo Rangers",
      "rookie_year": "2012",
      "city": "New Bethlehem",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3958,
      "name": "Schrodinger's Cat",
      "rookie_year": "2012",
      "city": "Boston",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 3959,
      "name": "Mech Tech",
      "rookie_year": "2012",
      "city": "Somerville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3960,
      "name": "BEast Robotics",
      "rookie_year": "2012",
      "city": "Salt Lake City",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3961,
      "name": "MBA Execs",
      "rookie_year": "2012",
      "city": "Memphis ",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3962,
      "name": "Incognito Robotics",
      "rookie_year": "2012",
      "city": "Kittanning",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3963,
      "name": "Urban Robots",
      "rookie_year": "2012",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3964,
      "name": "Dolphins",
      "rookie_year": "2012",
      "city": "Sanibel",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3965,
      "name": "Sultans",
      "rookie_year": "2012",
      "city": "Santee",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3966,
      "name": "L&N STEMpunks",
      "rookie_year": "2012",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3967,
      "name": "Trojans Robotics",
      "rookie_year": "2012",
      "city": "Chula Vista",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3968,
      "name": "Higher Voltage",
      "rookie_year": "2012",
      "city": "Renton",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3969,
      "name": "Phoenix",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3970,
      "name": "Duncan Dynamics",
      "rookie_year": "2012",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3971,
      "name": "Kai Orbus",
      "rookie_year": "2012",
      "city": "Weaverville",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3972,
      "name": "Raider Robos",
      "rookie_year": "2012",
      "city": "Kingsport",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3973,
      "name": "Pirate Robotics",
      "rookie_year": "2012",
      "city": "Platte City",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3974,
      "name": "E=mCD",
      "rookie_year": "2012",
      "city": "Wyncote",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3975,
      "name": "Les Dragons",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3976,
      "name": "Electric Hornets",
      "rookie_year": "2012",
      "city": "Hopkins",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3977,
      "name": "Predateurs ",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3978,
      "name": "Bouledogues",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3979,
      "name": "Solaris",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3980,
      "name": "Scorpions",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3981,
      "name": "Loups",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3983,
      "name": "Bobcats",
      "rookie_year": "2012",
      "city": "Verdun",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3984,
      "name": "Topper Robotics",
      "rookie_year": "2012",
      "city": "Johnson City",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3985,
      "name": "Sonic Howl",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3986,
      "name": "Express-O",
      "rookie_year": "2012",
      "city": "Saint-Laurent",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3987,
      "name": "Les Audacieux",
      "rookie_year": "2012",
      "city": "Montr\u00e9al",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3988,
      "name": "Scarabot",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3989,
      "name": "Classics",
      "rookie_year": "2012",
      "city": "Montreal",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3990,
      "name": "Tech for Kids",
      "rookie_year": "2012",
      "city": "Montr\u00e9al",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3991,
      "name": "KnightVision",
      "rookie_year": "2012",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3992,
      "name": "Eagles Robotics Xperience",
      "rookie_year": "2012",
      "city": "Delray Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3993,
      "name": "Humanoids",
      "rookie_year": "2012",
      "city": "Newhall",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3994,
      "name": "Goldenlions FIRST Robotics",
      "rookie_year": "2012",
      "city": "Pine Bluff",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3995,
      "name": "Automata",
      "rookie_year": "2012",
      "city": "Redmond",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3996,
      "name": "RIKITIK",
      "rookie_year": "2012",
      "city": "Rimouski",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 3997,
      "name": "Screaming Chickens",
      "rookie_year": "2012",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3998,
      "name": "Redneck Robotics",
      "rookie_year": "2012",
      "city": "Statesboro",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 3999,
      "name": "Shadetree Robotics",
      "rookie_year": "2012",
      "city": "Killeen",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4000,
      "name": "Texsquad",
      "rookie_year": "2012",
      "city": "Corpus Christi",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4001,
      "name": "RAMS ROBOTICS",
      "rookie_year": "2012",
      "city": "Thornhill",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4002,
      "name": "OSTC-SE Robotics",
      "rookie_year": "2012",
      "city": "Royal Oak",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4003,
      "name": "TriSonics",
      "rookie_year": "2012",
      "city": "Allendale",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4004,
      "name": "M.A.R.S. Rovers",
      "rookie_year": "2012",
      "city": "Muskegon",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4005,
      "name": "Hostile Gato Robotics",
      "rookie_year": "2012",
      "city": "Fort Gibson",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4006,
      "name": "CIBorgs",
      "rookie_year": "2012",
      "city": "Central Islip",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4007,
      "name": "Les Cactus",
      "rookie_year": "2012",
      "city": "Shawinigan",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4008,
      "name": "Theodore Roosevelt's Disco Haircut",
      "rookie_year": "2012",
      "city": "Petersburg",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4009,
      "name": "Denfeld DNA Robotics",
      "rookie_year": "2012",
      "city": "Duluth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4010,
      "name": "PrepaTec - Nautilus",
      "rookie_year": "2012",
      "city": "Tlalpan",
      "state": "Distrito Federal",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4011,
      "name": "\u03c0\u03c1b\u03bftics   (Pi robotics)",
      "rookie_year": "2012",
      "city": "La Crosse",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4012,
      "name": "Bad News Bots",
      "rookie_year": "2012",
      "city": "Staten Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4013,
      "name": "Clockwork Mania",
      "rookie_year": "2012",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4014,
      "name": "Pixelators",
      "rookie_year": "2012",
      "city": "Stanford",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4015,
      "name": "Jag",
      "rookie_year": "2012",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4016,
      "name": "Ashebots",
      "rookie_year": "2012",
      "city": "Asheville",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4017,
      "name": "Bulldogs",
      "rookie_year": "2012",
      "city": "Lind",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4018,
      "name": "Knight Bots",
      "rookie_year": "2012",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4019,
      "name": "Mechanical Paradise",
      "rookie_year": "2012",
      "city": "Studio City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4020,
      "name": "Cyber Tribe",
      "rookie_year": "2012",
      "city": "Kingsport",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4021,
      "name": "igKnightion",
      "rookie_year": "2012",
      "city": "Onalaska",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4022,
      "name": "Warriors",
      "rookie_year": "2012",
      "city": "Waterdown",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4023,
      "name": "Buff Sci-borgs",
      "rookie_year": "2012",
      "city": "Buffalo",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4024,
      "name": "The Jokers",
      "rookie_year": "2012",
      "city": "Winter Park",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4025,
      "name": "War Eagles",
      "rookie_year": "2012",
      "city": "Corryton",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4026,
      "name": "Global Dynamics",
      "rookie_year": "2012",
      "city": "Decatur",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4027,
      "name": "Centre Punch",
      "rookie_year": "2012",
      "city": "State College",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4028,
      "name": "The Beak Squad",
      "rookie_year": "2012",
      "city": "Cincinnati",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4029,
      "name": "SpartanBots",
      "rookie_year": "2012",
      "city": "Huntington Park",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4030,
      "name": "NullPointerException",
      "rookie_year": "2012",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4031,
      "name": "4-H Force Team",
      "rookie_year": "2012",
      "city": "Brookville",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4032,
      "name": "4-H Chrome Clovers",
      "rookie_year": "2012",
      "city": "Cecil",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4034,
      "name": "Pelham \u03c0thons Team 4034",
      "rookie_year": "2012",
      "city": "Pelham",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4035,
      "name": "Torbotix",
      "rookie_year": "2012",
      "city": "Orange",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4036,
      "name": "Short Circuit",
      "rookie_year": "2012",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4037,
      "name": "Hot Springs Tronix",
      "rookie_year": "2012",
      "city": "Hot Springs",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4038,
      "name": "Binary Robotics",
      "rookie_year": "2012",
      "city": "Bremerton",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4039,
      "name": "MakeShift Robotics",
      "rookie_year": "2012",
      "city": "Hamilton",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4040,
      "name": "Grease Monkeys",
      "rookie_year": "2012",
      "city": "Jonesboro",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4041,
      "name": "Iron Tigers",
      "rookie_year": "2012",
      "city": "Gardiner",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4042,
      "name": "Murphy's Lawyers",
      "rookie_year": "2012",
      "city": "South China",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4043,
      "name": "NerdHerd",
      "rookie_year": "2012",
      "city": "McMinnville",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4044,
      "name": "SCREAMIN' EAGLES",
      "rookie_year": "2012",
      "city": "Capac",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4045,
      "name": "Toxic Drones",
      "rookie_year": "2012",
      "city": "Fort Worth",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4046,
      "name": "Schrodinger's Dragons",
      "rookie_year": "2012",
      "city": "Los Angeles",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4047,
      "name": "Cyber Dogz",
      "rookie_year": "2012",
      "city": "Okland",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4048,
      "name": "Redshift",
      "rookie_year": "2012",
      "city": "Westborough",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4049,
      "name": "Knoch Knights Robotics",
      "rookie_year": "2012",
      "city": "Saxonburg",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4050,
      "name": "Biohazard",
      "rookie_year": "2012",
      "city": "Chambersburg",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4051,
      "name": "Sabin-Sharks",
      "rookie_year": "2012",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4052,
      "name": "WolfTrack",
      "rookie_year": "2012",
      "city": "Fort Myers",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4053,
      "name": "Team Ascension",
      "rookie_year": "2012",
      "city": "Gonzales",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4054,
      "name": "Robo Hawks",
      "rookie_year": "2012",
      "city": "La Crosse",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4055,
      "name": "NRG",
      "rookie_year": "2012",
      "city": "Winchester",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4056,
      "name": "Chancho's Robotics",
      "rookie_year": "2012",
      "city": "Mira Loma",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4057,
      "name": "Klamath Basin Robotics - STEAMPUNK",
      "rookie_year": "2012",
      "city": "Klamath Falls",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4058,
      "name": "BoomBots",
      "rookie_year": "2012",
      "city": "Liberty",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4059,
      "name": "SpareParts",
      "rookie_year": "2012",
      "city": "Eastman",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4060,
      "name": "Bearcat Robotics",
      "rookie_year": "2012",
      "city": "Chehalis",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4061,
      "name": "SciBorgs",
      "rookie_year": "2012",
      "city": "Pullman",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4062,
      "name": "\u00c9lectro Choc G\u00e9rald-Godin",
      "rookie_year": "2012",
      "city": "Ste-Genevieve",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4063,
      "name": "TriKzR4Kidz",
      "rookie_year": "2012",
      "city": "Del Rio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4064,
      "name": "InZombiacs",
      "rookie_year": "2012",
      "city": "Ocala",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4065,
      "name": "Nerds of Prey",
      "rookie_year": "2012",
      "city": "Minneola",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4066,
      "name": "MechMate",
      "rookie_year": "2012",
      "city": "Groveland",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4067,
      "name": "The Incredible Hawk",
      "rookie_year": "2012",
      "city": "Clarksville",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4068,
      "name": "Bearbotics",
      "rookie_year": "2012",
      "city": "Monument",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4069,
      "name": "Lo-Ellen Robotics",
      "rookie_year": "2012",
      "city": "Sudbury",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4070,
      "name": "Silicon Synapse",
      "rookie_year": "2012",
      "city": "Shelbyville",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4071,
      "name": "Diatonic Carbonites",
      "rookie_year": "2012",
      "city": "Syracuse",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4072,
      "name": "Demon Robotics",
      "rookie_year": "2012",
      "city": "Glenwood Springs",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4073,
      "name": "RoboKatz",
      "rookie_year": "2012",
      "city": "Myrtle Beach",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4074,
      "name": "Shark Bytes",
      "rookie_year": "2012",
      "city": "Murrells Inlet",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4075,
      "name": "Robo Tigers",
      "rookie_year": "2012",
      "city": "Conway",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4076,
      "name": "Texan Robotics",
      "rookie_year": "2012",
      "city": "Justin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4077,
      "name": "M*A*S*H",
      "rookie_year": "2012",
      "city": "Edmonds",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4078,
      "name": "Warriors",
      "rookie_year": "2012",
      "city": "La Puente",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4079,
      "name": "Quantum Leap",
      "rookie_year": "2012",
      "city": "Cypress",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4080,
      "name": "Team Reboot",
      "rookie_year": "2012",
      "city": "Tucker",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4081,
      "name": "Metal Masters",
      "rookie_year": "2012",
      "city": "East Chicago",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4082,
      "name": "Ranching Robots",
      "rookie_year": "2012",
      "city": "Dayton",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4083,
      "name": "The Iron Wolverines",
      "rookie_year": "2012",
      "city": "Dorchester",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4084,
      "name": "Nuclear Launch Detected",
      "rookie_year": "2012",
      "city": "Farmersville",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4085,
      "name": "Technical Difficulties",
      "rookie_year": "2012",
      "city": "Reynoldsburg",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4086,
      "name": "Team Tesla",
      "rookie_year": "2012",
      "city": "Twin Falls",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4087,
      "name": "Voodoo Voltage",
      "rookie_year": "2012",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4088,
      "name": "Insidious Aftershock",
      "rookie_year": "2012",
      "city": "Port Charlotte",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4089,
      "name": "Stealth Robotics",
      "rookie_year": "2012",
      "city": "Duvall",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4090,
      "name": "Reb Teks",
      "rookie_year": "2012",
      "city": "Fort Smith",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4091,
      "name": "DRIFT",
      "rookie_year": "2012",
      "city": "Santo Domingo",
      "state": "Santo Domingo",
      "country": "Dominican Republic",
      "district": ""
    },
    {
      "number": 4092,
      "name": "Jackson Robotics",
      "rookie_year": "2012",
      "city": "Dutton",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4093,
      "name": "Hardwired",
      "rookie_year": "2012",
      "city": "Orleans County",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4094,
      "name": "The Cyber Wolves",
      "rookie_year": "2012",
      "city": "Angus",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4095,
      "name": "Team RoXI",
      "rookie_year": "2012",
      "city": "Milwaukee",
      "state": "WI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4096,
      "name": "Ctrl-Z",
      "rookie_year": "2012",
      "city": "Champaign",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4097,
      "name": "Devilbots",
      "rookie_year": "2012",
      "city": "Northampton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4098,
      "name": "Viking Robotics Team",
      "rookie_year": "2012",
      "city": "Bristol",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4099,
      "name": "The Falcons",
      "rookie_year": "2012",
      "city": "Poolesville",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4101,
      "name": "St. Francis High School",
      "rookie_year": "2012",
      "city": "200 Foothill Bl.",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4102,
      "name": "Spartans",
      "rookie_year": "2012",
      "city": "Los Lunas",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4103,
      "name": "Roborioles",
      "rookie_year": "2012",
      "city": "Avon",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4104,
      "name": "Error-4104",
      "rookie_year": "2012",
      "city": "Cheney",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4105,
      "name": "ChiefBotsFTS",
      "rookie_year": "2012",
      "city": "Moses Lake",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4106,
      "name": "Bots of Prey",
      "rookie_year": "2012",
      "city": "Nampa",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4107,
      "name": "Team Storm",
      "rookie_year": "2012",
      "city": "Gulfport",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4108,
      "name": "Randolph Robotics",
      "rookie_year": "2012",
      "city": "New York",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4109,
      "name": "Reynolds Robo Raiders",
      "rookie_year": "2012",
      "city": "Troutdale",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4110,
      "name": "DEEP SPACE 9'ers",
      "rookie_year": "2012",
      "city": "Brookings",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4111,
      "name": "Some Assembly Required",
      "rookie_year": "2012",
      "city": "Mesa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4112,
      "name": "EagleBots",
      "rookie_year": "2012",
      "city": "Cumming ",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4113,
      "name": "IHS Robotics",
      "rookie_year": "2012",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4114,
      "name": "Pallindrones",
      "rookie_year": "2012",
      "city": "San Jacinto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4115,
      "name": "Team Breaking Lights",
      "rookie_year": "2012",
      "city": "Clarksville",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4116,
      "name": "SCC",
      "rookie_year": "2012",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4117,
      "name": "Wired Up",
      "rookie_year": "2012",
      "city": "San Diego",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4118,
      "name": "Roaring Riptide",
      "rookie_year": "2012",
      "city": "Gainesville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4119,
      "name": "AERO",
      "rookie_year": "2012",
      "city": "Avon",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4120,
      "name": "Jagwires",
      "rookie_year": "2012",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4121,
      "name": "Viking  Robotics",
      "rookie_year": "2012",
      "city": "North Canton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4122,
      "name": "Ossining O-Bots",
      "rookie_year": "2012",
      "city": "Ossining",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4123,
      "name": "Tribe Robotics",
      "rookie_year": "2012",
      "city": "Bellflower",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4124,
      "name": "Integration By Parts",
      "rookie_year": "2012",
      "city": "Massena",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4125,
      "name": "Confidential",
      "rookie_year": "2012",
      "city": "Umatilla",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4126,
      "name": "Decepta-Kings",
      "rookie_year": "2012",
      "city": "Yuma",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4127,
      "name": "LoggerBots",
      "rookie_year": "2012",
      "city": "Vernonia",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4128,
      "name": "TankBots",
      "rookie_year": "2012",
      "city": "Holmdel",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4129,
      "name": "Global Citizenship Experience High School",
      "rookie_year": "2012",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4130,
      "name": "The Blue Devils",
      "rookie_year": "2012",
      "city": "Richmond",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4131,
      "name": "Iron Patriots",
      "rookie_year": "2012",
      "city": "Renton",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4132,
      "name": "Scotbots",
      "rookie_year": "2012",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4133,
      "name": " S2-Boltz",
      "rookie_year": "2012",
      "city": "6406 E Chelsea St",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4134,
      "name": "RoboRams",
      "rookie_year": "2012",
      "city": "Amsterdam",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4135,
      "name": "Iron Patriots",
      "rookie_year": "2012",
      "city": "Modesto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4136,
      "name": "Vulcans",
      "rookie_year": "2012",
      "city": "new orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4137,
      "name": "Wilde Lake Robotics",
      "rookie_year": "2012",
      "city": "Columbia",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4138,
      "name": "Arc Flash",
      "rookie_year": "2012",
      "city": "Wichita Falls",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4139,
      "name": "Easy as Pi",
      "rookie_year": "2012",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4140,
      "name": "WIRED",
      "rookie_year": "2012",
      "city": "Chino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4141,
      "name": "Monarch Robotics",
      "rookie_year": "2012",
      "city": "Santa Ana",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4142,
      "name": "Shorebots",
      "rookie_year": "2012",
      "city": "Avon Lake",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4143,
      "name": "MARS/ WARS",
      "rookie_year": "2012",
      "city": "Metamora",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4144,
      "name": "Semi con-duck-tors",
      "rookie_year": "2012",
      "city": "Inglewood",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4145,
      "name": "WorBots",
      "rookie_year": "2012",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4146,
      "name": "Sabercats",
      "rookie_year": "2012",
      "city": "Scottsdale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4147,
      "name": "Vikings",
      "rookie_year": "2012",
      "city": "Yarmouth",
      "state": "NS",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4148,
      "name": "The SWAGbots",
      "rookie_year": "2012",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4149,
      "name": "The GLAMbots",
      "rookie_year": "2012",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4150,
      "name": "FRobotics",
      "rookie_year": "2012",
      "city": "Murrysville",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4151,
      "name": "SCRAP 4151",
      "rookie_year": "2012",
      "city": "Weymouth",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4152,
      "name": "Hoya Robotics",
      "rookie_year": "2012",
      "city": "Huntsville",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4153,
      "name": "Project Y",
      "rookie_year": "2012",
      "city": "Los Alamos",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4154,
      "name": "Perpetual Recursion",
      "rookie_year": "2012",
      "city": "Jefferson City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4155,
      "name": "SHARC",
      "rookie_year": "2012",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4156,
      "name": "Ninjaneers",
      "rookie_year": "2012",
      "city": "Springfield",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4157,
      "name": "Imaginarium",
      "rookie_year": "2012",
      "city": "Fort Myers",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4158,
      "name": "Leilehua Robotics",
      "rookie_year": "2012",
      "city": "Wahiawa",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4159,
      "name": "CardinalBotics",
      "rookie_year": "2012",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4160,
      "name": "The RoBucs",
      "rookie_year": "2012",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4161,
      "name": "T-Bird TECH",
      "rookie_year": "2012",
      "city": "Yucaipa",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4162,
      "name": "A3 BigBots",
      "rookie_year": "2012",
      "city": "New Braunfels",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4163,
      "name": "Westlake Robotics ",
      "rookie_year": "2012",
      "city": "Atlanta",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4164,
      "name": "Rocket Robotics",
      "rookie_year": "2012",
      "city": "Castle Rock",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4165,
      "name": "Appalachian Automation ",
      "rookie_year": "2012",
      "city": "LOGAN",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4166,
      "name": "Robostang",
      "rookie_year": "2012",
      "city": "Mora",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4167,
      "name": "Aquilon",
      "rookie_year": "2012",
      "city": "Quebec",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4169,
      "name": "Warrior Robotics",
      "rookie_year": "2012",
      "city": "Sudbury",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4170,
      "name": "What The FRaC",
      "rookie_year": "2012",
      "city": "Rialto",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4171,
      "name": "BayBots",
      "rookie_year": "2012",
      "city": "Seaside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4172,
      "name": "Buyukcekmece  Robotic",
      "rookie_year": "2012",
      "city": "Istanbul",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 4173,
      "name": "IMVERT (Mount Vernon Robotics Team)",
      "rookie_year": "2012",
      "city": "Mount Vernon",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4174,
      "name": "Mustangs",
      "rookie_year": "2012",
      "city": "Hector",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4175,
      "name": "Coded Summit",
      "rookie_year": "2012",
      "city": "Driggs",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4176,
      "name": "Iron Tigers",
      "rookie_year": "2012",
      "city": "North Easton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4177,
      "name": "Bulldawgs",
      "rookie_year": "2012",
      "city": "Monroe",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4178,
      "name": "MC Rocs",
      "rookie_year": "2012",
      "city": "Burley",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4179,
      "name": "Tahisco Techs",
      "rookie_year": "2012",
      "city": "Cantonment",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4180,
      "name": "Iron Riders",
      "rookie_year": "2012",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4181,
      "name": "Quack Attack",
      "rookie_year": "2012",
      "city": "Blackduck",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4182,
      "name": "Viking Robotics",
      "rookie_year": "2012",
      "city": "Minneota",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4183,
      "name": "Bit Buckets",
      "rookie_year": "2012",
      "city": "Tucson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4184,
      "name": "Wreck-techs",
      "rookie_year": "2012",
      "city": "Naples",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4185,
      "name": "The Resistance",
      "rookie_year": "2012",
      "city": "Fairfield",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4186,
      "name": "Alameda Aztechs",
      "rookie_year": "2012",
      "city": "Alameda",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4187,
      "name": "RoboRams",
      "rookie_year": "2012",
      "city": "Mount Vernon",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4188,
      "name": "Columbus Space Program",
      "rookie_year": "2012",
      "city": "Columbus",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4189,
      "name": "Chargers",
      "rookie_year": "2012",
      "city": "Jefferson",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4190,
      "name": "Hephaestus",
      "rookie_year": "2012",
      "city": "Port Richey",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4191,
      "name": "IMC",
      "rookie_year": "2012",
      "city": "Kocaeli",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 4192,
      "name": "Flower Mound Jaguar Robotics",
      "rookie_year": "2012",
      "city": "Flower Mound",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4193,
      "name": "Raptors",
      "rookie_year": "2012",
      "city": "Austell",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4195,
      "name": "Genesis",
      "rookie_year": "2012",
      "city": "Rome",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4196,
      "name": "QAVTC Devils",
      "rookie_year": "2012",
      "city": "Quincy",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4197,
      "name": "Lacoochee Cowboys",
      "rookie_year": "2012",
      "city": "Dade City",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4198,
      "name": "RoboCats 4198",
      "rookie_year": "2012",
      "city": "Waconia",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4199,
      "name": "   OG",
      "rookie_year": "2012",
      "city": "hattiesburg",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4200,
      "name": "Power Penguins",
      "rookie_year": "2012",
      "city": "Sarnia",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4201,
      "name": "The Vitruvian Bots",
      "rookie_year": "2012",
      "city": "El Segundo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4202,
      "name": "ROBOBEAR",
      "rookie_year": "2012",
      "city": "Scottsdale",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4203,
      "name": "RoboKronos",
      "rookie_year": "2012",
      "city": "Oneonta",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4205,
      "name": "ROBOCUBS",
      "rookie_year": "2012",
      "city": "Sedro Woolley",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4206,
      "name": "Robo Vikes",
      "rookie_year": "2012",
      "city": "Fort Worth",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4207,
      "name": "PyroBotics",
      "rookie_year": "2012",
      "city": "Victoria",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4208,
      "name": "AC PATRIOTS",
      "rookie_year": "2012",
      "city": "Hastings",
      "state": "NE",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4209,
      "name": "TigerBytes",
      "rookie_year": "2012",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4210,
      "name": "JagBots",
      "rookie_year": "2012",
      "city": "South Gate",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4211,
      "name": "Psycho Tech",
      "rookie_year": "2012",
      "city": "Indianapolis",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4212,
      "name": "Techno Ferrets",
      "rookie_year": "2012",
      "city": "Galesburg",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4213,
      "name": "MetalCow Robotics",
      "rookie_year": "2012",
      "city": "Bloomington",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4214,
      "name": "Robo-Flames",
      "rookie_year": "2012",
      "city": "Riverview",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4215,
      "name": "Tritons",
      "rookie_year": "2012",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4216,
      "name": "Blue Ops Robotics",
      "rookie_year": "2012",
      "city": "Jackson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4217,
      "name": "Scitobors",
      "rookie_year": "2012",
      "city": "Nashwauk",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4218,
      "name": "Navigator Robotics",
      "rookie_year": "2012",
      "city": "Kapolei",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4219,
      "name": "RED!",
      "rookie_year": "2012",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4222,
      "name": "The Frolicking Nerds",
      "rookie_year": "2012",
      "city": "Sanford",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4223,
      "name": "Robo-Flight-Transformer",
      "rookie_year": "2012",
      "city": "Lakeland",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4224,
      "name": "The Robo-Rays",
      "rookie_year": "2012",
      "city": "Naples",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4225,
      "name": "RoboCats",
      "rookie_year": "2012",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4226,
      "name": "Huskies",
      "rookie_year": "2012",
      "city": "Albany",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4227,
      "name": "quarks",
      "rookie_year": "2012",
      "city": "cannon falls",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4228,
      "name": "iRobotics",
      "rookie_year": "2012",
      "city": "Winthrop",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4229,
      "name": "Magnetech",
      "rookie_year": "2012",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4230,
      "name": "TopperBots",
      "rookie_year": "2012",
      "city": "Duluth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4231,
      "name": "Oakville Robotics 3",
      "rookie_year": "2012",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4232,
      "name": "AHS Robotics",
      "rookie_year": "2012",
      "city": "Alton",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4234,
      "name": "Bark Botz",
      "rookie_year": "2012",
      "city": "Indianapolis",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4235,
      "name": "RoboRaiders",
      "rookie_year": "2012",
      "city": "Danielsville",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4236,
      "name": "impulse robotics",
      "rookie_year": "2012",
      "city": "mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4237,
      "name": "Team Lance-A-Bot",
      "rookie_year": "2012",
      "city": "Stevensville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4238,
      "name": "Resistance Robotics",
      "rookie_year": "2012",
      "city": "Belgrade",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4239,
      "name": "WARPSPEED",
      "rookie_year": "2012",
      "city": "Willmar",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4240,
      "name": "TroTek Warriors",
      "rookie_year": "2012",
      "city": "Albany",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4241,
      "name": "Steel Tigers",
      "rookie_year": "2012",
      "city": "Joliet",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4242,
      "name": "Fresh T.E.C.H.",
      "rookie_year": "2012",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4243,
      "name": "Excelsior!",
      "rookie_year": "2012",
      "city": "Charleston",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4244,
      "name": "The Steel Battalion",
      "rookie_year": "2012",
      "city": "Le Sueur",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4245,
      "name": "Robo Dragons",
      "rookie_year": "2012",
      "city": "1304 Ashe Street",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4246,
      "name": "Resurrected Robotics",
      "rookie_year": "2012",
      "city": "Troy",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4247,
      "name": "CougarBots",
      "rookie_year": "2012",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4248,
      "name": "Bits & Pieces",
      "rookie_year": "2012",
      "city": "Whitby",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4249,
      "name": "Tektronix",
      "rookie_year": "2012",
      "city": "Brampton",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4250,
      "name": "Comet-tron",
      "rookie_year": "2012",
      "city": "Cobourg",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4251,
      "name": "The Gallup GearHeads",
      "rookie_year": "2012",
      "city": "Gallup",
      "state": "NM",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4252,
      "name": "Cardinal Robotics",
      "rookie_year": "2012",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4253,
      "name": "Raid Zero",
      "rookie_year": "2012",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 4254,
      "name": "Varsity Robotics",
      "rookie_year": "2012",
      "city": "Saratoga Springs",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4255,
      "name": "RoboDores",
      "rookie_year": "2012",
      "city": "Monterey",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4256,
      "name": "Cyborg Cats",
      "rookie_year": "2012",
      "city": "TOWN AND COUNTRY",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4257,
      "name": "CyberDogs",
      "rookie_year": "2012",
      "city": "Aurora",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4258,
      "name": "Thornhill Secondary School",
      "rookie_year": "2012",
      "city": "Markham",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4259,
      "name": "Robo Dragons",
      "rookie_year": "2012",
      "city": "Nacogdoches",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4260,
      "name": "BEAR (Blue Earth Area Robotics)",
      "rookie_year": "2012",
      "city": "Blue Earth Area",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4261,
      "name": "Raptors",
      "rookie_year": "2012",
      "city": "North Charleston",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4262,
      "name": "Tecmilenio - RoboHawk - 4262",
      "rookie_year": "2012",
      "city": "Santiago de Quer\u00e9taro",
      "state": "Quer\u00e9taro",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4263,
      "name": "CyberDragon",
      "rookie_year": "2012",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4264,
      "name": "The Fellowship of the Springs",
      "rookie_year": "2012",
      "city": "Rogersville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4265,
      "name": "Secret City Wildbots",
      "rookie_year": "2012",
      "city": "Oak Ridge",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4266,
      "name": "GhostBotics",
      "rookie_year": "2012",
      "city": "New Oxford",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4267,
      "name": "Brave Bots",
      "rookie_year": "2012",
      "city": "Myrtle Beach",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4268,
      "name": "Beehive Robotics",
      "rookie_year": "2012",
      "city": "Sandy",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4269,
      "name": "CardinalBots",
      "rookie_year": "2012",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4270,
      "name": "Crusaders",
      "rookie_year": "2012",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4271,
      "name": "Los Bandidos",
      "rookie_year": "2012",
      "city": "Austin",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4272,
      "name": "Maverick Boiler Robotics",
      "rookie_year": "2012",
      "city": "Lafayette",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 4273,
      "name": "n/a",
      "rookie_year": "2012",
      "city": "Culpeper",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4275,
      "name": "Western Hills RoboStangs",
      "rookie_year": "2012",
      "city": "Cincinnati",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4276,
      "name": "Surf City Vikings",
      "rookie_year": "2012",
      "city": "Huntington Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4277,
      "name": "Thingamajiggers",
      "rookie_year": "2012",
      "city": "New Hope",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4278,
      "name": "DABOT",
      "rookie_year": "2012",
      "city": "Madrid",
      "state": "MD",
      "country": "Spain",
      "district": ""
    },
    {
      "number": 4279,
      "name": "RoboRevolution",
      "rookie_year": "2012",
      "city": "Cincinnati",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4280,
      "name": "N-Gen",
      "rookie_year": "2012",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4281,
      "name": " Bulldogs",
      "rookie_year": "2012",
      "city": "Somerset",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4282,
      "name": "Cowboys",
      "rookie_year": "2012",
      "city": "Brownsvile",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4283,
      "name": "INSPIRE Robotics",
      "rookie_year": "2012",
      "city": "Granville",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4284,
      "name": "ScotBot4284",
      "rookie_year": "2012",
      "city": "Cincinnati",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4285,
      "name": "Camo-Bots",
      "rookie_year": "2012",
      "city": "Honesdale",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4286,
      "name": "Imperial Robotics",
      "rookie_year": "2012",
      "city": "Mechanicsville",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4287,
      "name": "Trojans",
      "rookie_year": "2012",
      "city": "College Park",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4288,
      "name": "Worcester Beach Bots",
      "rookie_year": "2012",
      "city": "Berlin",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4289,
      "name": "Autobots",
      "rookie_year": "2012",
      "city": "Lewistown",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4290,
      "name": "Bots on Wheels",
      "rookie_year": "2012",
      "city": "Charlotte",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4291,
      "name": "AstroBots",
      "rookie_year": "2012",
      "city": "Henderson",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4292,
      "name": "PorterBots",
      "rookie_year": "2012",
      "city": "Lockport",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4293,
      "name": "Komodo",
      "rookie_year": "2012",
      "city": "Highlands Ranch",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4294,
      "name": "StarTREC",
      "rookie_year": "2012",
      "city": "Lansing",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4295,
      "name": "Hudson Robotics",
      "rookie_year": "2012",
      "city": "Lufkin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4296,
      "name": "Trident Robotics",
      "rookie_year": "2012",
      "city": "Gurnee",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4297,
      "name": "WENORoBoTS",
      "rookie_year": "2012",
      "city": "Birmingham",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4298,
      "name": "Lectric Longhorn Ranch",
      "rookie_year": "2012",
      "city": "Amarillo",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4299,
      "name": "BCS RoboSharks",
      "rookie_year": "2012",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4300,
      "name": "The Lion Kings",
      "rookie_year": "2012",
      "city": "McKinney",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4301,
      "name": "SM Energy New Tech Narcissists",
      "rookie_year": "2012",
      "city": "Odessa",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4302,
      "name": "Robophins",
      "rookie_year": "2012",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4304,
      "name": "Iron Rams",
      "rookie_year": "2012",
      "city": "Puyallup",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4306,
      "name": "Robokomodos",
      "rookie_year": "2012",
      "city": "Franklin",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4307,
      "name": "Trojan Thunderbolts",
      "rookie_year": "2012",
      "city": "180 Church St. North",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4308,
      "name": "ABSOLUTE ROBOTICS",
      "rookie_year": "2012",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4309,
      "name": "4-H Botsmiths",
      "rookie_year": "2012",
      "city": "Snohomish",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4310,
      "name": "NUKES",
      "rookie_year": "2012",
      "city": "American Fork",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4311,
      "name": "Swampscott Currents",
      "rookie_year": "2012",
      "city": "Swampscott",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4314,
      "name": "SUL Abe-Ro-Bots",
      "rookie_year": "2012",
      "city": "Springfield ",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4315,
      "name": "Falcons",
      "rookie_year": "2012",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4316,
      "name": "Trobotics",
      "rookie_year": "2012",
      "city": "Raceland",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4317,
      "name": "Tech Busters",
      "rookie_year": "2012",
      "city": "Denton",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4318,
      "name": "Mo-Bots",
      "rookie_year": "2012",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4319,
      "name": "Ladies FIRST",
      "rookie_year": "2012",
      "city": "Beer Sheva",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4320,
      "name": "The Joker",
      "rookie_year": "2012",
      "city": "Petach Tikvah",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4321,
      "name": "Vikings",
      "rookie_year": "2012",
      "city": "Jacksonville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4322,
      "name": "Clockwork Oranges",
      "rookie_year": "2012",
      "city": "Orange",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4323,
      "name": "BGCircuit Breakers",
      "rookie_year": "2012",
      "city": "Columbus",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4324,
      "name": "HTA",
      "rookie_year": "2012",
      "city": "Decatur",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4325,
      "name": "RoboRangers",
      "rookie_year": "2012",
      "city": "Cassopolis",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4326,
      "name": "Team Rocket",
      "rookie_year": "2012",
      "city": "Ramat Hasharon",
      "state": "M",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4327,
      "name": "Q Branch",
      "rookie_year": "2012",
      "city": "Battle Creek",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4328,
      "name": "Furious Falcons",
      "rookie_year": "2012",
      "city": "Richmond",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4329,
      "name": "Lutheran Roboteers",
      "rookie_year": "2012",
      "city": "Saint Peters",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4330,
      "name": "Rambunction",
      "rookie_year": "2012",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4331,
      "name": "RoboSwag",
      "rookie_year": "2012",
      "city": "St. Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4332,
      "name": "EHS RoboCats",
      "rookie_year": "2012",
      "city": "Edinburg",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4333,
      "name": "Team MOSI",
      "rookie_year": "2012",
      "city": "Tampa",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4334,
      "name": "Alberta Tech Alliance (ATA)",
      "rookie_year": "2012",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4335,
      "name": "Metallic Clouds",
      "rookie_year": "2012",
      "city": "Waco",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4336,
      "name": "Ramageddon Robotics",
      "rookie_year": "2012",
      "city": "Lafayette",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4337,
      "name": "Red Devil robotics",
      "rookie_year": "2012",
      "city": "Holton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4338,
      "name": "Falcons",
      "rookie_year": "2012",
      "city": "Even-Yehuda",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4339,
      "name": "Topsail FIRST Robotics",
      "rookie_year": "2012",
      "city": "Hampstead",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4341,
      "name": "Panther Robotics",
      "rookie_year": "2012",
      "city": "Mulberry",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4342,
      "name": "Demon Robotics",
      "rookie_year": "2012",
      "city": "Kennett Square",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4343,
      "name": "MaxTech",
      "rookie_year": "2012",
      "city": "Aurora",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4344,
      "name": "SLCSE",
      "rookie_year": "2012",
      "city": "1400 W. Goodwin Ave.",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4345,
      "name": "AutoPilots",
      "rookie_year": "2012",
      "city": "Wilmington",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4346,
      "name": "Crimson Dragons",
      "rookie_year": "2012",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4347,
      "name": "Mechanical End",
      "rookie_year": "2012",
      "city": "Paterson",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4348,
      "name": "Bonneville Bots",
      "rookie_year": "2012",
      "city": "Tooele",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4349,
      "name": "Viking Robotics",
      "rookie_year": "2012",
      "city": "Oklahoma City",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4350,
      "name": "Harmony",
      "rookie_year": "2012",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4351,
      "name": "Broncobots",
      "rookie_year": "2012",
      "city": "McKinney",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4352,
      "name": "Generals",
      "rookie_year": "2012",
      "city": "Jacksonville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4353,
      "name": "Krewe de Reauxbotics",
      "rookie_year": "2012",
      "city": "Lafayette",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4354,
      "name": "PengWINs",
      "rookie_year": "2012",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4355,
      "name": "Pe\u00f1oles-CP-BOTS",
      "rookie_year": "2012",
      "city": "Gomez Palacio",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4356,
      "name": "BIG Furious George",
      "rookie_year": "2012",
      "city": "Chaffee",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4357,
      "name": "Spartans",
      "rookie_year": "2012",
      "city": "Port Hope",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4358,
      "name": "Ollibotics",
      "rookie_year": "2012",
      "city": "Freiburg im Breisgau",
      "state": "BW",
      "country": "Germany",
      "district": ""
    },
    {
      "number": 4359,
      "name": "North Robotics",
      "rookie_year": "2012",
      "city": "McKinney",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4360,
      "name": "Spudnik",
      "rookie_year": "2012",
      "city": "Moorhead",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4361,
      "name": "Roxbotix",
      "rookie_year": "2012",
      "city": "Roxbury Township",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4362,
      "name": "CSPA Gems",
      "rookie_year": "2012",
      "city": "Brighton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4363,
      "name": "Unbolted Puppeteers",
      "rookie_year": "2012",
      "city": "Hancock",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4364,
      "name": "Metal Jackets",
      "rookie_year": "2012",
      "city": "Stephenville",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4365,
      "name": "Torch Club",
      "rookie_year": "2012",
      "city": "Hueytown",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4366,
      "name": "Rawbotics",
      "rookie_year": "2012",
      "city": "Mexico",
      "state": "DIF",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4367,
      "name": "Tigers",
      "rookie_year": "2012",
      "city": "72 Joymar Drive",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4368,
      "name": "BullBots",
      "rookie_year": "2012",
      "city": "Vicksburg",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4369,
      "name": "Brick City Bots",
      "rookie_year": "2012",
      "city": "Sanford",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4370,
      "name": "PROJECT X",
      "rookie_year": "2012",
      "city": "Orangeburg",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4371,
      "name": "ART Mx - TecMilenio",
      "rookie_year": "2012",
      "city": "Cuautil\u00e1n Izcalli",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4372,
      "name": "PRDG",
      "rookie_year": "2012",
      "city": "Cambridge",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4373,
      "name": "RooBotics",
      "rookie_year": "2012",
      "city": "Jenkintown",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4374,
      "name": "Roosevelt Robotics",
      "rookie_year": "2012",
      "city": "Honolulu",
      "state": "HI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4375,
      "name": "Westend Gearbusters",
      "rookie_year": "2012",
      "city": "Ishpeming",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4376,
      "name": "Raydernators",
      "rookie_year": "2012",
      "city": "Charlevoix",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4377,
      "name": "Boyne City Blaze",
      "rookie_year": "2012",
      "city": "Boyne City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4378,
      "name": "Dark Knights",
      "rookie_year": "2012",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4379,
      "name": "Greased Lightning",
      "rookie_year": "2012",
      "city": "Weston",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4380,
      "name": "Dynomite",
      "rookie_year": "2012",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4381,
      "name": "Twisted Devils",
      "rookie_year": "2012",
      "city": "Richland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4382,
      "name": "Team Trobot",
      "rookie_year": "2012",
      "city": "Saginaw",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4383,
      "name": "The P-TECH Fly-Bots",
      "rookie_year": "2012",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4384,
      "name": "Benzene Bots",
      "rookie_year": "2012",
      "city": "Troy",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4385,
      "name": "The Bryan Automatons",
      "rookie_year": "2012",
      "city": "Bryan",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4386,
      "name": "Mecha-maniacs",
      "rookie_year": "2012",
      "city": "Brush",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4387,
      "name": "TBD",
      "rookie_year": "2012",
      "city": "Sterling",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4388,
      "name": "FIRST TEAM 4388 - Ridgebotics",
      "rookie_year": "2012",
      "city": "Fort Collins",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4389,
      "name": "Virtual Bot",
      "rookie_year": "2012",
      "city": "Battle Creek",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4390,
      "name": "ATA  Coregears",
      "rookie_year": "2012",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4391,
      "name": "BraveBots",
      "rookie_year": "2012",
      "city": "Gladstone",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4392,
      "name": "The Deceivers",
      "rookie_year": "2012",
      "city": "Brimley",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4394,
      "name": "Team Opportunity",
      "rookie_year": "2012",
      "city": "Williamsburg",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4395,
      "name": "Dundee Vi-Borgs",
      "rookie_year": "2012",
      "city": "Dundee",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4396,
      "name": "Gear Grinders ",
      "rookie_year": "2012",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4397,
      "name": "TEAM Clutch Robotics",
      "rookie_year": "2012",
      "city": "Bagley",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4398,
      "name": "Imprimis Deo",
      "rookie_year": "2012",
      "city": "Traverse City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4400,
      "name": "CERBOTICS",
      "rookie_year": "2012",
      "city": "TORREON",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4401,
      "name": "Pe\u00f1oles - CETMOV",
      "rookie_year": "2012",
      "city": "Laguna del Rey Coahuila",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4402,
      "name": "Connectors",
      "rookie_year": "2012",
      "city": "West Plains",
      "state": "MO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4403,
      "name": "PrepaTec - PE\u00d1OLES - ROULT",
      "rookie_year": "2012",
      "city": "Torreon",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4404,
      "name": "Nuts & Colts",
      "rookie_year": "2012",
      "city": "Chesterfield",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4405,
      "name": "The Atoms Family",
      "rookie_year": "2012",
      "city": "Canton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4406,
      "name": "Robotic Legends",
      "rookie_year": "2012",
      "city": "Tel Aviv",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4407,
      "name": "Virtualosity",
      "rookie_year": "2012",
      "city": "Jackson",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4408,
      "name": "Panthera Machina",
      "rookie_year": "2012",
      "city": "Battle Creek",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4409,
      "name": "Ground Zero",
      "rookie_year": "2012",
      "city": "Niles",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4410,
      "name": "Cyber Senators",
      "rookie_year": "2012",
      "city": "Orange",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4411,
      "name": "Jiao Da Fu Zhong",
      "rookie_year": "2012",
      "city": "Beijing",
      "state": "11",
      "country": "China",
      "district": ""
    },
    {
      "number": 4412,
      "name": "Steel Stallions",
      "rookie_year": "2012",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4413,
      "name": "Golden Gears Robotics",
      "rookie_year": "2012",
      "city": "Studio City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4414,
      "name": "HighTide",
      "rookie_year": "2012",
      "city": "Ventura",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4415,
      "name": "EPIC Robotz",
      "rookie_year": "2012",
      "city": "Cerritos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4416,
      "name": "Skynet",
      "rookie_year": "2012",
      "city": "Ramat Hasharon",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4418,
      "name": "Team IMPULSE",
      "rookie_year": "2012",
      "city": "Highlands Ranch",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4419,
      "name": "Team Rewind",
      "rookie_year": "2012",
      "city": "San Marcos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4420,
      "name": "Swarm Storm",
      "rookie_year": "2012",
      "city": "Torrington",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4421,
      "name": "FORGE Robotics",
      "rookie_year": "2012",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4450,
      "name": "Olympia Robotics Federation",
      "rookie_year": "2013",
      "city": "Olympia",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4451,
      "name": "ROBOTZ Garage",
      "rookie_year": "2013",
      "city": "Laurens",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4452,
      "name": "First Noble Team",
      "rookie_year": "2013",
      "city": "Seneca",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4453,
      "name": "The Red Hot Chili Bots",
      "rookie_year": "2013",
      "city": "Marshall",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4454,
      "name": "SLAM Robotics",
      "rookie_year": "2013",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4455,
      "name": "The Burger Bots",
      "rookie_year": "2013",
      "city": "Warrensburg",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4456,
      "name": "Mech Cadets",
      "rookie_year": "2013",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4457,
      "name": "Controlled Chaotic Robotics",
      "rookie_year": "2013",
      "city": "Portland",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4458,
      "name": "Infernobotix",
      "rookie_year": "2013",
      "city": "Center Moriches",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4459,
      "name": "LeoTechs",
      "rookie_year": "2013",
      "city": "Lithia Springs",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4460,
      "name": "Green MASHine",
      "rookie_year": "2013",
      "city": "West Vincent Township",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4461,
      "name": "Ramen",
      "rookie_year": "2013",
      "city": "Des Moines",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4462,
      "name": "Full Metal Jackets",
      "rookie_year": "2013",
      "city": "Kingston",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4463,
      "name": "The Blaze",
      "rookie_year": "2013",
      "city": "Jonesboro",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4464,
      "name": "Team Illusion",
      "rookie_year": "2013",
      "city": "Laurel",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4465,
      "name": "WC4-H",
      "rookie_year": "2013",
      "city": "Youngsville",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4466,
      "name": "Robo Hamsters",
      "rookie_year": "2013",
      "city": "Culpeper",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4467,
      "name": "Titanium Titans",
      "rookie_year": "2013",
      "city": "Canonsburg",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4468,
      "name": "Fernbank LINKS",
      "rookie_year": "2013",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4469,
      "name": "R.A.I.D. (Raider Artificial Intelligence DIvision)",
      "rookie_year": "2013",
      "city": "Federal Way",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4470,
      "name": "TiGears",
      "rookie_year": "2013",
      "city": "Placentia",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4471,
      "name": "SPARTRONS",
      "rookie_year": "2013",
      "city": "Hollywood",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4472,
      "name": "SuperNOVA",
      "rookie_year": "2013",
      "city": "Woodbridge",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4473,
      "name": "Delta Prime Robotics",
      "rookie_year": "2013",
      "city": "Farmingdale",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4474,
      "name": "Silver Circuit",
      "rookie_year": "2013",
      "city": "Kingston",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4475,
      "name": "Terrier Byte Bots",
      "rookie_year": "2013",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4476,
      "name": "W.A.F.F.L.E.S.",
      "rookie_year": "2013",
      "city": "Kingston",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4477,
      "name": "ASMSA FIRST",
      "rookie_year": "2013",
      "city": "Hot Springs",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4478,
      "name": "Materia Oscura",
      "rookie_year": "2013",
      "city": "Milford",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4479,
      "name": "Hixson Wiredcats",
      "rookie_year": "2013",
      "city": "5705 Middle Valley Rd",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4480,
      "name": "UC-Botics",
      "rookie_year": "2013",
      "city": "Upsala",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4481,
      "name": "Team Rembrandts",
      "rookie_year": "2013",
      "city": "Eindhoven",
      "state": "Noord-Brabant",
      "country": "Netherlands",
      "district": ""
    },
    {
      "number": 4482,
      "name": "ID Robotics",
      "rookie_year": "2013",
      "city": "Kalamazoo",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4483,
      "name": "21st Century Robotics",
      "rookie_year": "2013",
      "city": "Battle Creek",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4484,
      "name": "4-H DEADLOX",
      "rookie_year": "2013",
      "city": "Clearfield",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4485,
      "name": "Tribe Tech Robotics",
      "rookie_year": "2013",
      "city": "Danville",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 4486,
      "name": "Blue Prints",
      "rookie_year": "2013",
      "city": "Vista",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4487,
      "name": "Oologah",
      "rookie_year": "2013",
      "city": "Oologah",
      "state": "OK",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4488,
      "name": "Shockwave",
      "rookie_year": "2013",
      "city": "Hillsboro",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4489,
      "name": "Cybertribe",
      "rookie_year": "2013",
      "city": "Knoxville",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4490,
      "name": "TechRaiders",
      "rookie_year": "2013",
      "city": "Searcy",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4491,
      "name": "Richmond Knights",
      "rookie_year": "2013",
      "city": "Richmond",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4492,
      "name": "Chrono",
      "rookie_year": "2013",
      "city": "Coaticook",
      "state": "QC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4493,
      "name": "The Red Hornet",
      "rookie_year": "2013",
      "city": "Blevins",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4494,
      "name": "Scrapping Hornets",
      "rookie_year": "2013",
      "city": "Nashville",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4495,
      "name": "Kittitas County Robotics/ Team Haywire",
      "rookie_year": "2013",
      "city": "Thorp",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4496,
      "name": "Sonoran Storm Robotics",
      "rookie_year": "2013",
      "city": "Gilbert",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4497,
      "name": "SKy-Net",
      "rookie_year": "2013",
      "city": "Swift Current",
      "state": "Saskatchewan",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4498,
      "name": "Team X",
      "rookie_year": "2013",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4499,
      "name": "The Highlanders",
      "rookie_year": "2013",
      "city": "Fort Collins",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4500,
      "name": "RoboHounds",
      "rookie_year": "2013",
      "city": "Clayton",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4501,
      "name": "Humans",
      "rookie_year": "2013",
      "city": "Santa Monica",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4502,
      "name": "The Octo\u03c0",
      "rookie_year": "2013",
      "city": "New Braunfels",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4503,
      "name": "Wildcats",
      "rookie_year": "2013",
      "city": "El Dorado",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4504,
      "name": "B. C. Robotics",
      "rookie_year": "2013",
      "city": "Maryville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4505,
      "name": "McDonogh Robotics",
      "rookie_year": "2013",
      "city": "Owings Mills",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4506,
      "name": "PioNerds",
      "rookie_year": "2013",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4507,
      "name": "TARminators",
      "rookie_year": "2013",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4508,
      "name": "Steel Stallions",
      "rookie_year": "2013",
      "city": "Schuylerville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4509,
      "name": "Mechanical Bulls",
      "rookie_year": "2013",
      "city": "Sugar Hill",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4510,
      "name": "Bobcats",
      "rookie_year": "2013",
      "city": "715 North Third Street",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4511,
      "name": "Power Amplified",
      "rookie_year": "2013",
      "city": "Plymouth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4512,
      "name": "Otter Chaos",
      "rookie_year": "2013",
      "city": "Everett",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4513,
      "name": "Circuit Breakers",
      "rookie_year": "2013",
      "city": "Medical Lake",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4514,
      "name": "Calvert STEAM Works",
      "rookie_year": "2013",
      "city": "Huntingtown",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4515,
      "name": "Stag",
      "rookie_year": "2013",
      "city": "Shawnigan Lake",
      "state": "BC",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4516,
      "name": "Hyperion",
      "rookie_year": "2013",
      "city": "Roswell",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4517,
      "name": "Owl Robotics",
      "rookie_year": "2013",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4518,
      "name": "Optimus Pride",
      "rookie_year": "2013",
      "city": "Vaughan",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4519,
      "name": "King's Robotics",
      "rookie_year": "2013",
      "city": "Oakville",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4520,
      "name": "Misfit Toys",
      "rookie_year": "2013",
      "city": "Rathdrum",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4521,
      "name": "Harrison Robotics",
      "rookie_year": "2013",
      "city": "Harrison",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4522,
      "name": "Team SCREAM",
      "rookie_year": "2013",
      "city": "Sedalia",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4523,
      "name": "MCROBO",
      "rookie_year": "2013",
      "city": "Mayes County ",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4524,
      "name": "Sigma 6",
      "rookie_year": "2013",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4525,
      "name": "Renaissance Robotics",
      "rookie_year": "2013",
      "city": "St. Thomas",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4526,
      "name": "L\u00e9om\u00e9ga",
      "rookie_year": "2013",
      "city": "Terrebonne",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4527,
      "name": "Big Reds",
      "rookie_year": "2013",
      "city": "Milan",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4528,
      "name": "Automatons",
      "rookie_year": "2013",
      "city": "Queens",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4529,
      "name": "AI Robotics",
      "rookie_year": "2013",
      "city": "Armadale",
      "state": "Victoria",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4530,
      "name": "D3A",
      "rookie_year": "2013",
      "city": "Jacksonville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4531,
      "name": "STEMpunk",
      "rookie_year": "2013",
      "city": "Two Rivers",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4532,
      "name": "LAN Jaguars FIRST Robotics",
      "rookie_year": "2013",
      "city": "Sherwood",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4533,
      "name": "Wando Advanced Robotics",
      "rookie_year": "2013",
      "city": "Mt Pleasant",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4534,
      "name": "Wired Wizards",
      "rookie_year": "2013",
      "city": "Wilmington",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4535,
      "name": "PA Bruins",
      "rookie_year": "2013",
      "city": "Little Rock",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4536,
      "name": "MinuteBots",
      "rookie_year": "2013",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4537,
      "name": "RoboRoos",
      "rookie_year": "2013",
      "city": "Adelaide",
      "state": "South Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4538,
      "name": "Enginuity",
      "rookie_year": "2013",
      "city": "Newport News",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4539,
      "name": "KAOTIC Robotics",
      "rookie_year": "2013",
      "city": "Frazee",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4540,
      "name": "OrangeLab",
      "rookie_year": "2013",
      "city": "El Cajon",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4541,
      "name": "CAVineers",
      "rookie_year": "2013",
      "city": "Severn",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4542,
      "name": "Titanium Talons",
      "rookie_year": "2013",
      "city": "Woodinville",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4543,
      "name": "The Illuminators",
      "rookie_year": "2013",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4544,
      "name": "The Levitating Potatoes",
      "rookie_year": "2013",
      "city": "San Rafael",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4545,
      "name": "GOLDEN KNIGHTS",
      "rookie_year": "2013",
      "city": "Indianapolis",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4546,
      "name": "Shockwave",
      "rookie_year": "2013",
      "city": "Dover",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4547,
      "name": "WestyTek Robotics",
      "rookie_year": "2013",
      "city": "Johnstown",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4548,
      "name": "Omak FFA Wonders",
      "rookie_year": "2013",
      "city": "Omak",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4549,
      "name": "Iron Bulls",
      "rookie_year": "2013",
      "city": "South Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4550,
      "name": "Something's Bruin",
      "rookie_year": "2013",
      "city": "Greenwood Village ",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4551,
      "name": "Robotic Rangers",
      "rookie_year": "2013",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4552,
      "name": "Robotic Tigers",
      "rookie_year": "2013",
      "city": "Slaton",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4553,
      "name": "Patriobots",
      "rookie_year": "2013",
      "city": "Columbus",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4554,
      "name": "Bad News Bots",
      "rookie_year": "2013",
      "city": "Knoxville",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4555,
      "name": "Sprocketology",
      "rookie_year": "2013",
      "city": "Skowhegan",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4556,
      "name": "TBD",
      "rookie_year": "2013",
      "city": "Riverside",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4557,
      "name": "FullMetal Falcons",
      "rookie_year": "2013",
      "city": "Middletown",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4558,
      "name": "TDU II",
      "rookie_year": "2013",
      "city": "New Braunfels",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4559,
      "name": "FIRST DRaFT",
      "rookie_year": "2013",
      "city": "Redmond",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4560,
      "name": "Gatordone",
      "rookie_year": "2013",
      "city": "Federal Way",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4561,
      "name": "TerrorBytes",
      "rookie_year": "2013",
      "city": "Research Triangle Park",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4562,
      "name": "RIOT",
      "rookie_year": "2013",
      "city": "Dunnellon",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4563,
      "name": "ECR Robotics",
      "rookie_year": "2013",
      "city": "Woodland Hills",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4564,
      "name": "Orange Chaos",
      "rookie_year": "2013",
      "city": "Brewer",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4565,
      "name": "Skyline Robotics",
      "rookie_year": "2013",
      "city": "Mesa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4566,
      "name": "TERAdactyls",
      "rookie_year": "2013",
      "city": "Suwanee",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4567,
      "name": "The Mechanized Mafia",
      "rookie_year": "2013",
      "city": "Seaford",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4568,
      "name": "Robot Commander",
      "rookie_year": "2013",
      "city": "North Adams",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4569,
      "name": "Phoenix",
      "rookie_year": "2013",
      "city": "N. Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4570,
      "name": "Estacado Robodors",
      "rookie_year": "2013",
      "city": "Lubbock",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4571,
      "name": "Rambots",
      "rookie_year": "2013",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4572,
      "name": "BArlow RobAutics",
      "rookie_year": "2013",
      "city": "Redding",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4573,
      "name": "SRNJRambotics",
      "rookie_year": "2013",
      "city": "South River",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4574,
      "name": "Average Joe's",
      "rookie_year": "2013",
      "city": "Fullerton",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4575,
      "name": "The Tin Mints",
      "rookie_year": "2013",
      "city": "Springfield",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4576,
      "name": "Red Nation Robotics",
      "rookie_year": "2013",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4577,
      "name": "RoboFiends",
      "rookie_year": "2013",
      "city": "Vilonia",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4578,
      "name": "CometBots",
      "rookie_year": "2013",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4579,
      "name": "RoboEagles",
      "rookie_year": "2013",
      "city": "Federal Way",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4580,
      "name": "Conductors",
      "rookie_year": "2013",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4581,
      "name": "Rangeview Robotics",
      "rookie_year": "2013",
      "city": "Aurora",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4582,
      "name": "Robohawks",
      "rookie_year": "2013",
      "city": "Myrtle Beach",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4583,
      "name": "Robosaurus",
      "rookie_year": "2013",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4584,
      "name": "SentinelFox Engineering",
      "rookie_year": "2013",
      "city": "Mexicali",
      "state": "Baja California",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4585,
      "name": "Husky Robotics",
      "rookie_year": "2013",
      "city": "Midvale",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4586,
      "name": "PRIMO",
      "rookie_year": "2013",
      "city": "Modi'in",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4587,
      "name": "Jersey Voltage",
      "rookie_year": "2013",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4588,
      "name": "LVHS Tech Club",
      "rookie_year": "2013",
      "city": "Lander",
      "state": "WY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4589,
      "name": "AdamasBots",
      "rookie_year": "2013",
      "city": "Houston",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4590,
      "name": "GreenBlitz",
      "rookie_year": "2013",
      "city": "Hakfar Hayarok",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4591,
      "name": "Hunchbacks",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4592,
      "name": "M3 Mighty Mechanical Mustangs",
      "rookie_year": "2013",
      "city": "Hollywood",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4593,
      "name": "Rapid Acceleration",
      "rookie_year": "2013",
      "city": "Rapid City",
      "state": "South Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4594,
      "name": "Ph\u00e9minix",
      "rookie_year": "2013",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4595,
      "name": "Infinity",
      "rookie_year": "2013",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4596,
      "name": "Hackers",
      "rookie_year": "2013",
      "city": "Salt Lake City",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4597,
      "name": "SABERBOTS",
      "rookie_year": "2013",
      "city": "Edinburg",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4598,
      "name": "ICARUS INNOVATED",
      "rookie_year": "2013",
      "city": "Sandy",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4599,
      "name": "Team Fortress",
      "rookie_year": "2013",
      "city": "LAND O' LAKES",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4600,
      "name": "Tech Titans",
      "rookie_year": "2013",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4601,
      "name": "Circuit Birds",
      "rookie_year": "2013",
      "city": "Canfield",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4602,
      "name": "Calgary First Nation team",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4603,
      "name": "Pe\u00f1oles Leones Franc\u00e9s 4603",
      "rookie_year": "2013",
      "city": "Gomez Palacio ",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4604,
      "name": "Intimitrons from Area 51",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4605,
      "name": "Calgary Ismaili Team ",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4606,
      "name": "Team 4606, \"Larry\"",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4607,
      "name": "C.I.S.",
      "rookie_year": "2013",
      "city": "Becker",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4608,
      "name": "Duct Tape Warriors",
      "rookie_year": "2013",
      "city": "Tekoa",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4609,
      "name": "Mechanicatz",
      "rookie_year": "2013",
      "city": "Pawtucket",
      "state": "RI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4610,
      "name": "BearTecs",
      "rookie_year": "2013",
      "city": "Bastrop",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4611,
      "name": "OZone Robotics",
      "rookie_year": "2013",
      "city": "Lewis Center",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4612,
      "name": "RoboRockets",
      "rookie_year": "2013",
      "city": "oklahoma city",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4613,
      "name": "Barker Redbacks",
      "rookie_year": "2013",
      "city": "Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4614,
      "name": "Purple Monkey Dishwasher",
      "rookie_year": "2013",
      "city": "St Marys",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4615,
      "name": "Steel Trojans",
      "rookie_year": "2013",
      "city": "Chambersburg",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4616,
      "name": "Team Pharaohs",
      "rookie_year": "2013",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4617,
      "name": "DAUN",
      "rookie_year": "2013",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4618,
      "name": "Brave Cardinals",
      "rookie_year": "2013",
      "city": "Stoney Creek",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4619,
      "name": "HawkBots",
      "rookie_year": "2013",
      "city": "Huntington Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4620,
      "name": "Tec de Monterrey Robotics",
      "rookie_year": "2013",
      "city": "Mexico City",
      "state": "DIF",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4621,
      "name": "Yotta Robota",
      "rookie_year": "2013",
      "city": "Roswell",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4622,
      "name": "Academy at the Lakes Wildcats",
      "rookie_year": "2013",
      "city": "Land O Lakes",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4623,
      "name": "Flyer Robotics",
      "rookie_year": "2013",
      "city": "Little Falls",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4624,
      "name": "Rebel Alliance",
      "rookie_year": "2013",
      "city": "Owatonna",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4625,
      "name": "Trappers",
      "rookie_year": "2013",
      "city": "Fort McMurray",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4626,
      "name": "Iron Centaurs",
      "rookie_year": "2013",
      "city": "Brooklyn Center",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4627,
      "name": "M Robotics",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4628,
      "name": "Sintian Robotics",
      "rookie_year": "2013",
      "city": "Hamden",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4629,
      "name": "Dorado Bots",
      "rookie_year": "2013",
      "city": "Tucson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4630,
      "name": "Robodragons",
      "rookie_year": "2013",
      "city": "Clinton",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4631,
      "name": "Tsuu T'ina",
      "rookie_year": "2013",
      "city": "Tssuu T'ina",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4632,
      "name": "Monti-Pythons",
      "rookie_year": "2013",
      "city": "Monticello",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4633,
      "name": "Bobcats",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4634,
      "name": "The Wolfbotz",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4635,
      "name": "PrepaTec - Botbusters",
      "rookie_year": "2013",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4636,
      "name": "PHRD Robotics Team",
      "rookie_year": "2013",
      "city": "Westlock",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4637,
      "name": "BambieBotz",
      "rookie_year": "2013",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4638,
      "name": "Jagbots",
      "rookie_year": "2013",
      "city": "Germantown",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4639,
      "name": "The RoboSpartans",
      "rookie_year": "2013",
      "city": "Katy",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4640,
      "name": "Metallic Panthers 4640",
      "rookie_year": "2013",
      "city": "new york",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4641,
      "name": "TALON inc.",
      "rookie_year": "2013",
      "city": "Red Oak",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4642,
      "name": "Rebels",
      "rookie_year": "2013",
      "city": "Kingsport",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4643,
      "name": "Butte Built Bots",
      "rookie_year": "2013",
      "city": "Oroville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4644,
      "name": "Dragonbots",
      "rookie_year": "2013",
      "city": "Mountainburg",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4645,
      "name": "The Chicago Style BotDogs",
      "rookie_year": "2013",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4646,
      "name": "Wildcard Robotics",
      "rookie_year": "2013",
      "city": "Polk City",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4647,
      "name": "Vista Vortex",
      "rookie_year": "2013",
      "city": "Tecumseh",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4648,
      "name": "Techno-Tech",
      "rookie_year": "2013",
      "city": "Jordan",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4649,
      "name": "HeavyMech",
      "rookie_year": "2013",
      "city": "TEL AVIV",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4650,
      "name": "The Vo",
      "rookie_year": "2013",
      "city": "Newark",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4651,
      "name": "FrostBots",
      "rookie_year": "2013",
      "city": "Eyota",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4652,
      "name": "Ironmen 2",
      "rookie_year": "2013",
      "city": "Ramsey",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4653,
      "name": "Ironmen Robotics",
      "rookie_year": "2013",
      "city": "Ramsey",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4654,
      "name": "Mountaineers",
      "rookie_year": "2013",
      "city": "Deming",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4655,
      "name": "Stateline Robotics",
      "rookie_year": "2013",
      "city": "Rockton",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4656,
      "name": "Rock Solid Robotics",
      "rookie_year": "2013",
      "city": "Two Harbors",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4657,
      "name": "Saints Robotics",
      "rookie_year": "2013",
      "city": "Saint Croix Falls",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4658,
      "name": "Trojanbots",
      "rookie_year": "2013",
      "city": "Albany",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4659,
      "name": "Warriors",
      "rookie_year": "2013",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4660,
      "name": "----",
      "rookie_year": "2013",
      "city": "Salt Lake City",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4661,
      "name": "The Red Pirates",
      "rookie_year": "2013",
      "city": "bet-hasmonai",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4662,
      "name": "Byte Sized Robotics",
      "rookie_year": "2013",
      "city": "Scappoose",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4663,
      "name": "Cyber Tigers",
      "rookie_year": "2013",
      "city": "Belle Plaine",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4664,
      "name": "Butler Bots",
      "rookie_year": "2013",
      "city": "Andover",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4665,
      "name": "Predators",
      "rookie_year": "2013",
      "city": "Glencoe",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4666,
      "name": "Robowolves",
      "rookie_year": "2013",
      "city": "Roseville",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4667,
      "name": "Synergy ",
      "rookie_year": "2013",
      "city": "Cuernavaca",
      "state": "MOR",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4668,
      "name": "Spartans",
      "rookie_year": "2013",
      "city": "Slidell",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4669,
      "name": "Galileo Robotics",
      "rookie_year": "2013",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4670,
      "name": "The Pirates",
      "rookie_year": "2013",
      "city": "San Antoino",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4671,
      "name": "Mechaneers",
      "rookie_year": "2013",
      "city": "Pierz",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4672,
      "name": "Youth in Black",
      "rookie_year": "2013",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4673,
      "name": "Solar Engineering",
      "rookie_year": "2013",
      "city": "Mexicali",
      "state": "BCN",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4674,
      "name": "RoboJacks",
      "rookie_year": "2013",
      "city": "Bemidji",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4675,
      "name": "Eagles",
      "rookie_year": "2013",
      "city": "North Olmsted",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4676,
      "name": "Battery Chargers",
      "rookie_year": "2013",
      "city": "Palos Hills",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4677,
      "name": "RHHS Robotics Team",
      "rookie_year": "2013",
      "city": "Richmond Hill",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4678,
      "name": "CyberCavs",
      "rookie_year": "2013",
      "city": "Breslau",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4679,
      "name": "Dragonators",
      "rookie_year": "2013",
      "city": "San Benito",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4680,
      "name": "AzTech Eagles",
      "rookie_year": "2013",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4681,
      "name": "Murphy's law",
      "rookie_year": "2013",
      "city": "Everett",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4682,
      "name": "CyBears",
      "rookie_year": "2013",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4683,
      "name": "Full Metal Robotics",
      "rookie_year": "2013",
      "city": "Marysville ",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4684,
      "name": "eSharks",
      "rookie_year": "2013",
      "city": "Yonkers",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4685,
      "name": "Aztlavolt",
      "rookie_year": "2013",
      "city": "Azcapotzalco",
      "state": "Distrito Federal",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4686,
      "name": "Nay Ah Shing",
      "rookie_year": "2013",
      "city": "Onamia",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4687,
      "name": "Spartans",
      "rookie_year": "2013",
      "city": "Long Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4688,
      "name": "Saints Bot",
      "rookie_year": "2013",
      "city": "Belle River",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4689,
      "name": "ROyal BOTS",
      "rookie_year": "2013",
      "city": "Pattison",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4690,
      "name": "WD-40",
      "rookie_year": "2013",
      "city": "indianapolis",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4691,
      "name": "Falcons",
      "rookie_year": "2013",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4692,
      "name": "Metal Mallards",
      "rookie_year": "2013",
      "city": "Toutle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4693,
      "name": "Axiomatic Aftermath",
      "rookie_year": "2013",
      "city": "Rockford",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4694,
      "name": "Atomic Armadillos",
      "rookie_year": "2013",
      "city": "Amarillo",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4695,
      "name": "Chowchilla Robotics",
      "rookie_year": "2013",
      "city": "Chowchilla",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4696,
      "name": "RoboAzTechs",
      "rookie_year": "2013",
      "city": "el paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4697,
      "name": "Tigers",
      "rookie_year": "2013",
      "city": "Globe",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4698,
      "name": "Raider Robotics",
      "rookie_year": "2013",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4699,
      "name": "ESCT-Flammes",
      "rookie_year": "2013",
      "city": "Timmins",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4700,
      "name": "Wolves",
      "rookie_year": "2013",
      "city": "Battle Creek",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4701,
      "name": "Warriors (Team W.I.R.E.)",
      "rookie_year": "2013",
      "city": "Savannah",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4702,
      "name": "Cyberdogz",
      "rookie_year": "2013",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4703,
      "name": "Menahga Gigabot$",
      "rookie_year": "2013",
      "city": "Menahga",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4704,
      "name": "Northern Lights Robotics",
      "rookie_year": "2013",
      "city": "Timmins",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4705,
      "name": "Full Metal Kats",
      "rookie_year": "2013",
      "city": "Fontana",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4706,
      "name": "Bulls",
      "rookie_year": "2013",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4707,
      "name": "FORCE",
      "rookie_year": "2013",
      "city": "Santo Domingo",
      "state": "Santo Domingo",
      "country": "Dominican Republic",
      "district": ""
    },
    {
      "number": 4708,
      "name": "G-Force",
      "rookie_year": "2013",
      "city": "Nave Eitan",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4709,
      "name": "Stem-azing",
      "rookie_year": "2013",
      "city": "Riverside",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4710,
      "name": "Bot-Busters",
      "rookie_year": "2013",
      "city": "Shingle Springs",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4711,
      "name": "The Flying Aces",
      "rookie_year": "2013",
      "city": "Camarillo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4712,
      "name": "TracBots",
      "rookie_year": "2013",
      "city": "Kibbutz Neve Eitan",
      "state": "HaZafon (Northern)",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4713,
      "name": "Adom Robotics",
      "rookie_year": "2013",
      "city": "Istanbul",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 4714,
      "name": "The Millennium Falcons",
      "rookie_year": "2013",
      "city": "Richmond",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4715,
      "name": "Big Bay de Noc Bear Bots",
      "rookie_year": "2013",
      "city": "Cooks",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4716,
      "name": "Purple Raiders",
      "rookie_year": "2013",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4717,
      "name": "Westerner Robotics",
      "rookie_year": "2013",
      "city": "Lubbock",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4718,
      "name": "RoboPanthers",
      "rookie_year": "2013",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4719,
      "name": "Bulldogs",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4720,
      "name": "R2JAG2",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4721,
      "name": "Tiger Bots",
      "rookie_year": "2013",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4722,
      "name": "Cyberian Soldiers",
      "rookie_year": "2013",
      "city": "Rock Hill",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4723,
      "name": "Tecmilenio - EARTH - 4723",
      "rookie_year": "2013",
      "city": "Puebla",
      "state": "Puebla",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4724,
      "name": "ShakedTech",
      "rookie_year": "2013",
      "city": "Kibbutz  Sde Eliyahu",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4725,
      "name": "GeDarcaNator",
      "rookie_year": "2013",
      "city": "Gedera",
      "state": "Southern",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4726,
      "name": "Robo Dynasty",
      "rookie_year": "2013",
      "city": "Asotin",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4727,
      "name": "RoboFX",
      "rookie_year": "2013",
      "city": "Ottawa",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4728,
      "name": "ROCORI Ratcheteers",
      "rookie_year": "2013",
      "city": "Cold Spring",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4729,
      "name": "EMU Robotics",
      "rookie_year": "2013",
      "city": "Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4730,
      "name": "Terminators",
      "rookie_year": "2013",
      "city": "Albany",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4731,
      "name": "PrepaTec - MONARCH-E",
      "rookie_year": "2013",
      "city": "Morelia",
      "state": "Michoac\u00e1n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4732,
      "name": "SWC Robotics",
      "rookie_year": "2013",
      "city": "Thunder Bay",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4733,
      "name": "Scarlett Robotics",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4734,
      "name": "The Iron Plainsmen",
      "rookie_year": "2013",
      "city": "Lubbock",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 4735,
      "name": "Tecmilenio - Pe\u00f1oles - DEROF - 4735",
      "rookie_year": "2013",
      "city": "Torreon",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4736,
      "name": "Temp",
      "rookie_year": "2013",
      "city": "Rancho Cucamonga",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4737,
      "name": "Atomigators",
      "rookie_year": "2013",
      "city": "West Bloomfield",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4738,
      "name": "Patribots",
      "rookie_year": "2013",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4739,
      "name": "CTRL F5",
      "rookie_year": "2013",
      "city": "Normanhurst",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4740,
      "name": "Sparta Bots",
      "rookie_year": "2013",
      "city": "Nashville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4741,
      "name": "WingNuts",
      "rookie_year": "2013",
      "city": "Redwood Falls",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4742,
      "name": "JaliScience 4742",
      "rookie_year": "2013",
      "city": "Tlaquepaque",
      "state": "JAL",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4743,
      "name": "STEAM Engine",
      "rookie_year": "2013",
      "city": "Royal Oak",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4744,
      "name": "Ninjas",
      "rookie_year": "2013",
      "city": "Hadera",
      "state": "Haifa",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 4745,
      "name": "Mets Robotics",
      "rookie_year": "2013",
      "city": "little rock",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4746,
      "name": "Tecmilenio - Alebrijes - 4746",
      "rookie_year": "2013",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4747,
      "name": "Millennium Falcons",
      "rookie_year": "2013",
      "city": "Los Fresnos",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4748,
      "name": "Bulldog (Auto)'bots",
      "rookie_year": "2013",
      "city": "Charleston",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4749,
      "name": "Pisgah Robotics",
      "rookie_year": "2013",
      "city": "Alpharetta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4750,
      "name": "Bert",
      "rookie_year": "2013",
      "city": "Pennsauken",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 4751,
      "name": "Robo Warriors",
      "rookie_year": "2013",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4752,
      "name": "Ursus Robotica",
      "rookie_year": "2013",
      "city": "Columbus",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4753,
      "name": "Bexley Lions",
      "rookie_year": "2013",
      "city": "Bexley",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4754,
      "name": "RoBenedicts",
      "rookie_year": "2013",
      "city": "Sudbury",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4755,
      "name": "M^3",
      "rookie_year": "2013",
      "city": "Ann Arbor",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4757,
      "name": "Talos",
      "rookie_year": "2013",
      "city": "Petach Tikva",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4758,
      "name": "RoboBlazers",
      "rookie_year": "2013",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4759,
      "name": "Devil Robotics",
      "rookie_year": "2013",
      "city": "Hobart",
      "state": "TAS",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4760,
      "name": "Golden Eagles",
      "rookie_year": "2013",
      "city": "Indianapolis",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4761,
      "name": "The Robockets",
      "rookie_year": "2013",
      "city": "Reading",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4762,
      "name": "Robo-Saints",
      "rookie_year": "2013",
      "city": "St. Charles",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4763,
      "name": "i to the Fourth Robotics",
      "rookie_year": "2013",
      "city": "Fullerton",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4764,
      "name": "The Memphis MechWarriors",
      "rookie_year": "2013",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4765,
      "name": "PWRUP",
      "rookie_year": "2013",
      "city": "Los Altos Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4766,
      "name": "Team SCREAM Jr.",
      "rookie_year": "2013",
      "city": "Sedalia",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4767,
      "name": "C4",
      "rookie_year": "2013",
      "city": "Shelby",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4768,
      "name": "Cody Comets",
      "rookie_year": "2013",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4769,
      "name": "Nerdvana",
      "rookie_year": "2013",
      "city": "Saint Petersburg",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4770,
      "name": "EDW Robotics",
      "rookie_year": "2013",
      "city": "Thibodaux",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4771,
      "name": "Match",
      "rookie_year": "2013",
      "city": "Morelia",
      "state": "MIC",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4772,
      "name": "Optimistic Skyz",
      "rookie_year": "2013",
      "city": "Seattle",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4773,
      "name": "Steel Horses",
      "rookie_year": "2013",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4774,
      "name": "The Drop Bears",
      "rookie_year": "2013",
      "city": "Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4775,
      "name": "Aztech Robotics",
      "rookie_year": "2013",
      "city": "Mexico City",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4776,
      "name": "S.C.O.T.S. Bots",
      "rookie_year": "2013",
      "city": "Howell",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4777,
      "name": "Spirit Robotics",
      "rookie_year": "2013",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4778,
      "name": "Stormbots",
      "rookie_year": "2013",
      "city": "Chanhassen",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4779,
      "name": "RoboSapiens",
      "rookie_year": "2013",
      "city": "Marine City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4780,
      "name": "Tenacious Drones",
      "rookie_year": "2013",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4781,
      "name": "RoboSpartans",
      "rookie_year": "2013",
      "city": "Connersville",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4782,
      "name": "PrepaTec - Borrebots",
      "rookie_year": "2013",
      "city": "Hermosillo",
      "state": "Sonora",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4783,
      "name": "The RoboRavens",
      "rookie_year": "2013",
      "city": "Nepean",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4784,
      "name": "ATOM",
      "rookie_year": "2013",
      "city": "Afula",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4785,
      "name": "Cougar Robotics",
      "rookie_year": "2013",
      "city": "Clovis",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4786,
      "name": "Nicolet FEAR",
      "rookie_year": "2013",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4787,
      "name": "Axiom",
      "rookie_year": "2013",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4788,
      "name": "Can't Control",
      "rookie_year": "2013",
      "city": "Perth",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4789,
      "name": "VB Electras",
      "rookie_year": "2013",
      "city": "Queens Village",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4790,
      "name": "Yigal-Alon",
      "rookie_year": "2013",
      "city": "Rishon Le-Zion",
      "state": "TA",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4791,
      "name": "Pandroids",
      "rookie_year": "2013",
      "city": "South Bend",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4792,
      "name": "Desert Storm",
      "rookie_year": "2013",
      "city": "North Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4793,
      "name": "OOBotics",
      "rookie_year": "2013",
      "city": "old Orchard Beach",
      "state": "ME",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4794,
      "name": "infinity",
      "rookie_year": "2013",
      "city": "shaab",
      "state": "Haifa",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 4795,
      "name": "EastBots",
      "rookie_year": "2013",
      "city": "Chapel Hill",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4796,
      "name": "Cyber Dragons",
      "rookie_year": "2013",
      "city": "Hyde Park",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4797,
      "name": "Bryant HS",
      "rookie_year": "2013",
      "city": "Long Island City",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4798,
      "name": "Toxic Robos",
      "rookie_year": "2013",
      "city": "Wheeler",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4799,
      "name": "Lazbuddie Robotics",
      "rookie_year": "2013",
      "city": "Lazbuddie",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4800,
      "name": "Rage Against the Machines",
      "rookie_year": "2013",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4801,
      "name": "Blacktown Boys Cybernetic Phoenix",
      "rookie_year": "2013",
      "city": "Blacktown",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4802,
      "name": "U.M.M (Unidentified Moving Machines)",
      "rookie_year": "2013",
      "city": "Blacktown",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 4803,
      "name": "The Superbots",
      "rookie_year": "2013",
      "city": "Canonsburg",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4804,
      "name": "Port PiraTech",
      "rookie_year": "2013",
      "city": "Port Washington",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4805,
      "name": "Robotic Warriors",
      "rookie_year": "2013",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4806,
      "name": "Knights",
      "rookie_year": "2013",
      "city": "Orleans",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4807,
      "name": "Jag Squad",
      "rookie_year": "2013",
      "city": "Richmond Hill",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4808,
      "name": "Tigers",
      "rookie_year": "2013",
      "city": "Mississauga",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4809,
      "name": "Black Knight Robotics",
      "rookie_year": "2013",
      "city": "Marceline",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4810,
      "name": "I AM Robot",
      "rookie_year": "2013",
      "city": "Clinton Township",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4811,
      "name": "Majestic Eagles",
      "rookie_year": "2013",
      "city": "Madison Heights",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4812,
      "name": "Crosby Robotics Team",
      "rookie_year": "2013",
      "city": "Waterbury",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4813,
      "name": "NOT PAY FOR THIS TEAM",
      "rookie_year": "2013",
      "city": "Shen zhen",
      "state": "44",
      "country": "China",
      "district": ""
    },
    {
      "number": 4814,
      "name": "WE MARS Incubator",
      "rookie_year": "2013",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4815,
      "name": "ELECTROPANTHERS",
      "rookie_year": "2013",
      "city": "Center Line",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4816,
      "name": "holographic",
      "rookie_year": "2013",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4817,
      "name": "One Degree North",
      "rookie_year": "2013",
      "city": "Singapore",
      "state": "North West",
      "country": "Singapore",
      "district": ""
    },
    {
      "number": 4818,
      "name": "The Herd",
      "rookie_year": "2013",
      "city": "West Fargo",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4819,
      "name": "Flat Mountain Mechanics",
      "rookie_year": "2013",
      "city": "Mount Pleasant",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4820,
      "name": "Huey Tlatoani",
      "rookie_year": "2013",
      "city": "Zapopan",
      "state": "JAL",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4821,
      "name": "cyberUs",
      "rookie_year": "2013",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 4822,
      "name": "Bemidji LumberBots",
      "rookie_year": "2013",
      "city": "Bemidji",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4823,
      "name": "Metal Manes",
      "rookie_year": "2013",
      "city": "Loris",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4824,
      "name": "BerryBotics",
      "rookie_year": "2013",
      "city": "Logansport",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4825,
      "name": "The Coltenoids",
      "rookie_year": "2013",
      "city": "Ottawa",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4826,
      "name": "Deceptibots",
      "rookie_year": "2013",
      "city": "Harper Woods",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4827,
      "name": "Minerbotics",
      "rookie_year": "2013",
      "city": "Negaunee",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4828,
      "name": "RoboEagles",
      "rookie_year": "2013",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4829,
      "name": "Titanium Tigers",
      "rookie_year": "2013",
      "city": "Chapel Hill",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4830,
      "name": "ROBOT  2E",
      "rookie_year": "2013",
      "city": "Shenzhen",
      "state": "44",
      "country": "China",
      "district": ""
    },
    {
      "number": 4831,
      "name": "FIRST PARTICIPATE",
      "rookie_year": "2013",
      "city": "Shen zhen",
      "state": "44",
      "country": "China",
      "district": ""
    },
    {
      "number": 4832,
      "name": "CroBots",
      "rookie_year": "2013",
      "city": "Carencro",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4833,
      "name": "Bangarang",
      "rookie_year": "2013",
      "city": "Orlando",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4834,
      "name": "RoboColts",
      "rookie_year": "2013",
      "city": "Detroi",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4835,
      "name": "Junkyard Dawgs",
      "rookie_year": "2013",
      "city": "Manistique",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4836,
      "name": "Zai",
      "rookie_year": "2013",
      "city": "Chihuahua",
      "state": "CHH",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4838,
      "name": "Outlaws",
      "rookie_year": "2013",
      "city": "River Rouge",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4839,
      "name": "none",
      "rookie_year": "2013",
      "city": "Ishpeming",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4840,
      "name": "The Panthers",
      "rookie_year": "2013",
      "city": "Redford",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4841,
      "name": "Optimal Robotics",
      "rookie_year": "2013",
      "city": "Tucson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4842,
      "name": "Botrregos",
      "rookie_year": "2013",
      "city": "Chihuahua",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4843,
      "name": "Mystery Science Robotics",
      "rookie_year": "2013",
      "city": "Gentry",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4844,
      "name": "The Eagles",
      "rookie_year": "2013",
      "city": "Muskegon",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4845,
      "name": "Lion's Pride",
      "rookie_year": "2013",
      "city": "Duluth",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4846,
      "name": "G.I. Frost Bots",
      "rookie_year": "2013",
      "city": "Gary",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4847,
      "name": "Techno-Logic Trojans",
      "rookie_year": "2013",
      "city": "Green Sea",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4848,
      "name": "Black Knights",
      "rookie_year": "2013",
      "city": "Jacksonville",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4849,
      "name": "Rock City Robots",
      "rookie_year": "2013",
      "city": "Little Rock",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4850,
      "name": "Mr. Parks' Robotics",
      "rookie_year": "2013",
      "city": "Saint Paul",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4851,
      "name": "JungleBots",
      "rookie_year": "2013",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4852,
      "name": "The Eliminators",
      "rookie_year": "2013",
      "city": "Shallowater",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4853,
      "name": "RoboCats",
      "rookie_year": "2013",
      "city": "Idalou",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4854,
      "name": "Trobots",
      "rookie_year": "2013",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4855,
      "name": "Ramageddon",
      "rookie_year": "2013",
      "city": "South Haven",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4856,
      "name": "Brearley/Chapin Double X",
      "rookie_year": "2013",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4857,
      "name": "Jets",
      "rookie_year": "2013",
      "city": "Powers",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4858,
      "name": "Leopards",
      "rookie_year": "2013",
      "city": "New Home",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4859,
      "name": "The CyBears",
      "rookie_year": "2013",
      "city": "Byron",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4900,
      "name": "Magic Island Robotics",
      "rookie_year": "2014",
      "city": "Florianopolis",
      "state": "SC",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 4901,
      "name": "Garnet Squadron",
      "rookie_year": "2014",
      "city": "Columbia",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4902,
      "name": "The Wildebots",
      "rookie_year": "2014",
      "city": "Burlington",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4903,
      "name": "Mustangs",
      "rookie_year": "2014",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4904,
      "name": "Bot-Provoking",
      "rookie_year": "2014",
      "city": "San Mateo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4905,
      "name": "Andromeda One",
      "rookie_year": "2014",
      "city": "Ayer",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4906,
      "name": "The Collective",
      "rookie_year": "2014",
      "city": "Waterville",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4907,
      "name": "Thunderstamps",
      "rookie_year": "2014",
      "city": "St. Thomas",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4908,
      "name": "Duxbury Dragons",
      "rookie_year": "2014",
      "city": "Duxbury",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4909,
      "name": "Bionics",
      "rookie_year": "2014",
      "city": "Billerica",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4910,
      "name": "East Cobb Robotics 4910",
      "rookie_year": "2014",
      "city": "Marietta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4911,
      "name": "CyberKnights",
      "rookie_year": "2014",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4912,
      "name": "Panthers",
      "rookie_year": "2014",
      "city": "Chattanooga",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4913,
      "name": "Huskyteers",
      "rookie_year": "2014",
      "city": "Anaheim",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4914,
      "name": "Panthers",
      "rookie_year": "2014",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4915,
      "name": "Spartronics",
      "rookie_year": "2014",
      "city": "Bainbridge Island",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4916,
      "name": "H.V.L Robotics",
      "rookie_year": "2014",
      "city": "Gravatai",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 4917,
      "name": "Sir Lancerbot",
      "rookie_year": "2014",
      "city": "Elmira",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4918,
      "name": "The Roboctopi",
      "rookie_year": "2014",
      "city": "Port Townsend",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4919,
      "name": "Team Ronin",
      "rookie_year": "2014",
      "city": "Lemon Grove",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4920,
      "name": "Belle River Automatons",
      "rookie_year": "2014",
      "city": "Belle River",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4921,
      "name": "KDHS HAWKTOBOTS",
      "rookie_year": "2014",
      "city": "Harrow",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4922,
      "name": "Tartans",
      "rookie_year": "2014",
      "city": "Windsor",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4923,
      "name": "LaserBots",
      "rookie_year": "2014",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4924,
      "name": "STEM Pythons",
      "rookie_year": "2014",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4925,
      "name": "The Resistance",
      "rookie_year": "2014",
      "city": "Wolfeboro",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4926,
      "name": "GalacTech",
      "rookie_year": "2014",
      "city": "Columbus",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 4927,
      "name": "Marauders",
      "rookie_year": "2014",
      "city": "Fortville",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4928,
      "name": "Arabian Knights",
      "rookie_year": "2014",
      "city": "Al Ain",
      "state": "Abu Z\u00b8aby (Abu Dhabi)",
      "country": "United Arab Emirates",
      "district": ""
    },
    {
      "number": 4929,
      "name": "Maroon Monsoon",
      "rookie_year": "2014",
      "city": "Haverhill",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4930,
      "name": "Electric Mayhem",
      "rookie_year": "2014",
      "city": "Buffalo",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4931,
      "name": "Edwardsville Technologies",
      "rookie_year": "2014",
      "city": "Edwardsville",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4932,
      "name": "Cougar Robotics",
      "rookie_year": "2014",
      "city": "Leamington",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4933,
      "name": "Code Green",
      "rookie_year": "2014",
      "city": "Okmulgee",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4934,
      "name": "Gear Warriors",
      "rookie_year": "2014",
      "city": "Dallas",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4935,
      "name": "T-Rex",
      "rookie_year": "2014",
      "city": "Charlotte",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 4936,
      "name": "Viral Vortex",
      "rookie_year": "2014",
      "city": "Tecumseh",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4937,
      "name": "Santa Cruz Robotics",
      "rookie_year": "2014",
      "city": "Santa Cruz do Sul",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 4938,
      "name": "Falcons",
      "rookie_year": "2014",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4939,
      "name": "Allspark9",
      "rookie_year": "2014",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4940,
      "name": "Knight Vision",
      "rookie_year": "2014",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4941,
      "name": "RoboBibb",
      "rookie_year": "2014",
      "city": "Macon",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 4942,
      "name": "Spartech",
      "rookie_year": "2014",
      "city": "Sherbrooke",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4943,
      "name": "\"R Cubed\"  ",
      "rookie_year": "2014",
      "city": "Shelburne",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4944,
      "name": "The Hi Fives",
      "rookie_year": "2014",
      "city": "Grand Junction",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4945,
      "name": "Titanium-Wrecks",
      "rookie_year": "2014",
      "city": "Snow Hill",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4946,
      "name": "The Alpha Dogs",
      "rookie_year": "2014",
      "city": "Bolton",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4947,
      "name": "Fenix",
      "rookie_year": "2014",
      "city": "Cowansville",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4948,
      "name": "Buccaneers",
      "rookie_year": "2014",
      "city": "Oswego",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4949,
      "name": "Robo Panthers",
      "rookie_year": "2014",
      "city": "Riverdale",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4950,
      "name": "Centaures",
      "rookie_year": "2014",
      "city": "Quebec",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4951,
      "name": "CDS Cyclones",
      "rookie_year": "2014",
      "city": "King",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4952,
      "name": "Les Carnicas",
      "rookie_year": "2014",
      "city": "Magog",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4953,
      "name": "Laser Beam",
      "rookie_year": "2014",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 4954,
      "name": "Palindrome Robotics",
      "rookie_year": "2014",
      "city": "Newark",
      "state": "Delaware",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4955,
      "name": "LA Tech",
      "rookie_year": "2014",
      "city": "Lachine",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4956,
      "name": "RoboSharks",
      "rookie_year": "2014",
      "city": "Whitehall",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4957,
      "name": "Lynx",
      "rookie_year": "2014",
      "city": "Montr\u00e9al",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4958,
      "name": "Robocats",
      "rookie_year": "2014",
      "city": "Langdon",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4959,
      "name": "Millennium Falcons",
      "rookie_year": "2014",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4960,
      "name": "Polibot San Carlos",
      "rookie_year": "2014",
      "city": "San Carlos",
      "state": "BI",
      "country": "Chile",
      "district": ""
    },
    {
      "number": 4961,
      "name": "Shock and Awe-sum",
      "rookie_year": "2014",
      "city": "Almont",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4962,
      "name": "Knight Tech Robotics",
      "rookie_year": "2014",
      "city": "Phoenix",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4963,
      "name": "RoboJets",
      "rookie_year": "2014",
      "city": "Washington",
      "state": "DC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4964,
      "name": "Rough Riders Robotics",
      "rookie_year": "2014",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4965,
      "name": "FIRE",
      "rookie_year": "2014",
      "city": "Anderson",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4966,
      "name": "Condor Force Robot",
      "rookie_year": "2014",
      "city": "Santiago",
      "state": "RM",
      "country": "Chile",
      "district": ""
    },
    {
      "number": 4967,
      "name": "That ONE Team-OurNextEngineers",
      "rookie_year": "2014",
      "city": "Belmont",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4968,
      "name": "RoboHawks",
      "rookie_year": "2014",
      "city": "Lively",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 4969,
      "name": "Iron FeNix",
      "rookie_year": "2014",
      "city": "Virginia Beach",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4970,
      "name": "ICE Cubed",
      "rookie_year": "2014",
      "city": "Harris",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4971,
      "name": "River",
      "rookie_year": "2014",
      "city": "Vancouver",
      "state": "WA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4972,
      "name": "BORUSAN ROBOTICS",
      "rookie_year": "2014",
      "city": "Esenyurt",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 4973,
      "name": "Gator Gears",
      "rookie_year": "2014",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4974,
      "name": "Bluestanbul",
      "rookie_year": "2014",
      "city": "Buyukcekmece",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 4975,
      "name": "Team RobotISTs",
      "rookie_year": "2014",
      "city": "istanbul",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 4976,
      "name": "Revolt Robotics",
      "rookie_year": "2014",
      "city": "Georgetown",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4977,
      "name": "Iron Lion",
      "rookie_year": "2014",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 4978,
      "name": "Tiger Robotics",
      "rookie_year": "2014",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4979,
      "name": "DevilStorm Robotics",
      "rookie_year": "2014",
      "city": "Hinsdale",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4980,
      "name": "Canine Crusaders",
      "rookie_year": "2014",
      "city": "Kettle Falls",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 4981,
      "name": "Grifftechs",
      "rookie_year": "2014",
      "city": "Alamo",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4982,
      "name": "Olympus Robotics",
      "rookie_year": "2014",
      "city": "Fort Wayne",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 4983,
      "name": "IronBots",
      "rookie_year": "2014",
      "city": "Mancelona",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4984,
      "name": "Bullseye",
      "rookie_year": "2014",
      "city": "Temecula",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4985,
      "name": "elkSPLOSION",
      "rookie_year": "2014",
      "city": "Eagar",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4986,
      "name": "Iron Eagles",
      "rookie_year": "2014",
      "city": "Tower",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4987,
      "name": "MegaRams",
      "rookie_year": "2014",
      "city": "Worcester",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 4988,
      "name": "Yooper Troopers",
      "rookie_year": "2014",
      "city": "Cedarville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4989,
      "name": "Jaguars",
      "rookie_year": "2014",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4990,
      "name": "Gryphon Robotics",
      "rookie_year": "2014",
      "city": "Hillsborough",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4991,
      "name": "Team 4991 Horsepower-ed by NASA, Argo AI and Williams",
      "rookie_year": "2014",
      "city": "Bridgeville",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4992,
      "name": "Sparbotics",
      "rookie_year": "2014",
      "city": "Milton",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 4993,
      "name": "Molten Steel",
      "rookie_year": "2014",
      "city": "Hutchinson",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4994,
      "name": "Kingston Robo-Cards",
      "rookie_year": "2014",
      "city": "Kingston",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4995,
      "name": "Rockets",
      "rookie_year": "2014",
      "city": "Paradise",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4996,
      "name": "RHS FIRST Robotics Enterprise: Team SPOT",
      "rookie_year": "2014",
      "city": "Richlands",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4997,
      "name": "The Golden Machine",
      "rookie_year": "2014",
      "city": "Long Beach",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 4998,
      "name": "TESLA",
      "rookie_year": "2014",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 4999,
      "name": "Momentum",
      "rookie_year": "2014",
      "city": "Long Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5000,
      "name": "Hammerheads",
      "rookie_year": "2014",
      "city": "Hingham",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5001,
      "name": "Fast and Serious",
      "rookie_year": "2014",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5002,
      "name": "Dragon Robotics",
      "rookie_year": "2014",
      "city": "Collierville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5003,
      "name": "Topperbotics",
      "rookie_year": "2014",
      "city": "Onalaska",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5004,
      "name": "Gravity Loop",
      "rookie_year": "2014",
      "city": "Roswell",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5005,
      "name": "RoboBucs",
      "rookie_year": "2014",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5006,
      "name": "Apophis",
      "rookie_year": "2014",
      "city": "Fayetteville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5007,
      "name": "Phantomechanics",
      "rookie_year": "2014",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5008,
      "name": "(robo)LIONS",
      "rookie_year": "2014",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5009,
      "name": "Techno Inventors of Puerto Rico",
      "rookie_year": "2014",
      "city": "Guaynabo",
      "state": "PR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5010,
      "name": "Tiger Dynasty",
      "rookie_year": "2014",
      "city": "Fishers",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 5011,
      "name": "Desert star",
      "rookie_year": "2014",
      "city": "Ksifa",
      "state": "D",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5012,
      "name": "Gryffingear",
      "rookie_year": "2014",
      "city": "Palmdale",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5013,
      "name": "Trobots",
      "rookie_year": "2014",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5014,
      "name": "Wildcats",
      "rookie_year": "2014",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5015,
      "name": "SWAT Bots Robotics",
      "rookie_year": "2014",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5016,
      "name": "Huntington Robotics",
      "rookie_year": "2014",
      "city": "Huntington",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5017,
      "name": "Pirates",
      "rookie_year": "2014",
      "city": "Harbor Beach",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5018,
      "name": "The Droids You're Looking For",
      "rookie_year": "2014",
      "city": "Winter Garden",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5019,
      "name": "Gearbox Heroes",
      "rookie_year": "2014",
      "city": "West Salem",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5020,
      "name": "CavBOTS",
      "rookie_year": "2014",
      "city": "Roebuck",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5021,
      "name": "Bright Shiny Things",
      "rookie_year": "2014",
      "city": "Grand Forks",
      "state": "ND",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5022,
      "name": "Rat Rod Robotics",
      "rookie_year": "2014",
      "city": "Jonesborough",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5023,
      "name": "Furious Disco Ninjas",
      "rookie_year": "2014",
      "city": "San Bruno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5024,
      "name": "Raider Robotics",
      "rookie_year": "2014",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5025,
      "name": "Pacific Steel",
      "rookie_year": "2014",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5026,
      "name": "Iron Panthers",
      "rookie_year": "2014",
      "city": "Burlingame",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5027,
      "name": "Event Horizon (5027)",
      "rookie_year": "2014",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5028,
      "name": "Seacoast Robotics",
      "rookie_year": "2014",
      "city": "Santa Rosa Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5029,
      "name": "Batchelor Institute",
      "rookie_year": "2014",
      "city": "Batchelor",
      "state": "Northern Territory",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5030,
      "name": "The Second Mouse",
      "rookie_year": "2014",
      "city": "Utica",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5031,
      "name": "Full Metal Mustangs",
      "rookie_year": "2014",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5032,
      "name": "Falcons",
      "rookie_year": "2014",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5033,
      "name": "Beavertronics",
      "rookie_year": "2014",
      "city": "Dorchester",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5034,
      "name": "River City Robotics",
      "rookie_year": "2014",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5035,
      "name": "eNimkii",
      "rookie_year": "2014",
      "city": "North Bay",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5036,
      "name": "The Robo Devils",
      "rookie_year": "2014",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5037,
      "name": "Panther BOTS",
      "rookie_year": "2014",
      "city": "Greenbrier",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5038,
      "name": "MEGIDDO LIONS",
      "rookie_year": "2014",
      "city": "Megiddo Regional Council ",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5039,
      "name": "Irish Iron",
      "rookie_year": "2014",
      "city": "Sarnia",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5040,
      "name": "BoltBot",
      "rookie_year": "2014",
      "city": "Arlington",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5041,
      "name": "CyBears",
      "rookie_year": "2014",
      "city": "West Branch",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5042,
      "name": "Native Bots",
      "rookie_year": "2014",
      "city": "Scottsdale",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5043,
      "name": "Challenger",
      "rookie_year": "2014",
      "city": "Peoria",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5044,
      "name": "MBA Big Red Robots",
      "rookie_year": "2014",
      "city": "Nashville",
      "state": "TN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5045,
      "name": "SpartaBot",
      "rookie_year": "2014",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5046,
      "name": "Jacked Up Jackets",
      "rookie_year": "2014",
      "city": "Memphis",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5047,
      "name": "DV CONQUISTABOTS",
      "rookie_year": "2014",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5048,
      "name": "Spartronics",
      "rookie_year": "2014",
      "city": "Imlay City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5049,
      "name": "Minerbots",
      "rookie_year": "2014",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5050,
      "name": "Cow Town Robotics",
      "rookie_year": "2014",
      "city": "Carleton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5051,
      "name": "Fast Eddie Robotics",
      "rookie_year": "2014",
      "city": "Port Perry",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5052,
      "name": "The RoboLobos",
      "rookie_year": "2014",
      "city": "Cedar Park",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5053,
      "name": "Lakers",
      "rookie_year": "2014",
      "city": "Waterford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5054,
      "name": "Noobum Roboticum",
      "rookie_year": "2014",
      "city": "Chicago",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5055,
      "name": "robodogs",
      "rookie_year": "2014",
      "city": "New Orleans",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5056,
      "name": "MegaHurtz Robotics",
      "rookie_year": "2014",
      "city": "Buchanan",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5057,
      "name": "RoboBusters",
      "rookie_year": "2014",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5058,
      "name": "CGLA Mustang Innovators",
      "rookie_year": "2014",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5059,
      "name": "The Midnight Cicadas",
      "rookie_year": "2014",
      "city": "Globe",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5060,
      "name": "KnighTech",
      "rookie_year": "2014",
      "city": "Farmington",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5061,
      "name": "1",
      "rookie_year": "2014",
      "city": "Woodstock Academy",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5062,
      "name": "Warriors",
      "rookie_year": "2014",
      "city": "Tuba City",
      "state": "AZ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5063,
      "name": "BuzzBots",
      "rookie_year": "2014",
      "city": "Aynor",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5064,
      "name": "Opcom",
      "rookie_year": "2014",
      "city": "Edmonton",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5065,
      "name": "Knights",
      "rookie_year": "2014",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5066,
      "name": "Singularity",
      "rookie_year": "2014",
      "city": "Saline",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5067,
      "name": "Steiner Steel Storm",
      "rookie_year": "2014",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5068,
      "name": "The Outsiders",
      "rookie_year": "2014",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5069,
      "name": "The Iron Giants",
      "rookie_year": "2014",
      "city": "Edwardsburg",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5070,
      "name": "Gearnotics",
      "rookie_year": "2014",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5071,
      "name": "Chargers",
      "rookie_year": "2014",
      "city": "Draper",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5072,
      "name": "Raider Robotics",
      "rookie_year": "2014",
      "city": "De Tour Village",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5073,
      "name": "Sparks",
      "rookie_year": "2014",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5074,
      "name": "RoboMustangs",
      "rookie_year": "2014",
      "city": "Norcross",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5075,
      "name": "RoboJackets",
      "rookie_year": "2014",
      "city": "Tombstone",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5076,
      "name": "Richardson Stormbots",
      "rookie_year": "2014",
      "city": "Ajax",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5077,
      "name": "RoboCards",
      "rookie_year": "2014",
      "city": "Youngstown",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5078,
      "name": "ROBO-KAOS",
      "rookie_year": "2014",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5079,
      "name": "LGS",
      "rookie_year": "2014",
      "city": "Lahore",
      "state": "PB",
      "country": "Pakistan",
      "district": ""
    },
    {
      "number": 5080,
      "name": "Robot Alchemy Manipulators ",
      "rookie_year": "2014",
      "city": "Wilmington",
      "state": "DE",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5081,
      "name": "Lumbernators",
      "rookie_year": "2014",
      "city": "Bay City",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5082,
      "name": "Northmen Robotics",
      "rookie_year": "2014",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5083,
      "name": "PUMAS",
      "rookie_year": "2014",
      "city": "Edmonton",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5084,
      "name": "Team FridgeBot",
      "rookie_year": "2014",
      "city": "Corunna",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5085,
      "name": "LakerBots",
      "rookie_year": "2014",
      "city": "Blachly",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5086,
      "name": "Cadillac Connectors",
      "rookie_year": "2014",
      "city": "Cadillac",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5087,
      "name": "Marsden High School",
      "rookie_year": "2014",
      "city": "West Ryde",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5088,
      "name": "Engadine Robots",
      "rookie_year": "",
      "city": "Engadine",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5089,
      "name": "Robo-Nerds",
      "rookie_year": "2014",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5090,
      "name": "TorqueNados",
      "rookie_year": "2014",
      "city": "Trenton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5091,
      "name": "Squirrels",
      "rookie_year": "2014",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5092,
      "name": "Titanium Tigers",
      "rookie_year": "2014",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5093,
      "name": "Tech-Sets",
      "rookie_year": "2014",
      "city": "Culiacan",
      "state": "Sinaloa",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5094,
      "name": "Blizzard",
      "rookie_year": "2014",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5095,
      "name": "RoBeauce",
      "rookie_year": "2014",
      "city": "Saint-Georges",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5096,
      "name": "The Teutonic Force",
      "rookie_year": "2014",
      "city": "Germantown",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5097,
      "name": "Phantom",
      "rookie_year": "2014",
      "city": "Folsom",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5098,
      "name": "STING - R",
      "rookie_year": "2014",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5099,
      "name": "Northport Robotics",
      "rookie_year": "2014",
      "city": "Northport",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5100,
      "name": "Romanoid",
      "rookie_year": "2014",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5101,
      "name": "Braves",
      "rookie_year": "2014",
      "city": "San Carlos",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5102,
      "name": "The Underbots",
      "rookie_year": "2014",
      "city": "Santa Maria",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5103,
      "name": "Jaegernauts",
      "rookie_year": "2014",
      "city": "New Braunfels",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5104,
      "name": "BreakerBots",
      "rookie_year": "2014",
      "city": "Pacific Grove",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5105,
      "name": "PioTech",
      "rookie_year": "2014",
      "city": "Wayne",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5106,
      "name": "High Impact Technologies",
      "rookie_year": "2014",
      "city": "Sunderland",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5107,
      "name": "The Neurotoxins ",
      "rookie_year": "2014",
      "city": "Upland",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5108,
      "name": "Can-O-Bolts",
      "rookie_year": "2014",
      "city": "Jacksonville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5109,
      "name": "Gladiator Robotics",
      "rookie_year": "2014",
      "city": "Johns Creek",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5110,
      "name": "Robo Herd",
      "rookie_year": "2014",
      "city": "Elk Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5111,
      "name": "SaxonBots",
      "rookie_year": "2014",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5112,
      "name": "The Gongoliers",
      "rookie_year": "2014",
      "city": "Foster and Glocester ",
      "state": "Rhode Island",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5113,
      "name": "Combustible Lemons",
      "rookie_year": "2014",
      "city": "Moorestown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5114,
      "name": "Titanium Tigers 5114",
      "rookie_year": "2014",
      "city": "Fenton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5115,
      "name": "Knight Riders",
      "rookie_year": "2014",
      "city": "Silver Spring",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5116,
      "name": "Silicon Claymore",
      "rookie_year": "2014",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5117,
      "name": "Comets",
      "rookie_year": "2014",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5118,
      "name": "K-BOTS",
      "rookie_year": "2014",
      "city": "Standoff",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5119,
      "name": "Team STEAM",
      "rookie_year": "2014",
      "city": "Lawrence",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5120,
      "name": "Robo-Jags",
      "rookie_year": "2014",
      "city": "Little Rock",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5121,
      "name": "Trobots",
      "rookie_year": "2014",
      "city": "Riverside",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5122,
      "name": "robOTies",
      "rookie_year": "2014",
      "city": "Old Town",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5123,
      "name": "Mechadogs",
      "rookie_year": "2014",
      "city": "Yonkers",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5124,
      "name": "West Torrance Robotics",
      "rookie_year": "2014",
      "city": "Torrance",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5125,
      "name": "Hawks on the Horizon",
      "rookie_year": "2014",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5126,
      "name": "Electromagnetic Panthers (E.M.P.)",
      "rookie_year": "2014",
      "city": "Riverside",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5127,
      "name": "Red Hurricane",
      "rookie_year": "2014",
      "city": "Shenyang",
      "state": "Liaoning",
      "country": "China",
      "district": ""
    },
    {
      "number": 5128,
      "name": "Shenzhen Middle School Team",
      "rookie_year": "2014",
      "city": "shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5129,
      "name": "Digital Devils",
      "rookie_year": "2014",
      "city": "Plainville",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5130,
      "name": "Undercogs",
      "rookie_year": "2014",
      "city": "LIttle River",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5131,
      "name": "Rockets Robots2014",
      "rookie_year": "",
      "city": "Auburn",
      "state": "MA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5132,
      "name": "RoboClovers",
      "rookie_year": "2014",
      "city": "Winder",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5133,
      "name": "PrepaTec - Blue Steel",
      "rookie_year": "2014",
      "city": "Aguascalientes",
      "state": "Aguascalientes",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5134,
      "name": "RoboWolves",
      "rookie_year": "2014",
      "city": "Clovis",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5135,
      "name": "Black Unicorns",
      "rookie_year": "2014",
      "city": "Yehud",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5136,
      "name": "MechaPirates",
      "rookie_year": "2014",
      "city": "Santa Ynez",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5137,
      "name": "Iron Kodiaks",
      "rookie_year": "2014",
      "city": "San Marcos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5138,
      "name": "Maine East FIRST",
      "rookie_year": "2014",
      "city": "Park Ridge",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5139,
      "name": "Nellis Eagles",
      "rookie_year": "2014",
      "city": "Las Vegas",
      "state": "NV",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5140,
      "name": "Systematic Targeting Of Robotic Mayhem (S.T.O.R.M.)",
      "rookie_year": "2014",
      "city": "Edmonton",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5141,
      "name": "GRIFFINITE",
      "rookie_year": "2014",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5142,
      "name": "Robo Dominators",
      "rookie_year": "2014",
      "city": "West Haven",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5143,
      "name": "GRG Raw Steel",
      "rookie_year": "2014",
      "city": "Coleraine",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5144,
      "name": "LISD TECHnicians",
      "rookie_year": "2014",
      "city": "Adrian",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5145,
      "name": "WolfBotics",
      "rookie_year": "2014",
      "city": "Gainesville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5146,
      "name": "Rusty Knights",
      "rookie_year": "2014",
      "city": "Hebron",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5147,
      "name": "Hornets",
      "rookie_year": "2014",
      "city": "Fulton",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5148,
      "name": "New Berlin Blitz",
      "rookie_year": "2014",
      "city": "New Berlin",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5149,
      "name": "TroyBotics",
      "rookie_year": "2014",
      "city": "Troy",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5150,
      "name": "Hybrid Hornets",
      "rookie_year": "2014",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5151,
      "name": "RoboTitans",
      "rookie_year": "2014",
      "city": "bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5152,
      "name": "Alotobots",
      "rookie_year": "2014",
      "city": "Otsego",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5153,
      "name": "EAST at HHS",
      "rookie_year": "2014",
      "city": "Huntsville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5154,
      "name": "Dolphins",
      "rookie_year": "2014",
      "city": "Gulf Shores",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5155,
      "name": "Bearcats",
      "rookie_year": "2014",
      "city": "Ubly",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5156,
      "name": "Laker Battleships",
      "rookie_year": "2014",
      "city": "Pigeon",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5157,
      "name": "Roboprime Cardinals",
      "rookie_year": "2014",
      "city": "Sudbury",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5158,
      "name": "Richmond Hill",
      "rookie_year": "2014",
      "city": "Richmond Hill",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5159,
      "name": "Bengal Robotics",
      "rookie_year": "2014",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5160,
      "name": "Chargers",
      "rookie_year": "2014",
      "city": "Cary",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5161,
      "name": "Trojan Technicians ",
      "rookie_year": "2014",
      "city": "Plainwell",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5162,
      "name": "The Big Red Theory",
      "rookie_year": "2014",
      "city": "Big Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5163,
      "name": "The Aluminum Warriors",
      "rookie_year": "2014",
      "city": "Hopkinton",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5164,
      "name": "Robusters",
      "rookie_year": "2014",
      "city": "Sudbury",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5165,
      "name": "Yangtze",
      "rookie_year": "2014",
      "city": "Wuhan",
      "state": "Hubei",
      "country": "China",
      "district": ""
    },
    {
      "number": 5166,
      "name": "Fabricators",
      "rookie_year": "2014",
      "city": "Freeland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5167,
      "name": "Vi-Bots",
      "rookie_year": "2014",
      "city": "Marysville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5168,
      "name": "Guardian Angels",
      "rookie_year": "2014",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5169,
      "name": "The Armadillos ",
      "rookie_year": "2014",
      "city": "Senatobia",
      "state": "MS",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5170,
      "name": "Bobcats",
      "rookie_year": "2014",
      "city": "Gainesville",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5171,
      "name": "Deus Ex Machina",
      "rookie_year": "2014",
      "city": "Monterey",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5172,
      "name": "Gators",
      "rookie_year": "2014",
      "city": "Greenbush",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5173,
      "name": "Fennville RoboHawks",
      "rookie_year": "2014",
      "city": "Fennville",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5174,
      "name": "Enterprise ",
      "rookie_year": "2014",
      "city": "Naura",
      "state": "Z",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5175,
      "name": "Purple People Eaters",
      "rookie_year": "2014",
      "city": "Pickford",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5176,
      "name": "RoboBills",
      "rookie_year": "2014",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5177,
      "name": "Hatchets",
      "rookie_year": "2014",
      "city": "200 North Barrie Rd",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5178,
      "name": "The Nerdy Birds",
      "rookie_year": "2014",
      "city": "Farmington",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5179,
      "name": "Les S\u00e9nateurs",
      "rookie_year": "2014",
      "city": "Drummondville",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5180,
      "name": "Metal Heads",
      "rookie_year": "2014",
      "city": "Blythewood",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5181,
      "name": "Explorer Robotics",
      "rookie_year": "2014",
      "city": "Wyndmoor",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5182,
      "name": "Chieftainators",
      "rookie_year": "2014",
      "city": "Dowagiac",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5183,
      "name": "Devil Bots",
      "rookie_year": "2014",
      "city": "Gaylord",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5184,
      "name": "TITANICS",
      "rookie_year": "2014",
      "city": "Edmonton",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5185,
      "name": "Dial-Up Grizzlies",
      "rookie_year": "2014",
      "city": "Airdrie",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5186,
      "name": "Cybears",
      "rookie_year": "2014",
      "city": "Antioch",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5187,
      "name": "TEAM ON IT",
      "rookie_year": "2014",
      "city": "Miami",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5188,
      "name": "Area 5188 : Classified Robotics",
      "rookie_year": "2014",
      "city": "Terre Haute",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 5189,
      "name": "SABRES",
      "rookie_year": "2014",
      "city": "Kansas City",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5190,
      "name": "Green Hope Falcons",
      "rookie_year": "2014",
      "city": "Cary",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5191,
      "name": "LANCERobotics",
      "rookie_year": "2014",
      "city": "Sudbury",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5192,
      "name": "Toros",
      "rookie_year": "2014",
      "city": "Benton Harbor",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5193,
      "name": "Pantheon",
      "rookie_year": "2014",
      "city": "Saginaw",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5194,
      "name": "Gobles Voltage",
      "rookie_year": "2014",
      "city": "Gobles",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5195,
      "name": "The Renegade",
      "rookie_year": "2014",
      "city": "Wynne",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5196,
      "name": "Breaking Bot",
      "rookie_year": "2014",
      "city": "Pompano Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5197,
      "name": "DCP @ NW",
      "rookie_year": "2014",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5198,
      "name": "Knight Tech",
      "rookie_year": "2014",
      "city": "Grants Pass",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5199,
      "name": "Robot Dolphins From Outer Space",
      "rookie_year": "2014",
      "city": "San Juan Capistrano",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5200,
      "name": "Alchesay Falcon",
      "rookie_year": "2014",
      "city": "Whiteriver",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5201,
      "name": "North Branch Bad News Broncos",
      "rookie_year": "2014",
      "city": "North Branch",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5202,
      "name": "NewRo Bots",
      "rookie_year": "2014",
      "city": "New Rochelle",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5203,
      "name": "Volatile Chaos Inhibitors",
      "rookie_year": "2014",
      "city": "Sanford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5204,
      "name": "Robocats",
      "rookie_year": "2014",
      "city": "Three Rivers",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5205,
      "name": "FullMetal-Jackets",
      "rookie_year": "2014",
      "city": "Concord",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5206,
      "name": "A's Gurias",
      "rookie_year": "2014",
      "city": "Gravatai",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 5207,
      "name": "Coolidge Robotics",
      "rookie_year": "2014",
      "city": "Coolidge",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5208,
      "name": "TALON Robotics",
      "rookie_year": "2014",
      "city": "Turlock",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5209,
      "name": "Rectify",
      "rookie_year": "2014",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5210,
      "name": "Milpitas Xtreme Robotics",
      "rookie_year": "2014",
      "city": "Milpitas",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5211,
      "name": "Tuiuteam",
      "rookie_year": "2014",
      "city": "Gravatai",
      "state": "RS",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 5212,
      "name": "TAMSformers Robotics",
      "rookie_year": "2014",
      "city": "Denton",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5213,
      "name": "St. Ignace SHIELD",
      "rookie_year": "2014",
      "city": "Saint Ignace",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5214,
      "name": "The Mighty CavBots",
      "rookie_year": "2014",
      "city": "Saint Clair Shores",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5215,
      "name": "Steagles 5215",
      "rookie_year": "2014",
      "city": "Frankenmuth",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5216,
      "name": "E-Ville Empire",
      "rookie_year": "2014",
      "city": "Essexville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5217,
      "name": "Robocats",
      "rookie_year": "2014",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5218,
      "name": "System Overload",
      "rookie_year": "2014",
      "city": "Yuma",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5219,
      "name": "TeknoSquad",
      "rookie_year": "2014",
      "city": "East Point",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5220,
      "name": "Rockets",
      "rookie_year": "2014",
      "city": "Westland",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5221,
      "name": "Project Freelance",
      "rookie_year": "2014",
      "city": "Windsor",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5222,
      "name": "JackBotics",
      "rookie_year": "2014",
      "city": "Saginaw",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5223,
      "name": "Hillman Gearheads",
      "rookie_year": "2014",
      "city": "Hillman",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5224,
      "name": "Panther Power",
      "rookie_year": "2014",
      "city": "Standish",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5225,
      "name": "The Shambotz",
      "rookie_year": "2014",
      "city": "Eastpointe",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5226,
      "name": "Syn. Surgers",
      "rookie_year": "2014",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5227,
      "name": "Eagle Elite",
      "rookie_year": "2014",
      "city": "Schoolcraft",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5228,
      "name": "Astros",
      "rookie_year": "2014",
      "city": "Calgary",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5229,
      "name": "Heritage Hawkbots",
      "rookie_year": "2014",
      "city": "Saginaw",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5230,
      "name": "The Resistance",
      "rookie_year": "2014",
      "city": "Alpena ",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5231,
      "name": "Radical Jays",
      "rookie_year": "2014",
      "city": "Shepherd",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5232,
      "name": "Talons",
      "rookie_year": "2014",
      "city": "Hermantown",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5233,
      "name": "Golden Eagles",
      "rookie_year": "2014",
      "city": "Brooklyn",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5234,
      "name": "MarauderBots",
      "rookie_year": "2014",
      "city": "Elsie",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5235,
      "name": "Gears of Fortune",
      "rookie_year": "2014",
      "city": "Chesaning",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5236,
      "name": "Man O' War Robotics",
      "rookie_year": "2014",
      "city": "Cambridge",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5237,
      "name": "Bears",
      "rookie_year": "2014",
      "city": "Wyandotte",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5238,
      "name": "Falconators",
      "rookie_year": "2014",
      "city": "Otisville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5239,
      "name": "Harper Woods Pioneers",
      "rookie_year": "2014",
      "city": "Harper Woods",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5240,
      "name": "Udder Chaos",
      "rookie_year": "2014",
      "city": "Potsdam",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5241,
      "name": "Tribe Tech FRC",
      "rookie_year": "2014",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5242,
      "name": "\u2699\ufe0f RoboCats \u2699\ufe0f",
      "rookie_year": "2014",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5243,
      "name": "Aegis Robotics",
      "rookie_year": "2014",
      "city": "Clifton",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5244,
      "name": "LNHS",
      "rookie_year": "2014",
      "city": "Kalamazoo",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5245,
      "name": "Warriors",
      "rookie_year": "2014",
      "city": "Grass Lake",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5246,
      "name": "Tech Tribe",
      "rookie_year": "2014",
      "city": "Hartford",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5247,
      "name": "Red Devil Robotics",
      "rookie_year": "2014",
      "city": "East Jordan",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5248,
      "name": "Robo-Saxons",
      "rookie_year": "2014",
      "city": "Hastings",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5249,
      "name": "Revere Robotics",
      "rookie_year": "2014",
      "city": "Richfield",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5250,
      "name": "Kinetic",
      "rookie_year": "2014",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5251,
      "name": "C3 WAYbots",
      "rookie_year": "2014",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5252,
      "name": "Cyber Tigers",
      "rookie_year": "2014",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5253,
      "name": "Bigfork Backwoods Bots",
      "rookie_year": "2014",
      "city": "Bigfork",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5254,
      "name": "HYPE",
      "rookie_year": "2014",
      "city": "Trumansburg",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5255,
      "name": "Robotic Tigers",
      "rookie_year": "2014",
      "city": "Muskegon",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5256,
      "name": "Atomics",
      "rookie_year": "2014",
      "city": "Lake Odessa",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5257,
      "name": "CometKaze",
      "rookie_year": "2014",
      "city": "Coleman",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5258,
      "name": "Flyers",
      "rookie_year": "2014",
      "city": "Romeoville",
      "state": "IL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5259,
      "name": "Magic Smoke",
      "rookie_year": "2014",
      "city": "Jacksonville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5260,
      "name": "Owosso Operating System",
      "rookie_year": "2014",
      "city": "Owosso",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5261,
      "name": "Cyber Shock",
      "rookie_year": "2014",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5262,
      "name": "Robotum Manus",
      "rookie_year": "2014",
      "city": "Cullman",
      "state": "AL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5263,
      "name": "Robo-Bucs",
      "rookie_year": "2014",
      "city": "Riverview",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5264,
      "name": "The Integers",
      "rookie_year": "2014",
      "city": "Jamaica",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5265,
      "name": "Radical Impact",
      "rookie_year": "2014",
      "city": "Portland",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5267,
      "name": "Cougar",
      "rookie_year": "2014",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5268,
      "name": "The BioMech Falcons",
      "rookie_year": "2014",
      "city": "Olathe",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5269,
      "name": "Sonic Sci-borgs",
      "rookie_year": "2014",
      "city": "Silver Spring",
      "state": "MD",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5270,
      "name": "KULTUR LISESI",
      "rookie_year": "2014",
      "city": "ISTANBUL",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5271,
      "name": "Open Circuits",
      "rookie_year": "2014",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5272,
      "name": "Argobots",
      "rookie_year": "2014",
      "city": "Van",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5273,
      "name": "desert robot",
      "rookie_year": "2014",
      "city": "Kuseyfe",
      "state": "HaDarom",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5274,
      "name": "Wolverines",
      "rookie_year": "2014",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5275,
      "name": "T.I.M.E.-Bots",
      "rookie_year": "2014",
      "city": "New Prague",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5276,
      "name": "Edgar Allan Ohms",
      "rookie_year": "2014",
      "city": "Tampa",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5277,
      "name": "Rowville SC",
      "rookie_year": "2014",
      "city": "Rowville",
      "state": "VIC",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5278,
      "name": "Los Clasicos",
      "rookie_year": "2014",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5279,
      "name": "Bionic Eagles",
      "rookie_year": "2014",
      "city": "Altavista",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5280,
      "name": "Shockers",
      "rookie_year": "2014",
      "city": "Calgary",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5281,
      "name": "PyroNinjas",
      "rookie_year": "2014",
      "city": "Fort Walton Beach",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5282,
      "name": "Railroader Robotics",
      "rookie_year": "2014",
      "city": "Durand",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5283,
      "name": "Torque",
      "rookie_year": "2014",
      "city": "Tampa",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5284,
      "name": "The Monarchs",
      "rookie_year": "2014",
      "city": "Wilmington",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5285,
      "name": "Sea Kings Robotics",
      "rookie_year": "2014",
      "city": "Palos Verdes Estates",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5286,
      "name": "Trojonix",
      "rookie_year": "2014",
      "city": "Saco",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5287,
      "name": "FLARE",
      "rookie_year": "2014",
      "city": "Orange",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5288,
      "name": "Spartan Robotics",
      "rookie_year": "2014",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5289,
      "name": "Medabots",
      "rookie_year": "2014",
      "city": "New York City",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5290,
      "name": "Mechanical Howl",
      "rookie_year": "2014",
      "city": "Forest Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5291,
      "name": "Emperius",
      "rookie_year": "2014",
      "city": "Eilat",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5292,
      "name": "Cougar-Tron Squad",
      "rookie_year": "2014",
      "city": "Grassland",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5293,
      "name": "Metal Crusaders",
      "rookie_year": "2014",
      "city": "Duluth",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5294,
      "name": "Industrial Revolution",
      "rookie_year": "2014",
      "city": "Providence/Pawtucket",
      "state": "RI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5295,
      "name": "Aldernating Current",
      "rookie_year": "2014",
      "city": "Shelton",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5296,
      "name": "Iron Falcons",
      "rookie_year": "2014",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5297,
      "name": "BOLTZAP",
      "rookie_year": "2014",
      "city": "Guangzhou",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5298,
      "name": "E-TECH CHARGERS",
      "rookie_year": "2014",
      "city": "Astoria",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5299,
      "name": "Winger Tech",
      "rookie_year": "2014",
      "city": "Red Wing",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5300,
      "name": "Mustangs",
      "rookie_year": "2014",
      "city": "Clio",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5301,
      "name": "RBT",
      "rookie_year": "2014",
      "city": "CHUANGCHUN",
      "state": "22",
      "country": "China",
      "district": ""
    },
    {
      "number": 5302,
      "name": "Transformers",
      "rookie_year": "2014",
      "city": "DALIAN",
      "state": "21",
      "country": "China",
      "district": ""
    },
    {
      "number": 5303,
      "name": "Power Train",
      "rookie_year": "2014",
      "city": "ZhengZhou",
      "state": "46",
      "country": "China",
      "district": ""
    },
    {
      "number": 5304,
      "name": "Stone",
      "rookie_year": "2014",
      "city": "CHUANGCHUN",
      "state": "22",
      "country": "China",
      "district": ""
    },
    {
      "number": 5305,
      "name": "Yangtze Wuhan",
      "rookie_year": "2014",
      "city": "Wuhan",
      "state": "Hubei",
      "country": "China",
      "district": ""
    },
    {
      "number": 5306,
      "name": "R2",
      "rookie_year": "2014",
      "city": "CHONGQING",
      "state": "Chongqing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5307,
      "name": "Mechanical Dragon",
      "rookie_year": "2014",
      "city": "SHEN ZHEN",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5308,
      "name": "Wuhan Yangtze ",
      "rookie_year": "2014",
      "city": "Wuhan",
      "state": "Hubei",
      "country": "China",
      "district": ""
    },
    {
      "number": 5309,
      "name": "Robbery",
      "rookie_year": "2014",
      "city": "chuangchun",
      "state": "22",
      "country": "China",
      "district": ""
    },
    {
      "number": 5310,
      "name": "Eagles Apex",
      "rookie_year": "2014",
      "city": "East Orange",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5311,
      "name": "Colombian Space Stars",
      "rookie_year": "2014",
      "city": "Bogota",
      "state": "Distrito Capital de Bogot\u00e1",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 5312,
      "name": "Pe\u00f1oles - Lobotics",
      "rookie_year": "2014",
      "city": "Torreon",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5313,
      "name": "CIBERBOTS",
      "rookie_year": "2014",
      "city": "Toluca",
      "state": "MEX",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5314,
      "name": "Ice Bots",
      "rookie_year": "2014",
      "city": "Pellston",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5315,
      "name": "Panther Robot",
      "rookie_year": "2014",
      "city": "Peyton",
      "state": "CO",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5316,
      "name": "The Architects",
      "rookie_year": "2014",
      "city": "Saranac",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5317,
      "name": "@RedhawkRobotics",
      "rookie_year": "2014",
      "city": "Blythewood",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5318,
      "name": "DigiDigger",
      "rookie_year": "2014",
      "city": "Lead",
      "state": "South Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5320,
      "name": "Cyber Hornets",
      "rookie_year": "2014",
      "city": "Lorenzo",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5321,
      "name": "Medicengineers",
      "rookie_year": "2014",
      "city": "Buyukcekmece",
      "state": "34",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5322,
      "name": "Southern River",
      "rookie_year": "2014",
      "city": "Gosnels",
      "state": "WA",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5323,
      "name": "Mechanized Mayhem",
      "rookie_year": "2014",
      "city": "Chesapeake",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5324,
      "name": "Hawks",
      "rookie_year": "2014",
      "city": "Haliburton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5325,
      "name": "Hurricanes",
      "rookie_year": "2014",
      "city": "Marrero",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5326,
      "name": "Optimus PRIN",
      "rookie_year": "2014",
      "city": "St. Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5327,
      "name": "Griffin Robotics",
      "rookie_year": "2014",
      "city": "Winnsboro",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5328,
      "name": "APCR",
      "rookie_year": "2014",
      "city": "Astana",
      "state": "AST",
      "country": "Kazakhstan",
      "district": ""
    },
    {
      "number": 5329,
      "name": "Agents of S(A^3)S",
      "rookie_year": "2014",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5330,
      "name": "CBTIS 001 FRESNILLO",
      "rookie_year": "2014",
      "city": "FRESNILLO",
      "state": "ZAC",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5331,
      "name": "Lightning Bots",
      "rookie_year": "2014",
      "city": "Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5332,
      "name": "Toaster Tech",
      "rookie_year": "2014",
      "city": "Decatur",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5333,
      "name": "Can't C#",
      "rookie_year": "2014",
      "city": "Perth",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5334,
      "name": "BUHOS77",
      "rookie_year": "2014",
      "city": "LE\u00d3N",
      "state": "GUA",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5335,
      "name": "Falcons",
      "rookie_year": "2014",
      "city": "Pembroke Pines",
      "state": "FL",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5336,
      "name": "Longhorn ",
      "rookie_year": "2014",
      "city": "Suwanee",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5337,
      "name": "Real Steel",
      "rookie_year": "2014",
      "city": "Conway",
      "state": "SC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5338,
      "name": "RoboLoCo",
      "rookie_year": "2014",
      "city": "Leesburg",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5339,
      "name": "Hurricanes",
      "rookie_year": "2014",
      "city": "Houston",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5340,
      "name": "FAIRmingos",
      "rookie_year": "2014",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5341,
      "name": "The Cardinals",
      "rookie_year": "2014",
      "city": "Faribault",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5342,
      "name": "The Greyhounds",
      "rookie_year": "2014",
      "city": "TAFT",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5343,
      "name": "Environmental Charter High School",
      "rookie_year": "2014",
      "city": "Lawndale",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5344,
      "name": "Rhinos",
      "rookie_year": "2014",
      "city": "Mexico",
      "state": "",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5345,
      "name": "BOLTS",
      "rookie_year": "2014",
      "city": "West Valley City",
      "state": "UT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5346,
      "name": "Atlas Engineering",
      "rookie_year": "2014",
      "city": "Perry",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5347,
      "name": "Gryphons",
      "rookie_year": "2014",
      "city": "Weston",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5348,
      "name": "Charger Robotics",
      "rookie_year": "2014",
      "city": "Cokato",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5349,
      "name": "RoboEagles",
      "rookie_year": "2014",
      "city": "Central Square",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5350,
      "name": "Hope Robotics",
      "rookie_year": "2014",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5351,
      "name": "T-STEM Robotics",
      "rookie_year": "2014",
      "city": "El Paso",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5400,
      "name": "WARP",
      "rookie_year": "2015",
      "city": "Worcester",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5401,
      "name": "Fightin' Robotic Owls",
      "rookie_year": "2015",
      "city": "Bensalem",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5402,
      "name": "Iron Kings and Berrybotics",
      "rookie_year": "2015",
      "city": "Walton",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 5403,
      "name": "Aluminosity",
      "rookie_year": "2015",
      "city": "Bedford",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5404,
      "name": "Gearaffes",
      "rookie_year": "2015",
      "city": "Lansdale",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5405,
      "name": "Red Bank High School",
      "rookie_year": "2015",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5406,
      "name": "Celt-X",
      "rookie_year": "2015",
      "city": "Hamilton",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5407,
      "name": "Wolfpack Robotics",
      "rookie_year": "2015",
      "city": "Conshohocken",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5408,
      "name": "KENNEDYcache",
      "rookie_year": "2015",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5409,
      "name": "Chargers",
      "rookie_year": "2015",
      "city": "Oakville",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5410,
      "name": "Eaglebotics",
      "rookie_year": "2015",
      "city": "Coconut Creek",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5411,
      "name": "RoboTalons",
      "rookie_year": "2015",
      "city": "Prosper",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5412,
      "name": "Impossible Robotics",
      "rookie_year": "2015",
      "city": "Groningen",
      "state": "Groningen",
      "country": "Netherlands",
      "district": ""
    },
    {
      "number": 5413,
      "name": "Stellar Robotics",
      "rookie_year": "2015",
      "city": "Shelby",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5414,
      "name": "Pearadox",
      "rookie_year": "2015",
      "city": "Pearland",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5415,
      "name": "Bears",
      "rookie_year": "2015",
      "city": "Mexico City",
      "state": "Distrito Federal",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5416,
      "name": "TaRDIS",
      "rookie_year": "2015",
      "city": "Katy",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5417,
      "name": "Eagle Robotics",
      "rookie_year": "2015",
      "city": "Allen",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5418,
      "name": "The Sonic Screwdrivers",
      "rookie_year": "2015",
      "city": "Hubbard",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5419,
      "name": "Berkelium",
      "rookie_year": "2015",
      "city": "Berkeley",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5420,
      "name": "Velocity",
      "rookie_year": "2015",
      "city": "Bridgeton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5421,
      "name": "Birch Bots",
      "rookie_year": "2015",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5422,
      "name": "Stormgears FRC",
      "rookie_year": "2015",
      "city": "Westford",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5423,
      "name": "HopCo  Robo",
      "rookie_year": "2015",
      "city": "Madisonville",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5424,
      "name": "Rogue Robots",
      "rookie_year": "2015",
      "city": "Midland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5425,
      "name": "RVA Coder Collective",
      "rookie_year": "2015",
      "city": "Richmond",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5426,
      "name": "E.J. Lajeunesse",
      "rookie_year": "2015",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5427,
      "name": "Steel Talons",
      "rookie_year": "2015",
      "city": "Katy",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5428,
      "name": "Breaking Bots",
      "rookie_year": "2015",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5429,
      "name": "Black Knights",
      "rookie_year": "2015",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5430,
      "name": "Pirate Robolution",
      "rookie_year": "2015",
      "city": "Pittsburg",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5431,
      "name": "Titan Robotics",
      "rookie_year": "2015",
      "city": "Plano",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5432,
      "name": "AutoPilots",
      "rookie_year": "2015",
      "city": "Wilmington",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5433,
      "name": "Blinding Light",
      "rookie_year": "2015",
      "city": "Webster",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5434,
      "name": "Falcon Robotics",
      "rookie_year": "2015",
      "city": "Faribault",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5435,
      "name": "RoboMomoTrufflez",
      "rookie_year": "2015",
      "city": "Hamilton",
      "state": "NJ",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5436,
      "name": "Cyber Cats",
      "rookie_year": "2015",
      "city": "Rochester",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5437,
      "name": "Rocky Balboabots",
      "rookie_year": "2015",
      "city": "Booneville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5438,
      "name": "Technological Terrors",
      "rookie_year": "2015",
      "city": "Jersey City",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5439,
      "name": "Huskies",
      "rookie_year": "2015",
      "city": "Qu\u00e9bec",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5440,
      "name": "Les Chevaliers",
      "rookie_year": "2015",
      "city": "Quebec",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5441,
      "name": "Arsenal",
      "rookie_year": "2015",
      "city": "Mascouche",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5442,
      "name": "Mechanical Monarchy",
      "rookie_year": "2015",
      "city": "Washington",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5443,
      "name": "Les PATenteux",
      "rookie_year": "2015",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5444,
      "name": "VObotik",
      "rookie_year": "2015",
      "city": "Trois-Rivi\u00e8res",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5445,
      "name": "Rushing Peacock",
      "rookie_year": "2015",
      "city": "Kunming",
      "state": "Yunnan",
      "country": "China",
      "district": ""
    },
    {
      "number": 5446,
      "name": "Pink Detectives",
      "rookie_year": "2015",
      "city": "Apex",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5447,
      "name": "Team Robotica",
      "rookie_year": "2015",
      "city": "Sebewaing",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5448,
      "name": "CCA RoboCougars",
      "rookie_year": "2015",
      "city": "Big Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5449,
      "name": "Prototype",
      "rookie_year": "2015",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5450,
      "name": "SHREC 5450",
      "rookie_year": "2015",
      "city": "Saint Helens",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5451,
      "name": "Supernova",
      "rookie_year": "2015",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5452,
      "name": "Aurora Robot",
      "rookie_year": "2015",
      "city": "quanzhou",
      "state": "Fujian",
      "country": "China",
      "district": ""
    },
    {
      "number": 5453,
      "name": "RED COMET",
      "rookie_year": "2015",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5454,
      "name": "Obsidian",
      "rookie_year": "2015",
      "city": "Bentonville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5455,
      "name": "shenzhen pingshan high school ",
      "rookie_year": "2015",
      "city": "shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5456,
      "name": "hua nan shi fan da xue fushu zhong xue",
      "rookie_year": "2015",
      "city": "guangzhou",
      "state": "52",
      "country": "China",
      "district": ""
    },
    {
      "number": 5457,
      "name": "Falcobots",
      "rookie_year": "2015",
      "city": "Burlington",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5458,
      "name": "Digital Minds",
      "rookie_year": "2015",
      "city": "Woodland",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5459,
      "name": "Ipswich TIGERS",
      "rookie_year": "2015",
      "city": "Ipswich",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5460,
      "name": "Strike Zone",
      "rookie_year": "2015",
      "city": "Lapeer",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5461,
      "name": "Victorian Engineered Robotic Nation or V.E.R.N.",
      "rookie_year": "2015",
      "city": "Meridian",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5462,
      "name": "2PawR (2PawRobotics)",
      "rookie_year": "2015",
      "city": "Paw Paw",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5463,
      "name": "Iron Eagles",
      "rookie_year": "2015",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5464,
      "name": "Bluejacket Robotics",
      "rookie_year": "2015",
      "city": "Cambridge",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5465,
      "name": "Binary Bots",
      "rookie_year": "2015",
      "city": "Chandler",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5466,
      "name": "Shanghai Xiang Ming High School Of China",
      "rookie_year": "2015",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 5467,
      "name": "RoboTractors",
      "rookie_year": "2015",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5468,
      "name": "Chaos Theory",
      "rookie_year": "2015",
      "city": "Bend",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5469,
      "name": "FLARE",
      "rookie_year": "2015",
      "city": "Orange",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5470,
      "name": "The Cowpunchers",
      "rookie_year": "2015",
      "city": "Coopersville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5471,
      "name": "W.Hi.R.R.",
      "rookie_year": "2015",
      "city": "Winthrop",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5472,
      "name": "Stallion Robotics: The Wyld Stallyns",
      "rookie_year": "2015",
      "city": "Delray Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5473,
      "name": "Team Spitfire.",
      "rookie_year": "2015",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5474,
      "name": "Clairemonster",
      "rookie_year": "2015",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5475,
      "name": "Thunder",
      "rookie_year": "2015",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5476,
      "name": "Y Bridge 4H",
      "rookie_year": "2015",
      "city": "Galena",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5477,
      "name": "NuBotX - National University Academy Robotics Experience",
      "rookie_year": "2015",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5478,
      "name": "Pershing Doughbots",
      "rookie_year": "2015",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5479,
      "name": "Cafe Bot",
      "rookie_year": "2015",
      "city": "St. Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5480,
      "name": "FYRE",
      "rookie_year": "2015",
      "city": "Reno",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5481,
      "name": "Bristol Bots",
      "rookie_year": "2015",
      "city": "Bristolville",
      "state": "OH",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5482,
      "name": "Roarbotics",
      "rookie_year": "2015",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5483,
      "name": "GD-Bots",
      "rookie_year": "2015",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5484,
      "name": "Career Academy Robotics - Wolf Pack",
      "rookie_year": "2015",
      "city": "South Bend",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 5485,
      "name": "Manual T-Bots",
      "rookie_year": "2015",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5486,
      "name": "Robotic Turmoil",
      "rookie_year": "2015",
      "city": "Lake Linden",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5487,
      "name": "Tiger Robotics",
      "rookie_year": "2015",
      "city": "Caro",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5488,
      "name": "Baronbotix",
      "rookie_year": "2015",
      "city": "Chula Vista",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5489,
      "name": "CSI Golden Eagle Robotics",
      "rookie_year": "2015",
      "city": "Twin Falls",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5490,
      "name": "The Dark Byte",
      "rookie_year": "2015",
      "city": "Bethlehem",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5491,
      "name": "Hard Reset",
      "rookie_year": "2015",
      "city": "Winchendon",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5492,
      "name": "Winner's Circle Robo Jockey's",
      "rookie_year": "2015",
      "city": "Louisville",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5493,
      "name": "SMAbotics AG",
      "rookie_year": "2015",
      "city": "Englewood",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5494,
      "name": "Bizarbots Robotics",
      "rookie_year": "2015",
      "city": "Holbrook",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5495,
      "name": "Aluminati",
      "rookie_year": "2015",
      "city": "Snohomish",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5496,
      "name": "Robo Knights",
      "rookie_year": "2015",
      "city": "Vacaville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5497,
      "name": "Foxes",
      "rookie_year": "2015",
      "city": "Silverton",
      "state": "OR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5498,
      "name": "The Wired Devils",
      "rookie_year": "2015",
      "city": "Grosse Ile",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5499,
      "name": "The Bay Orangutans",
      "rookie_year": "2015",
      "city": "Berkeley",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5500,
      "name": "Jaguars Robotics & ROVs",
      "rookie_year": "2015",
      "city": "Long Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5501,
      "name": "Bobcats",
      "rookie_year": "2015",
      "city": "Burr Oak",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5502,
      "name": "Cobrots",
      "rookie_year": "2015",
      "city": "Jonesville",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5503,
      "name": "Smithville Tiger Trons",
      "rookie_year": "2015",
      "city": "Smithville",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5504,
      "name": "The Loose Connections",
      "rookie_year": "2015",
      "city": "Pinconning ",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5505,
      "name": "V2 - Volts Squared",
      "rookie_year": "2015",
      "city": "Alpena",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5506,
      "name": "Midcoast MAINEiacs Robotics Team",
      "rookie_year": "2015",
      "city": "Searsport",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5507,
      "name": "Robotic Eagles",
      "rookie_year": "2015",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5508,
      "name": "Wolfbots",
      "rookie_year": "2015",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5509,
      "name": "Like a Boss",
      "rookie_year": "2015",
      "city": "Midland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5510,
      "name": "The Da Vinci Coders",
      "rookie_year": "2015",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5511,
      "name": "Cortechs Robotics",
      "rookie_year": "2015",
      "city": "Cary",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5512,
      "name": "Pizza Mec\u00e1nica",
      "rookie_year": "2015",
      "city": "Recoleta",
      "state": "Regi\u00f3n Metropolitana de Santiago",
      "country": "Chile",
      "district": ""
    },
    {
      "number": 5513,
      "name": "Monroe Robotics",
      "rookie_year": "2015",
      "city": "North Hills",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5514,
      "name": "LCC MavBots",
      "rookie_year": "2015",
      "city": "Carlsbad",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5515,
      "name": "Blue Power Robotics",
      "rookie_year": "2015",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 5516,
      "name": "Iron Maple",
      "rookie_year": "2015",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5517,
      "name": "The Engineers on Fire",
      "rookie_year": "2015",
      "city": "Burton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5518,
      "name": "Techno Wolves",
      "rookie_year": "2015",
      "city": "Apex",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5519,
      "name": "LASS Robotics",
      "rookie_year": "2015",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5520,
      "name": "Duck and Cover",
      "rookie_year": "2015",
      "city": "Henrico",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5521,
      "name": "WOLF TEAM ROBOTICS",
      "rookie_year": "2015",
      "city": "SOPO",
      "state": "Cundinamarca",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 5522,
      "name": "Stargazer",
      "rookie_year": "2015",
      "city": "Shenzhen ",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5523,
      "name": "Redneck RoboWarriors",
      "rookie_year": "2015",
      "city": "Grass Lake",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5524,
      "name": "MacroProcessors ",
      "rookie_year": "2015",
      "city": "Birch Run",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5525,
      "name": "Alcona Tool Cats",
      "rookie_year": "2015",
      "city": "Lincoln",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5526,
      "name": "Pe\u00f1oles - TCATs",
      "rookie_year": "2015",
      "city": "Torreon",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5527,
      "name": "Cyber Phoenix",
      "rookie_year": "2015",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5528,
      "name": "Ultime",
      "rookie_year": "2015",
      "city": "Trois-Rivieres",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5529,
      "name": "Visalia Vanquishers",
      "rookie_year": "2015",
      "city": "Visalia",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5530,
      "name": "The Greenhills Lawnmowers",
      "rookie_year": "2015",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5531,
      "name": "Orange Crush",
      "rookie_year": "2015",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5532,
      "name": "The G.O.A.T.S",
      "rookie_year": "2015",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5533,
      "name": "Electric Horse Power",
      "rookie_year": "2015",
      "city": "Clio",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5534,
      "name": "Onaway Onabots",
      "rookie_year": "2015",
      "city": "Onaway",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5535,
      "name": "Bionic Bison",
      "rookie_year": "2015",
      "city": "New Buffalo",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5536,
      "name": "Titan Alliance",
      "rookie_year": "2015",
      "city": "Albany",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5537,
      "name": "Dia and the Brobots feat. J-Kwelin",
      "rookie_year": "2015",
      "city": "Fairfield",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5538,
      "name": "Vikingbots",
      "rookie_year": "2015",
      "city": "Saginaw",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5539,
      "name": "DVHS Cyborgs",
      "rookie_year": "2015",
      "city": "Tucson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5540,
      "name": "Lincoln High School Tigers",
      "rookie_year": "2015",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5541,
      "name": "Shakopee Robotics",
      "rookie_year": "2015",
      "city": "Shakopee",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5542,
      "name": "RoboHerd",
      "rookie_year": "2015",
      "city": "Buffalo",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5543,
      "name": "M.I.N.T.T.Z - Mechanically Insane Nerdy Tech Teenz",
      "rookie_year": "2015",
      "city": "Greensboro",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5544,
      "name": "SWIFT Robotics",
      "rookie_year": "2015",
      "city": "Vass",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5545,
      "name": "PiedmontSTEM",
      "rookie_year": "2015",
      "city": "concord",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5546,
      "name": "\u2692\ufe0f A.R.T. \u2692\ufe0f",
      "rookie_year": "2015",
      "city": "Petersburg",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5547,
      "name": "The Talons",
      "rookie_year": "2015",
      "city": "Hale",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5548,
      "name": "Psi Factor",
      "rookie_year": "2015",
      "city": "Yukon",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5549,
      "name": "Gryphon Robotics",
      "rookie_year": "2015",
      "city": "Falls Church",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5550,
      "name": "BRONChO BOTS",
      "rookie_year": "2015",
      "city": "Bethany",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5551,
      "name": "Harding Revolution",
      "rookie_year": "2015",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5552,
      "name": "SENSORED",
      "rookie_year": "2015",
      "city": "Green Bay",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5553,
      "name": "Robo'Lyon",
      "rookie_year": "2015",
      "city": "Neuville-sur-Sa\u00f4ne",
      "state": "Rh\u00f4ne",
      "country": "France",
      "district": ""
    },
    {
      "number": 5554,
      "name": "The Poros Robotics",
      "rookie_year": "2015",
      "city": "Netanya",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5555,
      "name": "Spartans",
      "rookie_year": "2015",
      "city": "Warren",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5556,
      "name": "Carriagetown Robotics",
      "rookie_year": "2015",
      "city": "Amesbury",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5557,
      "name": "BB-R8ERS",
      "rookie_year": "2015",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5558,
      "name": "Ad Astra",
      "rookie_year": "2015",
      "city": "Bursa",
      "state": "Bursa",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5559,
      "name": "Gear Grinders",
      "rookie_year": "2015",
      "city": "Camden",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5560,
      "name": "Central Lake Trobotics",
      "rookie_year": "2015",
      "city": "Central Lake",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5561,
      "name": "Raider Robotics",
      "rookie_year": "2015",
      "city": "Flushing",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5562,
      "name": "CTRL+Shift+qq",
      "rookie_year": "2015",
      "city": "Maple City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5563,
      "name": "Phalanx",
      "rookie_year": "2015",
      "city": "Lynn",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5564,
      "name": "GRANBOTS",
      "rookie_year": "2015",
      "city": "Granville",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5565,
      "name": "Auburn Girls",
      "rookie_year": "2015",
      "city": "Auburn",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5566,
      "name": "Sugar Rush",
      "rookie_year": "2015",
      "city": "Sugar Land ",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5567,
      "name": "Code Red Robotics",
      "rookie_year": "2015",
      "city": "Milan",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5568,
      "name": "Solid Rock ",
      "rookie_year": "2015",
      "city": "Bentonville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5569,
      "name": "Tech Titans",
      "rookie_year": "2015",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5570,
      "name": "Ookpik",
      "rookie_year": "2015",
      "city": "Montr\u00e9al",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5571,
      "name": "RATCHET",
      "rookie_year": "2015",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5572,
      "name": "ROSBOTS",
      "rookie_year": "2015",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5573,
      "name": "Ivanhoe",
      "rookie_year": "2015",
      "city": "Ivanhoe",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5574,
      "name": "P.A.N.T.H.E.R.S.",
      "rookie_year": "2015",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5575,
      "name": "SHOCK",
      "rookie_year": "2015",
      "city": "Boyne Falls",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5576,
      "name": "Team Terminator",
      "rookie_year": "2015",
      "city": "Spirit Lake",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5577,
      "name": "Kinematic Wolves",
      "rookie_year": "2015",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5578,
      "name": "Metro Mechanical Monsters",
      "rookie_year": "2015",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5579,
      "name": "Trojanbots",
      "rookie_year": "2015",
      "city": "Albany",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5580,
      "name": "BRAEZEN KNIGHTS",
      "rookie_year": "2015",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5581,
      "name": "Hornets",
      "rookie_year": "2015",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5582,
      "name": "Rex Machina",
      "rookie_year": "2015",
      "city": "Sharpsburg",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5583,
      "name": "SistamatiK",
      "rookie_year": "2015",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5584,
      "name": "ICRobotics",
      "rookie_year": "2015",
      "city": "Melbourne",
      "state": "Victoria",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5585,
      "name": "Blood, Sweat & Gears",
      "rookie_year": "2015",
      "city": "Edmeston",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5586,
      "name": "Bond Brigade",
      "rookie_year": "2015",
      "city": "Kiel",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5587,
      "name": "Titan Robotics",
      "rookie_year": "2015",
      "city": "Alexandria",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5588,
      "name": "Reign Robotics",
      "rookie_year": "2015",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5589,
      "name": "Red Devils",
      "rookie_year": "2015",
      "city": "Woodstock",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5590,
      "name": "Alumiboti",
      "rookie_year": "2015",
      "city": "Buffalo",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5591,
      "name": "Manta Mechanics",
      "rookie_year": "2015",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5592,
      "name": "Far North Robotics",
      "rookie_year": "2015",
      "city": "Cairns",
      "state": "Queensland",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5593,
      "name": "Devil Robotics",
      "rookie_year": "2015",
      "city": "Hobart",
      "state": "Tasmania",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5594,
      "name": "GI Joz",
      "rookie_year": "2015",
      "city": "Toccoa",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5595,
      "name": "NRHS TigerBytes",
      "rookie_year": "2015",
      "city": "New Richmond",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5596,
      "name": "Wolverines",
      "rookie_year": "2015",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5597,
      "name": "RoboMaidens",
      "rookie_year": "2015",
      "city": "Fort Mcmurray",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5598,
      "name": "sjmp",
      "rookie_year": "2015",
      "city": "toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5599,
      "name": "The Sentinels",
      "rookie_year": "2015",
      "city": "Bayside",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5600,
      "name": "Taiyuan Beijing Team",
      "rookie_year": "2015",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5601,
      "name": "Semia Team 1",
      "rookie_year": "2015",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 5602,
      "name": "STEMLAB\u00ae SCHOOL",
      "rookie_year": "2015",
      "city": "suzhou",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 5603,
      "name": "Rise of the Warrior Bots",
      "rookie_year": "2015",
      "city": "Auburn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5604,
      "name": "Feixueqingzang",
      "rookie_year": "2015",
      "city": "Xi'ning",
      "state": "Qinghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 5605,
      "name": "Team DaoZu",
      "rookie_year": "2015",
      "city": "Qingdao",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5606,
      "name": "Blue Hurricane",
      "rookie_year": "2015",
      "city": "Shenyang",
      "state": "Liaoning",
      "country": "China",
      "district": ""
    },
    {
      "number": 5607,
      "name": "Team Firewall",
      "rookie_year": "2015",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5608,
      "name": "Lassiter Robotics",
      "rookie_year": "2015",
      "city": "Marietta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5609,
      "name": "COOL School",
      "rookie_year": "2015",
      "city": "Gladwin",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5610,
      "name": "Turbulence",
      "rookie_year": "2015",
      "city": "Saugatuck",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5611,
      "name": "Neon Tigers",
      "rookie_year": "2015",
      "city": "Verden",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5612,
      "name": "RoboRaptors",
      "rookie_year": "2015",
      "city": "Burton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5613,
      "name": "ThunderDogs",
      "rookie_year": "2015",
      "city": "Alamogordo",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5614,
      "name": "Team Sycamore",
      "rookie_year": "2015",
      "city": "Holon",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5615,
      "name": "Miners RC",
      "rookie_year": "2015",
      "city": "Fort McMurray",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5616,
      "name": "Green Machine",
      "rookie_year": "2015",
      "city": "Fort Walton Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5617,
      "name": "Northern Lights",
      "rookie_year": "2015",
      "city": "Fort McMurray",
      "state": "AB",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5618,
      "name": "PLS",
      "rookie_year": "2015",
      "city": "Plessisville",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5619,
      "name": "RoboJags",
      "rookie_year": "2015",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5620,
      "name": "Community Team 1",
      "rookie_year": "2015",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5621,
      "name": "Cyberian Huskies",
      "rookie_year": "2015",
      "city": "Edmond",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5622,
      "name": "Robo Hornets",
      "rookie_year": "2015",
      "city": "Stanton",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5623,
      "name": "Robotic Rams",
      "rookie_year": "2015",
      "city": "Galesburg",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5624,
      "name": "TIGER TECH Robotics",
      "rookie_year": "2015",
      "city": "South Plainfield",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5625,
      "name": "TrojanBots",
      "rookie_year": "2015",
      "city": "Wailuku",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5626,
      "name": "Nu-matic Ninjas",
      "rookie_year": "2015",
      "city": "Norwood Young America",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5627,
      "name": "\u03c0rtz (Pi-rates)",
      "rookie_year": "2015",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5628,
      "name": "cyborg chakra",
      "rookie_year": "2015",
      "city": "Jacksonville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5629,
      "name": "Community Team 2",
      "rookie_year": "2015",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5630,
      "name": "The Nomads",
      "rookie_year": "2015",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5631,
      "name": "SpartanDroids",
      "rookie_year": "2015",
      "city": "Guelph",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5632,
      "name": "The Asimovians",
      "rookie_year": "2015",
      "city": "Appling",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5633,
      "name": "Hyde Cyber Wolves",
      "rookie_year": "2015",
      "city": "Bath",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5634,
      "name": "Jesterminators",
      "rookie_year": "2015",
      "city": "Lakewood",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5635,
      "name": "Demacia",
      "rookie_year": "2015",
      "city": "nes ziona",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5636,
      "name": "Moona",
      "rookie_year": "2015",
      "city": "Majd el Kurum",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5637,
      "name": "North Community High School Polars",
      "rookie_year": "2015",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5638,
      "name": "LQPV Robotics",
      "rookie_year": "2015",
      "city": "Madison",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5639,
      "name": "Loose Wires",
      "rookie_year": "2015",
      "city": "Pharr",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5640,
      "name": "Pegasus Robotics",
      "rookie_year": "2015",
      "city": "Philadelphia",
      "state": "PA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5641,
      "name": "Byron Robotics",
      "rookie_year": "2015",
      "city": "Byron",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5642,
      "name": "Mumford Mechanical Mustangs",
      "rookie_year": "2015",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5643,
      "name": "TBD",
      "rookie_year": "2015",
      "city": "Richmond",
      "state": "IN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5644,
      "name": "FHS ",
      "rookie_year": "2015",
      "city": "Fairfield",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5645,
      "name": "Community Team 4",
      "rookie_year": "2015",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5646,
      "name": "Spider-Bots",
      "rookie_year": "2015",
      "city": "Tampa",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5647,
      "name": "BadgerBots",
      "rookie_year": "2015",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5648,
      "name": "Melbourne RoboCats",
      "rookie_year": "2015",
      "city": "Clayton",
      "state": "Victoria",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5649,
      "name": "The Pithons",
      "rookie_year": "2015",
      "city": "London",
      "state": "CMD",
      "country": "Kingdom",
      "district": ""
    },
    {
      "number": 5650,
      "name": "Carbonite Crusaders",
      "rookie_year": "2015",
      "city": "Macomb",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5651,
      "name": "Maynard Jackson RoboJags",
      "rookie_year": "2015",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5652,
      "name": "Eagles",
      "rookie_year": "2015",
      "city": "Ottawa",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5653,
      "name": "Iron Mosquitos",
      "rookie_year": "2015",
      "city": "Babbitt",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5654,
      "name": "Phoenix",
      "rookie_year": "2015",
      "city": "Arad",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5655,
      "name": "KelRot",
      "rookie_year": "2015",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5656,
      "name": "Panther-bots",
      "rookie_year": "2015",
      "city": "Cabot",
      "state": "AR",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5657,
      "name": "Rawhide Robotics",
      "rookie_year": "2015",
      "city": "Lusk",
      "state": "Wyoming",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5658,
      "name": "STORMBOTICS",
      "rookie_year": "2015",
      "city": "Stephen",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5659,
      "name": "Team Supreme",
      "rookie_year": "2015",
      "city": "Bridgehampton",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5660,
      "name": "Symmetrical Chaos",
      "rookie_year": "2015",
      "city": "Burton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5661,
      "name": "RoboCards",
      "rookie_year": "2015",
      "city": "Whittemore",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5662,
      "name": "Cardinal Commanders",
      "rookie_year": "2015",
      "city": "Dryden",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5663,
      "name": "Ground Control",
      "rookie_year": "2015",
      "city": "Perth",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5664,
      "name": "Big Red Robotics",
      "rookie_year": "2015",
      "city": "Muskegon",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5665,
      "name": "SPARC",
      "rookie_year": "2015",
      "city": "Beyo\u011flu",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5666,
      "name": "Purple Lightning",
      "rookie_year": "2015",
      "city": "Trenton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5667,
      "name": "The Digital Eagles",
      "rookie_year": "2015",
      "city": "New Albany",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5668,
      "name": "NHHS1",
      "rookie_year": "2015",
      "city": "Bancroft",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5669,
      "name": "Techmen",
      "rookie_year": "2015",
      "city": "Rosemead",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5670,
      "name": "Al-Hayah",
      "rookie_year": "2015",
      "city": "Jerusalem",
      "state": "Yerushalayim",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5671,
      "name": "ROBIN, Rob\u00f3tica Inemita",
      "rookie_year": "2015",
      "city": "Medell\u00edn",
      "state": "ANT",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 5672,
      "name": "First Nations-STEM",
      "rookie_year": "2015",
      "city": "Wikwemikong",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5673,
      "name": "CougBorgs",
      "rookie_year": "2015",
      "city": "Detroit",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5674,
      "name": "The Gearhounds",
      "rookie_year": "2015",
      "city": "Eaton Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5675,
      "name": "WiredCats",
      "rookie_year": "2015",
      "city": "Mattawan",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5676,
      "name": "The H.E.R.O.E.S",
      "rookie_year": "2015",
      "city": "Hillsdale",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5677,
      "name": "The Subatomic Smarticles",
      "rookie_year": "2015",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5678,
      "name": "Knightrise",
      "rookie_year": "2015",
      "city": "Valley Glen",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5679,
      "name": "Girls on Fire",
      "rookie_year": "2015",
      "city": "Winston Salem",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5680,
      "name": "KYS Robotics",
      "rookie_year": "2015",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5681,
      "name": "Dragonbots",
      "rookie_year": "2015",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5682,
      "name": "Equus Engineering",
      "rookie_year": "2015",
      "city": "Mesquite",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5683,
      "name": "Hello World",
      "rookie_year": "2015",
      "city": "Auburn",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5684,
      "name": "Iron Mechs",
      "rookie_year": "2015",
      "city": "Trenton",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5685,
      "name": "Robo Terriers",
      "rookie_year": "2015",
      "city": "Litchfield",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5686,
      "name": "Wirecats",
      "rookie_year": "2015",
      "city": "Simsbury",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5687,
      "name": "The Outliers",
      "rookie_year": "2015",
      "city": "Portland",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5688,
      "name": "Robo Cats",
      "rookie_year": "2015",
      "city": "Pittsford",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5689,
      "name": "CK Cyber Pack",
      "rookie_year": "2015",
      "city": "Chatham",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5690,
      "name": "SubZero Robotics",
      "rookie_year": "2015",
      "city": "Esko",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5691,
      "name": "Team Tiger",
      "rookie_year": "2015",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5692,
      "name": "ChiefBots",
      "rookie_year": "2015",
      "city": "Cheboygan",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5693,
      "name": "Springport High School",
      "rookie_year": "2015",
      "city": "Springport",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5694,
      "name": "Hamady Hawks",
      "rookie_year": "2015",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5695,
      "name": "Heavy Duty Eagles",
      "rookie_year": "2015",
      "city": "Redford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5696,
      "name": "Tecmilenio Faraday",
      "rookie_year": "2015",
      "city": "Villahermosa",
      "state": "Tabasco",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5697,
      "name": "Bearcats",
      "rookie_year": "2015",
      "city": "Bridgeport",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5698,
      "name": "Raider Robotics",
      "rookie_year": "2015",
      "city": "Decatur",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5699,
      "name": "Robo Sapiens",
      "rookie_year": "2015",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5700,
      "name": "SOTA Cyberdragons",
      "rookie_year": "2015",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5701,
      "name": "RAIJINbotics",
      "rookie_year": "2015",
      "city": "Machida",
      "state": "T\u00f4ky\u00f4",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 5702,
      "name": "Robotowatomi",
      "rookie_year": "2015",
      "city": "Wilson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5703,
      "name": "Eagles Crew",
      "rookie_year": "2015",
      "city": "Midland",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5704,
      "name": "AUTOGOATS",
      "rookie_year": "2015",
      "city": "Lansing",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5705,
      "name": "DESERT EAGLES",
      "rookie_year": "2015",
      "city": "Torreon",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5706,
      "name": "Tahquamenon Phenomenon",
      "rookie_year": "2015",
      "city": "Newberry",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5707,
      "name": "Roseville High School Robotics",
      "rookie_year": "2015",
      "city": "Roseville",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5708,
      "name": "Zebrotics",
      "rookie_year": "2015",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5709,
      "name": "Rudyard Nerf Herders",
      "rookie_year": "2015",
      "city": "Rudyard",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5710,
      "name": "The O-Bots",
      "rookie_year": "2015",
      "city": "Charlotte",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5711,
      "name": "Battling Bathers",
      "rookie_year": "2015",
      "city": "Mt. Clemens",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5712,
      "name": "Hemlock's Gray Matter",
      "rookie_year": "2015",
      "city": "Hemlock",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5713,
      "name": "Beecher Cyber Bucs",
      "rookie_year": "2015",
      "city": "Mount Morris",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5714,
      "name": "F.R.O.G.S",
      "rookie_year": "2015",
      "city": "Brimley",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5715,
      "name": "DRC",
      "rookie_year": "2015",
      "city": "Dabburiya",
      "state": "HaZafon",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5716,
      "name": "PrepaTec - Keybot",
      "rookie_year": "2015",
      "city": "pachuca",
      "state": "Hidalgo",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5717,
      "name": "Sasquach",
      "rookie_year": "2015",
      "city": "Soddy Daisy",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5718,
      "name": "Campion Bears",
      "rookie_year": "2015",
      "city": "Brampton",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5719,
      "name": "Pink Titans",
      "rookie_year": "2015",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5720,
      "name": "Jagobotics",
      "rookie_year": "2015",
      "city": "Hinckley",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5721,
      "name": "Wolf Pack",
      "rookie_year": "2015",
      "city": "Newark",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5722,
      "name": "Seahawks 5722",
      "rookie_year": "2015",
      "city": "Santa Rosa Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5723,
      "name": "Robert Land Academy",
      "rookie_year": "2015",
      "city": "Wellandport",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5724,
      "name": "Spartan Robotics",
      "rookie_year": "2015",
      "city": "Salem",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5725,
      "name": "Cerberus",
      "rookie_year": "2015",
      "city": "Lethbridge",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5726,
      "name": "RHUMBOTZ",
      "rookie_year": "2015",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5727,
      "name": "Omegabytes",
      "rookie_year": "2015",
      "city": "Spindale",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5728,
      "name": "MC2",
      "rookie_year": "2015",
      "city": "Santa Rosa",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5729,
      "name": "MAD Dragons",
      "rookie_year": "2015",
      "city": "De Witt",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5730,
      "name": "The Professionals ",
      "rookie_year": "2015",
      "city": "Monett",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5731,
      "name": "Tiny Giants",
      "rookie_year": "2015",
      "city": "Yanco",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5732,
      "name": "ROBOTIGERS",
      "rookie_year": "2015",
      "city": "Bloomfield",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5733,
      "name": "NGeek",
      "rookie_year": "2015",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5734,
      "name": "RoboReign",
      "rookie_year": "2015",
      "city": "Augusta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5735,
      "name": "Control Freaks",
      "rookie_year": "2015",
      "city": "Wayland",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5736,
      "name": "Kingsmen Robotics",
      "rookie_year": "2015",
      "city": "Kings Park",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5737,
      "name": "Mars Style",
      "rookie_year": "2015",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5738,
      "name": "warriors",
      "rookie_year": "2015",
      "city": "Central Falls",
      "state": "Rhode Island",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5739,
      "name": "Crestbots",
      "rookie_year": "2015",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5740,
      "name": "Trojanators",
      "rookie_year": "2015",
      "city": "Cranberry Township",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5741,
      "name": "Coyotes",
      "rookie_year": "2015",
      "city": "Alice",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5742,
      "name": "Gators",
      "rookie_year": "2015",
      "city": "Langley",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5743,
      "name": "Robo-Wolves",
      "rookie_year": "2015",
      "city": "Jacksonville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5744,
      "name": "RoboRunners",
      "rookie_year": "2015",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5745,
      "name": "Gearheads",
      "rookie_year": "2015",
      "city": "Three Oaks",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5746,
      "name": "Human Error",
      "rookie_year": "2015",
      "city": "Deep River",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5747,
      "name": "Athena",
      "rookie_year": "2015",
      "city": "Beer Sheva",
      "state": "HaDarom",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5748,
      "name": "Adna Pirate Robotics",
      "rookie_year": "2015",
      "city": "Adna",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5749,
      "name": "Tokyo Technical Samurai",
      "rookie_year": "2015",
      "city": "Aoki,Kawaguchi-shi",
      "state": "Saitama",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 5750,
      "name": "Martian Mechanics",
      "rookie_year": "2015",
      "city": "Naucalpan",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5751,
      "name": "Myerbott",
      "rookie_year": "2015",
      "city": "Deep River",
      "state": "CT",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5752,
      "name": "Bevbotics",
      "rookie_year": "2015",
      "city": "Beverly",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5753,
      "name": "St. Joseph Academy Flashes",
      "rookie_year": "2015",
      "city": "St. Augustine",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5754,
      "name": "Brooks Academy Robotics",
      "rookie_year": "2015",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5755,
      "name": "Central Catholic Robotics",
      "rookie_year": "2015",
      "city": "San Antonio",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5756,
      "name": "REC'in Crew",
      "rookie_year": "2015",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5757,
      "name": "Eagletrons",
      "rookie_year": "2015",
      "city": "Orchard Lake",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5758,
      "name": "C-Bots",
      "rookie_year": "2015",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5759,
      "name": "TroBotics",
      "rookie_year": "2015",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5760,
      "name": "The Marinators",
      "rookie_year": "2015",
      "city": "Marina",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5761,
      "name": "Illawarra",
      "rookie_year": "2015",
      "city": "Cordeaux Heights",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5762,
      "name": "FranklinBots - TEAM HYDRA",
      "rookie_year": "2015",
      "city": "Louisburg",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 5763,
      "name": "Lightning Robotics",
      "rookie_year": "2015",
      "city": "Broomfield",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5764,
      "name": "Grasshopper Bots",
      "rookie_year": "2015",
      "city": "Loch Sheldrake",
      "state": "NY",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5765,
      "name": "ToroBots",
      "rookie_year": "2015",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5766,
      "name": "ET Robotics",
      "rookie_year": "2015",
      "city": "Hawthorn",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5767,
      "name": "VPE and Veritas Robotics",
      "rookie_year": "2015",
      "city": "Duluth",
      "state": "GA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5768,
      "name": "Leuzinger Resistors",
      "rookie_year": "2015",
      "city": "Lawndale",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5769,
      "name": "Radio Rangers R^2",
      "rookie_year": "2015",
      "city": "Santa Fe",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5770,
      "name": "ReMIT ",
      "rookie_year": "2015",
      "city": "Inglewood",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5771,
      "name": "Marfa Robohorns",
      "rookie_year": "2015",
      "city": "Marfa",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5772,
      "name": "The Mighty Morphin Power Bots",
      "rookie_year": "2015",
      "city": "Los Angeles ",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5773,
      "name": "YAFL Mechatronics",
      "rookie_year": "2015",
      "city": "Beylikd\u00fcz\u00fc",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5774,
      "name": "Maximum Overload",
      "rookie_year": "2015",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5775,
      "name": "CRHS RoboCats",
      "rookie_year": "2015",
      "city": "Malakoff",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5776,
      "name": "Phoenix",
      "rookie_year": "2015",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5777,
      "name": "Static Storm",
      "rookie_year": "2015",
      "city": "Sumter",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5778,
      "name": "The Power-Struck Girls",
      "rookie_year": "2015",
      "city": "Marrero",
      "state": "LA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5779,
      "name": "CB Tech",
      "rookie_year": "2015",
      "city": "Moses Lake",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5780,
      "name": "Harvesters",
      "rookie_year": "2015",
      "city": "Pampa",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5781,
      "name": "Petchey Robotics Team ",
      "rookie_year": "2015",
      "city": "London",
      "state": "England",
      "country": "United Kingdom",
      "district": ""
    },
    {
      "number": 5782,
      "name": "Sullivan 4H-Newport",
      "rookie_year": "2015",
      "city": "Newport",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5783,
      "name": "RoboDucks",
      "rookie_year": "2015",
      "city": "Eunice",
      "state": "New Mexico",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5784,
      "name": "Vassar Voltage",
      "rookie_year": "2015",
      "city": "Vassar",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5785,
      "name": "The Shield",
      "rookie_year": "2015",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5786,
      "name": "Pro-Botics",
      "rookie_year": "2015",
      "city": "Irving",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5787,
      "name": "NEXUS Robotics",
      "rookie_year": "2015",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5800,
      "name": "Magic Island Robotics",
      "rookie_year": "2016",
      "city": "FLORIANOPOLIS",
      "state": "Santa Catarina",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 5801,
      "name": "CTC Inspire",
      "rookie_year": "2016",
      "city": "Independence",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5802,
      "name": "Los STEMateros",
      "rookie_year": "2016",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5803,
      "name": "Apex Robotics",
      "rookie_year": "2016",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5804,
      "name": "TORCH",
      "rookie_year": "2016",
      "city": "Henrico",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5805,
      "name": "SMbly Required",
      "rookie_year": "2016",
      "city": "Rancho Santa Margarita",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5806,
      "name": "Basement Lions",
      "rookie_year": "2016",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5807,
      "name": "CANbotics",
      "rookie_year": "2016",
      "city": "North Bay",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5808,
      "name": "Revive Robotics",
      "rookie_year": "2016",
      "city": "Lodi",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5809,
      "name": "The Jesubots",
      "rookie_year": "2016",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5810,
      "name": "X-Bots Robotics",
      "rookie_year": "2016",
      "city": "Whittier",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5811,
      "name": "BONDS",
      "rookie_year": "2016",
      "city": "Dayton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5812,
      "name": "Drewbotics",
      "rookie_year": "2016",
      "city": "Riverdale",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5813,
      "name": "Morpheus",
      "rookie_year": "2016",
      "city": "Concord",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5814,
      "name": "ROBOTA",
      "rookie_year": "2016",
      "city": "Guayaquil",
      "state": "Guayas",
      "country": "Ecuador",
      "district": ""
    },
    {
      "number": 5815,
      "name": "Bond Science Engineer",
      "rookie_year": "2016",
      "city": "SHENZHEN",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5816,
      "name": "Gra-V Robotics",
      "rookie_year": "2016",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5817,
      "name": "Uni-Rex",
      "rookie_year": "2016",
      "city": "Sanger",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5818,
      "name": "Riviera Robotics",
      "rookie_year": "2016",
      "city": "Santa Barbara",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5819,
      "name": "Mecha Makos",
      "rookie_year": "2016",
      "city": "Key Biscayne",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5820,
      "name": "PathFinder",
      "rookie_year": "2016",
      "city": "YuLin",
      "state": "Shanxi",
      "country": "China",
      "district": ""
    },
    {
      "number": 5821,
      "name": "The Saunders Robotics Club",
      "rookie_year": "2016",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5822,
      "name": "WolfByte",
      "rookie_year": "2016",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5823,
      "name": "ACE",
      "rookie_year": "2016",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5824,
      "name": "Orion",
      "rookie_year": "2016",
      "city": "SHANGHAI",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 5825,
      "name": "Amherst Robotics",
      "rookie_year": "2016",
      "city": "Amherstburg",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5826,
      "name": "Avis Automata",
      "rookie_year": "2016",
      "city": "Chippewa Falls",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5827,
      "name": "Code Purple",
      "rookie_year": "2016",
      "city": "Kirkland",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5828,
      "name": "Westover Robotics",
      "rookie_year": "2016",
      "city": "Albany",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5829,
      "name": "AwtyBots",
      "rookie_year": "2016",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5830,
      "name": "LIFE Engineering",
      "rookie_year": "2016",
      "city": "Gambrills",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5831,
      "name": "Revolution Maker",
      "rookie_year": "2016",
      "city": "Macau",
      "state": "Macau",
      "country": "China",
      "district": ""
    },
    {
      "number": 5832,
      "name": "FULL OF AMBITION",
      "rookie_year": "2016",
      "city": "zhongshan",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5833,
      "name": "Team-5833",
      "rookie_year": "2016",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5834,
      "name": "R3P2",
      "rookie_year": "2016",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5835,
      "name": "Sage Robotics",
      "rookie_year": "2016",
      "city": "Newport Coast",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5836,
      "name": "Mechanic Mutts",
      "rookie_year": "2016",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5837,
      "name": "Unity4Tech",
      "rookie_year": "2016",
      "city": "Waterloo",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5838,
      "name": "Mitochondria",
      "rookie_year": "2016",
      "city": "Kunming ",
      "state": "Yunnan",
      "country": "China",
      "district": ""
    },
    {
      "number": 5839,
      "name": "Blue Whales",
      "rookie_year": "2016",
      "city": "Nanjing",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 5840,
      "name": "Shock Wave",
      "rookie_year": "2016",
      "city": "Dawson",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5841,
      "name": "The Patriots",
      "rookie_year": "2016",
      "city": "Frederick",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5842,
      "name": "Royal Robotics",
      "rookie_year": "2016",
      "city": "New Port Richey",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5843,
      "name": "Flurb",
      "rookie_year": "2016",
      "city": "East China",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5844,
      "name": "Phoenix Tech",
      "rookie_year": "2016",
      "city": "Boston",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5845,
      "name": "Twisted Gears",
      "rookie_year": "2016",
      "city": "Athens",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5846,
      "name": "SouthCoast Corsairs",
      "rookie_year": "2016",
      "city": "North Dartmouth",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5847,
      "name": "Ironclad",
      "rookie_year": "2016",
      "city": "Bradley",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5848,
      "name": "ROBO C3",
      "rookie_year": "2016",
      "city": "Edison",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5849,
      "name": "Joker",
      "rookie_year": "2016",
      "city": "Qingdao",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 5850,
      "name": "Guangzhou  lego xueyuan",
      "rookie_year": "2016",
      "city": "Guangzhou",
      "state": "44",
      "country": "China",
      "district": ""
    },
    {
      "number": 5851,
      "name": "Striking Vikings",
      "rookie_year": "2016",
      "city": "Downey",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5852,
      "name": "Illusion Robotics ",
      "rookie_year": "2016",
      "city": "Merced",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5853,
      "name": "FEAR The Termigators",
      "rookie_year": "2016",
      "city": "Ypsilanti",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5854,
      "name": "GLITCH",
      "rookie_year": "2016",
      "city": "Asheville",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5855,
      "name": "Blue Collar Bruisers",
      "rookie_year": "2016",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5856,
      "name": "Bullbots",
      "rookie_year": "2016",
      "city": "Waterbury",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5857,
      "name": "Walnut Valley Robotics",
      "rookie_year": "2016",
      "city": "Walnut",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5858,
      "name": "Golden Hurricane ",
      "rookie_year": "2016",
      "city": "Huntsville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5859,
      "name": "i",
      "rookie_year": "2016",
      "city": "Canton de Hatley",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5860,
      "name": "Full Metal Muskrats",
      "rookie_year": "2016",
      "city": "Algonac",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5861,
      "name": "ManGeKyo",
      "rookie_year": "2016",
      "city": "guangzhou",
      "state": "44",
      "country": "China",
      "district": ""
    },
    {
      "number": 5862,
      "name": "Atomic Disco Robotic Engineers",
      "rookie_year": "2016",
      "city": "concord",
      "state": "VA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5863,
      "name": "Hypercubed",
      "rookie_year": "2016",
      "city": "Brusly",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5864,
      "name": "Robo-Pelicans",
      "rookie_year": "2016",
      "city": "Port Allen",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5865,
      "name": "Droide",
      "rookie_year": "2016",
      "city": "Terrebonne",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5866,
      "name": "Fe [Iron] Tigers",
      "rookie_year": "2016",
      "city": "Wolfforth",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5867,
      "name": "fighters science",
      "rookie_year": "2016",
      "city": "Los Mochis",
      "state": "Sinaloa",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5868,
      "name": "UTM Veracruz",
      "rookie_year": "2016",
      "city": "Veracruz",
      "state": "VER",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5869,
      "name": "QHHS Aqueducks",
      "rookie_year": "2016",
      "city": "Quartz Hill",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5870,
      "name": "League of Logic",
      "rookie_year": "2016",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5871,
      "name": "Chickadees",
      "rookie_year": "2016",
      "city": "Boise",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5872,
      "name": "WiredCats",
      "rookie_year": "2016",
      "city": "Davie",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5873,
      "name": "Farmersville Robotics",
      "rookie_year": "2016",
      "city": "Farmersville",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5874,
      "name": "Tecmilenio Border Bots",
      "rookie_year": "2016",
      "city": "Nuevo Laredo",
      "state": "Tamaulipas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5875,
      "name": "ICE Cubed",
      "rookie_year": "2016",
      "city": "Fernley",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5876,
      "name": "ARTEMIS",
      "rookie_year": "2016",
      "city": "Wahroonga",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5877,
      "name": "Mechalodons",
      "rookie_year": "2016",
      "city": "Corona",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5878,
      "name": "The Great Lakers",
      "rookie_year": "2016",
      "city": "Mackinac Island",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5879,
      "name": "Shadow of Orion",
      "rookie_year": "2016",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5880,
      "name": "AF North HS",
      "rookie_year": "2016",
      "city": "Brunssum",
      "state": "Limburg",
      "country": "Netherlands",
      "district": ""
    },
    {
      "number": 5881,
      "name": "TVHS Dragons",
      "rookie_year": "2016",
      "city": "Albany",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5882,
      "name": "Titan Robotics",
      "rookie_year": "2016",
      "city": "Twin Valley",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5883,
      "name": "Spice Gears",
      "rookie_year": "2016",
      "city": "Krasnik",
      "state": "Lubelskie",
      "country": "Poland",
      "district": ""
    },
    {
      "number": 5884,
      "name": "Gray Storm",
      "rookie_year": "2016",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5885,
      "name": "Villanova WiredCats",
      "rookie_year": "2016",
      "city": "LaSalle",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5886,
      "name": "LAAE",
      "rookie_year": "2016",
      "city": "Hacienda Heights",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5887,
      "name": "PrepaTec-IMPERATOR",
      "rookie_year": "2016",
      "city": "Puebla",
      "state": "Puebla",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5888,
      "name": "M.E.T.A. Robotics",
      "rookie_year": "2016",
      "city": "Lubbock",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5889,
      "name": "Commandobots",
      "rookie_year": "2016",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5890,
      "name": "Tec Milenio Durango",
      "rookie_year": "2016",
      "city": "Durango",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5891,
      "name": "UASGC Robosquad",
      "rookie_year": "2016",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5892,
      "name": "Energy HEROs",
      "rookie_year": "2016",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5893,
      "name": "International Grammar School",
      "rookie_year": "2016",
      "city": "Ultimo",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5894,
      "name": "J.E.H.S. CyberJags",
      "rookie_year": "2016",
      "city": "Edinburg",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5895,
      "name": "Peddie Robotics",
      "rookie_year": "2016",
      "city": "Hightstown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5896,
      "name": "Fire 6",
      "rookie_year": "2016",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5897,
      "name": "APEX Robotics",
      "rookie_year": "2016",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5898,
      "name": "RoboFalcons",
      "rookie_year": "2016",
      "city": "Darlington",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5899,
      "name": "FROST",
      "rookie_year": "2016",
      "city": "Littleton",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5900,
      "name": "Career Blazer Robotics - The Fighting Mongooses",
      "rookie_year": "2016",
      "city": "Dalton",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 5901,
      "name": "Cougar Pack",
      "rookie_year": "2016",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5902,
      "name": "The Wire Clippers",
      "rookie_year": "2016",
      "city": "Portsmouth",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5903,
      "name": "ThorBots",
      "rookie_year": "2016",
      "city": "Westby",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5904,
      "name": "Iron 101",
      "rookie_year": "2016",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 5905,
      "name": "RoboCorps",
      "rookie_year": "2016",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5906,
      "name": "Titanium Badgers",
      "rookie_year": "2016",
      "city": "Bennington",
      "state": "Nebraska",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5907,
      "name": "CC Shambots",
      "rookie_year": "2016",
      "city": "Novi",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5908,
      "name": "Spartans",
      "rookie_year": "2016",
      "city": "Stafford",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5909,
      "name": "Cardinal Gibbons Cyber Chiefs",
      "rookie_year": "2016",
      "city": "Fort Lauderdale",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5910,
      "name": "Supertronix",
      "rookie_year": "2016",
      "city": "Matane",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5911,
      "name": "PARAGON",
      "rookie_year": "2016",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 5912,
      "name": "Heritage Robotics",
      "rookie_year": "2016",
      "city": "Jordan",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5913,
      "name": "Patriotics",
      "rookie_year": "2016",
      "city": "Pequot Lakes",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5914,
      "name": "Robotic Warriors",
      "rookie_year": "2016",
      "city": "Caledonia",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5915,
      "name": "Mercy Midnight Storm",
      "rookie_year": "2016",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5916,
      "name": "ELEKTRON",
      "rookie_year": "2016",
      "city": "Reynosa",
      "state": "Tamaulipas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5917,
      "name": "Supernova",
      "rookie_year": "2016",
      "city": "Mooresville",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5918,
      "name": "Pumatrons",
      "rookie_year": "2016",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5919,
      "name": "JoCo RoBos",
      "rookie_year": "2016",
      "city": "Smithfield",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5920,
      "name": "VIKotics",
      "rookie_year": "2016",
      "city": "Palouse",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5921,
      "name": "Binary Power",
      "rookie_year": "2016",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5922,
      "name": "scots",
      "rookie_year": "2016",
      "city": "Toronto",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5923,
      "name": "WildC.A.T.S.",
      "rookie_year": "2016",
      "city": "Angleton",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5924,
      "name": "Golden Gate Robotics",
      "rookie_year": "2016",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5925,
      "name": "Holden High Robotics",
      "rookie_year": "2016",
      "city": "Holden",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5926,
      "name": "Da MOOse",
      "rookie_year": "2016",
      "city": "Port Huron",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5927,
      "name": "Globetrotters",
      "rookie_year": "2016",
      "city": "Zeeland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5928,
      "name": "MetalBoost",
      "rookie_year": "2016",
      "city": "Petah Tiqua",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5929,
      "name": "The Marauders",
      "rookie_year": "2016",
      "city": "Lake Park",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5930,
      "name": "Lunar Kitties",
      "rookie_year": "2016",
      "city": "Newcastle",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5931,
      "name": "Bots of Prey",
      "rookie_year": "2016",
      "city": "Caldwell",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5932,
      "name": "Tecmilenio Quetzales 5932",
      "rookie_year": "2016",
      "city": "M\u00e9rida",
      "state": "Yucat\u00e1n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5933,
      "name": "JudgeMent Call",
      "rookie_year": "2016",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5934,
      "name": "Crowbotics",
      "rookie_year": "2016",
      "city": "DeKalb",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5935,
      "name": "Tech Tigers",
      "rookie_year": "2016",
      "city": "Grinnell",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5936,
      "name": "TigerBots",
      "rookie_year": "2016",
      "city": "Hanover",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5937,
      "name": "MI-Robotics",
      "rookie_year": "2016",
      "city": "Mercer Island",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5938,
      "name": "Razor Steel Robotics",
      "rookie_year": "2016",
      "city": "Dover",
      "state": "Delaware",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5939,
      "name": "Lakes Lancers",
      "rookie_year": "2016",
      "city": "Lakewood",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5940,
      "name": "BREAD",
      "rookie_year": "2016",
      "city": "Redwood City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5941,
      "name": "Cast Iron Orcas",
      "rookie_year": "2016",
      "city": "Everett",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5942,
      "name": "Warriors",
      "rookie_year": "2016",
      "city": "Walla Walla",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5943,
      "name": "The Bad News Gears",
      "rookie_year": "2016",
      "city": "Carmel",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5944,
      "name": "Robotic Pioneers",
      "rookie_year": "2016",
      "city": "Mooresville",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5945,
      "name": "|CTRL| (Absolute Control)",
      "rookie_year": "2016",
      "city": "Fulton",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5946,
      "name": "The SPartans",
      "rookie_year": "2016",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5947,
      "name": "Robojags",
      "rookie_year": "2016",
      "city": "Belmont",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5948,
      "name": "PrepaTec - Lebotics",
      "rookie_year": "2016",
      "city": "Xochitepec",
      "state": "Morelos",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5949,
      "name": "TechGarage",
      "rookie_year": "2016",
      "city": "Delray Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5950,
      "name": "Trojans",
      "rookie_year": "2016",
      "city": "Dry Fork",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5951,
      "name": "Makers Assemble",
      "rookie_year": "2016",
      "city": "Tel Aviv",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5952,
      "name": "RoBuck",
      "rookie_year": "2016",
      "city": "Verdun",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5953,
      "name": "NOLABOTS",
      "rookie_year": "2016",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5954,
      "name": "Portable Chargers",
      "rookie_year": "2016",
      "city": "Victoria",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 5955,
      "name": "Trailblazers",
      "rookie_year": "2016",
      "city": "Brookhaven",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5956,
      "name": "Falcons",
      "rookie_year": "2016",
      "city": "Milwaukie",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5957,
      "name": "CAT 5 CyberCanes",
      "rookie_year": "2016",
      "city": "Newport News",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5958,
      "name": "Blue Wave Robotics",
      "rookie_year": "2016",
      "city": "Providence",
      "state": "Rhode Island",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5959,
      "name": "PrepaTec - Titanium Rams",
      "rookie_year": "2016",
      "city": "Tampico",
      "state": "Tamaulipas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5960,
      "name": "Mission Eagle ROBO-RANGERS",
      "rookie_year": "2016",
      "city": "Mission",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5961,
      "name": "the pythons",
      "rookie_year": "2016",
      "city": "rehovot",
      "state": "HaMerkaz (Central)",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 5962,
      "name": "perSEVERE",
      "rookie_year": "2016",
      "city": "Lowell",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 5963,
      "name": "CA Frost High School",
      "rookie_year": "2016",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5964,
      "name": "The Praetorians",
      "rookie_year": "2016",
      "city": "Voorheesville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5965,
      "name": "Power Struck Girls",
      "rookie_year": "2016",
      "city": "Marrero",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5966,
      "name": "HB Oiler Robotics",
      "rookie_year": "2016",
      "city": "Huntington Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5967,
      "name": "Freedom FORCE",
      "rookie_year": "2016",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5968,
      "name": "Cyborg Indians",
      "rookie_year": "2016",
      "city": "Manhattan",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5969,
      "name": "English Skunkworks",
      "rookie_year": "2016",
      "city": "Jamaica Plain",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5970,
      "name": "Beavertronics",
      "rookie_year": "2016",
      "city": "Beaverton",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5971,
      "name": "Raider Robotics Team",
      "rookie_year": "2016",
      "city": "Metairie",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5972,
      "name": "Juarezbots",
      "rookie_year": "2016",
      "city": "juarez",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 5973,
      "name": "Moonshots",
      "rookie_year": "2016",
      "city": "Gates Mills",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5974,
      "name": "Mechanical Dragons",
      "rookie_year": "2016",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5975,
      "name": "Beta Blues",
      "rookie_year": "2016",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 5976,
      "name": "CyberSaders",
      "rookie_year": "2016",
      "city": "Waukesha",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5977,
      "name": "Rosemary Rebels+POIC",
      "rookie_year": "2016",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5978,
      "name": "Roboplugs",
      "rookie_year": "2016",
      "city": "Speedway",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5979,
      "name": "Apex",
      "rookie_year": "2016",
      "city": "Columbia",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5980,
      "name": "East Grand Rapids Robotics",
      "rookie_year": "2016",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5981,
      "name": "Thunderbotz",
      "rookie_year": "2016",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5982,
      "name": "Circuits of Destruction",
      "rookie_year": "2016",
      "city": "Merrill",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 5983,
      "name": "Blast Furnace Bots",
      "rookie_year": "2016",
      "city": "Lithgow",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5984,
      "name": "Salina Robocats",
      "rookie_year": "2016",
      "city": "Salina",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5985,
      "name": "Project Bucephalus",
      "rookie_year": "2016",
      "city": "Wollongong",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5986,
      "name": "\u250c Iron Fangs \u2510",
      "rookie_year": "2016",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 5987,
      "name": "Galaxia in memory of David Zohar",
      "rookie_year": "2016",
      "city": "Haifa",
      "state": "Haifa",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5988,
      "name": "Narooma High RoboRebels",
      "rookie_year": "2016",
      "city": "Narooma",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 5989,
      "name": "Panthers",
      "rookie_year": "2016",
      "city": "Ewen",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5990,
      "name": "TRIGON",
      "rookie_year": "2016",
      "city": "Modiin",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 5991,
      "name": "Chargers 5991",
      "rookie_year": "2016",
      "city": "Westbrook",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5992,
      "name": "Pirates",
      "rookie_year": "2016",
      "city": "West Orange",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 5993,
      "name": "Istech Robotics Society",
      "rookie_year": "2016",
      "city": "Florya",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 5994,
      "name": "Captain Retros",
      "rookie_year": "2016",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 5995,
      "name": "Servo Serpents",
      "rookie_year": "2016",
      "city": "Rancho Mirage",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5996,
      "name": "R.U.R.",
      "rookie_year": "2016",
      "city": "Prague",
      "state": "Praha, Hlavn\u00ed m\u011bsto",
      "country": "Czech Republic",
      "district": ""
    },
    {
      "number": 5997,
      "name": "Knightling Boltz",
      "rookie_year": "2016",
      "city": "St. Gabriel",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5998,
      "name": "The Chillbots",
      "rookie_year": "2016",
      "city": "International Falls",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 5999,
      "name": "Byte Force",
      "rookie_year": "2016",
      "city": "Milaca",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6000,
      "name": "Firehawk Robotics",
      "rookie_year": "2016",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6001,
      "name": "CIP",
      "rookie_year": "2016",
      "city": "Medellin",
      "state": "Antioquia",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 6002,
      "name": "ZooBOTix",
      "rookie_year": "2016",
      "city": "Kalamazoo",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6003,
      "name": "SUM",
      "rookie_year": "2016",
      "city": "Buies Creek",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6004,
      "name": "f(x) Robotics",
      "rookie_year": "2016",
      "city": "Smithfield",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6005,
      "name": "Cardinaltronics",
      "rookie_year": "2016",
      "city": "Custer",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6006,
      "name": "Albury High School",
      "rookie_year": "2016",
      "city": "Albury",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6007,
      "name": "RoboPod",
      "rookie_year": "2016",
      "city": "laurieton",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6008,
      "name": "Lions",
      "rookie_year": "2016",
      "city": "Surrey",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6009,
      "name": "CYBERHEART",
      "rookie_year": "2016",
      "city": "Etobicoke",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6010,
      "name": "Tecmilenio - Teravolts - 6010",
      "rookie_year": "2016",
      "city": "MAZATLAN",
      "state": "Sinaloa",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6011,
      "name": "Cyber Trojans",
      "rookie_year": "2016",
      "city": "Sturgis",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6012,
      "name": "STEAMROLLERS",
      "rookie_year": "2016",
      "city": "Bedford",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6013,
      "name": "Robowolves",
      "rookie_year": "2016",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6014,
      "name": "ARC",
      "rookie_year": "2016",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6015,
      "name": "Juicy Bots",
      "rookie_year": "2016",
      "city": "Hackensack",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6016,
      "name": "Tiger Robotics",
      "rookie_year": "2016",
      "city": "Hackettstown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6017,
      "name": "PrepaTec - Cyberius + Abtomat + Rockin Robots",
      "rookie_year": "2016",
      "city": "Santa Catarina NL / Le\u00f3n GTO / Tuxtla Gutierrez CHIS",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6018,
      "name": "TICK",
      "rookie_year": "2016",
      "city": "Lanzhou",
      "state": "Gansu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6019,
      "name": "Metabots",
      "rookie_year": "2016",
      "city": "Metamora",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6020,
      "name": "John Glenn Robotics",
      "rookie_year": "2016",
      "city": "Bay City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6021,
      "name": "Team T.I.G.E.R.S",
      "rookie_year": "2016",
      "city": "Sussex",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6022,
      "name": "Wrench Warmers",
      "rookie_year": "2016",
      "city": "Blooming Prairie",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6023,
      "name": "DISCBOTS",
      "rookie_year": "2016",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6024,
      "name": "R Factor",
      "rookie_year": "2016",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 6025,
      "name": "Adroit Androids",
      "rookie_year": "2016",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6026,
      "name": "Tiger Strike",
      "rookie_year": "2016",
      "city": "Broken Arrow",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6027,
      "name": "Brain Waves",
      "rookie_year": "2016",
      "city": "Newark",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6028,
      "name": "Rs Artisan",
      "rookie_year": "2016",
      "city": "Wuhan",
      "state": "Hubei",
      "country": "China",
      "district": ""
    },
    {
      "number": 6029,
      "name": "Railbots",
      "rookie_year": "2016",
      "city": "Lincoln Park",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6030,
      "name": "Tarbiya 360",
      "rookie_year": "2016",
      "city": "Sacramento",
      "state": "CA",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6031,
      "name": "Falcons",
      "rookie_year": "2016",
      "city": "Pentwater",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6032,
      "name": "Pirate Robotics",
      "rookie_year": "2016",
      "city": "Dayton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6033,
      "name": "Gadget Agents (HS)",
      "rookie_year": "2016",
      "city": "Beal City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6034,
      "name": "Eagle Storm",
      "rookie_year": "2016",
      "city": "Florissant",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6035,
      "name": "House of Ulladulla",
      "rookie_year": "2016",
      "city": "Ulladulla",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6036,
      "name": "Peninsula Robotics",
      "rookie_year": "2016",
      "city": "Palo Alto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6037,
      "name": "Vikings 51",
      "rookie_year": "2016",
      "city": "Huntersville",
      "state": "NC",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6038,
      "name": "ITOBOT",
      "rookie_year": "2016",
      "city": "Bayrampasa",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6039,
      "name": "Cypress Circuits",
      "rookie_year": "2016",
      "city": "Pebble Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6040,
      "name": "Getobotics",
      "rookie_year": "2016",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6041,
      "name": "Cougar Robotics",
      "rookie_year": "2016",
      "city": "Lethbridge",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6042,
      "name": "Robocamp",
      "rookie_year": "2016",
      "city": "Calera",
      "state": "Cundinamarca",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 6043,
      "name": "Tesla Tigers",
      "rookie_year": "2016",
      "city": "Allegan",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6044,
      "name": "Circuit Breakers",
      "rookie_year": "2016",
      "city": "Moose Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6045,
      "name": "Sabre Robotics",
      "rookie_year": "2016",
      "city": "Sartell",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6046,
      "name": "Tecking",
      "rookie_year": "2016",
      "city": "King City",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6047,
      "name": "Proctor Frostbyte",
      "rookie_year": "2016",
      "city": "Proctor",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6048,
      "name": "Ant-valanche",
      "rookie_year": "2016",
      "city": "Quer\u00e9taro",
      "state": "Quer\u00e9taro",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6049,
      "name": "Pegasus",
      "rookie_year": "2016",
      "city": "Dimona",
      "state": "HaDarom",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 6050,
      "name": "Wee Waa Bush Bots",
      "rookie_year": "2016",
      "city": "Wee Waa",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6051,
      "name": "Rockta\u03c0",
      "rookie_year": "2016",
      "city": "Converse",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6052,
      "name": "Clarke Road Trojans",
      "rookie_year": "2016",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6053,
      "name": "Robusters",
      "rookie_year": "2016",
      "city": "Colon",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6054,
      "name": "The Dukes",
      "rookie_year": "2016",
      "city": "Alliance",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6055,
      "name": "BOSS",
      "rookie_year": "2016",
      "city": "Batesville",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6056,
      "name": "Brotherhood of Steel",
      "rookie_year": "2016",
      "city": "Rothsay",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6057,
      "name": "Thunderbots",
      "rookie_year": "2016",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6058,
      "name": "ROBOTURK",
      "rookie_year": "2016",
      "city": "Besiktas",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6059,
      "name": "System Overload Robotics",
      "rookie_year": "2016",
      "city": "Livermore",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6060,
      "name": "Circuit Serpents",
      "rookie_year": "2016",
      "city": "Rosamond",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6061,
      "name": "Carbon Crusaders",
      "rookie_year": "2016",
      "city": "Muswellbrook",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6062,
      "name": "WHAM (Willyama High Advanced Mechatronics)",
      "rookie_year": "2016",
      "city": "Broken Hill",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6063,
      "name": "QLD Pineapples",
      "rookie_year": "2016",
      "city": "Rothwell",
      "state": "Queensland",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6064,
      "name": "IstanBULLS",
      "rookie_year": "2016",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6065,
      "name": "Titanium Dragons",
      "rookie_year": "2016",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6066,
      "name": "Rambler Robotics",
      "rookie_year": "2016",
      "city": "McBain",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6067,
      "name": "Underdogs",
      "rookie_year": "2016",
      "city": "Saint Charles",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6068,
      "name": "Delta Overload",
      "rookie_year": "2016",
      "city": "Indianola",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6069,
      "name": "BHS Robotics",
      "rookie_year": "2016",
      "city": "Bloomington",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6070,
      "name": "Gryphon Machine",
      "rookie_year": "2016",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6071,
      "name": "The Aluminators",
      "rookie_year": "2016",
      "city": "Bay City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6072,
      "name": "Triton Tech",
      "rookie_year": "2016",
      "city": "Newport Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6073,
      "name": "Cav-Bots",
      "rookie_year": "2016",
      "city": "Carrollton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6074,
      "name": "RoboBucks",
      "rookie_year": "2016",
      "city": "Roscommon",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6075,
      "name": "Leland Zebrotics",
      "rookie_year": "2016",
      "city": "Leland",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6076,
      "name": "Mustang Mechanica",
      "rookie_year": "2016",
      "city": "Northport",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6077,
      "name": "Wiking Kujon",
      "rookie_year": "2016",
      "city": "Posen",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6078,
      "name": "RoboRams",
      "rookie_year": "2016",
      "city": "Holt",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6079,
      "name": "JET SET",
      "rookie_year": "2016",
      "city": "Powers",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6080,
      "name": "A.D. Johnston First",
      "rookie_year": "2016",
      "city": "Bessemer",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6081,
      "name": "Digital Dislocators",
      "rookie_year": "2016",
      "city": "Manchester",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6082,
      "name": "Calgary Tech Coalition (CTC)",
      "rookie_year": "2016",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6083,
      "name": "Overlooking",
      "rookie_year": "2016",
      "city": "Chiayi",
      "state": "Chiayi",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 6084,
      "name": "Swoop Robotics",
      "rookie_year": "2016",
      "city": "Cincinnati",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6085,
      "name": "Green Devil Bots",
      "rookie_year": "2016",
      "city": "Brown City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6086,
      "name": "Ignition",
      "rookie_year": "2016",
      "city": "Mt. Morris",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6087,
      "name": "Cybertronic Lancers",
      "rookie_year": "2016",
      "city": "Ellsworth",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6088,
      "name": "Stephenson Eagles",
      "rookie_year": "2016",
      "city": "Stephenson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6089,
      "name": "Cyber Cougars",
      "rookie_year": "2016",
      "city": "Dearborn Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6090,
      "name": "Wayland Wildcats",
      "rookie_year": "2016",
      "city": "Wayland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6091,
      "name": "Eagle 1",
      "rookie_year": "2016",
      "city": "Deckerville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6092,
      "name": "Q-Bots",
      "rookie_year": "2016",
      "city": "Quincy",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6093,
      "name": "Unplugged",
      "rookie_year": "2016",
      "city": "Sandusky",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6094,
      "name": "Manic Mechanics",
      "rookie_year": "2016",
      "city": "Montague",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6095,
      "name": "PARDUX",
      "rookie_year": "2016",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6096,
      "name": "UPSM Cobras",
      "rookie_year": "2016",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6097,
      "name": "Botcats",
      "rookie_year": "2016",
      "city": "Brethren",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6098,
      "name": "bIrobot",
      "rookie_year": "2016",
      "city": "Beaver Island",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6099,
      "name": "Knight Riders",
      "rookie_year": "2016",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6100,
      "name": "MS Mobots",
      "rookie_year": "2016",
      "city": "Morley",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6101,
      "name": "Strange Quarks",
      "rookie_year": "2016",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6102,
      "name": "Mustangs",
      "rookie_year": "2016",
      "city": "Blanchard",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6103,
      "name": "Space Pirates",
      "rookie_year": "2016",
      "city": "Plaquemine",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6104,
      "name": "Desert Eagles",
      "rookie_year": "2016",
      "city": "Ofakim",
      "state": "HaDarom",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 6105,
      "name": "Firebirds with Skills",
      "rookie_year": "2016",
      "city": "Nashville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6106,
      "name": "PrepaTec - TecGear",
      "rookie_year": "2016",
      "city": "Irapuato",
      "state": "Guanajuato",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6107,
      "name": "CyberJagzz",
      "rookie_year": "2016",
      "city": "Huntsville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6108,
      "name": "DRAGONBOTS",
      "rookie_year": "2016",
      "city": "Clinton Township",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6109,
      "name": "Longhorn Robotics",
      "rookie_year": "2016",
      "city": "Payson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6110,
      "name": "Doc Botics",
      "rookie_year": "2016",
      "city": "Ajax",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6111,
      "name": "RoboKnights",
      "rookie_year": "2016",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6112,
      "name": "Cyberstangs",
      "rookie_year": "2016",
      "city": "Munising",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6113,
      "name": "M.A.R.C. 1",
      "rookie_year": "2016",
      "city": "Menominee",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6114,
      "name": "Hamilton CyberHawks",
      "rookie_year": "2016",
      "city": "Hamilton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6115,
      "name": "Ellington Saints",
      "rookie_year": "2016",
      "city": "Grand Rapids",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6116,
      "name": "Cougar Robotics",
      "rookie_year": "2016",
      "city": "Garden City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6117,
      "name": "Wingspan",
      "rookie_year": "2016",
      "city": "Pontiac",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6118,
      "name": "Dunedoo Central School",
      "rookie_year": "2016",
      "city": "Dunedoo",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6119,
      "name": "Prototype Pumas",
      "rookie_year": "2016",
      "city": "Coldwater",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6120,
      "name": "CyberStangs",
      "rookie_year": "2016",
      "city": "New Haven",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6121,
      "name": "RoboVikes",
      "rookie_year": "2016",
      "city": "Grayling",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6122,
      "name": "Potential Energy",
      "rookie_year": "2016",
      "city": "Bear Lake",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6123,
      "name": "Mad Scientist Club",
      "rookie_year": "2016",
      "city": "Lake Elsinore",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6124,
      "name": "Overdrive",
      "rookie_year": "2016",
      "city": "Fontana",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6125,
      "name": "Jagbots",
      "rookie_year": "2016",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6126,
      "name": "Robo-Blazers",
      "rookie_year": "2016",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6127,
      "name": "BHS Pumatrons",
      "rookie_year": "2016",
      "city": "Bisbee",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6128,
      "name": "M.O.T.O.R (More Than Our Robot)",
      "rookie_year": "2016",
      "city": "Hart",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6129,
      "name": "Warp Speed, Scotty !",
      "rookie_year": "2016",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6130,
      "name": "Vipers",
      "rookie_year": "2016",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6131,
      "name": "NLR Robotics",
      "rookie_year": "2016",
      "city": "North Little Rock",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6132,
      "name": "Iron Rangers",
      "rookie_year": "2016",
      "city": "Crosby",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6133,
      "name": "b a s h",
      "rookie_year": "2016",
      "city": "North Richland Hills",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6134,
      "name": "Robo Ram",
      "rookie_year": "2016",
      "city": "Zapopan",
      "state": "Jalisco",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6135,
      "name": "Arctos",
      "rookie_year": "2016",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6136,
      "name": "The Robo Ravens 6136",
      "rookie_year": "2016",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6137,
      "name": "Falcon Robotics",
      "rookie_year": "2016",
      "city": "Constantine",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6138,
      "name": "Dogbotics 1",
      "rookie_year": "2016",
      "city": "Centreville",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6139,
      "name": "ThunderBotz",
      "rookie_year": "2016",
      "city": "Dublin",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6140,
      "name": "SMT Titans",
      "rookie_year": "2016",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6141,
      "name": "O'Connor Robotics",
      "rookie_year": "2016",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6142,
      "name": "Cross Keys High School",
      "rookie_year": "2016",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6143,
      "name": "APEX Automation",
      "rookie_year": "2016",
      "city": "Sarver",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6144,
      "name": "Angelbots Gold",
      "rookie_year": "2016",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6145,
      "name": "War Eagles",
      "rookie_year": "2016",
      "city": "Crawfordville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6146,
      "name": "Blackjacks",
      "rookie_year": "2016",
      "city": "Dawson",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6147,
      "name": "Tonkabots",
      "rookie_year": "2016",
      "city": "Mound",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6148,
      "name": "CASS Electro Knights",
      "rookie_year": "2016",
      "city": "Woodstock",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6149,
      "name": "hand by hand",
      "rookie_year": "2016",
      "city": "arara negev",
      "state": "HaDarom",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 6150,
      "name": "BlueBotics",
      "rookie_year": "2016",
      "city": "Adrian",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6151,
      "name": "Red Devil Robotics",
      "rookie_year": "2016",
      "city": "Ironwood",
      "state": "MI",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6152,
      "name": "Robo-Falcons",
      "rookie_year": "2016",
      "city": "DEARBORN HEIGHTS",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6153,
      "name": "Blue Crew",
      "rookie_year": "2016",
      "city": "Farmington",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6154,
      "name": "Universal Robots",
      "rookie_year": "2016",
      "city": "Frederikssund",
      "state": "South Denmark",
      "country": "Denmark",
      "district": ""
    },
    {
      "number": 6155,
      "name": "ElektraBots",
      "rookie_year": "2016",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6156,
      "name": "PrepaTec - Infinity Robotics Team",
      "rookie_year": "2016",
      "city": "Ciudad Obregon",
      "state": "Sonora",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6157,
      "name": "Marshall Mechs",
      "rookie_year": "2016",
      "city": "Benton",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6158,
      "name": "PiRbot2",
      "rookie_year": "2016",
      "city": "Birmingham",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6159,
      "name": "ALIANZA MEDELLIN",
      "rookie_year": "2016",
      "city": "Medellin",
      "state": "Antioquia",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 6160,
      "name": "Bombatrons",
      "rookie_year": "2016",
      "city": "Barnum",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6161,
      "name": "Equilibrium",
      "rookie_year": "2016",
      "city": "Gray",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6162,
      "name": "Cap Alpaca 6162",
      "rookie_year": "2016",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6163,
      "name": "Mustangs",
      "rookie_year": "2016",
      "city": "Birmingham",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6164,
      "name": "Moonshot Slaybots",
      "rookie_year": "2016",
      "city": "Dike",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6165,
      "name": "Aurora",
      "rookie_year": "2016",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6166,
      "name": "Thorobotics",
      "rookie_year": "2016",
      "city": "Holmen",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6167,
      "name": "CB Bearbots",
      "rookie_year": "2016",
      "city": "Hemingway",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6168,
      "name": "alzahrawi",
      "rookie_year": "2016",
      "city": "iksal",
      "state": "HaZafon",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 6169,
      "name": "Chaos Squad",
      "rookie_year": "2016",
      "city": "Lacombe",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6170,
      "name": "Tecmilenio Vitronik",
      "rookie_year": "2016",
      "city": "San Luis Potos\u00ed",
      "state": "San Luis Potos\u00ed",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6171,
      "name": "\u269b Chain Reaction \u269b",
      "rookie_year": "2016",
      "city": "Plano",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6172,
      "name": "The Mad Dogs",
      "rookie_year": "2016",
      "city": "Fairfield",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6173,
      "name": "Elgin Metal Mayhem",
      "rookie_year": "2016",
      "city": "Elgin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6174,
      "name": "Kaprekar's Constants",
      "rookie_year": "2016",
      "city": "Winters",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6175,
      "name": "EVW Mystery Machine",
      "rookie_year": "2016",
      "city": "Eden Valley-Watkins",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6176,
      "name": "MTS",
      "rookie_year": "2016",
      "city": "MInneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6177,
      "name": "Atomic-Robotic-Dogs",
      "rookie_year": "2016",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6178,
      "name": "Techno Titans",
      "rookie_year": "2016",
      "city": "Moose Jaw",
      "state": "Saskatchewan",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6179,
      "name": "PhotonBox",
      "rookie_year": "2016",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6180,
      "name": "Mechanical Lions",
      "rookie_year": "2016",
      "city": "Mission",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6181,
      "name": "Cryptic Cyborgs",
      "rookie_year": "2016",
      "city": "Archbold",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6182,
      "name": "Royals",
      "rookie_year": "2016",
      "city": "Rogers",
      "state": "MN",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6183,
      "name": "RIGS - Robotics Inspired Greenland Students",
      "rookie_year": "2016",
      "city": "Greenland",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6184,
      "name": "Capital City Chaotic Coders",
      "rookie_year": "2016",
      "city": "Tallahassee",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6185,
      "name": "TV Patriots",
      "rookie_year": "2016",
      "city": "New Madison",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6186,
      "name": "Hope BotCats",
      "rookie_year": "2016",
      "city": "Hope",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6187,
      "name": "Narrabri High School- Kaputar Klockworks",
      "rookie_year": "2016",
      "city": "Narrabri",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6188,
      "name": "Sting Robotics",
      "rookie_year": "2016",
      "city": "Fort Saskatchewan",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6189,
      "name": "Cyber Raiders",
      "rookie_year": "2016",
      "city": "Amelia Court House",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6190,
      "name": "Cybernetic Crusaders",
      "rookie_year": "2016",
      "city": "Canton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6191,
      "name": "RoboKryptonite",
      "rookie_year": "2016",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 6192,
      "name": "IEA Robotim",
      "rookie_year": "2016",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6193,
      "name": "The Legend of Robotics",
      "rookie_year": "2016",
      "city": "Bay City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6194,
      "name": "The Aftershocks",
      "rookie_year": "2016",
      "city": "Cumberland",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6195,
      "name": "GOLDBOTS",
      "rookie_year": "2016",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6196,
      "name": "Spontaneous Disassembly",
      "rookie_year": "2016",
      "city": "College Station",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6197,
      "name": "Semia United",
      "rookie_year": "2016",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6198,
      "name": "Bayou Bots",
      "rookie_year": "2016",
      "city": "Pensacola",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6199,
      "name": "Pe\u00f1oles E-Hawks",
      "rookie_year": "2016",
      "city": "Torre\u00f3n",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6200,
      "name": "PrepaTec - XRAMS",
      "rookie_year": "2016",
      "city": "Ju\u00e1rez",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6201,
      "name": "The Highlanders",
      "rookie_year": "2016",
      "city": "Somerville",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6202,
      "name": "The Centurions",
      "rookie_year": "2016",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6203,
      "name": "Titanium Knights Robotics",
      "rookie_year": "2016",
      "city": "Hackensack",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6204,
      "name": "Team Pedare",
      "rookie_year": "2016",
      "city": "Adelaide",
      "state": "South Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6205,
      "name": "SD Tech",
      "rookie_year": "2016",
      "city": "Shanghai",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6206,
      "name": "Shandong T",
      "rookie_year": "2016",
      "city": "Taiyuan",
      "state": "Shaanxi",
      "country": "China",
      "district": ""
    },
    {
      "number": 6207,
      "name": "Beichen",
      "rookie_year": "2016",
      "city": "Changchun",
      "state": "Jilin",
      "country": "China",
      "district": ""
    },
    {
      "number": 6208,
      "name": "Mechstangs",
      "rookie_year": "2016",
      "city": "Portage",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6209,
      "name": "Robo Warriors",
      "rookie_year": "2016",
      "city": "Lubbock",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6210,
      "name": "The Dragons Lair",
      "rookie_year": "2016",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6211,
      "name": "Hayden Robotics",
      "rookie_year": "2016",
      "city": "Burlington",
      "state": "ON",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6212,
      "name": "Kaniva College",
      "rookie_year": "2016",
      "city": "Kaniva",
      "state": "Victoria",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6213,
      "name": "Team Quantum",
      "rookie_year": "2016",
      "city": "Bowie",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6214,
      "name": "PHEnix",
      "rookie_year": "2016",
      "city": "Burgaw",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6215,
      "name": "Armored Eagles",
      "rookie_year": "2016",
      "city": "Apex",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6216,
      "name": "movers and shakers ",
      "rookie_year": "2016",
      "city": "chester",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6217,
      "name": "Bomb-Botz",
      "rookie_year": "2016",
      "city": "Cannon Falls",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6218,
      "name": "Tecmilenio - TAURUS - 6218 ",
      "rookie_year": "2016",
      "city": "Hermosillo",
      "state": "Sonora",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6219,
      "name": "Cuttin' Edge Robotics",
      "rookie_year": "2016",
      "city": "Blountville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6220,
      "name": "MEME Team",
      "rookie_year": "2016",
      "city": "Los Alamitos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6221,
      "name": "Vandals",
      "rookie_year": "2016",
      "city": "Miami",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6222,
      "name": "Flying Tigers",
      "rookie_year": "2016",
      "city": "Hemingway",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6223,
      "name": "Arsenal Engineering",
      "rookie_year": "2016",
      "city": "Menomonee Falls",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6224,
      "name": "Saint Dominators",
      "rookie_year": "2016",
      "city": "Auburn",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6225,
      "name": "SLC Roarin' Robotics",
      "rookie_year": "2016",
      "city": "Fort Pierce",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6226,
      "name": "Blue Devils",
      "rookie_year": "2016",
      "city": "Burlington",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6227,
      "name": "Robohovers",
      "rookie_year": "2016",
      "city": "Xi'An",
      "state": "Shaanxi",
      "country": "China",
      "district": ""
    },
    {
      "number": 6228,
      "name": "MAT Robotics",
      "rookie_year": "2016",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6229,
      "name": "spartans",
      "rookie_year": "2016",
      "city": "metepec",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6230,
      "name": "Team Koi",
      "rookie_year": "2016",
      "city": "Jerusalem",
      "state": "Yerushalayim",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 6231,
      "name": "AKINCILAR",
      "rookie_year": "2016",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6232,
      "name": "Florya Bisons",
      "rookie_year": "2016",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6233,
      "name": "Phoe-Bots",
      "rookie_year": "2016",
      "city": "Mission",
      "state": "TX",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6234,
      "name": "Madson",
      "rookie_year": "2016",
      "city": "kuna",
      "state": "ID",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6235,
      "name": "Robo-Nerds",
      "rookie_year": "2016",
      "city": "Midlothian",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6236,
      "name": "Robots at The Center of the Universe",
      "rookie_year": "2016",
      "city": "Ashland",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6237,
      "name": "Martin Motion",
      "rookie_year": "2016",
      "city": "Neponset",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6238,
      "name": "POPCORN PENGUINS 6238",
      "rookie_year": "2016",
      "city": "Los Altos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6239,
      "name": "The Irrational Engineers",
      "rookie_year": "2016",
      "city": "Capitol Heights",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6240,
      "name": "Eagles of the Knight",
      "rookie_year": "2016",
      "city": "Warrenton",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6241,
      "name": "CowTech",
      "rookie_year": "2016",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6242,
      "name": "Greene Machine",
      "rookie_year": "2016",
      "city": "Belton",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6243,
      "name": "Raiders Robotics",
      "rookie_year": "2016",
      "city": "Red Deer",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6244,
      "name": "Reese Rockets High School Robotics",
      "rookie_year": "2016",
      "city": "Reese",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6245,
      "name": "Innovos Robotics",
      "rookie_year": "2016",
      "city": "Orange",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6246,
      "name": "Union Knight Robotics",
      "rookie_year": "2016",
      "city": "La Porte City",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6248,
      "name": "Millbrook High School",
      "rookie_year": "2016",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6300,
      "name": "Northwood School Robotics",
      "rookie_year": "2017",
      "city": "Lake Placid",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6301,
      "name": "Nerointellect-sim Engineering & Robot Design Soiree   N.E.R.D.S.",
      "rookie_year": "2017",
      "city": "Taunton",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6302,
      "name": "Red Armadillos",
      "rookie_year": "2017",
      "city": "Greeneville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6303,
      "name": "Citadel",
      "rookie_year": "2017",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6304,
      "name": "EAGLE",
      "rookie_year": "2017",
      "city": "zhenjiang",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6305,
      "name": "Stable Circuits",
      "rookie_year": "2017",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6306,
      "name": "Atonement Academy CrewStators",
      "rookie_year": "2017",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6307,
      "name": "Courtland High School",
      "rookie_year": "2017",
      "city": "Fredericksburg",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6308,
      "name": "SPCS - Hafabots",
      "rookie_year": "2017",
      "city": "Yigo",
      "state": "Guam",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6309,
      "name": "SPCS - Koko Tek",
      "rookie_year": "2017",
      "city": "Yigo",
      "state": "Guam",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6312,
      "name": "Hippocampinae",
      "rookie_year": "2017",
      "city": "Christchurch",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6313,
      "name": "Hippocampus",
      "rookie_year": "2017",
      "city": "Christchurch",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6314,
      "name": "DM Robotics The WolfPack",
      "rookie_year": "2017",
      "city": "Scottsdale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6315,
      "name": "Code Error 404",
      "rookie_year": "2017",
      "city": "Laredo",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6317,
      "name": "Disruptive Innovation",
      "rookie_year": "2017",
      "city": "Davenport",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6318,
      "name": "FE Freedom Engineers",
      "rookie_year": "2017",
      "city": "Freedom",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6319,
      "name": "Tecmilenio ENKI-NOVA 6319",
      "rookie_year": "2017",
      "city": "AHOME",
      "state": "Sinaloa",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6320,
      "name": "Iron Hawks",
      "rookie_year": "2017",
      "city": "Manchester",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6321,
      "name": "\u25a0 R-Cubed  Rouse Raider Robotics \u25a0",
      "rookie_year": "2017",
      "city": "Leander",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6322,
      "name": "ONECLAY A.R.M.O.R.Y.",
      "rookie_year": "2017",
      "city": "Orange Park",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6323,
      "name": "Hayden Robotics",
      "rookie_year": "2017",
      "city": "Burlington",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6324,
      "name": "The Blue Devils",
      "rookie_year": "2017",
      "city": "Salem",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6325,
      "name": "Reset Robotics",
      "rookie_year": "2017",
      "city": "Alpharetta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6326,
      "name": "\u26a1 Baltimore Bolts \u26a1",
      "rookie_year": "2017",
      "city": "Baltimore",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6327,
      "name": "The Fighting Gophers",
      "rookie_year": "2017",
      "city": "Springfield",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6328,
      "name": "Mechanical Advantage",
      "rookie_year": "2017",
      "city": "Littleton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6329,
      "name": "The Bucks' Wrath",
      "rookie_year": "2017",
      "city": "Bucksport",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6330,
      "name": "6330 - Arc Angels",
      "rookie_year": "2017",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6331,
      "name": "Sabotage",
      "rookie_year": "2017",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6332,
      "name": "Bull City Botics",
      "rookie_year": "2017",
      "city": "Durham",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6333,
      "name": "Scavenger Robotics",
      "rookie_year": "2017",
      "city": "Putnam",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6334,
      "name": "Aluminati",
      "rookie_year": "2017",
      "city": "Midlothian",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6335,
      "name": "Terminal Velocity",
      "rookie_year": "2017",
      "city": "Burlington",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6336,
      "name": "Javawockies",
      "rookie_year": "2017",
      "city": "Springwater",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6337,
      "name": "Terror Bytes",
      "rookie_year": "2017",
      "city": "Pittsfield",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6338,
      "name": "DRIVING STEEL",
      "rookie_year": "2017",
      "city": "Macomb",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6339,
      "name": "Pelican Falls First Nations High School",
      "rookie_year": "2017",
      "city": "Sioux Lookout",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6340,
      "name": "The Marist Manatees",
      "rookie_year": "2017",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6341,
      "name": "Firestorm Robotics",
      "rookie_year": "2017",
      "city": "Acworth",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6342,
      "name": "BT Robotics",
      "rookie_year": "2017",
      "city": "Ancaster",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6343,
      "name": "Steel Ridge Robotics",
      "rookie_year": "2017",
      "city": "Ridgefield",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6344,
      "name": "Yale Jiggawattz",
      "rookie_year": "2017",
      "city": "Yale",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6345,
      "name": "Nimrod Nation",
      "rookie_year": "2017",
      "city": "Watersmeet",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6346,
      "name": "Cybears Robotics Team",
      "rookie_year": "2017",
      "city": "Norwalk",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6347,
      "name": "St. James Lions",
      "rookie_year": "2017",
      "city": "Guelph",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6348,
      "name": "PrepaTec - HORUS",
      "rookie_year": "2017",
      "city": "COLIMA",
      "state": "Colima",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6349,
      "name": "Albany High Indians",
      "rookie_year": "2017",
      "city": "Albany",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6350,
      "name": "Clawbots",
      "rookie_year": "2017",
      "city": "Enumclaw",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6351,
      "name": "Rundle College Robotics",
      "rookie_year": "2017",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6352,
      "name": "LAUNCH TEAM",
      "rookie_year": "2017",
      "city": "Surprise",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6353,
      "name": "Zodiac",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6354,
      "name": "Jiayi Superhuman Strength",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6355,
      "name": "Patriots",
      "rookie_year": "2017",
      "city": "Sandusky",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6356,
      "name": "MetaRobotics",
      "rookie_year": "2017",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6357,
      "name": "The Spring Konstant",
      "rookie_year": "2017",
      "city": "Dripping Springs",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6358,
      "name": "The Buhlean Operators",
      "rookie_year": "2017",
      "city": "Buhl",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6359,
      "name": "TechKnow Difficulties",
      "rookie_year": "2017",
      "city": "Aurora",
      "state": "Nebraska",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6360,
      "name": "Quanzhou No.5 Middle School",
      "rookie_year": "2017",
      "city": "Quanzhou",
      "state": "Fujian",
      "country": "China",
      "district": ""
    },
    {
      "number": 6361,
      "name": "The Blazer",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6362,
      "name": "Shengxue Corps",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6363,
      "name": "BirdBots",
      "rookie_year": "2017",
      "city": "El Campo",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6364,
      "name": "Ten Ton Robotics",
      "rookie_year": "2017",
      "city": "West Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6365,
      "name": "Imperial star destroyer",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6366,
      "name": "RAM Rodz Robotics",
      "rookie_year": "2017",
      "city": "Simpsonville",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6367,
      "name": "The ElectroLights",
      "rookie_year": "2017",
      "city": "Dorchester Center",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6368,
      "name": "Unknown",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6369,
      "name": "Mercenary Robotics",
      "rookie_year": "2017",
      "city": "McKinney",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6370,
      "name": "Texas Titans",
      "rookie_year": "2017",
      "city": "Helotes",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6371,
      "name": "Spencer Robotics",
      "rookie_year": "2017",
      "city": "Spencer",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6372,
      "name": "Chi-squared Robotics",
      "rookie_year": "2017",
      "city": "Gilbert",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6373,
      "name": "River City Robotics",
      "rookie_year": "2017",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6374,
      "name": "NanChong Union",
      "rookie_year": "2017",
      "city": "Nan Chong",
      "state": "Sichuan",
      "country": "China",
      "district": ""
    },
    {
      "number": 6375,
      "name": "MC\u00b2",
      "rookie_year": "2017",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6376,
      "name": "Further Dream",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6377,
      "name": "Howdy Bots",
      "rookie_year": "2017",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6378,
      "name": "LYNX",
      "rookie_year": "2017",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6379,
      "name": "Terabyte of Ram",
      "rookie_year": "2017",
      "city": "Pleasant Hill",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6380,
      "name": "ORION ROBOTICS",
      "rookie_year": "2017",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6381,
      "name": "Red Raider Robotics",
      "rookie_year": "2017",
      "city": "Sheboygan",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6382,
      "name": "RoboHornz",
      "rookie_year": "2017",
      "city": "Vista",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6383,
      "name": "PLUG&PLAY",
      "rookie_year": "2017",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6384,
      "name": "Hisar Ravens",
      "rookie_year": "2017",
      "city": "Gokturk ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6385,
      "name": "TrueMoe",
      "rookie_year": "2017",
      "city": "Jinhua",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 6386,
      "name": "Guangzhou research robot club",
      "rookie_year": "2017",
      "city": "GUANGZHOU",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6387,
      "name": "Discobots Canada",
      "rookie_year": "2017",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6388,
      "name": "WonderWorks Robotics",
      "rookie_year": "2017",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6389,
      "name": "Matster Mechanist",
      "rookie_year": "2017",
      "city": "Nanjing",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6390,
      "name": "Hephaestus",
      "rookie_year": "2017",
      "city": "Surrey",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6391,
      "name": "Ursuline Bearbotics",
      "rookie_year": "2017",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6392,
      "name": "Dimension Creator",
      "rookie_year": "2017",
      "city": "Chengdu",
      "state": "Sichuan",
      "country": "China",
      "district": ""
    },
    {
      "number": 6393,
      "name": "Pioneer",
      "rookie_year": "2017",
      "city": "Zhengzhou",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 6394,
      "name": "MITO",
      "rookie_year": "2017",
      "city": "Suzhou",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6395,
      "name": "Xindu No.2 High School ",
      "rookie_year": "2017",
      "city": "Chengdu ",
      "state": "Sichuan",
      "country": "China",
      "district": ""
    },
    {
      "number": 6396,
      "name": "Steel Tempest",
      "rookie_year": "2017",
      "city": "Pensacola",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6397,
      "name": "Romero Robotics",
      "rookie_year": "2017",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6398,
      "name": "Kilo-bots",
      "rookie_year": "2017",
      "city": "Santa Paula",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6399,
      "name": "Tinspiratio",
      "rookie_year": "2017",
      "city": "JINAN",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6400,
      "name": "The Manhattan Project",
      "rookie_year": "2017",
      "city": "Manhattan",
      "state": "Montana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6401,
      "name": "8-bit RAMs",
      "rookie_year": "2017",
      "city": "New City",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6402,
      "name": "GOKTURKLER | GTR",
      "rookie_year": "2017",
      "city": "\u0130STANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6403,
      "name": "D.P. Todd Secondary",
      "rookie_year": "2017",
      "city": "Prince George",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6404,
      "name": "Brazilian Storm",
      "rookie_year": "2017",
      "city": "S\u00e3o Jos\u00e9 dos Campos",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 6405,
      "name": "EntreBots",
      "rookie_year": "2017",
      "city": "Palmdale",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6406,
      "name": "Cyber/Scorpions",
      "rookie_year": "2017",
      "city": "Salt Spring Island",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6407,
      "name": "Tecmilenio - DEVOLT - 6407",
      "rookie_year": "2017",
      "city": "Chihuahua",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6408,
      "name": "Syntechs Robotics",
      "rookie_year": "2017",
      "city": "Port Moody",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6409,
      "name": "Odrinias",
      "rookie_year": "2017",
      "city": "Edirne",
      "state": "Edirne",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6410,
      "name": "Supreme Eagles",
      "rookie_year": "2017",
      "city": "Salinas",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6411,
      "name": "Gravediggers",
      "rookie_year": "2017",
      "city": "Sandy",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6412,
      "name": "For Sale By Owner",
      "rookie_year": "2017",
      "city": "Cedar Rapids",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6413,
      "name": "Degrees of Freedom",
      "rookie_year": "2017",
      "city": "Chandler",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6414,
      "name": "Voyager",
      "rookie_year": "2017",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6415,
      "name": "GULTEPE ROBOTICS",
      "rookie_year": "2017",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6416,
      "name": "MEVOLUTION ROBOTIC TEAM",
      "rookie_year": "2017",
      "city": "B\u00fcy\u00fck\u00e7ekmece",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6417,
      "name": "Fridolins",
      "rookie_year": "2017",
      "city": "Glarus",
      "state": "Glarus",
      "country": "Switzerland",
      "district": ""
    },
    {
      "number": 6418,
      "name": "The Missfits",
      "rookie_year": "2017",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6419,
      "name": "ICE",
      "rookie_year": "2017",
      "city": "West Des Moines",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6420,
      "name": "Fire Island Robotics",
      "rookie_year": "2017",
      "city": "Muscatine",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6421,
      "name": "WarriorBots",
      "rookie_year": "2017",
      "city": "Muskego",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6422,
      "name": "GearHeadz",
      "rookie_year": "2017",
      "city": "Rocky Point",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6423,
      "name": "Ward Melville Iron Patriots",
      "rookie_year": "2017",
      "city": "East Setauket",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6424,
      "name": "Stealth Panther Robotics",
      "rookie_year": "2017",
      "city": "Knob Noster",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6425,
      "name": "The Conclave",
      "rookie_year": "2017",
      "city": "Coldwater",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6426,
      "name": "Robo Gladiators",
      "rookie_year": "2017",
      "city": "Durham",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6427,
      "name": "Glendale",
      "rookie_year": "2017",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6428,
      "name": "STEMINEERS",
      "rookie_year": "2017",
      "city": "Coopersville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6429,
      "name": "4th Dimension",
      "rookie_year": "2017",
      "city": "Bornova",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6430,
      "name": "Kalsedon&RoboAnt",
      "rookie_year": "2017",
      "city": "Eski\u015fehir",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6431,
      "name": "NoktaParantez",
      "rookie_year": "2017",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6432,
      "name": "St Cathodes",
      "rookie_year": "2017",
      "city": "Waverley",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6433,
      "name": "HZ4Z",
      "rookie_year": "2017",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 6434,
      "name": "Bossley Park High School",
      "rookie_year": "2017",
      "city": "Bossley Park",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6435,
      "name": "Jetson's Robotics",
      "rookie_year": "2017",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6436,
      "name": "PARS ROBOTICS",
      "rookie_year": "2017",
      "city": "Basaksehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6437,
      "name": "The Pacific Quakers",
      "rookie_year": "2017",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6438,
      "name": "MEF THUNDER FTD",
      "rookie_year": "2017",
      "city": "Besiktas",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6439,
      "name": "tanx",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6440,
      "name": "Canobolas",
      "rookie_year": "2017",
      "city": "Orange",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6441,
      "name": "Turbo Turtle",
      "rookie_year": "2017",
      "city": "Nanjing",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6442,
      "name": "Modern Americans",
      "rookie_year": "2017",
      "city": "Pendleton",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6443,
      "name": "AEMBOT",
      "rookie_year": "2017",
      "city": "Hillsboro",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6444,
      "name": "PrepaTec Chihuahua- Sigma Robotics",
      "rookie_year": "2017",
      "city": "Chihuahua",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6445,
      "name": "CTEC Robotics",
      "rookie_year": "2017",
      "city": "Salem",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6446,
      "name": "Redhawks",
      "rookie_year": "2017",
      "city": "Blythewood",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6447,
      "name": "Bad 2 the Bone - Bingara Central School",
      "rookie_year": "2017",
      "city": "Bingara",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6448,
      "name": "LBJ Early College High School ",
      "rookie_year": "2017",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6449,
      "name": "DigiBots",
      "rookie_year": "2017",
      "city": "Warnbro",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6450,
      "name": "The Reaper",
      "rookie_year": "2017",
      "city": "Jinhua ",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 6451,
      "name": "Wired Warriors",
      "rookie_year": "2017",
      "city": "Whiteland",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 6452,
      "name": "GPrep Thumpin Pup",
      "rookie_year": "2017",
      "city": "Spokane",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6453,
      "name": "Bog Bots!",
      "rookie_year": "2017",
      "city": "Kelliher",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6454,
      "name": "Chicken Strips",
      "rookie_year": "2017",
      "city": "Pasco",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6455,
      "name": "The Coded Collective",
      "rookie_year": "2017",
      "city": "Waterloo",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6456,
      "name": "Oregon Trail Academy Wi-Fires",
      "rookie_year": "2017",
      "city": "Boring",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6457,
      "name": "Roots Charter High School",
      "rookie_year": "2017",
      "city": "West Valley City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6458,
      "name": "Semiahmoo Robotics",
      "rookie_year": "2017",
      "city": "Surrey",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6459,
      "name": "AG Robotik",
      "rookie_year": "2017",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6460,
      "name": "Air Guardians",
      "rookie_year": "2017",
      "city": "Mansfield",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6461,
      "name": "Iron Stallions",
      "rookie_year": "2017",
      "city": "Wingham",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6462,
      "name": "techJOYnT",
      "rookie_year": "2017",
      "city": "Edmond",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6463,
      "name": "NOVA",
      "rookie_year": "2017",
      "city": "Port Ewen",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6464,
      "name": "Danger Noodle Danger",
      "rookie_year": "2017",
      "city": "Seminole",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6465,
      "name": "Mystic Biscuit",
      "rookie_year": "2017",
      "city": "Bend",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6466,
      "name": "Tiger Tech",
      "rookie_year": "2017",
      "city": "Stanfield",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6467,
      "name": "Tiger Robotics",
      "rookie_year": "2017",
      "city": "Lenox",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6468,
      "name": "The Positronic Panthers",
      "rookie_year": "2017",
      "city": "Ponte Vedra",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6469,
      "name": "Junkyard Dogs",
      "rookie_year": "2017",
      "city": "Goochland",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6470,
      "name": "Templeton STEM",
      "rookie_year": "2017",
      "city": "Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6471,
      "name": "Lee County High School Trobots",
      "rookie_year": "2017",
      "city": "Leesburg",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6472,
      "name": "H-TECH",
      "rookie_year": "2017",
      "city": "uskudar",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6473,
      "name": "Rock Star Robotics",
      "rookie_year": "2017",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6474,
      "name": "Indigo Dynamics",
      "rookie_year": "2017",
      "city": "Fairfield",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6475,
      "name": "Helium-3",
      "rookie_year": "2017",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6476,
      "name": "Supernova Star Squad",
      "rookie_year": "2017",
      "city": "Coonabarabran",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6477,
      "name": "Conqueror of Istanbul",
      "rookie_year": "2017",
      "city": "Buyukcekmece",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6478,
      "name": "CASHS Bot Team",
      "rookie_year": "2017",
      "city": "Seville Grove",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6479,
      "name": "AZTECH Robotics",
      "rookie_year": "2017",
      "city": "Tempe",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6480,
      "name": "SAGE Robotics",
      "rookie_year": "2017",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6481,
      "name": "Deus Ex Machina",
      "rookie_year": "2017",
      "city": "Parkhill",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6482,
      "name": "Wildcat Robotics",
      "rookie_year": "2017",
      "city": "Joseph City",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6483,
      "name": "CHARGER",
      "rookie_year": "2017",
      "city": "JU\u00c1REZ",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6484,
      "name": "TechKnowLogic",
      "rookie_year": "2017",
      "city": "Greenwich",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6485,
      "name": "Mecha Mustangs",
      "rookie_year": "2017",
      "city": "Surrey",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6486,
      "name": "Ten More Tons",
      "rookie_year": "2017",
      "city": "West Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6487,
      "name": "Clockwork Knights",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6488,
      "name": "RoboRams",
      "rookie_year": "2017",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6489,
      "name": "Bronco Robotics",
      "rookie_year": "2017",
      "city": "Zachary",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6490,
      "name": "Panther Robotics",
      "rookie_year": "2017",
      "city": "Geneva",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6491,
      "name": "Short Circuits",
      "rookie_year": "2017",
      "city": "Fairhope",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6492,
      "name": "Pangburn S.W.A.T.",
      "rookie_year": "2017",
      "city": "Pangburn",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6493,
      "name": "Red Steel",
      "rookie_year": "2017",
      "city": "University Center",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6494,
      "name": "Wings of Liberty",
      "rookie_year": "2017",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6495,
      "name": "Future Star",
      "rookie_year": "2017",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6496,
      "name": "AREA 27",
      "rookie_year": "2017",
      "city": "Durham",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6497,
      "name": "Future Forward",
      "rookie_year": "2017",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6498,
      "name": "Castle Robotics",
      "rookie_year": "2017",
      "city": "Newburgh",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 6499,
      "name": "Innovos Robotics",
      "rookie_year": "2017",
      "city": "Orange",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6500,
      "name": "GearCats",
      "rookie_year": "2017",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6502,
      "name": "DARC SIDE",
      "rookie_year": "2017",
      "city": "Durham",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6503,
      "name": "Iron Dragon",
      "rookie_year": "2017",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6504,
      "name": "FCHS Jagwires",
      "rookie_year": "2017",
      "city": "Falls Church",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6505,
      "name": "ElectroPanthers",
      "rookie_year": "2017",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6506,
      "name": "Steel Boot",
      "rookie_year": "2017",
      "city": "Salinas",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6507,
      "name": "Tecmilenio CYBORG HAWKS  6507",
      "rookie_year": "2017",
      "city": "Reynosa",
      "state": "Tamaulipas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6508,
      "name": "Hastings Heroes",
      "rookie_year": "2017",
      "city": "Port Macquarie",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6509,
      "name": "Southern River",
      "rookie_year": "2017",
      "city": "Gosnells",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6510,
      "name": "Pymble Pride",
      "rookie_year": "2017",
      "city": "Pymble",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6511,
      "name": "Oberoi",
      "rookie_year": "2017",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 6512,
      "name": "Coastal CATastrophe",
      "rookie_year": "2017",
      "city": "Shallotte",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6513,
      "name": "The Wyverns",
      "rookie_year": "2017",
      "city": "Woodbridge",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6514,
      "name": "Sutton Robotics League",
      "rookie_year": "2017",
      "city": "Sutton West",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6515,
      "name": "Unimatics",
      "rookie_year": "2017",
      "city": "Calexico",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6516,
      "name": "Robonados",
      "rookie_year": "2017",
      "city": "Lebanon",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6517,
      "name": "So-Kno Robo",
      "rookie_year": "2017",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6518,
      "name": "JagBots",
      "rookie_year": "2017",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6519,
      "name": "The Vegas Vortechs",
      "rookie_year": "2017",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6520,
      "name": "Hanoi Amsterdam School",
      "rookie_year": "2017",
      "city": "Hanoi",
      "state": "Ha Noi",
      "country": "Vietnam",
      "district": ""
    },
    {
      "number": 6521,
      "name": "FPT",
      "rookie_year": "2017",
      "city": "hanoi",
      "state": "Ha Noi",
      "country": "Vietnam",
      "district": ""
    },
    {
      "number": 6522,
      "name": "Tomaree High School",
      "rookie_year": "2017",
      "city": "Salamander Bay",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6523,
      "name": "Condobolin",
      "rookie_year": "2017",
      "city": "Condobolin",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6524,
      "name": "Wilder Wolves FRC",
      "rookie_year": "2017",
      "city": "Seville Grove",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6525,
      "name": "Greater Sydney Robotics",
      "rookie_year": "2017",
      "city": "Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6526,
      "name": "Cyber Rangers",
      "rookie_year": "2017",
      "city": "Garland",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6527,
      "name": "Short SirKit",
      "rookie_year": "2017",
      "city": "Lake Mary",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6528,
      "name": "Terror Bytes",
      "rookie_year": "2017",
      "city": "Gibraltar",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6529,
      "name": "Beantown Blitz",
      "rookie_year": "2017",
      "city": "Roxbury Crossing",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6530,
      "name": "Ra",
      "rookie_year": "2017",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6531,
      "name": "Redhawks",
      "rookie_year": "2017",
      "city": "Cedar Springs",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6532,
      "name": "TechnoPaths",
      "rookie_year": "2017",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6533,
      "name": "BeaverTech",
      "rookie_year": "2017",
      "city": "Beaverton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6534,
      "name": "Saints Scholars",
      "rookie_year": "2017",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6535,
      "name": "Edison Sustainabots",
      "rookie_year": "2017",
      "city": "Huntington Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6536,
      "name": "TheDarkSide",
      "rookie_year": "2017",
      "city": "Vinton",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6537,
      "name": "WIHS Robotics",
      "rookie_year": "2017",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6538,
      "name": "Linc-Bots",
      "rookie_year": "2017",
      "city": "Ypsilanti",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6539,
      "name": "Success Robotics Team",
      "rookie_year": "2017",
      "city": "Ontonagon",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6540,
      "name": "Dynamo",
      "rookie_year": "2017",
      "city": "Mont-Royal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6541,
      "name": "T-FROGS",
      "rookie_year": "2017",
      "city": "LA TALAUDIERE",
      "state": "Loire",
      "country": "France",
      "district": ""
    },
    {
      "number": 6542,
      "name": "Technomancers",
      "rookie_year": "2017",
      "city": "Pittsburg",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6543,
      "name": "pumaTECH",
      "rookie_year": "2017",
      "city": "Oakton",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6544,
      "name": "A-Team Robotics",
      "rookie_year": "2017",
      "city": "Amherstburg",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6545,
      "name": "Tawas Braves",
      "rookie_year": "2017",
      "city": "Tawas City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6546,
      "name": "Naatsis\u02bc\u00e1\u00e1n Robotics",
      "rookie_year": "2017",
      "city": "Navajo Mountain",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6547,
      "name": "Flaming Metal Robotics",
      "rookie_year": "2017",
      "city": "Magnolia",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6548,
      "name": "Perry RAMBOTS",
      "rookie_year": "2017",
      "city": "Perry",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6549,
      "name": "caseville eagles",
      "rookie_year": "2017",
      "city": "Caseville",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6550,
      "name": "Wildcat Robotics ",
      "rookie_year": "2017",
      "city": "Evart",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6551,
      "name": "MOOTeam",
      "rookie_year": "2017",
      "city": "Port Huron",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6552,
      "name": "RoboCats",
      "rookie_year": "2017",
      "city": "Houghton Lake",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6553,
      "name": "Roboticus",
      "rookie_year": "2017",
      "city": "Oxnard",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6554,
      "name": "Phoenix Robotics",
      "rookie_year": "2017",
      "city": "La Mirada",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6555,
      "name": "Ad Astra",
      "rookie_year": "2017",
      "city": "Bursa",
      "state": "Bursa",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6556,
      "name": "Spartan Robotics",
      "rookie_year": "2017",
      "city": "Waldron",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6557,
      "name": "S.R.U - Special Robotics Unit",
      "rookie_year": "2017",
      "city": "Baraga",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6558,
      "name": "Aluminum Sting",
      "rookie_year": "2017",
      "city": "Lanse",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6559,
      "name": "Bay-Arenac",
      "rookie_year": "2017",
      "city": "Bay City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6560,
      "name": "Charging Champions",
      "rookie_year": "2017",
      "city": "Irvine",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6561,
      "name": "Omecha Wolf Pack",
      "rookie_year": "2017",
      "city": "Scottville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6562,
      "name": "She Heroes",
      "rookie_year": "2017",
      "city": "Mercedes",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6563,
      "name": "ROBO CORR",
      "rookie_year": "2017",
      "city": "Quesnel",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6564,
      "name": "TDSS Titans",
      "rookie_year": "2017",
      "city": "Woodbridge",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6565,
      "name": "Team Bobcat",
      "rookie_year": "2017",
      "city": "Arapahoe",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6566,
      "name": "Battering Rams",
      "rookie_year": "2017",
      "city": "Madison Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6567,
      "name": "The Broken Drill Bits ",
      "rookie_year": "2017",
      "city": "Saint Clair Shores",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6568,
      "name": "Decatur Robotics Team",
      "rookie_year": "2017",
      "city": "Decatur",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6569,
      "name": "Gladiators",
      "rookie_year": "2017",
      "city": "Ontonagon",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6570,
      "name": "Whiteford Bobcats",
      "rookie_year": "2017",
      "city": "Ottawa Lake",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6571,
      "name": "Lakeview Wildcats",
      "rookie_year": "2017",
      "city": "Lakeview",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6572,
      "name": "Forest Area",
      "rookie_year": "2017",
      "city": "Fife Lake",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6573,
      "name": "Alanson Viking Robotics",
      "rookie_year": "2017",
      "city": "Alanson",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6574,
      "name": "Ferradermis",
      "rookie_year": "2017",
      "city": "Whitewater",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6575,
      "name": "Tempe T-Rex",
      "rookie_year": "2017",
      "city": "Tempe",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6576,
      "name": "High School Science Education",
      "rookie_year": "2017",
      "city": "Hanoi",
      "state": "Ha Noi",
      "country": "Vietnam",
      "district": ""
    },
    {
      "number": 6577,
      "name": "South City International School",
      "rookie_year": "2017",
      "city": "Kolkata",
      "state": "West Bengal",
      "country": "India",
      "district": ""
    },
    {
      "number": 6578,
      "name": "G D Goenka",
      "rookie_year": "2017",
      "city": "New Delhi",
      "state": "Delhi",
      "country": "India",
      "district": ""
    },
    {
      "number": 6579,
      "name": "Komplete Kaos Inc",
      "rookie_year": "2017",
      "city": "Helensburgh",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6580,
      "name": "Positive Charge",
      "rookie_year": "2017",
      "city": "Marshall",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6581,
      "name": "Hancock Robotics",
      "rookie_year": "2017",
      "city": "Hancock",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6582,
      "name": "Vestabots",
      "rookie_year": "2017",
      "city": "Vestaburg",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6583,
      "name": "Human Error",
      "rookie_year": "2017",
      "city": "Plymouth",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6584,
      "name": "AHC Transformers",
      "rookie_year": "2017",
      "city": "Kensington",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6585,
      "name": "H\u00f3zh\u00f3ogo Naash\u00e1a Doo (Walk in Beauty)",
      "rookie_year": "2017",
      "city": "Many Farms",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6586,
      "name": "Tuskin' Raiders",
      "rookie_year": "2017",
      "city": "Texarkana",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6587,
      "name": "WCA Cougars",
      "rookie_year": "2017",
      "city": "Hillsdale",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6588,
      "name": "Counter-Torque Robotics",
      "rookie_year": "2017",
      "city": "Lawton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6589,
      "name": "Cardinal Robotics",
      "rookie_year": "2017",
      "city": "Bloomingdale",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6590,
      "name": "SaviTech",
      "rookie_year": "2017",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6591,
      "name": "Panther Powered Robotics 6591",
      "rookie_year": "2017",
      "city": "Stockbridge",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6592,
      "name": "Sexton Redbots",
      "rookie_year": "2017",
      "city": "Lansing",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6593,
      "name": "HyperDrive Robotics",
      "rookie_year": "2017",
      "city": "Richmond Hill",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6594,
      "name": "EV ROBOTICS",
      "rookie_year": "2017",
      "city": "Lansing",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6595,
      "name": "QUAKE",
      "rookie_year": "2017",
      "city": "Lansing",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6596,
      "name": "Ashley BearBots",
      "rookie_year": "2017",
      "city": "Ashley",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6597,
      "name": "Eagles",
      "rookie_year": "2017",
      "city": "Saginaw",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6599,
      "name": "Northport Wildcats",
      "rookie_year": "2017",
      "city": "Northport",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6600,
      "name": "Tech Heads",
      "rookie_year": "2017",
      "city": "Baldwin",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6601,
      "name": "Easy Company",
      "rookie_year": "2017",
      "city": "Staten Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6602,
      "name": "Belle Bots",
      "rookie_year": "2017",
      "city": "Little Rock",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6603,
      "name": "Cornerstone Crushers",
      "rookie_year": "2017",
      "city": "Weyburn",
      "state": "Saskatchewan",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6604,
      "name": "Tecmilenio - Equipo ITAC - 6604",
      "rookie_year": "2017",
      "city": "CULIACAN",
      "state": "Sinaloa",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6605,
      "name": "Imperium Fons- 6605 Tecmilenio Cuernavaca",
      "rookie_year": "2017",
      "city": "Cuernavaca",
      "state": "Morelos",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6606,
      "name": "Tecmilenio PINK HAWKS 6606",
      "rookie_year": "2017",
      "city": "Metepec",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6607,
      "name": "Tecmilenio - ARMY ROBOT TECHNOLOGY - 6607",
      "rookie_year": "2017",
      "city": "Veracruz",
      "state": "Veracruz",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6608,
      "name": "Prepa Tecmilenio - ARCADIA",
      "rookie_year": "2017",
      "city": "Tlaquepaque",
      "state": "Jalisco",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6609,
      "name": "Suwannee Bulldogs",
      "rookie_year": "2017",
      "city": "Live Oak",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6610,
      "name": "Robot Roll Call",
      "rookie_year": "2017",
      "city": "Burton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6611,
      "name": "WolverBots",
      "rookie_year": "2017",
      "city": "Au Gres",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6612,
      "name": "NexGen Robotics",
      "rookie_year": "2017",
      "city": "Antioch",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6613,
      "name": "Gogebic Range Robotics",
      "rookie_year": "2017",
      "city": "Hurley",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6614,
      "name": "ROBOTEDIST",
      "rookie_year": "2017",
      "city": "\u0130STANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6615,
      "name": "Belle Voxel - Bots",
      "rookie_year": "2017",
      "city": "Belleville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6616,
      "name": "Mechanical Pumas",
      "rookie_year": "2017",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6617,
      "name": "NASA BHS Black Hawks Robotics Club",
      "rookie_year": "2017",
      "city": "Bellingham",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6618,
      "name": "WARHBOTS",
      "rookie_year": "2017",
      "city": "Flat Rock",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6619,
      "name": "GravitechX",
      "rookie_year": "2017",
      "city": "Livermore",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6620,
      "name": "The Northmengineers",
      "rookie_year": "2017",
      "city": "North Smithfield",
      "state": "Rhode Island",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6621,
      "name": "Artemis Robotics",
      "rookie_year": "2017",
      "city": "Chatham",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6622,
      "name": "Stan Robotix",
      "rookie_year": "2017",
      "city": "Outremont",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6623,
      "name": "Robot Maroc",
      "rookie_year": "2017",
      "city": "Mekn\u00e8s",
      "state": "Mekn\u00e8s",
      "country": "Morocco",
      "district": ""
    },
    {
      "number": 6624,
      "name": "Marinette RoboMarines",
      "rookie_year": "2017",
      "city": "Marinette",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6625,
      "name": "\u0130EA Robotics",
      "rookie_year": "2017",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6626,
      "name": "Robohana",
      "rookie_year": "2017",
      "city": "Andrews",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6627,
      "name": "Niles Nordic Knights",
      "rookie_year": "2017",
      "city": "Niles",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6628,
      "name": "KMS BOTKICKERS",
      "rookie_year": "2017",
      "city": "Kerkhoven",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6629,
      "name": "Concord Boyne Kestrels",
      "rookie_year": "2017",
      "city": "Boyne City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6630,
      "name": "F.U.N.  (Fiercely Uknighted Nation)",
      "rookie_year": "2017",
      "city": "La Porte City",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6631,
      "name": "Rocket Robotics",
      "rookie_year": "2017",
      "city": "Reese",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6632,
      "name": "Northview Robotics",
      "rookie_year": "2017",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6633,
      "name": "Robo-Elephants",
      "rookie_year": "2017",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6634,
      "name": "Tecmilenio Phoenix Forces 6634",
      "rookie_year": "2017",
      "city": "San Nicol\u00e1s de los Garza",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6635,
      "name": "JaXon Falcon Works",
      "rookie_year": "2017",
      "city": "Jackson",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6636,
      "name": "Full Metal Beavers",
      "rookie_year": "2017",
      "city": "Jamaica",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6637,
      "name": "BetaWolves",
      "rookie_year": "2017",
      "city": "Carney",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6638,
      "name": "Fulton Pirates",
      "rookie_year": "2017",
      "city": "Middleton",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6639,
      "name": "The Mechanical Minds",
      "rookie_year": "2017",
      "city": "Hickory",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6640,
      "name": "Metal Eagles",
      "rookie_year": "2017",
      "city": "Mayflower",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6641,
      "name": "GSLRobotX",
      "rookie_year": "2017",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6642,
      "name": "Harrison Stingers of Steel",
      "rookie_year": "2017",
      "city": "Harrison",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6643,
      "name": "Walnuts and Bolts",
      "rookie_year": "2017",
      "city": "Racine",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6644,
      "name": "Atomic Automatons",
      "rookie_year": "2017",
      "city": "Rocklin",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6645,
      "name": "Alloy Obsession",
      "rookie_year": "2017",
      "city": "Crosby",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6646,
      "name": "Belton Robotics Spacemakers",
      "rookie_year": "2017",
      "city": "Belton",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6647,
      "name": "PrepaTec - VOLTEC Robotics",
      "rookie_year": "2017",
      "city": "MONTERREY",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6648,
      "name": "MechaSpartans",
      "rookie_year": "2017",
      "city": "Ozone Park",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6649,
      "name": "CHA Circuits ",
      "rookie_year": "2017",
      "city": "Saint Helen",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6650,
      "name": "Tribebots",
      "rookie_year": "2017",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6651,
      "name": "Golden Bots",
      "rookie_year": "2017",
      "city": "Sterling",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6652,
      "name": "Tigres",
      "rookie_year": "2017",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6653,
      "name": "West Wyalong",
      "rookie_year": "2017",
      "city": "West Wyalong",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6654,
      "name": "Central Robobcatics",
      "rookie_year": "2017",
      "city": "Knoxville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6655,
      "name": "Texan Robotics",
      "rookie_year": "2017",
      "city": "Arlington",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6656,
      "name": "Ryu Botics",
      "rookie_year": "2017",
      "city": "Payson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6657,
      "name": "Arborbotics",
      "rookie_year": "2017",
      "city": "Visalia",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6658,
      "name": "Rockbotics",
      "rookie_year": "2017",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6659,
      "name": "CouBots",
      "rookie_year": "2017",
      "city": "Escondido",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6660,
      "name": "MarkerBots",
      "rookie_year": "2017",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6661,
      "name": "Polaris",
      "rookie_year": "2017",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6662,
      "name": "FalconX",
      "rookie_year": "2017",
      "city": "Pleasant Hill",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6663,
      "name": "Kamikaze Krew",
      "rookie_year": "2017",
      "city": "Onamia",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6664,
      "name": "LADYBOTS",
      "rookie_year": "2017",
      "city": "Pharr",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6665,
      "name": "Nuns and Bolts",
      "rookie_year": "2017",
      "city": "Monterey",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6666,
      "name": "Tecmilenio NORTHERN HAWKS",
      "rookie_year": "2017",
      "city": "Guadalupe",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6667,
      "name": "STEM Clippers",
      "rookie_year": "2017",
      "city": "Chester",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6668,
      "name": "Scorpion ",
      "rookie_year": "2017",
      "city": "Hesperia",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6669,
      "name": "ATL Eagles Robotics",
      "rookie_year": "2017",
      "city": "Delray Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6670,
      "name": "Red Cat Robots",
      "rookie_year": "2017",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6671,
      "name": "Adamas Robotics",
      "rookie_year": "2017",
      "city": "Fort Worth",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6672,
      "name": "Fusion Corps",
      "rookie_year": "2017",
      "city": "Irving",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6673,
      "name": "Alexis Tech Warriors",
      "rookie_year": "2017",
      "city": "Glenevis",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6674,
      "name": "MIT Iron Eagles",
      "rookie_year": "2017",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6675,
      "name": "Ingenious Innovators",
      "rookie_year": "2017",
      "city": "New Britain",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6676,
      "name": "Tecmilenio - Thunder Hawks - 6676",
      "rookie_year": "2017",
      "city": "Obreg\u00f3n",
      "state": "Sonora",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6677,
      "name": "Team Avengers",
      "rookie_year": "2017",
      "city": "Pascagoula",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6678,
      "name": "DKRobotics",
      "rookie_year": "2017",
      "city": "Svendborg",
      "state": "South Denmark",
      "country": "Denmark",
      "district": ""
    },
    {
      "number": 6679,
      "name": "TESLA Robotics",
      "rookie_year": "2017",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6680,
      "name": "TRIObotics",
      "rookie_year": "2017",
      "city": "Pocatello",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6681,
      "name": "FHC Warriors",
      "rookie_year": "2017",
      "city": "Whitehorse",
      "state": "Yukon Territory",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6682,
      "name": "A.S.T.R.O. Vikings",
      "rookie_year": "2017",
      "city": "Alamogordo",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6683,
      "name": "The ROAR-Botics",
      "rookie_year": "2017",
      "city": "Glendale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6684,
      "name": "RoboCats",
      "rookie_year": "2017",
      "city": "Carrizo Springs",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6685,
      "name": "Amped Up",
      "rookie_year": "2017",
      "city": "West Palm Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6686,
      "name": "Bionic Broncos",
      "rookie_year": "2017",
      "city": "West Palm Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6687,
      "name": "Owltronics",
      "rookie_year": "2017",
      "city": "Garland",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6688,
      "name": "West Valley Middle College Robotics Team",
      "rookie_year": "2017",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6689,
      "name": "Robit",
      "rookie_year": "2017",
      "city": "Mexico City ",
      "state": "Distrito Federal",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6690,
      "name": "MV roboPride",
      "rookie_year": "2017",
      "city": "Concord",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6691,
      "name": "Torque",
      "rookie_year": "2017",
      "city": "Wolfeboro",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6692,
      "name": "Robofalcons",
      "rookie_year": "2017",
      "city": "San Bernardino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6693,
      "name": "TrailBLAZERS",
      "rookie_year": "2017",
      "city": "Columbia",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6694,
      "name": "INNOBOTICS",
      "rookie_year": "2017",
      "city": "Mexicali",
      "state": "Baja California",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6695,
      "name": "Alpha Knights",
      "rookie_year": "2017",
      "city": "San Marcos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6696,
      "name": "Cardinal Dynamics",
      "rookie_year": "2017",
      "city": "Corbett",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6697,
      "name": "EUROBOTICS",
      "rookie_year": "2017",
      "city": "\u0130STANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6699,
      "name": "Thunder Robotics",
      "rookie_year": "2017",
      "city": "Atwater",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6700,
      "name": "Patriot Robotics",
      "rookie_year": "2017",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6701,
      "name": "Phoenix ",
      "rookie_year": "2017",
      "city": "Moose Jaw",
      "state": "Saskatchewan",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6702,
      "name": "PrepaTec - StingBots",
      "rookie_year": "2017",
      "city": "Tlajomulco de Zu\u00f1iga",
      "state": "Jalisco",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6703,
      "name": "Prince George Secondary School Robotics Club",
      "rookie_year": "2017",
      "city": "Prince George",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6704,
      "name": "Mid Pacific Owl Robotics",
      "rookie_year": "2017",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6705,
      "name": "WildCat 5e",
      "rookie_year": "2017",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6706,
      "name": "GOLEM",
      "rookie_year": "2017",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6707,
      "name": "RCW Jaguar Robosapiens",
      "rookie_year": "2017",
      "city": "Renville",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6708,
      "name": "Lobos Conalep",
      "rookie_year": "2017",
      "city": "Almoloya del Rio",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6709,
      "name": "Spudinc",
      "rookie_year": "2017",
      "city": "Big Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6710,
      "name": "Southside Robotics",
      "rookie_year": "2017",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6711,
      "name": "Millennial Falcons",
      "rookie_year": "2017",
      "city": "Atwater",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6712,
      "name": "Mountaineers",
      "rookie_year": "2017",
      "city": "Chatsworth",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6714,
      "name": "A. R. Johnson's Panthers",
      "rookie_year": "2017",
      "city": "Augusta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6715,
      "name": "Hephzibah High Robotics",
      "rookie_year": "2017",
      "city": "Hephzibah",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6716,
      "name": "Circuit Br8kers",
      "rookie_year": "2017",
      "city": "Augusta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6717,
      "name": "SPARTANS",
      "rookie_year": "2017",
      "city": "Castle Dale",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6718,
      "name": "Rocket Dogs",
      "rookie_year": "2017",
      "city": "Oakland",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6719,
      "name": "P.O.W.E.R.",
      "rookie_year": "2017",
      "city": "Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6720,
      "name": "Walker-Hackensack-Akeley",
      "rookie_year": "2017",
      "city": "Walker",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6721,
      "name": "Tindley Trailblazers",
      "rookie_year": "2017",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 6722,
      "name": "LED Robotics",
      "rookie_year": "2017",
      "city": "New Port Richey",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6723,
      "name": "Mechanical Mounties",
      "rookie_year": "2017",
      "city": "Williamstown",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6724,
      "name": "Raiders Robotics",
      "rookie_year": "2017",
      "city": "Red Deer",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6725,
      "name": "Westminster WildBOTS",
      "rookie_year": "2017",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6726,
      "name": "MITOX",
      "rookie_year": "2017",
      "city": "Suzhou",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6727,
      "name": "HOT Bots",
      "rookie_year": "2017",
      "city": "Belton",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6728,
      "name": "The Fast and the Curious",
      "rookie_year": "2017",
      "city": "Morrilton",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6729,
      "name": "RobCoBots",
      "rookie_year": "2017",
      "city": "Lumberton",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6730,
      "name": "CCS Nuclear Knights",
      "rookie_year": "2017",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6731,
      "name": "Record Robotics",
      "rookie_year": "2017",
      "city": "Belmont",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6732,
      "name": "BHS RoboRaiders",
      "rookie_year": "2017",
      "city": "Bruce",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6733,
      "name": "PSJA North Raiders",
      "rookie_year": "2017",
      "city": "Pharr",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6734,
      "name": "Sydney TAFE",
      "rookie_year": "2017",
      "city": "Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6735,
      "name": "Rauner College Prep",
      "rookie_year": "2017",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6736,
      "name": "Knights of the Sea",
      "rookie_year": "2017",
      "city": "AKKO",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 6737,
      "name": "H.R.T",
      "rookie_year": "2017",
      "city": "HAIFA",
      "state": "Haifa",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 6738,
      "name": "Excalibur",
      "rookie_year": "2017",
      "city": "Modi'in",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 6739,
      "name": "Tel Shevaa",
      "rookie_year": "2017",
      "city": "tel sheva",
      "state": "HaDarom",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 6740,
      "name": "G3 - Glue Gun & Glitter",
      "rookie_year": "2017",
      "city": "Pardes Hana",
      "state": "Haifa",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 6741,
      "name": "Space monkeys",
      "rookie_year": "2017",
      "city": "rishon le tzion",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 6742,
      "name": "Augmented Jays",
      "rookie_year": "2017",
      "city": "Westland",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6743,
      "name": "Tiger Engineering",
      "rookie_year": "2017",
      "city": "Fort Myers",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6744,
      "name": "Mehville Pi",
      "rookie_year": "2017",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6745,
      "name": "DAPCEP",
      "rookie_year": "2017",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6746,
      "name": "Mustangs",
      "rookie_year": "2017",
      "city": "Syosset",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6747,
      "name": "East Jefferson High School",
      "rookie_year": "2017",
      "city": "Metairie",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6748,
      "name": "MustangRobotics",
      "rookie_year": "2017",
      "city": "Mesa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6749,
      "name": "tERAbytes",
      "rookie_year": "2017",
      "city": "Hopkins",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6750,
      "name": "HenBotix",
      "rookie_year": "2017",
      "city": "McDonough",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6751,
      "name": "RoboFlash",
      "rookie_year": "2017",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6752,
      "name": "charger robotics",
      "rookie_year": "2017",
      "city": "Keller",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6753,
      "name": "CBA RoboKings",
      "rookie_year": "2017",
      "city": "Midland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6754,
      "name": "Trailbots ",
      "rookie_year": "2017",
      "city": "Edinburg",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6755,
      "name": "Overdrive",
      "rookie_year": "2017",
      "city": "Fontana",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6756,
      "name": "Cross Creek Razorbacks",
      "rookie_year": "2017",
      "city": "Augusta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6757,
      "name": "Apex Robotics FPHS",
      "rookie_year": "2017",
      "city": "Forest Park",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6758,
      "name": "Otternauts",
      "rookie_year": "2017",
      "city": "Kasson",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6759,
      "name": "Rebel",
      "rookie_year": "2017",
      "city": "Pearl River",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6762,
      "name": "Oscats",
      "rookie_year": "2017",
      "city": "Hillsborough",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6763,
      "name": "FUSION",
      "rookie_year": "2017",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6764,
      "name": "Flash Drives",
      "rookie_year": "2017",
      "city": "Fillmore",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6765,
      "name": "Columbus City Schools Walnut Ridge Scotts",
      "rookie_year": "2017",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6766,
      "name": "ATOM x SKOLL",
      "rookie_year": "2017",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6768,
      "name": "Denison Robo-Jackets",
      "rookie_year": "2017",
      "city": "Denison",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6769,
      "name": "Future Star",
      "rookie_year": "2017",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6770,
      "name": "Semia United",
      "rookie_year": "2017",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6771,
      "name": "Raven",
      "rookie_year": "2017",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6800,
      "name": "Valor",
      "rookie_year": "2018",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6801,
      "name": "Robot Crabshell ",
      "rookie_year": "2018",
      "city": "Guangzhou",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6802,
      "name": "Mean Caimans",
      "rookie_year": "2018",
      "city": "Cedar Bluff",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6803,
      "name": "HAI-Panda",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6804,
      "name": "Team Wolfpack",
      "rookie_year": "2018",
      "city": "Livingston",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6805,
      "name": "Cyber Jays",
      "rookie_year": "2018",
      "city": "Omaha",
      "state": "Nebraska",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6806,
      "name": "Mineola Wild Reds",
      "rookie_year": "2018",
      "city": "Mineola",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6807,
      "name": "REAL Robotics",
      "rookie_year": "2018",
      "city": "Racine",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6808,
      "name": "William Tennent Robotics",
      "rookie_year": "2018",
      "city": "Warminster",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6809,
      "name": "Ace Robotics",
      "rookie_year": "2018",
      "city": "Enid",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6810,
      "name": "Starship Robotics",
      "rookie_year": "2018",
      "city": "Maringouin",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6811,
      "name": "Gunnery Gears",
      "rookie_year": "2018",
      "city": "Washington",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6812,
      "name": "Andover Snowflakes",
      "rookie_year": "2018",
      "city": "Andover",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6813,
      "name": "Pangaea",
      "rookie_year": "2018",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 6814,
      "name": "Ellipse",
      "rookie_year": "2018",
      "city": "Santa Rosa",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6815,
      "name": "The Memphis MechWarriors",
      "rookie_year": "2018",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6816,
      "name": "POPCORN PENGUINS",
      "rookie_year": "2018",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6817,
      "name": "10 Factorial",
      "rookie_year": "2018",
      "city": "Rolla",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6818,
      "name": "Navigator",
      "rookie_year": "2018",
      "city": "Suzhou",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6819,
      "name": "Viking Robotics",
      "rookie_year": "2018",
      "city": "V\u00e4xj\u00f6",
      "state": "Kronobergs l\u00e4n",
      "country": "Sweden",
      "district": ""
    },
    {
      "number": 6820,
      "name": "Tecmilenio - Scorpion Bots - 6820",
      "rookie_year": "2018",
      "city": "DURANGO",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6821,
      "name": "Rogue Techs",
      "rookie_year": "2018",
      "city": "San Bernardino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6822,
      "name": "THE SHISHKABOTS",
      "rookie_year": "2018",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6823,
      "name": "USM Robotics - Wildcats",
      "rookie_year": "2018",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6824,
      "name": "LVA Robot Pigeons",
      "rookie_year": "2018",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6825,
      "name": "THE STRONGHORNS (FRC6825)",
      "rookie_year": "2018",
      "city": "North Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6826,
      "name": "Experiment 6826",
      "rookie_year": "2018",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6827,
      "name": "hexagon",
      "rookie_year": "2018",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6828,
      "name": "Hazel Green",
      "rookie_year": "2018",
      "city": "Meridianville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6829,
      "name": "Ignite Robotics",
      "rookie_year": "2018",
      "city": "Suwanee",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6830,
      "name": "Hogbotics",
      "rookie_year": "2018",
      "city": "Pharr",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6831,
      "name": "A-05 Annex",
      "rookie_year": "2018",
      "city": "Hood River",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6832,
      "name": "STEAMex",
      "rookie_year": "2018",
      "city": "Santa Catarina",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6833,
      "name": "Phoenix Robotics",
      "rookie_year": "2018",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6834,
      "name": "Bionic Warriors",
      "rookie_year": "2018",
      "city": "Pataskala",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6835,
      "name": "Steel Satyr",
      "rookie_year": "2018",
      "city": "Puebla",
      "state": "Puebla",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6836,
      "name": "The Tinkerers",
      "rookie_year": "2018",
      "city": "Manly",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6837,
      "name": "Tecmilenio - Bellum - 6837",
      "rookie_year": "2018",
      "city": "Azcapotzalco",
      "state": "",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6838,
      "name": "X-SHARC",
      "rookie_year": "2018",
      "city": "\u00c7EKMEK\u00d6Y",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6839,
      "name": "Terminators",
      "rookie_year": "2018",
      "city": "Karditsa",
      "state": "Thessalia",
      "country": "Greece",
      "district": ""
    },
    {
      "number": 6840,
      "name": "Trojan Robotics",
      "rookie_year": "2018",
      "city": "Kirby",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6841,
      "name": "Cerberus 2.0",
      "rookie_year": "2018",
      "city": "Lethbridge",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6842,
      "name": "Polaris",
      "rookie_year": "2018",
      "city": "Marietta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6843,
      "name": "Guardian Gears",
      "rookie_year": "2018",
      "city": "Lees Summit",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6844,
      "name": "Provotypes",
      "rookie_year": "2018",
      "city": "Provo",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6845,
      "name": "River Bots",
      "rookie_year": "2018",
      "city": "Astoria",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 6846,
      "name": "MAGNETUDE",
      "rookie_year": "2018",
      "city": "Murfreesboro",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6847,
      "name": "Les Lions",
      "rookie_year": "2018",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6848,
      "name": "Hades",
      "rookie_year": "2018",
      "city": "Puebla",
      "state": "Puebla",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6849,
      "name": "Juventics",
      "rookie_year": "2018",
      "city": "Guadalupe",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6850,
      "name": "Cell-Ticks",
      "rookie_year": "2018",
      "city": "Ocala",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6851,
      "name": "Empereurs",
      "rookie_year": "2018",
      "city": "Laval",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6852,
      "name": "JV BX",
      "rookie_year": "2018",
      "city": "Temperance",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6853,
      "name": "JaegersTec",
      "rookie_year": "2018",
      "city": "Tuxtla Gutierrez ",
      "state": "Chiapas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6854,
      "name": "Viking Robotics",
      "rookie_year": "2018",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6855,
      "name": "Badger Robotics",
      "rookie_year": "2018",
      "city": "Arkadelphia",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6856,
      "name": "RoboRaptors",
      "rookie_year": "2018",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6857,
      "name": "Mechanized Garbage",
      "rookie_year": "2018",
      "city": "San Fernando",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6858,
      "name": "Fern Creek Tiger Robotics",
      "rookie_year": "2018",
      "city": "Louisville",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6859,
      "name": "BML Robotics",
      "rookie_year": "2018",
      "city": "Bracebridge",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6860,
      "name": "Equitum Robotics",
      "rookie_year": "2018",
      "city": "Paterson",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6861,
      "name": "The Tyros Team",
      "rookie_year": "2018",
      "city": "Livonia",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6862,
      "name": "The Reavers",
      "rookie_year": "2018",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6863,
      "name": "Squirrels",
      "rookie_year": "2018",
      "city": "Woodbine",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6864,
      "name": "Gryphtech Robotics",
      "rookie_year": "2018",
      "city": "Gravenhurst",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6865,
      "name": "Manitoulin Metal 6865",
      "rookie_year": "2018",
      "city": "M'Chigeeng",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6866,
      "name": "Markham Space Invaders",
      "rookie_year": "2018",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6867,
      "name": "Panthera Tech",
      "rookie_year": "2018",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6868,
      "name": "Cadet Robotics",
      "rookie_year": "2018",
      "city": "Hilton",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6869,
      "name": "Gladiateurs",
      "rookie_year": "2018",
      "city": "Saint-Jerome",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6870,
      "name": "BEAM Robotics",
      "rookie_year": "2018",
      "city": "Buffalo",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6871,
      "name": "QC DogSquad",
      "rookie_year": "2018",
      "city": "Queen Creek",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6872,
      "name": "Panthera Ferro",
      "rookie_year": "2018",
      "city": "Brossard",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6873,
      "name": "The Generals",
      "rookie_year": "2018",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6874,
      "name": "IMPERIUM ",
      "rookie_year": "2018",
      "city": "D\u00f6\u015femealt\u0131",
      "state": "Antalya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6875,
      "name": "Amazon Warriors  -  Build A Dream Robotics",
      "rookie_year": "2018",
      "city": "LaSalle",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6876,
      "name": "UHS Wolfpack",
      "rookie_year": "2018",
      "city": "Unionville",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6877,
      "name": "Mechanical Mustangs",
      "rookie_year": "2018",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6878,
      "name": "SJB Odyssey ",
      "rookie_year": "2018",
      "city": "Hamilton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6879,
      "name": "Aquatic Robotics",
      "rookie_year": "2018",
      "city": "Avon",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6880,
      "name": "Universal Serial Brawlers (USB)",
      "rookie_year": "2018",
      "city": "Yorktown Heights",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6881,
      "name": "South Lions Roarbotics",
      "rookie_year": "2018",
      "city": "London",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6882,
      "name": "Fahrenheit Robotics",
      "rookie_year": "2018",
      "city": "Fredericksburg",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6883,
      "name": "Leviathan Robotics",
      "rookie_year": "2018",
      "city": "Santa Rosa",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6884,
      "name": "Deep-Space",
      "rookie_year": "2018",
      "city": "Hollister",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6885,
      "name": "The Pilots",
      "rookie_year": "2018",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6886,
      "name": "Synthesizers",
      "rookie_year": "2018",
      "city": "Warsaw",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6887,
      "name": "Dalton Catabots",
      "rookie_year": "2018",
      "city": "Dalton",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6888,
      "name": "Foothills Robotics",
      "rookie_year": "2018",
      "city": "Hildebran",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6889,
      "name": "DC Current",
      "rookie_year": "2018",
      "city": "Bloomfield",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6890,
      "name": "Legendary Cyber kNights",
      "rookie_year": "2018",
      "city": "Macomb",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6891,
      "name": "Indians",
      "rookie_year": "2018",
      "city": "Asher",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6892,
      "name": "Big Cat Robotics",
      "rookie_year": "2018",
      "city": "Wellsville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6893,
      "name": "Bladerunners",
      "rookie_year": "2018",
      "city": "Greenbelt",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 6894,
      "name": "Iced Java",
      "rookie_year": "2018",
      "city": "Mount Holly",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6895,
      "name": "Mechanical Madness 4-H",
      "rookie_year": "2018",
      "city": "Walpole",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6896,
      "name": "CABOTS",
      "rookie_year": "2018",
      "city": "Heroica Caborca",
      "state": "Sonora",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6897,
      "name": "Astraea Robotics",
      "rookie_year": "2018",
      "city": "East Brunswick",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6898,
      "name": "The Undergraduate School of Carrots ",
      "rookie_year": "2018",
      "city": "Plano",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6899,
      "name": "Macon Bots FRC",
      "rookie_year": "2018",
      "city": "Franklin",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6900,
      "name": "Hoodie-bots",
      "rookie_year": "2018",
      "city": "Maud",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6901,
      "name": "Knights Robotics",
      "rookie_year": "2018",
      "city": "Frisco",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6902,
      "name": "STRIKE",
      "rookie_year": "2018",
      "city": "FOZ DO IGUA\u00c7U",
      "state": "Paran\u00e1",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 6903,
      "name": "MEXICAN HOPE",
      "rookie_year": "2018",
      "city": "METEPEC",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6904,
      "name": "TeraWatts",
      "rookie_year": "2018",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6905,
      "name": "Raiders of the ARC- TEAR-A-BYTE",
      "rookie_year": "2018",
      "city": "Alpharetta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6906,
      "name": "Reybots",
      "rookie_year": "2018",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6907,
      "name": "The G.O.A.T",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6908,
      "name": "Infuzed",
      "rookie_year": "2013",
      "city": "Cary",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6909,
      "name": "SAKURA Tempesta",
      "rookie_year": "2018",
      "city": "Chiba",
      "state": "Chiba",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 6910,
      "name": "Mill Creek Steel Talons",
      "rookie_year": "2018",
      "city": "Hoschton",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6911,
      "name": "SO BOTZ",
      "rookie_year": "2018",
      "city": "Orangeburg",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6912,
      "name": "InterGalactic Transformers",
      "rookie_year": "2018",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6913,
      "name": "North Crawford Robotics Club",
      "rookie_year": "2018",
      "city": "Soldiers Grove",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6914,
      "name": "Retro5ive",
      "rookie_year": "2018",
      "city": "Melvindale",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6915,
      "name": "Bulldogs",
      "rookie_year": "2018",
      "city": "Hesperia",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6916,
      "name": "Iron Thunder",
      "rookie_year": "2018",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6917,
      "name": "Voyageur Robotics",
      "rookie_year": "2018",
      "city": "Atikokan",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6918,
      "name": "Napa Cellar Rats",
      "rookie_year": "2018",
      "city": "Napa",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6919,
      "name": "The Commodores",
      "rookie_year": "2018",
      "city": "Albany",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6920,
      "name": "Force Fusion",
      "rookie_year": "2018",
      "city": "Eindhoven",
      "state": "Noord-Brabant",
      "country": "Netherlands",
      "district": ""
    },
    {
      "number": 6921,
      "name": "Technados",
      "rookie_year": "2018",
      "city": "Pennsauken",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6922,
      "name": "Apache Genesis",
      "rookie_year": "2018",
      "city": "Nogales",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6923,
      "name": "Royal Blue Robotics [RB]^2",
      "rookie_year": "2018",
      "city": "Saint Francisville",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6924,
      "name": "Hogarth Hornets",
      "rookie_year": "2018",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6925,
      "name": "W.A.Robotics",
      "rookie_year": "2018",
      "city": "College Park",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 6926,
      "name": "RobotiCats",
      "rookie_year": "2018",
      "city": "Clovis",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6927,
      "name": "The Franklinton Firebirds",
      "rookie_year": "2018",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6928,
      "name": "Blue Armadillos",
      "rookie_year": "2018",
      "city": "Greeneville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6929,
      "name": "Cuivre & Or",
      "rookie_year": "2018",
      "city": "Rouyn-Noranda",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6930,
      "name": "Hill Robotics",
      "rookie_year": "2018",
      "city": "Staten Island",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6931,
      "name": "The Red Company ",
      "rookie_year": "2018",
      "city": "Tucson",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6932,
      "name": "SMART (Smoky Mountain Academic Robotics Team)",
      "rookie_year": "2018",
      "city": "Sylva",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 6933,
      "name": "Archytas",
      "rookie_year": "2018",
      "city": "Bethel",
      "state": "Vermont",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 6934,
      "name": "Scorps",
      "rookie_year": "2018",
      "city": "Camarillo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6935,
      "name": "The Brainy Bunch- Ingram Tom Moore HS",
      "rookie_year": "2018",
      "city": "Ingram",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6936,
      "name": "Innovation Vault 6936",
      "rookie_year": "2018",
      "city": "Beavercreek",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6937,
      "name": "McCallie Robotics",
      "rookie_year": "2018",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6938,
      "name": "STEM3 West Robotics",
      "rookie_year": "2018",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6939,
      "name": "The Houde Academy",
      "rookie_year": "2018",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6940,
      "name": "Violet Z",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6941,
      "name": "IronPulse Robotics",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6942,
      "name": "SAIE",
      "rookie_year": "2018",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6943,
      "name": "Blue Bears",
      "rookie_year": "2018",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6944,
      "name": "Wolverines",
      "rookie_year": "2018",
      "city": "Cumming",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6945,
      "name": "Children of the Corn",
      "rookie_year": "2018",
      "city": "Blairstown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 6946,
      "name": "F & E",
      "rookie_year": "2018",
      "city": "Kunming",
      "state": "Yunnan",
      "country": "China",
      "district": ""
    },
    {
      "number": 6947,
      "name": "Savage Tumaz",
      "rookie_year": "2018",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 6948,
      "name": "EAGLES",
      "rookie_year": "2018",
      "city": "Kartal",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6949,
      "name": "F.E.W Bots",
      "rookie_year": "2018",
      "city": "Nanjing",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6950,
      "name": "The Breakfast Club",
      "rookie_year": "2018",
      "city": "Stuart",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6951,
      "name": "Spartans",
      "rookie_year": "2018",
      "city": "Porter",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6952,
      "name": "Vector Machines",
      "rookie_year": "2018",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6953,
      "name": "Quetzals",
      "rookie_year": "2018",
      "city": "Brossard",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6954,
      "name": "Titans of Industry",
      "rookie_year": "2018",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6955,
      "name": "Los Chilis",
      "rookie_year": "2018",
      "city": "Santiago",
      "state": "Regi\u00f3n Metropolitana de Santiago",
      "country": "Chile",
      "district": ""
    },
    {
      "number": 6956,
      "name": "SHAM-ROCK-BOTICS \u2618",
      "rookie_year": "2018",
      "city": "Westfield",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 6957,
      "name": "A.C.E.S. (Army of Christian Engineering Students)",
      "rookie_year": "2018",
      "city": "Henderson",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6958,
      "name": "CougarBots",
      "rookie_year": "2018",
      "city": "Warren",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6959,
      "name": "Organized Chaos",
      "rookie_year": "2018",
      "city": "Centralia",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6960,
      "name": "The Rusty Huskies",
      "rookie_year": "2018",
      "city": "Riverside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6961,
      "name": "SIbots",
      "rookie_year": "2018",
      "city": "Spartanburg",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6962,
      "name": "RobotX",
      "rookie_year": "2018",
      "city": "Mountain View",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6963,
      "name": "Blood Sweat and Gears",
      "rookie_year": "2018",
      "city": "Remus",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 6964,
      "name": "BearBots",
      "rookie_year": "2018",
      "city": "Columbus",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6965,
      "name": "Tecmilenio XibalBots 6965",
      "rookie_year": "2018",
      "city": "Cancun",
      "state": "Quintana Roo",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6966,
      "name": "Sons Of God ",
      "rookie_year": "2018",
      "city": "Toluca",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6967,
      "name": "A.T.Vortex",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6968,
      "name": "Team Pi",
      "rookie_year": "2018",
      "city": "Eindhoven",
      "state": "Noord-Brabant",
      "country": "Netherlands",
      "district": ""
    },
    {
      "number": 6969,
      "name": "Cyborgs",
      "rookie_year": "2018",
      "city": "West Nyack",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6970,
      "name": "Barbarian",
      "rookie_year": "2018",
      "city": "Qingdao",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 6971,
      "name": "The Sky Savior",
      "rookie_year": "2018",
      "city": "ZhengZhou",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 6972,
      "name": "NEXUS Robotics",
      "rookie_year": "2018",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6973,
      "name": "Obliq Tech ",
      "rookie_year": "2018",
      "city": "Adama",
      "state": "Oromiya",
      "country": "Ethiopia",
      "district": ""
    },
    {
      "number": 6974,
      "name": "Zia Robotics",
      "rookie_year": "2018",
      "city": "Socorro",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 6975,
      "name": "Neil McNeil Maroonotics",
      "rookie_year": "2018",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6976,
      "name": "Electric Eagles",
      "rookie_year": "2018",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6977,
      "name": "Cyber Squad",
      "rookie_year": "2018",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6978,
      "name": "QuickStrike Niagara",
      "rookie_year": "2018",
      "city": "St. Catharines",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6979,
      "name": "The 5 Nighters",
      "rookie_year": "2018",
      "city": "Lacombe",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6980,
      "name": "VERTIES",
      "rookie_year": "2018",
      "city": "Zhengzhou",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 6981,
      "name": "Clockwork Soldiers",
      "rookie_year": "2018",
      "city": "Concord",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6982,
      "name": "Team CEL Paraguay",
      "rookie_year": "2018",
      "city": "Asunci\u00f3n",
      "state": "Asunci\u00f3n",
      "country": "Paraguay",
      "district": ""
    },
    {
      "number": 6983,
      "name": "Tecmilenio - STEMHAWKS - 6983",
      "rookie_year": "2018",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 6984,
      "name": "Magical Monkey",
      "rookie_year": "2018",
      "city": "Nanjing",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6985,
      "name": "ENKA TECH.",
      "rookie_year": "2018",
      "city": "Dilovas\u0131",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6986,
      "name": "PPT Bots",
      "rookie_year": "2018",
      "city": "Nanjing",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 6987,
      "name": "Falcon Automation",
      "rookie_year": "2018",
      "city": "Fenelon Falls",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 6988,
      "name": "ACI 35",
      "rookie_year": "2018",
      "city": "Izmir",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6989,
      "name": "KAISER",
      "rookie_year": "2018",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6990,
      "name": "Ambition",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6991,
      "name": "Crosbotics",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 6992,
      "name": "FrancoBots",
      "rookie_year": "2018",
      "city": "Sarnia",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 6993,
      "name": "Dragons ",
      "rookie_year": "2018",
      "city": "Lubbock ",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6994,
      "name": "Citadel",
      "rookie_year": "2018",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 6995,
      "name": "NOMAD",
      "rookie_year": "2018",
      "city": "Escondido",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 6996,
      "name": "Koalafied",
      "rookie_year": "2018",
      "city": "Adelaide",
      "state": "South Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 6997,
      "name": "Bad wolf",
      "rookie_year": "2018",
      "city": "Chongqing",
      "state": "Chongqing",
      "country": "China",
      "district": ""
    },
    {
      "number": 6998,
      "name": "NNKIEH",
      "rookie_year": "2018",
      "city": "Tainan",
      "state": "Tainan Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 6999,
      "name": "B.E.S.T.",
      "rookie_year": "2018",
      "city": "Sinop",
      "state": "Sinop",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7000,
      "name": "Newton's 4th Law",
      "rookie_year": "2018",
      "city": "Chengdu",
      "state": "Sichuan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7001,
      "name": "Buning Power",
      "rookie_year": "2018",
      "city": "Zhengzhou ",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7002,
      "name": "\u98ce\u4e91\u8e66\u8c46",
      "rookie_year": "2018",
      "city": "Taiyuan",
      "state": "Shanxi",
      "country": "China",
      "district": ""
    },
    {
      "number": 7003,
      "name": "Robots A-Gogo",
      "rookie_year": "2018",
      "city": "Changhua",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7004,
      "name": "Ossining Orbiters ",
      "rookie_year": "2012",
      "city": "Ossining",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7005,
      "name": "RAHS Phoenix",
      "rookie_year": "2018",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7006,
      "name": "IMC",
      "rookie_year": "2018",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7007,
      "name": "RROOTT",
      "rookie_year": "2018",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 7008,
      "name": "YakRob",
      "rookie_year": "2018",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7009,
      "name": "Carp & Donkey",
      "rookie_year": "2018",
      "city": "ZhengZhou",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7010,
      "name": "SINFEN ROBOTICS",
      "rookie_year": "2018",
      "city": "MERKEZ",
      "state": "Sinop",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7011,
      "name": "ROBOFEN",
      "rookie_year": "2018",
      "city": "ISPARTA",
      "state": "Isparta",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7012,
      "name": "Rainerum Robotics",
      "rookie_year": "2018",
      "city": "Bolzano",
      "state": "Bolzano",
      "country": "Italy",
      "district": ""
    },
    {
      "number": 7013,
      "name": "ACCN Techtronix",
      "rookie_year": "2018",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7014,
      "name": "YIWU TEAM",
      "rookie_year": "2018",
      "city": "yiwu",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7015,
      "name": "Bannerlords",
      "rookie_year": "2018",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7016,
      "name": "PV Shock Bots",
      "rookie_year": "2018",
      "city": "Putnam Valley",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7017,
      "name": "Fellowship of the Gear",
      "rookie_year": "2018",
      "city": "Mesa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7018,
      "name": "Pe\u00f1oles - EOLOTICS",
      "rookie_year": "2018",
      "city": "El Espinal",
      "state": "Oaxaca",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7019,
      "name": "TechNoLogic",
      "rookie_year": "2018",
      "city": "Hopkins",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7020,
      "name": "IM ROBOT",
      "rookie_year": "2018",
      "city": "Iron Mountain",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7021,
      "name": "TC Robotics",
      "rookie_year": "2018",
      "city": "Arcadia",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7022,
      "name": "ACE Robotics",
      "rookie_year": "2018",
      "city": "Cambridge",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7023,
      "name": "Tamworth Titans",
      "rookie_year": "2018",
      "city": "Tamworth",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7024,
      "name": "ENFORCERS",
      "rookie_year": "2018",
      "city": "Egg Harbor Township",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7025,
      "name": "BETA",
      "rookie_year": "2018",
      "city": "Fountain Valley",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7026,
      "name": "Team Vinity",
      "rookie_year": "2018",
      "city": "Fort Lauderdale",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7027,
      "name": "Radioactive Rebels Robotics",
      "rookie_year": "2018",
      "city": "Parish",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7028,
      "name": "Binary Battalion",
      "rookie_year": "2018",
      "city": "Saint Michael",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7029,
      "name": "Scotbotics",
      "rookie_year": "2018",
      "city": "Laurinburg",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7030,
      "name": "Lake Placid Robotics - The ROBOlympians",
      "rookie_year": "2018",
      "city": "Lake Placid",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7031,
      "name": "Duanesburg Jr./Sr. High School",
      "rookie_year": "2018",
      "city": "Delanson",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7032,
      "name": "Raptors",
      "rookie_year": "2018",
      "city": "La Pine",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7033,
      "name": "Roosters",
      "rookie_year": "2018",
      "city": "Medianeira",
      "state": "Paran\u00e1",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7034,
      "name": "2B Determined",
      "rookie_year": "2018",
      "city": "West Linn",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 7035,
      "name": "MEF Thunders",
      "rookie_year": "2018",
      "city": "\u0130stanbul/Be\u015fikta\u015f",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7036,
      "name": "The RoarBots",
      "rookie_year": "2018",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7037,
      "name": "Jeunes d'argent",
      "rookie_year": "2018",
      "city": "Fresnillo",
      "state": "Zacatecas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7038,
      "name": "TG Eagles (Pizza Pi's)",
      "rookie_year": "2018",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7039,
      "name": "\u274c\u2b55",
      "rookie_year": "2018",
      "city": "Kfar hanoar Neurim ",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 7040,
      "name": "POTROBOTS",
      "rookie_year": "2018",
      "city": "TURUACHI",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7041,
      "name": "Doomsday Dogs ",
      "rookie_year": "2018",
      "city": "Carlton",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7042,
      "name": "Poly Rabbotics",
      "rookie_year": "2018",
      "city": "Long Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7043,
      "name": "RoboPirates",
      "rookie_year": "2018",
      "city": "Rocky River",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7044,
      "name": "FeneRobotics",
      "rookie_year": "2018",
      "city": "Atasehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7045,
      "name": "MCCrusaders",
      "rookie_year": "2018",
      "city": "Denville",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 7046,
      "name": "UNIMATE",
      "rookie_year": "2018",
      "city": "San Luis Potos\u00ed",
      "state": "San Luis Potos\u00ed",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7047,
      "name": "Magic Frog",
      "rookie_year": "2018",
      "city": "zhengzhou ",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7048,
      "name": "Red River Rage",
      "rookie_year": "2018",
      "city": "Fargo",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7049,
      "name": "Marine Machines",
      "rookie_year": "2018",
      "city": "Shreveport",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7050,
      "name": "SARNIC",
      "rookie_year": "2018",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7051,
      "name": "RoboDons",
      "rookie_year": "2018",
      "city": "Baldwin Park",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7052,
      "name": "Falcotronix",
      "rookie_year": "2018",
      "city": "Thunder Bay",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7053,
      "name": "Robo Huskies",
      "rookie_year": "2018",
      "city": "St-Hubert",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7054,
      "name": "SC Sailors",
      "rookie_year": "2018",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7055,
      "name": "Quantum Steam",
      "rookie_year": "2018",
      "city": "Bay Village",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7056,
      "name": "The F.A.S.T. Team - Fowlerville Area Scientific Technicians",
      "rookie_year": "2018",
      "city": "Fowlerville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7057,
      "name": "Titanators",
      "rookie_year": "2018",
      "city": "Orange Cove",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7058,
      "name": "StrathDroids",
      "rookie_year": "2018",
      "city": "Strathroy",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7059,
      "name": "Bot-E Builders",
      "rookie_year": "2018",
      "city": "Prescott",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7060,
      "name": "Riverside Military Academy Eagle Bots ",
      "rookie_year": "2018",
      "city": "Gainesville",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7063,
      "name": "Wagner TRILOBYTES",
      "rookie_year": "2018",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7064,
      "name": "Voltron Robotics",
      "rookie_year": "2018",
      "city": "Lansing",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7065,
      "name": "Wolverine 1 ",
      "rookie_year": "2018",
      "city": "Montgomery",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7066,
      "name": "Faulkner County Library Gadget Droids",
      "rookie_year": "2018",
      "city": "Conway",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7067,
      "name": "Team Streak",
      "rookie_year": "2018",
      "city": "jerusalem",
      "state": "Yerushalayim",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 7068,
      "name": "Mechanical Masterminds",
      "rookie_year": "2018",
      "city": "Saint Francis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7069,
      "name": "Taipei 101",
      "rookie_year": "2018",
      "city": "Taipei",
      "state": "Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7070,
      "name": "SRT",
      "rookie_year": "2018",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7071,
      "name": "ITU-Robee",
      "rookie_year": "2018",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7072,
      "name": "O.G.R.E. (Opelika's Greatest Robotics Engineers)",
      "rookie_year": "2018",
      "city": "Opelika",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7073,
      "name": "Ottawa Hills High School",
      "rookie_year": "2018",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7074,
      "name": "Reapers",
      "rookie_year": "2018",
      "city": "North Sydney",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7075,
      "name": "Gearbreakers",
      "rookie_year": "2018",
      "city": "Pleasant Plains",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7076,
      "name": "WestTech Sentinels",
      "rookie_year": "2018",
      "city": "Augusta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7077,
      "name": "Sundevils' Fire",
      "rookie_year": "2018",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7078,
      "name": "BENG DOU",
      "rookie_year": "2018",
      "city": "TAIYUAN",
      "state": "Shanxi",
      "country": "China",
      "district": ""
    },
    {
      "number": 7079,
      "name": "Co-Bot",
      "rookie_year": "2018",
      "city": "Haifa",
      "state": "Haifa",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 7080,
      "name": "Vision",
      "rookie_year": "2018",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 7081,
      "name": "NEYC",
      "rookie_year": "2018",
      "city": "Shenyang",
      "state": "Liaoning",
      "country": "China",
      "district": ""
    },
    {
      "number": 7082,
      "name": "Rogozin",
      "rookie_year": "2018",
      "city": "Kiryat Gat",
      "state": "Yerushalayim",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 7083,
      "name": "Green Hekma",
      "rookie_year": "2018",
      "city": "Nazareth",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 7084,
      "name": "Hillman Pyrobots",
      "rookie_year": "2018",
      "city": "Hillman",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7085,
      "name": "Paranoid Androids",
      "rookie_year": "2018",
      "city": "Pawleys Island",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7086,
      "name": "IOROBOT",
      "rookie_year": "2018",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7087,
      "name": "BCS",
      "rookie_year": "2018",
      "city": "Balcarres",
      "state": "Saskatchewan",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7088,
      "name": "Robodogs",
      "rookie_year": "2018",
      "city": "Somerset",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7091,
      "name": "Atlas Orbis",
      "rookie_year": "2018",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7092,
      "name": "Bionic Bulldogs",
      "rookie_year": "2018",
      "city": "Lyford",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7093,
      "name": "Veritas Valiants",
      "rookie_year": "2018",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7094,
      "name": "Alpha Omega",
      "rookie_year": "2018",
      "city": "Bay Saint Louis",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7095,
      "name": "HiMach",
      "rookie_year": "2018",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 7096,
      "name": "Educated Business",
      "rookie_year": "2018",
      "city": "Los Gatos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7097,
      "name": "The Archers ",
      "rookie_year": "2018",
      "city": "Myrtle Beach",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7098,
      "name": "Seoul High School",
      "rookie_year": "2018",
      "city": "APO",
      "state": "Armed Forces - Americas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7099,
      "name": "Osan Middle/High School",
      "rookie_year": "2018",
      "city": "APO",
      "state": "Armed Forces - Pacific",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7100,
      "name": "Noble Mechanical Knights",
      "rookie_year": "2018",
      "city": "North Berwick",
      "state": "Maine",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7101,
      "name": "Genesee Robotic Wolves",
      "rookie_year": "2018",
      "city": "Genesee",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7102,
      "name": "PrepaTec - Daedalus",
      "rookie_year": "2018",
      "city": "Zapopan",
      "state": "Jalisco",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7103,
      "name": "Robo Remedy @ Mantiowoc Lutheran High School",
      "rookie_year": "2018",
      "city": "Manitowoc",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7104,
      "name": "Benedictine Military School Bot Brothers",
      "rookie_year": "2018",
      "city": "Savannah",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 7105,
      "name": "PBG AREA ROBOTICS",
      "rookie_year": "2018",
      "city": "Palm Beach Gardens",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7106,
      "name": "MPV StingerBots",
      "rookie_year": "2018",
      "city": "Mulberry",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7107,
      "name": "Blazer Robotics",
      "rookie_year": "2018",
      "city": "Boca Raton",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7108,
      "name": "volTRan",
      "rookie_year": "2018",
      "city": "Fatih",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7109,
      "name": "Clare Chaos Theory",
      "rookie_year": "2018",
      "city": "Clare",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7110,
      "name": "Heights Bytes",
      "rookie_year": "2018",
      "city": "Haddon Heights",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 7111,
      "name": "RAD Robotics",
      "rookie_year": "2018",
      "city": "Huntsville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7112,
      "name": "EverGreen",
      "rookie_year": "2018",
      "city": "Kadima-Zoran",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 7113,
      "name": "Control Rising",
      "rookie_year": "2018",
      "city": "Perth",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7114,
      "name": "Robo-Raiders",
      "rookie_year": "2018",
      "city": "High Point",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7115,
      "name": "Red Lion Bots",
      "rookie_year": "2018",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7116,
      "name": "\u00c9lectriks",
      "rookie_year": "2018",
      "city": "Shawinigan",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7117,
      "name": "Robotic Dragons",
      "rookie_year": "2018",
      "city": "De Soto",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7118,
      "name": "ScotBots",
      "rookie_year": "2018",
      "city": "Shoreline",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7119,
      "name": "Sunset RoboBison",
      "rookie_year": "2018",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7120,
      "name": "ThunderChicas",
      "rookie_year": "2018",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7121,
      "name": "Keller Fusion Robotics",
      "rookie_year": "2018",
      "city": "Keller",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7122,
      "name": "WYSIWYG",
      "rookie_year": "2018",
      "city": "Des Moines",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7123,
      "name": "Emerald City Robotics",
      "rookie_year": "2018",
      "city": "Mount Vernon",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7124,
      "name": "8-bit Destroyers - Cranebrook HS",
      "rookie_year": "2018",
      "city": "Cranebrook",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7125,
      "name": "Tigerbotics",
      "rookie_year": "2018",
      "city": "Glen Rose",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7126,
      "name": "Atom.OS",
      "rookie_year": "2018",
      "city": "Newmarket",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7127,
      "name": "LongMetal",
      "rookie_year": "2018",
      "city": "Longmeadow",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7128,
      "name": "XLR8",
      "rookie_year": "2018",
      "city": "Wantirna",
      "state": "Victoria",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7129,
      "name": "Pilbara Protons",
      "rookie_year": "2018",
      "city": "South Hedland",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7130,
      "name": "Future Shock",
      "rookie_year": "2018",
      "city": "Wuri Dist.",
      "state": "Taichung Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7131,
      "name": "Mavericks",
      "rookie_year": "2018",
      "city": "Caledon",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7132,
      "name": "Axeman",
      "rookie_year": "2018",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7133,
      "name": "STEAM Makers",
      "rookie_year": "2018",
      "city": "Farmington",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7134,
      "name": "rOctopus",
      "rookie_year": "2018",
      "city": "Aydin",
      "state": "Aydin",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7135,
      "name": "System Reset",
      "rookie_year": "2018",
      "city": "Surrey",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7136,
      "name": "Thistletown Scot Bots",
      "rookie_year": "2018",
      "city": "Etobicoke",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7137,
      "name": "Project 212",
      "rookie_year": "2018",
      "city": "Concord",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7138,
      "name": "Wing It",
      "rookie_year": "2018",
      "city": "Fischer",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7139,
      "name": "AERO",
      "rookie_year": "2018",
      "city": "MANIZALES",
      "state": "Caldas",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 7140,
      "name": "OKSEF ROBOTICS",
      "rookie_year": "2018",
      "city": "IZMIR",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7141,
      "name": "Cyberhounds",
      "rookie_year": "2018",
      "city": "Fort Madison",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7142,
      "name": "Saydel High School Robotics Team---Vulcan Eagles",
      "rookie_year": "2018",
      "city": "Des Moines",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7143,
      "name": "The Cyber-Eagles",
      "rookie_year": "2018",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7144,
      "name": "NexTech Hydra",
      "rookie_year": "2018",
      "city": "Okemos",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7145,
      "name": "Robocanes",
      "rookie_year": "2018",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7146,
      "name": "Infinity Robotics",
      "rookie_year": "2018",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7147,
      "name": "Falcons Senior Robo Team",
      "rookie_year": "2018",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7148,
      "name": "Faster Than Light",
      "rookie_year": "2018",
      "city": "Zhengzhou",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7149,
      "name": "WuKong",
      "rookie_year": "2018",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 7150,
      "name": "Ogemaw Overdrive",
      "rookie_year": "2018",
      "city": "West Branch",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7151,
      "name": "Real Robotics",
      "rookie_year": "2018",
      "city": "Herriman",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7152,
      "name": "Owltonomous",
      "rookie_year": "2018",
      "city": "Boca Raton",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7153,
      "name": "Aetos Dios (Eagles of Zeus)",
      "rookie_year": "2018",
      "city": "Manchester",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7154,
      "name": "TheROK",
      "rookie_year": "2018",
      "city": "Kingsford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7155,
      "name": "The Robotic Rangers",
      "rookie_year": "2018",
      "city": "Manton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7156,
      "name": "Metal Heads",
      "rookie_year": "2018",
      "city": "Norway",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7157,
      "name": "\u03bcBotics",
      "rookie_year": "2018",
      "city": "Brea",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7158,
      "name": "The Conspirators ",
      "rookie_year": "2018",
      "city": "Langley",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7159,
      "name": "Burnaby Central Secondary",
      "rookie_year": "2018",
      "city": "Burnaby",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7160,
      "name": "Ludington O-Bots",
      "rookie_year": "2018",
      "city": "Ludington",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7161,
      "name": "PE\u00d1OLES - LeopardBots 7161",
      "rookie_year": "2018",
      "city": "Zacazonapan",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7162,
      "name": "Maraudeurs",
      "rookie_year": "2018",
      "city": "Laval",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7163,
      "name": "A.I. Metal Pies",
      "rookie_year": "2018",
      "city": "Merrylands",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7164,
      "name": "RHODE REBELS",
      "rookie_year": "2018",
      "city": "Providence",
      "state": "Rhode Island",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7165,
      "name": "Perkins Pirates",
      "rookie_year": "2018",
      "city": "Sandusky",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7166,
      "name": "Red Thunder Robotics",
      "rookie_year": "2018",
      "city": "Laingsburg",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7167,
      "name": "Spectrum ThunderBots",
      "rookie_year": "2018",
      "city": "Victoria",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7168,
      "name": "Infinity",
      "rookie_year": "2018",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7169,
      "name": "Belmont Bytes ",
      "rookie_year": "2018",
      "city": "Victoria",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7170,
      "name": "Spooky Action Robotics",
      "rookie_year": "2018",
      "city": "Comox",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7171,
      "name": "Wolverine Wildcats",
      "rookie_year": "2018",
      "city": "Wolverine",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7172,
      "name": "AEA Robolution",
      "rookie_year": "2018",
      "city": "Oscoda",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7173,
      "name": "Iris Robotics",
      "rookie_year": "2018",
      "city": "Maple Ridge",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7174,
      "name": "Charger Robotics",
      "rookie_year": "2018",
      "city": "Dearborn Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7175,
      "name": "Team Red Line",
      "rookie_year": "2018",
      "city": "Clinton",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7176,
      "name": "ROC",
      "rookie_year": "2018",
      "city": "Unionville",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7177,
      "name": "Amal tayibe",
      "rookie_year": "2018",
      "city": "tayibe",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 7178,
      "name": "Yeti",
      "rookie_year": "2018",
      "city": "Walled Lake",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7179,
      "name": "Crossfire",
      "rookie_year": "2018",
      "city": "Garland",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7180,
      "name": "Wellstone Lions",
      "rookie_year": "2018",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7181,
      "name": "Lions",
      "rookie_year": "2018",
      "city": "Florence",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7182,
      "name": "Robotic Indians",
      "rookie_year": "2018",
      "city": "Leighton",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7183,
      "name": "WAR Club",
      "rookie_year": "2018",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7184,
      "name": "BIT CHALLENGE",
      "rookie_year": "2018",
      "city": "Foushan",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7185,
      "name": "TartanBots",
      "rookie_year": "2018",
      "city": "Glendora",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7187,
      "name": "Gear Cats",
      "rookie_year": "2018",
      "city": "Delton",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7188,
      "name": "SaddleBots",
      "rookie_year": "2018",
      "city": "Warren",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7189,
      "name": "EX NIHILO",
      "rookie_year": "2018",
      "city": "Kelowna",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7190,
      "name": "Vancouver Rainstorms",
      "rookie_year": "2018",
      "city": "Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7191,
      "name": "ABT Gators",
      "rookie_year": "2018",
      "city": "Melvindale",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7192,
      "name": "Blue Thunderneers",
      "rookie_year": "2018",
      "city": "Croswell",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7193,
      "name": "Invictus",
      "rookie_year": "2018",
      "city": "Fort Myers",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7194,
      "name": "iRam",
      "rookie_year": "2018",
      "city": "New Port Richey",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7195,
      "name": "Twin River Robotics",
      "rookie_year": "2018",
      "city": "Portland",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7196,
      "name": "Tech Tigers",
      "rookie_year": "2018",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7197,
      "name": "Mountie MegaBots",
      "rookie_year": "2018",
      "city": "Jackson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7198,
      "name": "TL Fearsome Gears",
      "rookie_year": "2018",
      "city": "Monticello",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 7199,
      "name": "Thunder",
      "rookie_year": "2018",
      "city": "Maple Ridge",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7200,
      "name": "Banting Memorial high school",
      "rookie_year": "2018",
      "city": "Alliston",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7201,
      "name": "Crobotics",
      "rookie_year": "2018",
      "city": "Rijeka",
      "state": "Primorsko-goranska \u017eupanija",
      "country": "Croatia",
      "district": ""
    },
    {
      "number": 7202,
      "name": "Cyber Orioles",
      "rookie_year": "2018",
      "city": "Morrice",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7203,
      "name": "21st Century Cyber Bearcats",
      "rookie_year": "2018",
      "city": "Battle Creek",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7204,
      "name": "Freedom Gliders",
      "rookie_year": "2018",
      "city": "Prospect",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7205,
      "name": "Dene Strong Engineering",
      "rookie_year": "2018",
      "city": "La Loche",
      "state": "Saskatchewan",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7206,
      "name": "Titanium Rex",
      "rookie_year": "2018",
      "city": "Center Line",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7207,
      "name": "Angry Birds",
      "rookie_year": "2018",
      "city": "Delta",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7208,
      "name": "CMA Navigators",
      "rookie_year": "2018",
      "city": "Charlevoix",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7209,
      "name": "Titanium Trojans (Homer Robotics Club)",
      "rookie_year": "2018",
      "city": "Homer",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7210,
      "name": "RoboJackets",
      "rookie_year": "2018",
      "city": "Greenville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7211,
      "name": "Hollywood",
      "rookie_year": "2018",
      "city": "Holly",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7212,
      "name": "LCS Warriors",
      "rookie_year": "2018",
      "city": "Lebanon",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7213,
      "name": "Gladwin Knights",
      "rookie_year": "2018",
      "city": "Gladwin",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7214,
      "name": "Tiger-Ops Robotics",
      "rookie_year": "2018",
      "city": "Marana",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7215,
      "name": "Patriots",
      "rookie_year": "2018",
      "city": "Hollywood",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7216,
      "name": "CHARGERS ROBOTICS",
      "rookie_year": "2018",
      "city": "North Miami Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7217,
      "name": "SallaBots / ULSA Laguna",
      "rookie_year": "2018",
      "city": "TORREON",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7218,
      "name": "Bradford Botdogs",
      "rookie_year": "2018",
      "city": "Southfield",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7219,
      "name": "Olivet Eagles",
      "rookie_year": "2018",
      "city": "Olivet",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7220,
      "name": "Steel Falcons",
      "rookie_year": "2018",
      "city": "Brighton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7221,
      "name": "Viking Robotics",
      "rookie_year": "2018",
      "city": "Jackson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7222,
      "name": "The Fighting Anomalocari ",
      "rookie_year": "2018",
      "city": "Parma",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7223,
      "name": "MVHS Robotics",
      "rookie_year": "2018",
      "city": "Vermontville",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7224,
      "name": "RoboDrakens",
      "rookie_year": "2018",
      "city": "Hazel Park",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7225,
      "name": "Mechatronic Mustangs",
      "rookie_year": "2018",
      "city": "Milford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7226,
      "name": "Error 404",
      "rookie_year": "2018",
      "city": "Lansing",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7227,
      "name": "Tornado",
      "rookie_year": "2018",
      "city": "Kayseri",
      "state": "Kayseri",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7228,
      "name": "Tigers",
      "rookie_year": "2018",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7229,
      "name": "Electronic Eagles",
      "rookie_year": "2018",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7230,
      "name": "Mythic Mechanix",
      "rookie_year": "2018",
      "city": "Irvine",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7231,
      "name": "Team Freedom",
      "rookie_year": "2018",
      "city": "Santo Domingo",
      "state": "Distrito Nacional",
      "country": "Dominican Republic",
      "district": ""
    },
    {
      "number": 7232,
      "name": "Pharaohs",
      "rookie_year": "2018",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7233,
      "name": "Hope Of Detroit Warriors",
      "rookie_year": "2018",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7234,
      "name": "Lee Robotics",
      "rookie_year": "2018",
      "city": "Wyoming",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7235,
      "name": "Red Lake Ogichidaag",
      "rookie_year": "2018",
      "city": "Red Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7236,
      "name": "ROBOGED\u0130K",
      "rookie_year": "2018",
      "city": "Pendik",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7237,
      "name": "UniBots",
      "rookie_year": "2018",
      "city": "Bridgeview",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7238,
      "name": "coolker",
      "rookie_year": "2018",
      "city": "zhengzhou",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7239,
      "name": "Hell Robotics",
      "rookie_year": "2018",
      "city": "Hell",
      "state": "Tr\u00f8ndelag",
      "country": "Norway",
      "district": ""
    },
    {
      "number": 7240,
      "name": "Nitro Knights",
      "rookie_year": "2018",
      "city": "Cambridge",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7241,
      "name": "NexTech Knights Robotics",
      "rookie_year": "2018",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7242,
      "name": "FRC 7242",
      "rookie_year": "2018",
      "city": "Hong Kong",
      "state": "Hong Kong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7243,
      "name": "Robo-Lobo-Bellos",
      "rookie_year": "2018",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7244,
      "name": "Huskies Robotics",
      "rookie_year": "2018",
      "city": "Atlanta",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7245,
      "name": "Lion Bots",
      "rookie_year": "2018",
      "city": "San Lorenzo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7246,
      "name": "Thom Collegiate Trojans",
      "rookie_year": "2018",
      "city": "Regina",
      "state": "Saskatchewan",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7247,
      "name": "Error 404",
      "rookie_year": "2018",
      "city": "Fair Haven",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7248,
      "name": "Tactical Hams",
      "rookie_year": "2018",
      "city": "Wyoming",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7249,
      "name": "CVH SPARTANS",
      "rookie_year": "2018",
      "city": "Chula Vista",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7250,
      "name": "OsCODEa 0w|5",
      "rookie_year": "2018",
      "city": "Oscoda",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7251,
      "name": "Warrior Robotics",
      "rookie_year": "2018",
      "city": "Salamanca",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7252,
      "name": "Ionia Bulldogs",
      "rookie_year": "2018",
      "city": "Ionia",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7253,
      "name": "Timber Wolf",
      "rookie_year": "2018",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7254,
      "name": "Knowmads",
      "rookie_year": "2018",
      "city": "Potterville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7255,
      "name": "Mechanical Mettle",
      "rookie_year": "2018",
      "city": "Charleston",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7256,
      "name": "Irish Robotics",
      "rookie_year": "2018",
      "city": "Kalamazoo",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7257,
      "name": "Sauk Centre Robotics",
      "rookie_year": "2018",
      "city": "Sauk Centre",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7258,
      "name": "Robolobos - Hiawatha Collegiate",
      "rookie_year": "2018",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7259,
      "name": "Mechanical Mustangs",
      "rookie_year": "2018",
      "city": "Granby",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7260,
      "name": "Diamondback Turtles  (Heritage High School)",
      "rookie_year": "2018",
      "city": "Rogers",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7261,
      "name": "Mulgrave Robotics",
      "rookie_year": "2018",
      "city": "Victoria",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7262,
      "name": "QBOT",
      "rookie_year": "2018",
      "city": "Quesnel",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7263,
      "name": "TOPPS TECH",
      "rookie_year": "2018",
      "city": "Pine Bluff",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7264,
      "name": "Cougar Robotics",
      "rookie_year": "2018",
      "city": "New Braunfels",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7265,
      "name": "Skeleton Crew",
      "rookie_year": "2018",
      "city": "Hampstead",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7266,
      "name": "NBHS Steampunks",
      "rookie_year": "2018",
      "city": "North Brookfield",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7267,
      "name": "Lisgar Robotics Club",
      "rookie_year": "2018",
      "city": "Ottawa",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7268,
      "name": "BCNY Gerry Robotic Lions (East Harlem)",
      "rookie_year": "2018",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7269,
      "name": "ISB VoltBots",
      "rookie_year": "2018",
      "city": "Cambridge",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7270,
      "name": "The Bandits",
      "rookie_year": "2018",
      "city": "Burgaw",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 7271,
      "name": "Hanger 84 Robotics",
      "rookie_year": "2018",
      "city": "Roswell",
      "state": "New Mexico",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7272,
      "name": "Envirobots",
      "rookie_year": "2018",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7273,
      "name": "ZooM Robotics",
      "rookie_year": "2018",
      "city": "Zumbrota",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7274,
      "name": "Brashear Bulls Robotics",
      "rookie_year": "2018",
      "city": "Pittsburgh",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7275,
      "name": "PRIDE Robotics",
      "rookie_year": "2018",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7276,
      "name": "Success Initiative Robotics",
      "rookie_year": "2018",
      "city": "Spartanburg",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7277,
      "name": "Mandela United Squadron",
      "rookie_year": "2018",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7278,
      "name": "Toormina High School",
      "rookie_year": "2018",
      "city": "Toormina",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7279,
      "name": "Xishan Senior High School Team",
      "rookie_year": "2018",
      "city": "Wuxi",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 7280,
      "name": "MITO Octopus",
      "rookie_year": "2018",
      "city": "Suzhou",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 7281,
      "name": "F.G.",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7282,
      "name": "Semia United 1",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7283,
      "name": "Semia United 2",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7284,
      "name": "Semia United 3",
      "rookie_year": "2018",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7285,
      "name": "Sneaky Snakes",
      "rookie_year": "2018",
      "city": "\u015ei\u015fli",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7286,
      "name": "Enigma",
      "rookie_year": "2018",
      "city": "daliat el carmel ",
      "state": "Haifa",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 7287,
      "name": "Esquimalt Atom Smashers",
      "rookie_year": "2018",
      "city": "Victoria",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7288,
      "name": "NOMMA D3V1LB0TS",
      "rookie_year": "2018",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7289,
      "name": "Blue Eagles",
      "rookie_year": "2018",
      "city": "Fowler",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7290,
      "name": "TARHUNDA",
      "rookie_year": "2018",
      "city": "ADANA",
      "state": "Adana",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7291,
      "name": "TYANA - N\u0130\u011eDE GAZOZU",
      "rookie_year": "2018",
      "city": "N\u0130\u011eDE",
      "state": "Nigde",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7292,
      "name": "\u00c7OROBOT",
      "rookie_year": "2018",
      "city": "\u00c7orum",
      "state": "\u00c7orum",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7293,
      "name": "COTANAK ROBOTICS",
      "rookie_year": "2018",
      "city": "Piraziz",
      "state": "Giresun",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7294,
      "name": "RoboCirak",
      "rookie_year": "2018",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7295,
      "name": "SPECTRUM",
      "rookie_year": "2018",
      "city": "SAMSUN",
      "state": "Samsun",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7296,
      "name": "TeRoBoT",
      "rookie_year": "2018",
      "city": "Levent",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7297,
      "name": "KAFKAS KARTALLARI",
      "rookie_year": "2018",
      "city": "KARS",
      "state": "Kars",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7298,
      "name": "TOROS",
      "rookie_year": "2018",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7299,
      "name": "Robotic Eagles",
      "rookie_year": "2018",
      "city": "Santa Catarina",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7300,
      "name": "Dectro",
      "rookie_year": "2018",
      "city": "Edirne",
      "state": "Edirne",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7301,
      "name": "Jackbots",
      "rookie_year": "2018",
      "city": "Saint Maries",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7302,
      "name": "afaq school team ",
      "rookie_year": "2018",
      "city": "kfar manda",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 7303,
      "name": "Reach Robotics",
      "rookie_year": "2018",
      "city": "Haslet",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7304,
      "name": "CAPA MEE6",
      "rookie_year": "2018",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7305,
      "name": "Rambo Robotics",
      "rookie_year": "2018",
      "city": "Snow Hill",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7306,
      "name": "Epping High School",
      "rookie_year": "2018",
      "city": "Epping",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7307,
      "name": "Team Muskwa",
      "rookie_year": "2018",
      "city": "Rancho Palos Verdes",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7308,
      "name": "DeepVision",
      "rookie_year": "2018",
      "city": "Los Altos",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7309,
      "name": "Green Lightning",
      "rookie_year": "2018",
      "city": "Storm Lake",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7310,
      "name": "Lightning Gears",
      "rookie_year": "2018",
      "city": "Culiacan",
      "state": "Sinaloa",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7311,
      "name": "Boring Robots",
      "rookie_year": "2018",
      "city": "Virginia",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7312,
      "name": "T3",
      "rookie_year": "2018",
      "city": "Tomball",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7313,
      "name": "SBA Talon Tech  #7313",
      "rookie_year": "2018",
      "city": "Cordova",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7314,
      "name": "Tornadoes",
      "rookie_year": "2018",
      "city": "Franklin",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7315,
      "name": "Giga Knights",
      "rookie_year": "2018",
      "city": "Albany",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 7316,
      "name": "Ursuline Academy High School ",
      "rookie_year": "2018",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7317,
      "name": "Armor Robotics",
      "rookie_year": "2018",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7318,
      "name": "Nanuet Knightronz",
      "rookie_year": "2018",
      "city": "Nanuet",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7319,
      "name": "1UP",
      "rookie_year": "2018",
      "city": "Garland",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7320,
      "name": "Astralis",
      "rookie_year": "2018",
      "city": "Diyarbakir",
      "state": "Diyarbakir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7321,
      "name": "\u00c1guila Rob\u00f3tica",
      "rookie_year": "2018",
      "city": "Irving",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7322,
      "name": "YVHS Robotics",
      "rookie_year": "2018",
      "city": "Yucca Valley",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7323,
      "name": "TriTron",
      "rookie_year": "2018",
      "city": "Oxnard",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7324,
      "name": "The RoboRaiders",
      "rookie_year": "2018",
      "city": "Oxnard",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7325,
      "name": "ASU  Brave Guide Right ",
      "rookie_year": "2018",
      "city": "Natchez ",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7326,
      "name": "Red Riot",
      "rookie_year": "2018",
      "city": "Oxnard",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7327,
      "name": "Metal Jackets",
      "rookie_year": "2018",
      "city": "Oxnard",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7328,
      "name": "Frontier High School",
      "rookie_year": "2018",
      "city": "Camarillo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7329,
      "name": "The Afghan Dreamers",
      "rookie_year": "2018",
      "city": "Jadeh Mahbas",
      "state": "Her\u0101t",
      "country": "Afghanistan",
      "district": ""
    },
    {
      "number": 7330,
      "name": "C.O.U.G.A.R.S (Cybernetic Operational Unit Generated For Artificial Robotic Syst",
      "rookie_year": "2018",
      "city": "Dendron",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7331,
      "name": "Bionic Riot Rebel Robotics Baton Rouge ",
      "rookie_year": "2018",
      "city": "Baton Rouge",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7332,
      "name": "Puddle Jumpers 7332",
      "rookie_year": "2018",
      "city": "Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7400,
      "name": "ThunderMiners",
      "rookie_year": "2019",
      "city": "Melville",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7401,
      "name": "Devtech117",
      "rookie_year": "2019",
      "city": "Concord",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7403,
      "name": "Lightning Blue Lizards",
      "rookie_year": "2019",
      "city": "Envigado",
      "state": "Antioquia",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 7405,
      "name": "IcyNights",
      "rookie_year": "2019",
      "city": "Zhangjiagang",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 7406,
      "name": "Ministry of Mechanics",
      "rookie_year": "2019",
      "city": "Cleveland",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7407,
      "name": "Wired Boars",
      "rookie_year": "2019",
      "city": "Wallingford",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7408,
      "name": "Pearl City Cats",
      "rookie_year": "2019",
      "city": "Boca Raton",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7409,
      "name": "GLOW",
      "rookie_year": "2019",
      "city": "Boca Raton",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7410,
      "name": "Texas Toast FRC",
      "rookie_year": "2019",
      "city": "Clute",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7411,
      "name": "CrossThreaded",
      "rookie_year": "2019",
      "city": "Cedar Falls",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7412,
      "name": "KDHS Robotic Owls",
      "rookie_year": "2019",
      "city": "Metairie",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7413,
      "name": "Plus Ultra",
      "rookie_year": "2019",
      "city": "Marina",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7414,
      "name": "RetroRobotics",
      "rookie_year": "2019",
      "city": "Collegeville",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 7415,
      "name": "Jaguar Robotics",
      "rookie_year": "2019",
      "city": "West Hills",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7416,
      "name": "Northern Horizons",
      "rookie_year": "2019",
      "city": "Bethlehem",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7417,
      "name": "Bionic Bombers",
      "rookie_year": "2019",
      "city": "Williamsfield",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7418,
      "name": "Channelview TechnoFalcons",
      "rookie_year": "2019",
      "city": "Channelview",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7419,
      "name": "QLS Tech Support",
      "rookie_year": "2019",
      "city": "Dublin",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7420,
      "name": "Napa County Robotics - OtterBots",
      "rookie_year": "2019",
      "city": "Napa",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7421,
      "name": "PrepaTec - OVERTURE",
      "rookie_year": "2019",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7422,
      "name": "WildBots",
      "rookie_year": "2019",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7423,
      "name": "GrizzBot",
      "rookie_year": "2019",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7424,
      "name": "Sin City Robotics",
      "rookie_year": "2019",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7425,
      "name": "Green Valley Robotics",
      "rookie_year": "2019",
      "city": "Henderson",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7426,
      "name": "PAIR OF DICE ROBOTICS",
      "rookie_year": "2019",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7427,
      "name": "Protocol X Robotics",
      "rookie_year": "2019",
      "city": "Milton",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7428,
      "name": "Gigawatts",
      "rookie_year": "2019",
      "city": "Fort Payne",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7429,
      "name": "Convergence",
      "rookie_year": "2019",
      "city": "Midlothian",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 7430,
      "name": "System Overload",
      "rookie_year": "2019",
      "city": "Marion",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7431,
      "name": "Wingspan",
      "rookie_year": "2019",
      "city": "Melbourne",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7432,
      "name": "NOS",
      "rookie_year": "2019",
      "city": "Independence",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7433,
      "name": "Iona Fusion",
      "rookie_year": "2019",
      "city": "Port Macquarie",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7434,
      "name": "Beyond The Stars",
      "rookie_year": "2019",
      "city": "Dayton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7435,
      "name": "CYBERTRONICS",
      "rookie_year": "2019",
      "city": "Saint Charles",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7436,
      "name": "8-Bit Miners",
      "rookie_year": "2019",
      "city": "South Jordan",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7437,
      "name": "Lionautics",
      "rookie_year": "2019",
      "city": "Lancaster",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7438,
      "name": "Brain Busters",
      "rookie_year": "2019",
      "city": "Sherborn",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7439,
      "name": "QUBIT",
      "rookie_year": "2019",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7440,
      "name": "Robo Lions (FRC)",
      "rookie_year": "2019",
      "city": "Livingston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7441,
      "name": "Lancer EVO ",
      "rookie_year": "2019",
      "city": "Chula Vista",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7442,
      "name": "Jaguar Robotics",
      "rookie_year": "2019",
      "city": "Port Saint Lucie",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7443,
      "name": "Overhills Jag-Wires",
      "rookie_year": "2019",
      "city": "Spring Lake",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 7444,
      "name": "Moon Star Robotics",
      "rookie_year": "2019",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7445,
      "name": "Garage Robotics",
      "rookie_year": "2019",
      "city": "Palo Alto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7446,
      "name": "S.E.A. Monsters",
      "rookie_year": "2019",
      "city": "Harvest",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7447,
      "name": "R\u014dnin Robotics",
      "rookie_year": "2019",
      "city": "Irvine",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7448,
      "name": "S.C. Robotics",
      "rookie_year": "2019",
      "city": "Adair Village",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7449,
      "name": "Lithium Robotics",
      "rookie_year": "2019",
      "city": "Acworth",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7450,
      "name": "oTECH Aimbots",
      "rookie_year": "2019",
      "city": "Kissimmee",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7451,
      "name": "AvengerRobotics",
      "rookie_year": "2019",
      "city": "Cumming",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 7452,
      "name": "Dupo Tigers",
      "rookie_year": "2019",
      "city": "Dupo",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7453,
      "name": "Lobo Robotics",
      "rookie_year": "2019",
      "city": "Littlerock",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7454,
      "name": "Huskies on Hogs",
      "rookie_year": "2019",
      "city": "Evansville",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 7455,
      "name": "Narbots",
      "rookie_year": "2019",
      "city": "Harbor City",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7456,
      "name": "Aurobots",
      "rookie_year": "2019",
      "city": "Aurora",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7457,
      "name": "suPURDUEper Robotics",
      "rookie_year": "2019",
      "city": "Indianapolis",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 7458,
      "name": "Senior Robotics Team",
      "rookie_year": "2019",
      "city": "Atat\u00fcrk Mah.",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7459,
      "name": "TAUBATEXAS ROBOTICS",
      "rookie_year": "2019",
      "city": "TAUBATE",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7460,
      "name": "Avi and Friends",
      "rookie_year": "2019",
      "city": "Sylvania",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7461,
      "name": "Sushi Squad",
      "rookie_year": "2019",
      "city": "Redmond",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 7462,
      "name": "Disruptive Technologies",
      "rookie_year": "2019",
      "city": "Danbury",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7463,
      "name": "Incandescent Mice",
      "rookie_year": "2019",
      "city": "Apex",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7464,
      "name": "ORION",
      "rookie_year": "2019",
      "city": "Norman",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7465,
      "name": "Magnetech",
      "rookie_year": "2019",
      "city": "Atakum",
      "state": "Samsun",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7466,
      "name": "Cymurghs",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7467,
      "name": "Devils Burn-In",
      "rookie_year": "2019",
      "city": "West Memphis",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7468,
      "name": "FireBolts",
      "rookie_year": "2019",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7469,
      "name": "META ROBOTICS",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7470,
      "name": "iRAMBOTS with NASA",
      "rookie_year": "2019",
      "city": "Sylvester",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 7471,
      "name": "Robo Montagnards",
      "rookie_year": "2019",
      "city": "Mont-Saint-Hilaire",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7472,
      "name": "R2 Jesu Robotics",
      "rookie_year": "2019",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7473,
      "name": "Mechanics!",
      "rookie_year": "2019",
      "city": "Tecumseh",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7474,
      "name": "JXN UNITED",
      "rookie_year": "2019",
      "city": "Jackson",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7475,
      "name": "WIRED",
      "rookie_year": "2019",
      "city": "Woodstock",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7476,
      "name": "EOM Lions",
      "rookie_year": "2019",
      "city": "Kanata",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7477,
      "name": "Giddy GOATS",
      "rookie_year": "2019",
      "city": "Mishawaka",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 7478,
      "name": "ISTECH",
      "rookie_year": "2019",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7479,
      "name": "Cardinals Robotics Team",
      "rookie_year": "2019",
      "city": "Elizabeth",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7480,
      "name": "Machine Mavericks",
      "rookie_year": "2019",
      "city": "Kingston",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7481,
      "name": "istiklal",
      "rookie_year": "2019",
      "city": "Kastamonu",
      "state": "Kastamonu",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7482,
      "name": "Lincoln Panther Robotics",
      "rookie_year": "2019",
      "city": "Riverside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7483,
      "name": "Mechanically Challenged",
      "rookie_year": "2019",
      "city": "Viola",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7484,
      "name": "Wings of Steel",
      "rookie_year": "2019",
      "city": "Fort Campbell",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7485,
      "name": "Mo Co Robo",
      "rookie_year": "2019",
      "city": "Craig",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7486,
      "name": "Hudson Hybrids",
      "rookie_year": "2019",
      "city": "Hudson",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7487,
      "name": "Palm Beach County Sheriff PAL WestGate",
      "rookie_year": "2019",
      "city": "West Palm Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7488,
      "name": "Milagro & Village Academy ",
      "rookie_year": "2019",
      "city": "Delray Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7489,
      "name": "R2R",
      "rookie_year": "2019",
      "city": "Boca Raton",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7490,
      "name": "Boys & Girls Club of Riviera Beach",
      "rookie_year": "2019",
      "city": "West Palm Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7491,
      "name": "Cyber Soldiers",
      "rookie_year": "2019",
      "city": "Burton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7492,
      "name": "CavBots",
      "rookie_year": "2019",
      "city": "The Woodlands",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7493,
      "name": "Phoenix Force Robotics",
      "rookie_year": "2019",
      "city": "Tukwila",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7494,
      "name": "Circuit Bizurkers",
      "rookie_year": "2019",
      "city": "Missouri City",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7495,
      "name": "SHAbotics",
      "rookie_year": "2019",
      "city": "Mount Pleasant",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7496,
      "name": "Robo Indians",
      "rookie_year": "2019",
      "city": "Mascoutah",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7497,
      "name": "MARAHO",
      "rookie_year": "2019",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7498,
      "name": "Wingus & Dingus",
      "rookie_year": "2019",
      "city": "Auckland",
      "state": "Auckland",
      "country": "New Zealand",
      "district": ""
    },
    {
      "number": 7499,
      "name": "Stallion Robotics",
      "rookie_year": "2019",
      "city": "Tifton",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7500,
      "name": "MARAUDERS",
      "rookie_year": "2019",
      "city": "Fort Lauderdale",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7501,
      "name": "Golden Gears",
      "rookie_year": "2019",
      "city": "Brooklyn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7502,
      "name": "CyberBuggies Northridge High School",
      "rookie_year": "2019",
      "city": "Middlebury",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7503,
      "name": "Radicubs",
      "rookie_year": "2019",
      "city": "Frisco",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7504,
      "name": "Cybearbots",
      "rookie_year": "2019",
      "city": "Brewster",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7505,
      "name": "PTU",
      "rookie_year": "2019",
      "city": "SHANGHAI",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7506,
      "name": "WILDCARDS",
      "rookie_year": "2019",
      "city": "Arlington",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7507,
      "name": "Terminators Educational Robotics Team",
      "rookie_year": "2019",
      "city": "Karditsa",
      "state": "Thessalia",
      "country": "Greece",
      "district": ""
    },
    {
      "number": 7508,
      "name": "STartEM ",
      "rookie_year": "2019",
      "city": "Temple",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7509,
      "name": "Brainstorm Robotics",
      "rookie_year": "2019",
      "city": "Brantford",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7510,
      "name": "Prowlers",
      "rookie_year": "2019",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7511,
      "name": "GWAMA FRC Robotics",
      "rookie_year": "2019",
      "city": "Waco",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7512,
      "name": "Lions Bots",
      "rookie_year": "2019",
      "city": "Mobile",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7513,
      "name": "Muskrat",
      "rookie_year": "2019",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7514,
      "name": "EVE Robotics",
      "rookie_year": "2019",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7515,
      "name": "Dark Side Robotics",
      "rookie_year": "2019",
      "city": "Parkersburg",
      "state": "West Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7516,
      "name": "Louisville Centrons",
      "rookie_year": "2019",
      "city": "Louisville",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7517,
      "name": "Massis Robotics",
      "rookie_year": "2019",
      "city": "Encino",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7518,
      "name": "Generals FRC",
      "rookie_year": "2019",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7519,
      "name": "Silver Warriors",
      "rookie_year": "2019",
      "city": "Clewiston",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7520,
      "name": "Team MineKee",
      "rookie_year": "2019",
      "city": "Thornhill",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7521,
      "name": "ULTIMATE Robotics",
      "rookie_year": "2019",
      "city": "Laredo",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7522,
      "name": "Make 1 Robot",
      "rookie_year": "2019",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7523,
      "name": "SpringBots",
      "rookie_year": "2019",
      "city": "Centurion",
      "state": "Gauteng",
      "country": "South Africa",
      "district": ""
    },
    {
      "number": 7524,
      "name": "Regen",
      "rookie_year": "2019",
      "city": "zhengzhou",
      "state": "Henan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7525,
      "name": "Pioneers",
      "rookie_year": "2019",
      "city": "Nashville",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7526,
      "name": "Welcome to team",
      "rookie_year": "2019",
      "city": "kaohsiung",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7527,
      "name": "Kaohsiung power",
      "rookie_year": "2019",
      "city": " Kaohsiung ",
      "state": "Kaohsiung Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7528,
      "name": "Nuts and Bolts",
      "rookie_year": "2019",
      "city": "Morgan Hill",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7529,
      "name": "Mulan",
      "rookie_year": "2019",
      "city": "Shenzhen ",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7530,
      "name": "Brotherhood of Steel",
      "rookie_year": "2019",
      "city": "Watertown",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7531,
      "name": "Servos Strike Back",
      "rookie_year": "2019",
      "city": "Dubuque",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7532,
      "name": "Gophertronics",
      "rookie_year": "2019",
      "city": "Winnipeg",
      "state": "Manitoba",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7533,
      "name": "OSO-TECH",
      "rookie_year": "2019",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7534,
      "name": "Dragonflies",
      "rookie_year": "2019",
      "city": "Fort Worth",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7535,
      "name": "Purple Poison",
      "rookie_year": "2019",
      "city": "Arlington",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7536,
      "name": "ANKA ROBOTICS",
      "rookie_year": "2019",
      "city": "Ba\u015fak\u015fehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7537,
      "name": "Thunderbots",
      "rookie_year": "2019",
      "city": "Henderson",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7538,
      "name": "Metal Mountain",
      "rookie_year": "2019",
      "city": "Lawrenceville",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 7539,
      "name": "Elev8",
      "rookie_year": "2019",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 7540,
      "name": "Timberwolf Robotics",
      "rookie_year": "2019",
      "city": "Sandia Park",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7541,
      "name": "Maple River Robotics",
      "rookie_year": "2019",
      "city": "Mapleton",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7542,
      "name": "Entel Foreign language school",
      "rookie_year": "2019",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7543,
      "name": "Graphene ",
      "rookie_year": "2019",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7544,
      "name": "IZMIR ROBOTIK",
      "rookie_year": "2019",
      "city": "Konak",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7545,
      "name": "Leptechons",
      "rookie_year": "2019",
      "city": "Yuma",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7546,
      "name": "Prepa Tec - MinerZ",
      "rookie_year": "2019",
      "city": "Zacatecas",
      "state": "Zacatecas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7547,
      "name": "Hawkinators",
      "rookie_year": "2019",
      "city": "Glendale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7548,
      "name": "Le Jardin Academy",
      "rookie_year": "2019",
      "city": "Kailua",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7549,
      "name": "LYBOTICS YOUTH TEAM",
      "rookie_year": "2019",
      "city": "Tripoli",
      "state": "Tarabulus",
      "country": "Libya",
      "district": ""
    },
    {
      "number": 7550,
      "name": "DieForTonga",
      "rookie_year": "2019",
      "city": "Nukualofa",
      "state": "Tongatapu",
      "country": "Tonga",
      "district": ""
    },
    {
      "number": 7551,
      "name": "Extreme Mechanism",
      "rookie_year": "2019",
      "city": "Zhuqi",
      "state": "Chiayi",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7552,
      "name": "PERSEUS",
      "rookie_year": "2019",
      "city": "HATAY",
      "state": "Hatay",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7553,
      "name": "OSTC -  SWEET BOTS",
      "rookie_year": "2019",
      "city": "Wixom",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7554,
      "name": "Green Rockets",
      "rookie_year": "2019",
      "city": "Jaffa of Nazareth",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 7555,
      "name": "Maestro",
      "rookie_year": "2019",
      "city": "Lachine",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7556,
      "name": "PRISER",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7557,
      "name": "dasheng",
      "rookie_year": "2019",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7558,
      "name": "ALT-F4",
      "rookie_year": "2019",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7559,
      "name": "Sweet Springs Robotics Team",
      "rookie_year": "2019",
      "city": "Sweet Springs",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7560,
      "name": "Meteor Bots",
      "rookie_year": "2019",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7561,
      "name": "Blue Flamingos",
      "rookie_year": "2019",
      "city": "Wollongong",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7562,
      "name": "NSU Demons Robotics",
      "rookie_year": "2019",
      "city": "Natchitoches",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7563,
      "name": "SESI SENAI MEGAZORD",
      "rookie_year": "2019",
      "city": "Jundia\u00ed",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7564,
      "name": "Lakers",
      "rookie_year": "2019",
      "city": "Oshawa",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7565,
      "name": "SESI SENAI Robon\u00e1ticos",
      "rookie_year": "2019",
      "city": "S\u00e3o Paulo",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7566,
      "name": "SESI SENAI NI\u00d3BIO",
      "rookie_year": "2019",
      "city": "Campinas",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7567,
      "name": "SESI SENAI S\u00c3O PAULO OCTOPUS",
      "rookie_year": "2019",
      "city": "Bauru",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7568,
      "name": "Tro-Bots",
      "rookie_year": "2019",
      "city": "Marianna",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7569,
      "name": "Optimus Robotics",
      "rookie_year": "2019",
      "city": "Atasehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7570,
      "name": "New Tech",
      "rookie_year": "2019",
      "city": "Zamosc",
      "state": "Dolnoslaskie",
      "country": "Poland",
      "district": ""
    },
    {
      "number": 7571,
      "name": "SESI/DN #1",
      "rookie_year": "2019",
      "city": "Bras\u00edlia",
      "state": "Distrito Federal",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7572,
      "name": "Uplift Robotics",
      "rookie_year": "2019",
      "city": "Lake Forest",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7573,
      "name": "MULEBOTICS",
      "rookie_year": "2019",
      "city": "Muleshoe",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7574,
      "name": "Les Sentinelles",
      "rookie_year": "2019",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7575,
      "name": "Stark Robotics",
      "rookie_year": "2019",
      "city": "B\u00fcy\u00fck\u00e7ekmece",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7576,
      "name": "FMWill",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7577,
      "name": "Pe\u00f1oles - VELABOTS",
      "rookie_year": "2019",
      "city": "Velarde\u00f1a",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7578,
      "name": "Quantum Misfits",
      "rookie_year": "2019",
      "city": "Jamestown",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7579,
      "name": "SESI/DN #2",
      "rookie_year": "2019",
      "city": "Bras\u00edlia",
      "state": "Distrito Federal",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7580,
      "name": "SESI/DN #3",
      "rookie_year": "2019",
      "city": "Bras\u00edlia",
      "state": "Distrito Federal",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7581,
      "name": "SESI/DN #4",
      "rookie_year": "2019",
      "city": "Bras\u00edlia",
      "state": "Distrito Federal",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7582,
      "name": "SESI/DN #5",
      "rookie_year": "2019",
      "city": "Bras\u00edlia",
      "state": "Distrito Federal",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 7583,
      "name": "Embers",
      "rookie_year": "2019",
      "city": "North Wollongong",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7584,
      "name": "RoverBots",
      "rookie_year": "2019",
      "city": "Easton",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7585,
      "name": "The Thunder",
      "rookie_year": "2019",
      "city": "B\u00fcy\u00fck\u00e7ekmece",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7586,
      "name": "The Salted Fishballs",
      "rookie_year": "2019",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7587,
      "name": "Metuchen Momentum",
      "rookie_year": "2019",
      "city": "Metuchen",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 7588,
      "name": "H.I.I Robot",
      "rookie_year": "2019",
      "city": "HANGZHOU",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7589,
      "name": "Lishan Blue Magpie",
      "rookie_year": "2019",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7590,
      "name": "Wisigoths",
      "rookie_year": "2019",
      "city": "Trois-Rivieres",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7591,
      "name": "Aurora",
      "rookie_year": "2019",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 7592,
      "name": "Sugar Nerds",
      "rookie_year": "2019",
      "city": "Basseterre",
      "state": "Saint George Basseterre",
      "country": "Saint Kitts and Nevis",
      "district": ""
    },
    {
      "number": 7593,
      "name": "SymbiOHSis",
      "rookie_year": "2019",
      "city": "Auckland",
      "state": "Auckland",
      "country": "New Zealand",
      "district": ""
    },
    {
      "number": 7594,
      "name": "Nautilus",
      "rookie_year": "2019",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7595,
      "name": "Crosspoint at Shanghai & Suzhou United",
      "rookie_year": "2019",
      "city": "Suzhou",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 7596,
      "name": "Trojan Horses",
      "rookie_year": "2019",
      "city": "Rushford",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7597,
      "name": "Rambler Robotics",
      "rookie_year": "2019",
      "city": "Fraser",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7598,
      "name": "SCA Constellations",
      "rookie_year": "2019",
      "city": "Wixom",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7599,
      "name": "Blue Pride",
      "rookie_year": "2019",
      "city": "Philadelphia",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 7600,
      "name": "VORTEX",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7601,
      "name": "Iron Phoenix",
      "rookie_year": "2019",
      "city": "shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7602,
      "name": "Spartronics",
      "rookie_year": "2019",
      "city": "Scottville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7603,
      "name": "VESPA ROBOTICS #7603 - Bill Hogarth Secondary School",
      "rookie_year": "2019",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7604,
      "name": "Sickle and Hammer",
      "rookie_year": "2019",
      "city": "hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7605,
      "name": "ASTRO",
      "rookie_year": "2019",
      "city": "Sainte-Therese",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7606,
      "name": "Liberty Robotics",
      "rookie_year": "2019",
      "city": "Parma Hts.",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7607,
      "name": "The Blackbirds",
      "rookie_year": "2019",
      "city": "Palmdale",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7608,
      "name": "Owlenators",
      "rookie_year": "2019",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7609,
      "name": "Half Bananas",
      "rookie_year": "2019",
      "city": "Bridgeview",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7610,
      "name": "HZYulan",
      "rookie_year": "2019",
      "city": "hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7611,
      "name": "AMAL HAWKS",
      "rookie_year": "2019",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7612,
      "name": "HIS ",
      "rookie_year": "2019",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7613,
      "name": "Revoltage",
      "rookie_year": "2019",
      "city": "Silivri",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7614,
      "name": "Phoenix Robotics",
      "rookie_year": "2019",
      "city": "Newmarket",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7615,
      "name": "PatBots",
      "rookie_year": "2019",
      "city": "Saint-Laurent",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7616,
      "name": "Cerberus",
      "rookie_year": "2019",
      "city": "Sweeny",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7617,
      "name": "RoboBlazers",
      "rookie_year": "2019",
      "city": "Carmel",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 7618,
      "name": "WHS Vikings",
      "rookie_year": "2019",
      "city": "Williams",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7619,
      "name": "illumiBOTi",
      "rookie_year": "2019",
      "city": "Manitowoc",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7620,
      "name": "Anthem Bolts",
      "rookie_year": "2019",
      "city": "Anthem",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7621,
      "name": "Iron Rangers",
      "rookie_year": "2019",
      "city": "Spring Branch",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7622,
      "name": "Ten More Tons",
      "rookie_year": "2019",
      "city": "West Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7623,
      "name": "Morebotics",
      "rookie_year": "2019",
      "city": "Hamilton",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7624,
      "name": "YOUNG",
      "rookie_year": "2019",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7625,
      "name": "STORMING",
      "rookie_year": "2019",
      "city": "Changsha",
      "state": "Hunan",
      "country": "China",
      "district": ""
    },
    {
      "number": 7626,
      "name": "NLHS",
      "rookie_year": "2019",
      "city": "Taoyuan",
      "state": "Taoyuan",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7627,
      "name": "Bearcat Robotics",
      "rookie_year": "2019",
      "city": "Monroe",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 7628,
      "name": "LISA",
      "rookie_year": "2019",
      "city": "Altdorf",
      "state": "Uri",
      "country": "Switzerland",
      "district": ""
    },
    {
      "number": 7629,
      "name": "Deus ex machina 14",
      "rookie_year": "2019",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7630,
      "name": "SCIE FIRST",
      "rookie_year": "2019",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7631,
      "name": "Cool Guy",
      "rookie_year": "2019",
      "city": "Toyota",
      "state": "Aichi",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 7632,
      "name": "An Kang Robotics Maker",
      "rookie_year": "2019",
      "city": "New Taipei City",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7633,
      "name": "GRYPHUS ROBOTICS",
      "rookie_year": "2019",
      "city": "NEIVA",
      "state": "Huila",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 7634,
      "name": "New Hawks",
      "rookie_year": "2019",
      "city": "Sandy",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7635,
      "name": "SWIS ROBOTICS",
      "rookie_year": "2019",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7636,
      "name": "Robomania",
      "rookie_year": "2019",
      "city": "Daya Dist.",
      "state": "Taichung Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7637,
      "name": "Asimov Effect",
      "rookie_year": "2019",
      "city": "Sinop",
      "state": "Sinop",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7638,
      "name": "Northern Exposure Robotics Division ",
      "rookie_year": "2019",
      "city": "Ironwood",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7639,
      "name": "ENJOY VARIETY",
      "rookie_year": "2019",
      "city": "SHENZHEN",
      "state": "Anhui",
      "country": "China",
      "district": ""
    },
    {
      "number": 7640,
      "name": "CK Steam UNION",
      "rookie_year": "2019",
      "city": "hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 7641,
      "name": "Normal Force",
      "rookie_year": "2019",
      "city": "Tainan",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7642,
      "name": "BozlakS",
      "rookie_year": "2019",
      "city": "k\u0131r\u015fehir",
      "state": "Kirsehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7643,
      "name": "UWCDR",
      "rookie_year": "2019",
      "city": "Dilijan",
      "state": "Tavu\u0161",
      "country": "Armenia",
      "district": ""
    },
    {
      "number": 7644,
      "name": "CCHS",
      "rookie_year": "2019",
      "city": " Changhua City",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7645,
      "name": "NK MTC",
      "rookie_year": "2019",
      "city": "Taipei City",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7646,
      "name": "Cadets",
      "rookie_year": "2019",
      "city": "Cresco",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7647,
      "name": "Juventics",
      "rookie_year": "2019",
      "city": "Guadalupe",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7648,
      "name": "McMainFrame",
      "rookie_year": "2019",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7649,
      "name": "Feles Numine",
      "rookie_year": "2019",
      "city": "Santa Fe",
      "state": "New Mexico",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7650,
      "name": "Monte Pacis Robotics",
      "rookie_year": "2019",
      "city": "Gossau",
      "state": "Sankt Gallen",
      "country": "Switzerland",
      "district": ""
    },
    {
      "number": 7651,
      "name": "Bethlehem Eagles",
      "rookie_year": "2019",
      "city": "Bethlehem",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7652,
      "name": "MiamiBeachBots",
      "rookie_year": "2019",
      "city": "Miami Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7653,
      "name": "PE\u00d1OLES - Minebots 7653",
      "rookie_year": "2019",
      "city": "Santiago Papasquiaro",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7654,
      "name": "Robot In Box",
      "rookie_year": "2019",
      "city": "Henderson",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7655,
      "name": "Hamburg Robotics Team",
      "rookie_year": "2019",
      "city": "Hamburg",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7656,
      "name": "MC Hammers",
      "rookie_year": "2019",
      "city": "Michigan Center",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7657,
      "name": "ThunderBots",
      "rookie_year": "2019",
      "city": "Evansville",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 7658,
      "name": "MagiTech",
      "rookie_year": "2019",
      "city": "Kalamazoo",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7659,
      "name": "HNMCS Robotics",
      "rookie_year": "2019",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7660,
      "name": "The Byting Irish",
      "rookie_year": "2019",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7661,
      "name": "SciHigh Nautili",
      "rookie_year": "2019",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7662,
      "name": "3RingCircuits",
      "rookie_year": "2019",
      "city": "Lebanon",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7663,
      "name": "Sleuth Robotics",
      "rookie_year": "2019",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7664,
      "name": "Big Celtic 6",
      "rookie_year": "2019",
      "city": "Guelph",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7665,
      "name": "GL Gadgets",
      "rookie_year": "2019",
      "city": "Grand Ledge",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7667,
      "name": "OtterBots",
      "rookie_year": "2019",
      "city": "Napa",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7668,
      "name": "GatorBots",
      "rookie_year": "2019",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7669,
      "name": "Pe\u00f1oles - Techno R4v7ns",
      "rookie_year": "2019",
      "city": "Gomez Palacio",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7670,
      "name": "Highlanders",
      "rookie_year": "2019",
      "city": "Claysville",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7671,
      "name": "Fire Hazard",
      "rookie_year": "2019",
      "city": "Creedmoor",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 7672,
      "name": "SCORPIONS",
      "rookie_year": "2019",
      "city": "ANTALYA",
      "state": "Antalya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7673,
      "name": "Formosan Sika",
      "rookie_year": "2019",
      "city": "New Taipei City",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7674,
      "name": "RaiderBots",
      "rookie_year": "2019",
      "city": "Rochester",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7675,
      "name": "Spark Guardians ",
      "rookie_year": "2019",
      "city": "Gatesville",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7676,
      "name": "THS RoboDogs",
      "rookie_year": "2019",
      "city": "Thomson",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 7677,
      "name": "Bodacious Bulldogs",
      "rookie_year": "2019",
      "city": "Swanville",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7678,
      "name": "DONKERRY",
      "rookie_year": "2019",
      "city": "Ciudad de Mexico",
      "state": "",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7679,
      "name": "ROBOVAN",
      "rookie_year": "2019",
      "city": "Ipekyolu",
      "state": "Van",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7680,
      "name": "DFORCE",
      "rookie_year": "2019",
      "city": "ANKARA",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7681,
      "name": "haxhax",
      "rookie_year": "2019",
      "city": "Afyonkarahisar",
      "state": "Afyonkarahisar",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7682,
      "name": "FUSION ROBOTICS",
      "rookie_year": "2019",
      "city": "Bah\u00e7elievler",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7683,
      "name": "Harmonia",
      "rookie_year": "2019",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7684,
      "name": "first nilufer team",
      "rookie_year": "2019",
      "city": "BURSA",
      "state": "Bursa",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7685,
      "name": "SZALTech",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7686,
      "name": "Acabots",
      "rookie_year": "2019",
      "city": "Lafayette",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7687,
      "name": "PE\u00d1OLES - CORCEBOTS 7687",
      "rookie_year": "2019",
      "city": "BERMEJILLO",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7688,
      "name": "Creekside Robotics ",
      "rookie_year": "2019",
      "city": "Burnaby",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7689,
      "name": "WMC Robotics",
      "rookie_year": "2019",
      "city": "Muskegon",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7690,
      "name": "Ironworks Robotics",
      "rookie_year": "2019",
      "city": "Richmond Hill",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7691,
      "name": "TSA All Stars",
      "rookie_year": "2019",
      "city": "Tomball",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7692,
      "name": "Beach Bums",
      "rookie_year": "2019",
      "city": "Southfield",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7693,
      "name": "Craft Robotics",
      "rookie_year": "2019",
      "city": "Morehead",
      "state": "Kentucky",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7694,
      "name": "THE IRON LIONS",
      "rookie_year": "2019",
      "city": "West Hartford",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7695,
      "name": "Trojan Thunder",
      "rookie_year": "2019",
      "city": "Highland",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7696,
      "name": "Gear Hounds ",
      "rookie_year": "2019",
      "city": "Grandview",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7699,
      "name": "VeneBot Robotics",
      "rookie_year": "2019",
      "city": "Maracaibo",
      "state": "Zulia",
      "country": "Venezuela",
      "district": ""
    },
    {
      "number": 7700,
      "name": "West Tech Paladins",
      "rookie_year": "2019",
      "city": "Westmount",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7701,
      "name": "A\u00e9robot",
      "rookie_year": "2019",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7702,
      "name": "Lions.exe",
      "rookie_year": "2019",
      "city": "Clarendon",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7703,
      "name": "RoboBears",
      "rookie_year": "2019",
      "city": "Scottsdale",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7704,
      "name": "Kimball E-TECH / HarozTec",
      "rookie_year": "2019",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7705,
      "name": "Mustangs Robotics",
      "rookie_year": "2019",
      "city": "Sugar Land",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7706,
      "name": "Rottweilers Robotics",
      "rookie_year": "2019",
      "city": "Torre\u00f3n",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7707,
      "name": "Cutting Edge Robotics",
      "rookie_year": "2019",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 7708,
      "name": "Tiger Nation ",
      "rookie_year": "2019",
      "city": "Terrell",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7709,
      "name": "Formosa Pangolin",
      "rookie_year": "2019",
      "city": "Ban Qiao District",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7710,
      "name": "Mowat Mustangs",
      "rookie_year": "2019",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7711,
      "name": "Applewood Axemen ",
      "rookie_year": "2019",
      "city": "Mississauga",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7712,
      "name": "ACCN UMOJA",
      "rookie_year": "2019",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7713,
      "name": "The Sons & Daughters of Ivaldi, Norse-code",
      "rookie_year": "2019",
      "city": "Felch",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7714,
      "name": "RedRoad",
      "rookie_year": "2019",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7715,
      "name": "Robo-Banditos",
      "rookie_year": "2019",
      "city": "Elizabeth City",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 7716,
      "name": "JLW Formula 01",
      "rookie_year": "2019",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7717,
      "name": "Steam Punks",
      "rookie_year": "2019",
      "city": "Santo Domingo",
      "state": "Distrito Nacional",
      "country": "Dominican Republic",
      "district": ""
    },
    {
      "number": 7718,
      "name": "HVPA Dragons",
      "rookie_year": "2019",
      "city": "Ulster Park",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7719,
      "name": "Java Knights",
      "rookie_year": "2019",
      "city": "Depok",
      "state": "Jawa Barat",
      "country": "Indonesia",
      "district": ""
    },
    {
      "number": 7720,
      "name": "\u26a0\ufe0f Dallas Area Robotics Experience \u26a0\ufe0f ",
      "rookie_year": "2019",
      "city": "Carrollton",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7721,
      "name": "UHS Wolfpack",
      "rookie_year": "2019",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7722,
      "name": "Resurrection MechaPhoenix",
      "rookie_year": "2019",
      "city": "Kitchener",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7723,
      "name": "Tiger Robotics",
      "rookie_year": "2019",
      "city": "Thunder Bay",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7724,
      "name": "Molokai Robotics",
      "rookie_year": "2019",
      "city": "Hoolehua",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7725,
      "name": "PrepaTec - NUTS & VOLTS",
      "rookie_year": "2019",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7726,
      "name": "ShanDong Experimental High School",
      "rookie_year": "2019",
      "city": "Jinan",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7727,
      "name": "Iteration Beaker",
      "rookie_year": "2019",
      "city": "Jinan",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7728,
      "name": "CAAFE",
      "rookie_year": "2019",
      "city": "Windermere",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7729,
      "name": "RAMs",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7730,
      "name": "Aperture Robotics",
      "rookie_year": "2019",
      "city": "Thiells",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7731,
      "name": "CTB Robotics Team",
      "rookie_year": "2019",
      "city": "Thai Binh",
      "state": "Thai Binh",
      "country": "Vietnam",
      "district": ""
    },
    {
      "number": 7732,
      "name": "Artificial Intelligence",
      "rookie_year": "2019",
      "city": "Wuxi",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 7733,
      "name": "GreenHSGS Robotics Team",
      "rookie_year": "2019",
      "city": "Ha Noi",
      "state": "Ha Noi",
      "country": "Vietnam",
      "district": ""
    },
    {
      "number": 7734,
      "name": "High School of Education Sciences",
      "rookie_year": "2019",
      "city": "Hanoi",
      "state": "Ha Noi",
      "country": "Vietnam",
      "district": ""
    },
    {
      "number": 7735,
      "name": "Silver Knights",
      "rookie_year": "2019",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7736,
      "name": "DRAMA KINGS",
      "rookie_year": "2019",
      "city": "Qingdao",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7737,
      "name": "RaptorBotics",
      "rookie_year": "2019",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7738,
      "name": "Helion",
      "rookie_year": "2019",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 7739,
      "name": "Royal Tech Warriors",
      "rookie_year": "2019",
      "city": "Tarboro",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7740,
      "name": "Iron Donkeys",
      "rookie_year": "2019",
      "city": "Pachuca",
      "state": "Hidalgo",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7741,
      "name": "RSSH",
      "rookie_year": "2019",
      "city": "Kaohsiung",
      "state": "Kaohsiung Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 7742,
      "name": "Cosmos Robot Works",
      "rookie_year": "2019",
      "city": "\u00dcsk\u00fcdar",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7743,
      "name": "ShanDong Experimental High School",
      "rookie_year": "2019",
      "city": "Jinan",
      "state": "Shandong",
      "country": "China",
      "district": ""
    },
    {
      "number": 7744,
      "name": "Wild Cards",
      "rookie_year": "2019",
      "city": "Collinsville",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7745,
      "name": "College Heights",
      "rookie_year": "2019",
      "city": "Guelph",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7746,
      "name": "Culture",
      "rookie_year": "2019",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7747,
      "name": "Hancock High Tech",
      "rookie_year": "2019",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7748,
      "name": "TECHTOLIA ROBOTICS",
      "rookie_year": "2019",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7749,
      "name": "Level UP",
      "rookie_year": "2019",
      "city": "Dallas",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7750,
      "name": "Alpine Robo-Bucks",
      "rookie_year": "2019",
      "city": "Alpine",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 7751,
      "name": "The A.E.A.-ALTimate Electric Androids ",
      "rookie_year": "2019",
      "city": "West Branch",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7752,
      "name": "ROBYBAM",
      "rookie_year": "2019",
      "city": "Tijuana",
      "state": "Baja California",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7753,
      "name": "Tj Robotics",
      "rookie_year": "2019",
      "city": "Tijuana",
      "state": "Baja California",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 7754,
      "name": "STAR",
      "rookie_year": "2019",
      "city": "Saint Augustine",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7755,
      "name": "Phantom Circuits",
      "rookie_year": "2019",
      "city": "Casa Grande",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7756,
      "name": "Bionic Blue Devils",
      "rookie_year": "2019",
      "city": "Hopewell",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7757,
      "name": "Atomic Dishwashers",
      "rookie_year": "2019",
      "city": "Owen Sound",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7758,
      "name": "MEVOLUTION",
      "rookie_year": "2019",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7759,
      "name": "Bulldog Bytes",
      "rookie_year": "2019",
      "city": "Irvington",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7760,
      "name": "PomTech",
      "rookie_year": "2019",
      "city": "Pomfret",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7761,
      "name": "Eagle Tech",
      "rookie_year": "2019",
      "city": "Kartal",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7762,
      "name": "AutoPilots",
      "rookie_year": "2019",
      "city": "Warren",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7763,
      "name": "Carrborobotics",
      "rookie_year": "2019",
      "city": "Carrboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 7764,
      "name": "Voltech",
      "rookie_year": "2019",
      "city": "Santiago",
      "state": "Regi\u00f3n Metropolitana de Santiago",
      "country": "Chile",
      "district": ""
    },
    {
      "number": 7765,
      "name": "STEM SOP\u00d3",
      "rookie_year": "2019",
      "city": "SOP\u00d3",
      "state": "Cundinamarca",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 7766,
      "name": "Panthers",
      "rookie_year": "2019",
      "city": "Heber Springs",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7767,
      "name": "Rock City Robots",
      "rookie_year": "2019",
      "city": "Little Rock",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7768,
      "name": "The Iron Hill Automatons",
      "rookie_year": "2019",
      "city": "Iron River",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7769,
      "name": "The CREW",
      "rookie_year": "2019",
      "city": "Royal Oak",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7770,
      "name": "Infinite Voltage",
      "rookie_year": "2019",
      "city": "Bel Air",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 7771,
      "name": "Lakewood Robotics",
      "rookie_year": "2019",
      "city": "Lakewood",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7772,
      "name": "The Lucky 7's",
      "rookie_year": "2019",
      "city": "Montrose",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7773,
      "name": "UB Ignite",
      "rookie_year": "2019",
      "city": "Park Hills",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7774,
      "name": "Duval Techs",
      "rookie_year": "2019",
      "city": "Jacksonville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7775,
      "name": "Dunedin Talons",
      "rookie_year": "2019",
      "city": "Dunedin",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7776,
      "name": "MVR",
      "rookie_year": "2019",
      "city": "Okanogan",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7777,
      "name": "Septobots",
      "rookie_year": "2019",
      "city": "Greenfield",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7778,
      "name": "D' Elite Cookies",
      "rookie_year": "2019",
      "city": "Bakersfield",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7779,
      "name": "Under Pressure",
      "rookie_year": "2019",
      "city": "Perth",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7780,
      "name": "Colyton High School",
      "rookie_year": "2019",
      "city": "Colyton",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7781,
      "name": "Port Moody Robotics",
      "rookie_year": "2019",
      "city": "Port Moody",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7782,
      "name": "Wolverine Circuit Breakers",
      "rookie_year": "2019",
      "city": "Rock",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7783,
      "name": "St. Mary's Preparatory",
      "rookie_year": "2019",
      "city": "Orchard Lake",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7784,
      "name": "Vassar Voltage",
      "rookie_year": "2019",
      "city": "Vassar",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7785,
      "name": "Mechanical Mustangs",
      "rookie_year": "2019",
      "city": "Shenandoah",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7786,
      "name": "Power Surge",
      "rookie_year": "2019",
      "city": "Woodbury",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7787,
      "name": "Reynolds Reybots",
      "rookie_year": "2019",
      "city": "Victoria",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7788,
      "name": "The Electro Vikings",
      "rookie_year": "2019",
      "city": "Inkster",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7789,
      "name": "Oakland Panthers",
      "rookie_year": "2019",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7790,
      "name": "Baywatch Robotics",
      "rookie_year": "2019",
      "city": "Harbor Springs",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7791,
      "name": "Lincoln Abes",
      "rookie_year": "2019",
      "city": "Warren",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7792,
      "name": "ROBOTAYFA",
      "rookie_year": "2019",
      "city": "Reyhanl\u0131",
      "state": "Hatay",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7793,
      "name": "Team Zimbabwe",
      "rookie_year": "2019",
      "city": "Harare",
      "state": "Harare",
      "country": "Zimbabwe",
      "district": ""
    },
    {
      "number": 7794,
      "name": "Marion Eagle Engineers",
      "rookie_year": "2019",
      "city": "Marion",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7795,
      "name": "Norse Code",
      "rookie_year": "2019",
      "city": "Winthrop",
      "state": "Massachusetts",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7796,
      "name": "Breaker Robotics",
      "rookie_year": "2019",
      "city": "Richmond",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7797,
      "name": "Cloquet's RipSaw Robotics",
      "rookie_year": "2019",
      "city": "Cloquet",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7798,
      "name": "Cougar Coders",
      "rookie_year": "2019",
      "city": "Helena",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7799,
      "name": "Phat Cache",
      "rookie_year": "2019",
      "city": "Calgary",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7800,
      "name": "Electric Comets",
      "rookie_year": "2019",
      "city": "Windsor",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7801,
      "name": "Frisch CouGears",
      "rookie_year": "2019",
      "city": "Paramus",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7802,
      "name": "Dust Devils",
      "rookie_year": "2019",
      "city": "Dayton",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7803,
      "name": "Pioneer Robotics",
      "rookie_year": "2019",
      "city": "Omak",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7804,
      "name": "Team Sabotage",
      "rookie_year": "2019",
      "city": "Cabot",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7805,
      "name": "Walnut Grove Gators",
      "rookie_year": "2019",
      "city": "Langley",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7806,
      "name": "KDHS Kolts",
      "rookie_year": "2019",
      "city": "Kapuskasing",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7807,
      "name": "Cambridge Panthers",
      "rookie_year": "2019",
      "city": "Garden City",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7808,
      "name": "Dragoneers",
      "rookie_year": "2019",
      "city": "Kalkaska",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7809,
      "name": "Valhalla Nation",
      "rookie_year": "2019",
      "city": "Bangor",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7810,
      "name": "Eagle Robotics",
      "rookie_year": "2019",
      "city": "Muskegon",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7811,
      "name": "Flamin' Hot Tigers",
      "rookie_year": "2019",
      "city": "Battle Creek",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7812,
      "name": "Robot Warriors",
      "rookie_year": "2019",
      "city": "Ionia",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7813,
      "name": "New Haven Rockets Robotics",
      "rookie_year": "2019",
      "city": "New Haven",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7814,
      "name": "River Valley Gearheads",
      "rookie_year": "2019",
      "city": "Three Oaks",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7815,
      "name": "CavBots",
      "rookie_year": "2019",
      "city": "Spencer",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7816,
      "name": "Wizards of Wire",
      "rookie_year": "2019",
      "city": "Ishpeming",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7817,
      "name": "Lansing Catholic Cougars",
      "rookie_year": "2019",
      "city": "Lansing",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7818,
      "name": "Williamston High School",
      "rookie_year": "2019",
      "city": "Williamston",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7819,
      "name": "Automataardvarks",
      "rookie_year": "2019",
      "city": "Portland",
      "state": "Oregon",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7820,
      "name": "DawgBots",
      "rookie_year": "2019",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7821,
      "name": "Ravenna Bulldogs Robotics",
      "rookie_year": "2019",
      "city": "Ravenna",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7822,
      "name": "Generals Robotics",
      "rookie_year": "2019",
      "city": "South Hamilton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7823,
      "name": "Double Negative",
      "rookie_year": "2019",
      "city": "Rogers City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7824,
      "name": "165th Airlift Wing Air National Guard Eagles",
      "rookie_year": "2019",
      "city": "Savannah",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7825,
      "name": "DAMBAZE",
      "rookie_year": "2019",
      "city": "\u0130ZM\u0130T",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7826,
      "name": "Marquette Robotics",
      "rookie_year": "2019",
      "city": "Marquette",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7827,
      "name": "Yooper Robotics",
      "rookie_year": "2019",
      "city": "Crystal Falls",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7828,
      "name": "KALROBOTICS",
      "rookie_year": "2019",
      "city": "Kad\u0131koy",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7829,
      "name": "test team turkey",
      "rookie_year": "2019",
      "city": "test",
      "state": "Kahramanmaras",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7830,
      "name": "Ultimate Robotics",
      "rookie_year": "2019",
      "city": "\u00dcsk\u00fcdar",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7831,
      "name": "BAL\u0130STA B\u0130LSEM",
      "rookie_year": "2019",
      "city": "\u0130STANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7832,
      "name": "Hayata Destek",
      "rookie_year": "2019",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7833,
      "name": "FALCONS",
      "rookie_year": "2019",
      "city": "West Palm Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7834,
      "name": "Neville High School",
      "rookie_year": "2019",
      "city": "Monroe",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7835,
      "name": "APRIKOD",
      "rookie_year": "2019",
      "city": "KULUNCAK/MALATYA",
      "state": "Malatya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7836,
      "name": "NEC@ Co-Lin",
      "rookie_year": "2019",
      "city": "Natchez",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7837,
      "name": "Mechanised Chaos",
      "rookie_year": "2019",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7838,
      "name": "Crobotics",
      "rookie_year": "2019",
      "city": "Crows Nest",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7839,
      "name": "Night Fury",
      "rookie_year": "2019",
      "city": "Be\u015fikta\u015f",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7840,
      "name": "EMONER ROBOTICS",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7841,
      "name": "TECHNO-ROB",
      "rookie_year": "2019",
      "city": "\u00c7AYIROVA",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7842,
      "name": "LVGalaxy",
      "rookie_year": "2019",
      "city": "Lake Village",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7843,
      "name": "The Galactic Defenders",
      "rookie_year": "2019",
      "city": "Bentley",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7844,
      "name": "Yirara Colleg",
      "rookie_year": "2019",
      "city": "Alice Springs",
      "state": "Northern Territory",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7845,
      "name": "8BIT",
      "rookie_year": "2019",
      "city": "Jerusalem",
      "state": "Yerushalayim",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 7846,
      "name": "Zombie Squad",
      "rookie_year": "2019",
      "city": "Barton",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7847,
      "name": "Lincoln's Horse Power....Abraham Lincoln Robotics Club",
      "rookie_year": "2019",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7848,
      "name": "WI-FIghterz",
      "rookie_year": "2019",
      "city": "Pontiac",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7849,
      "name": "Da Vinci's Creation",
      "rookie_year": "2019",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7850,
      "name": "C.A.R.D.S.",
      "rookie_year": "2019",
      "city": "Coon Rapids",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7851,
      "name": "NeuraBl!nk",
      "rookie_year": "2019",
      "city": "Kyiv",
      "state": "Ky\u00efv",
      "country": "Ukraine",
      "district": ""
    },
    {
      "number": 7852,
      "name": "DEN\u0130ZYILDIZLARI_MTAL",
      "rookie_year": "2019",
      "city": "DARICA",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7853,
      "name": "Kronecker Delta",
      "rookie_year": "2019",
      "city": "Elizabeth",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7854,
      "name": "MTCPS Bathers",
      "rookie_year": "2019",
      "city": "Mount Clemens",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7855,
      "name": "Bone Yard Bro-bots",
      "rookie_year": "2019",
      "city": "Mesick",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7856,
      "name": "UPAD NASA Fusion",
      "rookie_year": "2019",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7857,
      "name": "OPFI Robo Knights",
      "rookie_year": "2019",
      "city": "Oak Park",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7858,
      "name": "Warriors",
      "rookie_year": "2019",
      "city": "Olivia",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7859,
      "name": "Summit Electro-Dragons",
      "rookie_year": "2019",
      "city": "Romulus",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7860,
      "name": "Falcon",
      "rookie_year": "2019",
      "city": "Sterling Heights",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7861,
      "name": "The Wildkatz - RoboKatz",
      "rookie_year": "2019",
      "city": "Alba",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7862,
      "name": "Mott Bears",
      "rookie_year": "2019",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7863,
      "name": "ATA",
      "rookie_year": "2019",
      "city": "DETROIT",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7864,
      "name": "North Woods Robotics ",
      "rookie_year": "2019",
      "city": "Cook",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7865,
      "name": "Hope of Detroit Robotics",
      "rookie_year": "2019",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7866,
      "name": "Balista",
      "rookie_year": "2019",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7867,
      "name": "NEBULA",
      "rookie_year": "2019",
      "city": "TEPEBASI",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7868,
      "name": "FC Mustangs",
      "rookie_year": "2019",
      "city": "Forrest City",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7869,
      "name": "The Fun Gang",
      "rookie_year": "2019",
      "city": "New Haven",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7870,
      "name": "The RoboHawks",
      "rookie_year": "2019",
      "city": "Reno",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7871,
      "name": "South Gate High School Robotics",
      "rookie_year": "2019",
      "city": "South Gate",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7872,
      "name": "Wimberley Wavelengths",
      "rookie_year": "2019",
      "city": "Wimberley",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7873,
      "name": "AURORA",
      "rookie_year": "2019",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 7874,
      "name": "RoboCats",
      "rookie_year": "2019",
      "city": "Monroe",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7875,
      "name": "MNIC Robotics",
      "rookie_year": "2019",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7876,
      "name": "AC JONES ROBOTICS",
      "rookie_year": "2019",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 7877,
      "name": "Neuro Brytes",
      "rookie_year": "2019",
      "city": "Camden",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 7878,
      "name": "PBHS Robotics Team",
      "rookie_year": "2019",
      "city": "Pine Bluff",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7879,
      "name": "TigerBots",
      "rookie_year": "2019",
      "city": "Hanover",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7880,
      "name": "Rancho R.A.T.S.",
      "rookie_year": "2019",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7881,
      "name": "Cuyahoga Heights High School",
      "rookie_year": "2019",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7882,
      "name": "SKYFIRST",
      "rookie_year": "2019",
      "city": "TEL AVIV",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 7883,
      "name": "CCHS RazorBots ",
      "rookie_year": "2019",
      "city": "Augusta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7884,
      "name": "Delta Phoenix",
      "rookie_year": "2019",
      "city": "Parramatta",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 7885,
      "name": "Spinning Dragons",
      "rookie_year": "2019",
      "city": "Elyria",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7886,
      "name": "Cadet Robotics",
      "rookie_year": "2019",
      "city": "Frederick",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 7887,
      "name": "Final FRONTIER",
      "rookie_year": "2019",
      "city": "Camarillo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7889,
      "name": "OSAT",
      "rookie_year": "2019",
      "city": "Edmonton",
      "state": "Alberta",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 7890,
      "name": "SeQuEnCe",
      "rookie_year": "2019",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 7891,
      "name": "Inov8",
      "rookie_year": "2019",
      "city": "Longmont",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7892,
      "name": "Medford RoboTigers",
      "rookie_year": "2019",
      "city": "Medford",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7893,
      "name": "Maple Lake High School",
      "rookie_year": "2019",
      "city": "Maple Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7894,
      "name": "The Hawk Nation",
      "rookie_year": "2019",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7895,
      "name": "Trobots",
      "rookie_year": "2019",
      "city": "Homedale",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7896,
      "name": "CyberNoles",
      "rookie_year": "2019",
      "city": "Osceola",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7897,
      "name": "WHS Auto Barks",
      "rookie_year": "2019",
      "city": "Winslow",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7898,
      "name": "Cool Geeks",
      "rookie_year": "2019",
      "city": "Honolulu",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7899,
      "name": "Gibsland-Coleman STEM Club",
      "rookie_year": "2019",
      "city": "Gibsland",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7900,
      "name": "Trial & Terror",
      "rookie_year": "2019",
      "city": "Racine",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7901,
      "name": "Snow Hill Robotics",
      "rookie_year": "2019",
      "city": "Snow Hill",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7902,
      "name": "Markham FireBirds",
      "rookie_year": "2019",
      "city": "Markham",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 7903,
      "name": "Rochester Prep",
      "rookie_year": "2019",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7904,
      "name": "Mountaineers",
      "rookie_year": "2019",
      "city": "Highwood",
      "state": "Montana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7905,
      "name": "Night Hawks",
      "rookie_year": "2019",
      "city": "Clearfield",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7906,
      "name": "Underdogs",
      "rookie_year": "2019",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7907,
      "name": "Spartan Robotics",
      "rookie_year": "2019",
      "city": "Whitefield",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7908,
      "name": "MARVELL MAKERS",
      "rookie_year": "2019",
      "city": "Marvell",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7909,
      "name": "GTI WingNuts",
      "rookie_year": "2019",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7910,
      "name": "Crossett Eagles",
      "rookie_year": "2019",
      "city": "Crossett",
      "state": "Arkansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7911,
      "name": "Belding Scrapcat Robotics",
      "rookie_year": "2019",
      "city": "Belding",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 7912,
      "name": "Flex Tech Robotics",
      "rookie_year": "2019",
      "city": "Novi",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7913,
      "name": "\"Bear\"ly Functioning",
      "rookie_year": "2019",
      "city": "Bristol",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 7914,
      "name": "CHS RoboDogs",
      "rookie_year": "2019",
      "city": "Monroe",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 7915,
      "name": "Ripon Robotics",
      "rookie_year": "2019",
      "city": "Ripon",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8002,
      "name": "The Knack",
      "rookie_year": "2020",
      "city": "Hartland",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8003,
      "name": "Bushmen Robotics",
      "rookie_year": "2020",
      "city": "Pine Bush",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8004,
      "name": "Tigris ex Machina",
      "rookie_year": "2020",
      "city": "Waynesville",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8005,
      "name": "Mega MeadowBots",
      "rookie_year": "2020",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8006,
      "name": "The Phantoms, from Cathedral High School",
      "rookie_year": "2020",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8007,
      "name": "Hold Team 1",
      "rookie_year": "2020",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8011,
      "name": "Guangzhou Wayi",
      "rookie_year": "2020",
      "city": "Guangzhou",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8012,
      "name": "APEX Robotics",
      "rookie_year": "2020",
      "city": "Mesa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8013,
      "name": "Boston Lions",
      "rookie_year": "2020",
      "city": "Boston",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8014,
      "name": "Fortitude Robotics",
      "rookie_year": "2020",
      "city": "Aurora",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8015,
      "name": "The Cheetahs",
      "rookie_year": "2020",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8016,
      "name": "Eco Robotics",
      "rookie_year": "2020",
      "city": "Rohnert Park",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8017,
      "name": "SCREW IT!!",
      "rookie_year": "2020",
      "city": "taichung",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8018,
      "name": "Del Sol Dragons",
      "rookie_year": "2020",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8019,
      "name": "Patriot Engineering",
      "rookie_year": "2020",
      "city": "Mission",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8020,
      "name": "CyberpunK",
      "rookie_year": "2020",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8021,
      "name": "Panther Robotics",
      "rookie_year": "2020",
      "city": "Surprise",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8022,
      "name": "Raging Hawk Robotics",
      "rookie_year": "2020",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8023,
      "name": "LRTC 8023",
      "rookie_year": "2020",
      "city": "Lewiston",
      "state": "Maine",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8024,
      "name": "Sparta Robotans",
      "rookie_year": "2020",
      "city": "Sparta",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8025,
      "name": "Navigator Robotics ",
      "rookie_year": "2020",
      "city": "Kapolei",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8026,
      "name": "Tennessee Robotics Club",
      "rookie_year": "2020",
      "city": "Murfreesboro",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8027,
      "name": "Not the Droids You Are Looking For",
      "rookie_year": "2020",
      "city": "Sharon",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8028,
      "name": "The Resistance Network",
      "rookie_year": "2020",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8029,
      "name": "Steel Bronco Robotics",
      "rookie_year": "2020",
      "city": "Barrington",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8030,
      "name": "East lincoln Iron stangs",
      "rookie_year": "2020",
      "city": "Denver",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8031,
      "name": "Luminous",
      "rookie_year": "2020",
      "city": "Muratpa\u015fa",
      "state": "Antalya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8032,
      "name": "Redshift",
      "rookie_year": "2020",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8033,
      "name": "Highlander Robotics",
      "rookie_year": "2020",
      "city": "Piedmont",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8034,
      "name": "Butterfly Effect",
      "rookie_year": "2020",
      "city": "Bornova",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8035,
      "name": "Potential Failures",
      "rookie_year": "2020",
      "city": "Perth",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8036,
      "name": "Sneaky Snakes",
      "rookie_year": "2018",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8037,
      "name": "VW Cougar Robotics",
      "rookie_year": "2020",
      "city": "Van Wert",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8038,
      "name": "R.O.B. (Robots Outta Bristow)",
      "rookie_year": "2020",
      "city": "Bristow",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8039,
      "name": "ArtisanSoul",
      "rookie_year": "2020",
      "city": "Taipei",
      "state": "Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8040,
      "name": "ZODIAC",
      "rookie_year": "2020",
      "city": "TRABZON",
      "state": "Trabzon",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8041,
      "name": "Lake City Ultrabots",
      "rookie_year": "2020",
      "city": "Lake City",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8042,
      "name": "Fenrir",
      "rookie_year": "2020",
      "city": "ANTALYA",
      "state": "Antalya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8043,
      "name": "Neon Ryders",
      "rookie_year": "2020",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8044,
      "name": "Denham Venom",
      "rookie_year": "2020",
      "city": "Denham Springs",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8045,
      "name": "CVHS First Robotics: The Wallace Dynasty",
      "rookie_year": "2020",
      "city": "Castro Valley",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8046,
      "name": "LakerBots",
      "rookie_year": "2020",
      "city": "Meredith",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8047,
      "name": "YAKACIK ROBOTICS",
      "rookie_year": "2020",
      "city": "kartal",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8048,
      "name": "East Palo Alto Churrobots",
      "rookie_year": "2020",
      "city": "East Palo Alto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8049,
      "name": "Ironwood Ridge Robotics",
      "rookie_year": "2020",
      "city": "Oro Valley",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8050,
      "name": "Nova Robotics",
      "rookie_year": "2020",
      "city": "Ball Ground",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8051,
      "name": "TinkRex",
      "rookie_year": "2020",
      "city": "Tukwila",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8052,
      "name": "Water Bears",
      "rookie_year": "2020",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8053,
      "name": "Rage Against the Machine Robotics",
      "rookie_year": "2020",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8054,
      "name": "FLARE",
      "rookie_year": "2020",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8055,
      "name": "EGM Robotics - BOSS BOTS",
      "rookie_year": "2020",
      "city": "Frisco",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8056,
      "name": "ENS\u0130A Youth - Laissez Faire",
      "rookie_year": "2020",
      "city": "Gaziemir",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8057,
      "name": "All Wired Up",
      "rookie_year": "2020",
      "city": "Groveland",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8058,
      "name": "IEL ROBOTICS",
      "rookie_year": "2020",
      "city": "\u0130STANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8059,
      "name": "Robotics at Eastside Catholic (REC)",
      "rookie_year": "2020",
      "city": "Sammamish",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8060,
      "name": "Command B",
      "rookie_year": "2020",
      "city": "Valencia",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8061,
      "name": "Butler Tech Robotics",
      "rookie_year": "2020",
      "city": "Hamilton",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8062,
      "name": "O Hale Gnaw",
      "rookie_year": "2020",
      "city": "Tulsa",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8063,
      "name": "Tornado Robotics",
      "rookie_year": "2020",
      "city": "Drumright",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8064,
      "name": "Imperial Watch",
      "rookie_year": "2020",
      "city": "Drumright",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8065,
      "name": "Robarks",
      "rookie_year": "2020",
      "city": "Wagoner",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8066,
      "name": "WOLF ARMY ROBOTICS",
      "rookie_year": "2020",
      "city": "Lorena",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 8067,
      "name": "Alpha Lab",
      "rookie_year": "2020",
      "city": "Longueuil",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8068,
      "name": "Oakland Underground Robotics",
      "rookie_year": "2020",
      "city": "Waterford",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8069,
      "name": "Super Hornets",
      "rookie_year": "2020",
      "city": "Saint Charles",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8070,
      "name": "CyberGriffins",
      "rookie_year": "2020",
      "city": "Kad\u0131k\u00f6y",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8071,
      "name": "R3-D3 Mersin",
      "rookie_year": "2020",
      "city": "Mersin",
      "state": "Mersin",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8072,
      "name": "Tech Tigers",
      "rookie_year": "2020",
      "city": "Ottawa",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8073,
      "name": "Electron Affinity",
      "rookie_year": "2020",
      "city": "Ottawa",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8074,
      "name": "Rumble Bots",
      "rookie_year": "2020",
      "city": "Wewoka",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8075,
      "name": "CyberTigers",
      "rookie_year": "2020",
      "city": "Dover",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8076,
      "name": "Academy of Loudoun High School - Team Robo Loco # 5338",
      "rookie_year": "2020",
      "city": "Leesburg",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8077,
      "name": "Delmar Robotics Engineers At MADE (DREAM)",
      "rookie_year": "2020",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8078,
      "name": "G FORCE",
      "rookie_year": "2020",
      "city": "Menemen",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8079,
      "name": "River Robotics Team",
      "rookie_year": "2020",
      "city": "CADDEBOSTAN",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8080,
      "name": "Sequoyah Robotics",
      "rookie_year": "2020",
      "city": "Canton",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8081,
      "name": "UMEI Lightning Robotics",
      "rookie_year": "2020",
      "city": "Leamington",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8082,
      "name": "Tech-Mates",
      "rookie_year": "2020",
      "city": "Surrey",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8083,
      "name": "ALX Robotics",
      "rookie_year": "2020",
      "city": "Douglasville",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8084,
      "name": "ALFA ROBOTICS",
      "rookie_year": "2020",
      "city": "\u00fcmraniye",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8085,
      "name": "MOJO",
      "rookie_year": "2020",
      "city": "Milford",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8086,
      "name": "AnadarKODERS",
      "rookie_year": "2020",
      "city": "Anadarko",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8087,
      "name": "Cougar Pride Robotics",
      "rookie_year": "2020",
      "city": "Show Low",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8088,
      "name": "Bionic Panthers",
      "rookie_year": "2020",
      "city": "Liberty Hill",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8089,
      "name": "Rockway Robotics",
      "rookie_year": "2020",
      "city": "Kitchener",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8090,
      "name": "Mavnesium",
      "rookie_year": "2020",
      "city": "Roxboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8091,
      "name": "The Condors",
      "rookie_year": "2020",
      "city": "Castroville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8092,
      "name": "Greatest Of All Times",
      "rookie_year": "2020",
      "city": "Tekirda\u011f",
      "state": "Tekirdag",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8093,
      "name": "Ranger Force",
      "rookie_year": "2020",
      "city": "Spencerport",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8094,
      "name": "Back Road Robotics ",
      "rookie_year": "2020",
      "city": "Statesboro",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8095,
      "name": "ORDU TOBB MESLEK\u0130 VE TEKN\u0130K ANADOLU L\u0130SES\u0130",
      "rookie_year": "2020",
      "city": "ORDU",
      "state": "Ordu",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8096,
      "name": "Cache Money",
      "rookie_year": "2020",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8097,
      "name": "AREA 27",
      "rookie_year": "2020",
      "city": "Durham",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8098,
      "name": "Wildkat Robotiks FRC",
      "rookie_year": "2020",
      "city": "Willis",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8099,
      "name": "APEIRON ROBOTICS",
      "rookie_year": "2020",
      "city": "TRABZON",
      "state": "Trabzon",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8100,
      "name": "Grayson Robotics",
      "rookie_year": "2020",
      "city": "Grayson",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8101,
      "name": "Coo-Coo Pigeons",
      "rookie_year": "2020",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 8102,
      "name": "NAMETBD-DCLSTEM",
      "rookie_year": "2020",
      "city": "Wayne",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8103,
      "name": "East Noble High School",
      "rookie_year": "2020",
      "city": "Kendallville",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 8104,
      "name": "Squid Worx Robotics",
      "rookie_year": "2020",
      "city": "Jupiter",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8105,
      "name": "PE\u00d1OLES - Apollo Black Cat",
      "rookie_year": "2020",
      "city": "Torre\u00f3n",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8106,
      "name": "Toronto French School",
      "rookie_year": "2020",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8107,
      "name": "THS Robotics",
      "rookie_year": "2020",
      "city": "Torrington",
      "state": "Connecticut",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8108,
      "name": "Fantastic4Robotics",
      "rookie_year": "2020",
      "city": "Abingdon",
      "state": "Virginia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8109,
      "name": "Pirate Robotics",
      "rookie_year": "2020",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8110,
      "name": "Sugared Knights",
      "rookie_year": "2020",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 8111,
      "name": "Whiter Tiger",
      "rookie_year": "2020",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 8112,
      "name": "Cyclotrons",
      "rookie_year": "2020",
      "city": "Ottawa",
      "state": "Kansas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8113,
      "name": "Royal Thunder Robotics",
      "rookie_year": "2020",
      "city": "Sarnia",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8114,
      "name": "Rocketeers",
      "rookie_year": "2020",
      "city": "Boerne",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8115,
      "name": "Platinum Peacocks",
      "rookie_year": "2020",
      "city": "Chesterfield",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8116,
      "name": "Hatchet Robotics",
      "rookie_year": "2020",
      "city": "Washington",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 8117,
      "name": "RoboRovers",
      "rookie_year": "2020",
      "city": "Easton",
      "state": "Pennsylvania",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8118,
      "name": "Gearing With Grace",
      "rookie_year": "2020",
      "city": "Covington",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8119,
      "name": "TigerBotics",
      "rookie_year": "2020",
      "city": "Imperial",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8120,
      "name": "YORK MEMORIAL JAEGERS",
      "rookie_year": "2020",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8121,
      "name": "I.C.R.T.",
      "rookie_year": "2020",
      "city": "Tainan",
      "state": "Tainan Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8122,
      "name": "Robotic Eagles",
      "rookie_year": "2020",
      "city": "Chicago",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8123,
      "name": "Pace Enginerds",
      "rookie_year": "2020",
      "city": "Brownsville",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8124,
      "name": "BearBots",
      "rookie_year": "2020",
      "city": "Wyandotte",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8125,
      "name": "Artnox Robotic",
      "rookie_year": "2020",
      "city": "Fatih",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8126,
      "name": "Control Freaks",
      "rookie_year": "2020",
      "city": "Vicksburg",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8127,
      "name": "Team RaByte",
      "rookie_year": "2020",
      "city": "Warsaw",
      "state": "",
      "country": "Poland",
      "district": ""
    },
    {
      "number": 8128,
      "name": "ACE INNOVATORS",
      "rookie_year": "2020",
      "city": "Reno",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8129,
      "name": "ZZRT",
      "rookie_year": "2020",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8130,
      "name": "Fundamentals",
      "rookie_year": "2020",
      "city": "Absecon",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8131,
      "name": "Magnetech Vega",
      "rookie_year": "2020",
      "city": "Samsun",
      "state": "Samsun",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8132,
      "name": "Sysmik",
      "rookie_year": "2020",
      "city": "La Malbaie",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8133,
      "name": "JayBots",
      "rookie_year": "2020",
      "city": "Jeannette",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8134,
      "name": "SJP Eagle Botz",
      "rookie_year": "2020",
      "city": "Boca Raton",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8135,
      "name": "Legacy Robotics",
      "rookie_year": "2020",
      "city": "Santa Ana",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8136,
      "name": "STEAMLes",
      "rookie_year": "2020",
      "city": "Teyateyaneng",
      "state": "Berea",
      "country": "Lesotho",
      "district": ""
    },
    {
      "number": 8137,
      "name": "Byting Bulldogs",
      "rookie_year": "2020",
      "city": "Georgetown",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8138,
      "name": "SpicyBots",
      "rookie_year": "2020",
      "city": "Tacoma",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8139,
      "name": "Pirate Robotics",
      "rookie_year": "2020",
      "city": "Egg Harbor City",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8140,
      "name": "RoboManiacs",
      "rookie_year": "2020",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8141,
      "name": "LYBOTICS Girls Team",
      "rookie_year": "2020",
      "city": "Tripoli",
      "state": "Tarabulus",
      "country": "Libya",
      "district": ""
    },
    {
      "number": 8142,
      "name": "The Legion",
      "rookie_year": "2020",
      "city": "Riverside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8143,
      "name": "SOLUTION TURK",
      "rookie_year": "2020",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8144,
      "name": "Red Chair Robotics",
      "rookie_year": "2020",
      "city": "Cypress",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8145,
      "name": "Tech Warriors",
      "rookie_year": "2020",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8146,
      "name": "Albatros OSTIMTECH",
      "rookie_year": "2020",
      "city": "Ankara",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8147,
      "name": "Ekinoks",
      "rookie_year": "2020",
      "city": "BEYL\u0130KD\u00dcZ\u00dc / \u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8148,
      "name": "QUANTUM RANGERS",
      "rookie_year": "2020",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8149,
      "name": "RoboTesla",
      "rookie_year": "2020",
      "city": "Afyonkarah\u0131sar",
      "state": "Afyonkarahisar",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8150,
      "name": "Tungsten",
      "rookie_year": "2020",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8151,
      "name": "WildFire",
      "rookie_year": "2020",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8152,
      "name": "Escouade",
      "rookie_year": "2020",
      "city": "Saint-Charles-de-Bellechasse",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8153,
      "name": "Tech 4 Peace",
      "rookie_year": "2020",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8154,
      "name": "Gibuu",
      "rookie_year": "2020",
      "city": "Aiyansh",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8155,
      "name": "Uranos",
      "rookie_year": "2020",
      "city": "Antakya",
      "state": "Hatay",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8156,
      "name": "Khalkedon TEAM",
      "rookie_year": "2020",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8157,
      "name": "St. Augustine Prep",
      "rookie_year": "2020",
      "city": "Richland",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8158,
      "name": "Bosphorus Robotics",
      "rookie_year": "2020",
      "city": "Be\u015fikta\u015f",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8159,
      "name": "Golden Horn",
      "rookie_year": "2020",
      "city": "Ata\u015fehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8160,
      "name": "Oly Rock Stars",
      "rookie_year": "2020",
      "city": "Matteson",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8161,
      "name": "Chihuahuas Robotics Team",
      "rookie_year": "2020",
      "city": "Chihuahua",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8162,
      "name": "FaTech",
      "rookie_year": "2020",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8163,
      "name": "Phoenix",
      "rookie_year": "2020",
      "city": "Zhenjiang",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 8164,
      "name": "RADIUM",
      "rookie_year": "2020",
      "city": "Foshan",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8165,
      "name": "Bahlam Bots",
      "rookie_year": "2020",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8166,
      "name": "INTECHNE",
      "rookie_year": "2020",
      "city": "Pendik",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8167,
      "name": "Cognatives",
      "rookie_year": "2020",
      "city": "Durham",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8168,
      "name": "Northeast",
      "rookie_year": "2020",
      "city": "Rochester",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8169,
      "name": "Kangshan Super Steel Robot",
      "rookie_year": "2020",
      "city": "Kangshan",
      "state": "Kaohsiung Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8170,
      "name": "Fi-Lab",
      "rookie_year": "2020",
      "city": "Taipei",
      "state": "Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8171,
      "name": "RL Robotics",
      "rookie_year": "2020",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8172,
      "name": "Celestial Shadow",
      "rookie_year": "2020",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8173,
      "name": "Brighton College",
      "rookie_year": "2020",
      "city": "Brighton",
      "state": "England",
      "country": "United Kingdom",
      "district": ""
    },
    {
      "number": 8174,
      "name": "Titan Robotics",
      "rookie_year": "2020",
      "city": "Salt Lake City",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8175,
      "name": "Piece of Mind",
      "rookie_year": "2020",
      "city": "Emek Yizrael",
      "state": "HaZafon",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 8176,
      "name": "Alien Robotics",
      "rookie_year": "2020",
      "city": "Douliu City",
      "state": "Yunlin",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8177,
      "name": "Vector",
      "rookie_year": "2020",
      "city": "Tomball",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8178,
      "name": "Sky Honor",
      "rookie_year": "2020",
      "city": "tainan city",
      "state": "Tainan Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8179,
      "name": "Robo Falcons",
      "rookie_year": "2020",
      "city": "Dearborn",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8180,
      "name": "ChainsMaker",
      "rookie_year": "2020",
      "city": "Taipei",
      "state": "Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8181,
      "name": "Bilsem Robotics",
      "rookie_year": "2020",
      "city": "Ba\u015fak\u015fehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8182,
      "name": "Loth Robotics",
      "rookie_year": "2020",
      "city": "Be\u015fikta\u015f",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8183,
      "name": "WAO",
      "rookie_year": "2020",
      "city": "shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8184,
      "name": "ROBOTTACK",
      "rookie_year": "2020",
      "city": "Silivri",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8185,
      "name": "Blue Sky Eagle",
      "rookie_year": "2020",
      "city": "NANJING",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 8186,
      "name": "Belle Glade Boys & Girls Club",
      "rookie_year": "2020",
      "city": "Belle Glade",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8187,
      "name": "CyberPunks",
      "rookie_year": "2020",
      "city": "Kyiv",
      "state": "Ky\u00efv",
      "country": "Ukraine",
      "district": ""
    },
    {
      "number": 8188,
      "name": "Grand Force",
      "rookie_year": "2020",
      "city": "Grand Forks",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8189,
      "name": "SubCat Academy ",
      "rookie_year": "2020",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8190,
      "name": "\u0130sov Robotic Team",
      "rookie_year": "2020",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8191,
      "name": "Barbados Robotics Team",
      "rookie_year": "2020",
      "city": "Waterford",
      "state": "Saint Michael",
      "country": "Barbados",
      "district": ""
    },
    {
      "number": 8192,
      "name": "Luminous",
      "rookie_year": "2020",
      "city": "Muratpa\u015fa",
      "state": "Antalya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8193,
      "name": "The Steel Stingers",
      "rookie_year": "2020",
      "city": "New Lothrop",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8194,
      "name": "Robo Bulls",
      "rookie_year": "2020",
      "city": "Ventura",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8195,
      "name": "Bullbots",
      "rookie_year": "2020",
      "city": "Ventura",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8197,
      "name": "AirTigers8197",
      "rookie_year": "2020",
      "city": "Lanham",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8198,
      "name": "Baker Hornets",
      "rookie_year": "2020",
      "city": "Mobile",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8200,
      "name": "ANATOLIAN BEES",
      "rookie_year": "2020",
      "city": "D\u00fczce",
      "state": "D\u00fczce",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8202,
      "name": "BeAr",
      "rookie_year": "2020",
      "city": "Rancho Cucamonga",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8203,
      "name": "ROBARGEM",
      "rookie_year": "2020",
      "city": "ISTANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8204,
      "name": "Keystone Robotics",
      "rookie_year": "2020",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 8205,
      "name": "Mind Over Metal",
      "rookie_year": "2020",
      "city": "Wilmington",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8206,
      "name": "Team NeXT",
      "rookie_year": "2020",
      "city": "newdelhi",
      "state": "Delhi",
      "country": "India",
      "district": ""
    },
    {
      "number": 8207,
      "name": "Orenda",
      "rookie_year": "2020",
      "city": "Izmir",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8208,
      "name": "SYCAMORE",
      "rookie_year": "2020",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8209,
      "name": "SEZMECH",
      "rookie_year": "2020",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8210,
      "name": "Rambotics Inc.",
      "rookie_year": "2020",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8211,
      "name": "Ranger Robots ",
      "rookie_year": "2020",
      "city": "Port Hueneme CBC Base",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8212,
      "name": "Dragon Effect",
      "rookie_year": "2020",
      "city": "Port Hueneme CBC Base",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8213,
      "name": "Trinity Christian High School",
      "rookie_year": "2020",
      "city": "Monterey",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8214,
      "name": "Cyber Unicorn",
      "rookie_year": "2020",
      "city": "Shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8215,
      "name": "High Five",
      "rookie_year": "2020",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8216,
      "name": "Vision Robotics",
      "rookie_year": "2020",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8217,
      "name": "Generals Robotics",
      "rookie_year": "2020",
      "city": "Arlington",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8218,
      "name": "German Engineering",
      "rookie_year": "2020",
      "city": "D\u00fcsseldorf",
      "state": "Nordrhein-Westfalen",
      "country": "Germany",
      "district": ""
    },
    {
      "number": 8219,
      "name": "BG Robotics",
      "rookie_year": "2020",
      "city": "Sofia",
      "state": "Sofia-Grad",
      "country": "Bulgaria",
      "district": ""
    },
    {
      "number": 8220,
      "name": "Space Tigers",
      "rookie_year": "2020",
      "city": "Yeni\u015fehir",
      "state": "Mersin",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8221,
      "name": "TEDES",
      "rookie_year": "2020",
      "city": "eskisehir",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8222,
      "name": "Robo-Aviators",
      "rookie_year": "2020",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8223,
      "name": "Mariners",
      "rookie_year": "2020",
      "city": "Tel Aviv",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 8224,
      "name": "Vanguard Robotics",
      "rookie_year": "2020",
      "city": "Saint-Laurent",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8225,
      "name": "Circuit Blazers",
      "rookie_year": "2020",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8226,
      "name": "Hope",
      "rookie_year": "2020",
      "city": "Tainan",
      "state": "Changhua",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8229,
      "name": "Pollobots",
      "rookie_year": "2020",
      "city": "Oakland",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8230,
      "name": "KoiBots",
      "rookie_year": "2020",
      "city": "Arlington",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8231,
      "name": "BWW",
      "rookie_year": "2020",
      "city": "Kawasaki-city",
      "state": "Kanagawa",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 8232,
      "name": "Girl Gang",
      "rookie_year": "2020",
      "city": "Lafayette",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 8233,
      "name": "Robo-Riff-Raff",
      "rookie_year": "2020",
      "city": "New Braunfels",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8234,
      "name": "Panthinators",
      "rookie_year": "2020",
      "city": "Minneapolis",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8235,
      "name": "Beyond the Flames",
      "rookie_year": "2020",
      "city": "SINGAPORE",
      "state": "South East",
      "country": "Singapore",
      "district": ""
    },
    {
      "number": 8236,
      "name": "Ecobotic",
      "rookie_year": "2020",
      "city": "Montreal",
      "state": "Qu\u00e9bec",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8237,
      "name": "ESATA",
      "rookie_year": "2020",
      "city": "Eski\u015fehir",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8238,
      "name": "ESES",
      "rookie_year": "2020",
      "city": "Odunpazar\u0131",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8239,
      "name": "INTERNATIONAL YELKIKANAT ROBOT COMMUNITY",
      "rookie_year": "2020",
      "city": "MALTEPE",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8240,
      "name": "Atat\u00fcrk Robotics",
      "rookie_year": "2020",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8241,
      "name": "Iron Ram",
      "rookie_year": "2020",
      "city": "New York",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8242,
      "name": "Tekno NFL",
      "rookie_year": "2020",
      "city": "Ni\u011fde",
      "state": "Nigde",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8243,
      "name": "AstroCircuits",
      "rookie_year": "2020",
      "city": "Cleveland",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8244,
      "name": "Delfines CBTech",
      "rookie_year": "2020",
      "city": "Tec\u00e1mac",
      "state": "Mexico",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8245,
      "name": "ROBEAL",
      "rookie_year": "2020",
      "city": "Erdek",
      "state": "Balikesir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8246,
      "name": "Tuku",
      "rookie_year": "2020",
      "city": "Sakarya ",
      "state": "Sakarya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8247,
      "name": "Grandview Ze-Bots",
      "rookie_year": "2020",
      "city": "Grandview",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8248,
      "name": "ChainLynx",
      "rookie_year": "2020",
      "city": "Seattle",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8249,
      "name": "Jinfeng Dynamics",
      "rookie_year": "2020",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8250,
      "name": "Rebel Robotics",
      "rookie_year": "2020",
      "city": "Littleton",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8251,
      "name": "White cloud",
      "rookie_year": "2020",
      "city": "guangzhou ",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8252,
      "name": "Blue sword",
      "rookie_year": "2020",
      "city": "foushan",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8253,
      "name": "Kapok",
      "rookie_year": "2020",
      "city": "guangzhou",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8254,
      "name": "BEY-TEK",
      "rookie_year": "2020",
      "city": "Beyo\u011flu",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8255,
      "name": "Robodogs",
      "rookie_year": "2020",
      "city": "Rolla",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8256,
      "name": "Tecmilenio - ARMY ROBOT TECHNOLOGY",
      "rookie_year": "2020",
      "city": "Alvarado",
      "state": "Veracruz",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8257,
      "name": "Zombie Apocalypse Counter Task Force",
      "rookie_year": "2000",
      "city": "Bronx",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8258,
      "name": "Les dragons ",
      "rookie_year": "2020",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8259,
      "name": "Deakin Velocity",
      "rookie_year": "2020",
      "city": "Geelong",
      "state": "Victoria",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8260,
      "name": "ROB\u0130LSA",
      "rookie_year": "2020",
      "city": "Merkez",
      "state": "Afyonkarahisar",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8261,
      "name": "PROGRESSUS",
      "rookie_year": "2020",
      "city": "KUCUKCEKMECE",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8262,
      "name": "Jump Robotics",
      "rookie_year": "2020",
      "city": "Palo Alto",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8263,
      "name": "Robin",
      "rookie_year": "2020",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8264,
      "name": "EKOBOT41",
      "rookie_year": "2020",
      "city": "\u0130zmit",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8265,
      "name": "MCHS Knights",
      "rookie_year": "2020",
      "city": "Mission",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8266,
      "name": "Pe\u00f1oles-OWLBOT",
      "rookie_year": "2020",
      "city": "LAGUNA DEL REY",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8267,
      "name": "Riptide Robotics 8267",
      "rookie_year": "2020",
      "city": "Long Beach",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8268,
      "name": "Ashley Bears",
      "rookie_year": "2020",
      "city": "Ashley",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8269,
      "name": "Patrionauts",
      "rookie_year": "2020",
      "city": "Perris",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8270,
      "name": "Double N",
      "rookie_year": "2020",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8271,
      "name": "WESTSIDE 1002",
      "rookie_year": "2020",
      "city": "Augusta",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8272,
      "name": "Antimatter Neko",
      "rookie_year": "2020",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 8273,
      "name": "Titanibot",
      "rookie_year": "2020",
      "city": "Beijing",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 8274,
      "name": "Raider Robotics",
      "rookie_year": "2020",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8275,
      "name": "Technical Difficulties ",
      "rookie_year": "2020",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8276,
      "name": "ETECHNOLOGY#8276",
      "rookie_year": "2020",
      "city": "S\u00c3O JOS\u00c9 DOS CAMPOS",
      "state": "S\u00e3o Paulo",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 8277,
      "name": "PEI Bots",
      "rookie_year": "2020",
      "city": "Wheeling",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8278,
      "name": "Alpha Robotics",
      "rookie_year": "2020",
      "city": "Burnaby",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8279,
      "name": "Lincoln Park Academy ",
      "rookie_year": "2020",
      "city": "Fort Pierce",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8280,
      "name": "K9.0 Robotics",
      "rookie_year": "2020",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8281,
      "name": "Allstars",
      "rookie_year": "2020",
      "city": "San Jose",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8282,
      "name": "Metal Minds Robotics",
      "rookie_year": "2020",
      "city": "Evandale",
      "state": "Tasmania",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8283,
      "name": "Pantherbots",
      "rookie_year": "2020",
      "city": "Denver",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8284,
      "name": "Urban Planners",
      "rookie_year": "2020",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8285,
      "name": "Ravenna Bulldogs Robotics",
      "rookie_year": "2020",
      "city": "Ravenna",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8286,
      "name": "Robotnic",
      "rookie_year": "2020",
      "city": "Farwell",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8287,
      "name": "Team Malfunction",
      "rookie_year": "2020",
      "city": "Aston",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8288,
      "name": "Machine Hunters",
      "rookie_year": "2020",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8289,
      "name": "STEM+M Ravens Robotics",
      "rookie_year": "2020",
      "city": "South Point",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8290,
      "name": "Pe\u00f1oles - Jaegers60",
      "rookie_year": "2020",
      "city": "RAMOS ARIZPE",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8291,
      "name": "PE\u00d1OLES-Yellow Experience Bateil",
      "rookie_year": "2020",
      "city": "Torreon",
      "state": "Coahuila",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8292,
      "name": "FPC Bulldogs Robotics",
      "rookie_year": "2020",
      "city": "Palm Coast",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8293,
      "name": "Tecmilenio Whitefox Robotics",
      "rookie_year": "2020",
      "city": "Zapopan",
      "state": "Jalisco",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8294,
      "name": "LVR Inn0vat0rs",
      "rookie_year": "2020",
      "city": "Nelson",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8295,
      "name": "SparTex",
      "rookie_year": "2020",
      "city": "El Paso",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8296,
      "name": "Bengals",
      "rookie_year": "2020",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8297,
      "name": "WIHI Robo Wolves",
      "rookie_year": "2020",
      "city": "Ypsilanti",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8298,
      "name": "Mighty Morphing Banana Slugs",
      "rookie_year": "2020",
      "city": "Luverne",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8299,
      "name": "Techno Falcons",
      "rookie_year": "2020",
      "city": "Brighton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8300,
      "name": "Lumen Christi Titans",
      "rookie_year": "2020",
      "city": "Jackson",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8301,
      "name": "Sparks",
      "rookie_year": "2020",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8302,
      "name": "Beamer Team",
      "rookie_year": "2020",
      "city": "Federal Way",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8303,
      "name": "G0LDEN_GAT0RS",
      "rookie_year": "2020",
      "city": "Federal Way",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8304,
      "name": "Robot MaSTrs",
      "rookie_year": "2020",
      "city": "Morehead City",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8305,
      "name": "Nepean Robotics",
      "rookie_year": "2020",
      "city": "Nepean",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8306,
      "name": "Sierra Linda High School Robotics",
      "rookie_year": "2020",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8307,
      "name": "GRIZZLY",
      "rookie_year": "2020",
      "city": "Gans",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8308,
      "name": "GFLRobotics",
      "rookie_year": "2020",
      "city": "G\u00d6LC\u00dcK",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8309,
      "name": "WILDCAT",
      "rookie_year": "2020",
      "city": "K\u00dc\u00c7\u00dcK\u00c7EKMECE",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8310,
      "name": "ASO.TECHO",
      "rookie_year": "2020",
      "city": "ANKARA",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8311,
      "name": "PRISER",
      "rookie_year": "2020",
      "city": "Istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8312,
      "name": "Royals Robotics",
      "rookie_year": "2020",
      "city": "Surrey",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8313,
      "name": "Waygooks",
      "rookie_year": "2020",
      "city": "Pyeongtaek-si",
      "state": "Gyeonggido",
      "country": "South Korea",
      "district": ""
    },
    {
      "number": 8314,
      "name": "The Roar",
      "rookie_year": "2020",
      "city": "Carsonville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8315,
      "name": "Spartan Robots",
      "rookie_year": "2020",
      "city": "Monroe",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8316,
      "name": "Les Cougars de L'Escale",
      "rookie_year": "2020",
      "city": "Rockland",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8317,
      "name": "South Kamloops Titans Robotics",
      "rookie_year": "2020",
      "city": "Kamloops",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8318,
      "name": "RSS Robotics",
      "rookie_year": "2020",
      "city": "Kelowna",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8319,
      "name": "HHS Robotics",
      "rookie_year": "2020",
      "city": "Hillsboro",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8320,
      "name": "D.O.X.A. 8320",
      "rookie_year": "2020",
      "city": "Hamilton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8321,
      "name": "BEMS",
      "rookie_year": "2020",
      "city": "Vacaville",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8322,
      "name": "Peter Skene Ogden Roughneck Robotics",
      "rookie_year": "2020",
      "city": "100 Mile House",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8323,
      "name": "PolarBots",
      "rookie_year": "2020",
      "city": "Grand Marais",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8324,
      "name": "MECO Robotics",
      "rookie_year": "2020",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8325,
      "name": "Botcats",
      "rookie_year": "2020",
      "city": "Espanola",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8326,
      "name": "GDS Mighty Hoppers",
      "rookie_year": "2020",
      "city": "Washington",
      "state": "District of Columbia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8327,
      "name": "Paradise Rockets",
      "rookie_year": "2020",
      "city": "Paradise",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8328,
      "name": "Miss Ice Bots",
      "rookie_year": "2020",
      "city": "Pellston",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8329,
      "name": "Warrior 1",
      "rookie_year": "2020",
      "city": "Redford",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8330,
      "name": "KillarneyRobotics",
      "rookie_year": "2020",
      "city": "Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8331,
      "name": "Zen Maker Lab Robotics",
      "rookie_year": "2020",
      "city": "North Vancouver",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8332,
      "name": "Alternate Reality",
      "rookie_year": "2020",
      "city": "Auburn Hills",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8333,
      "name": "TOPAZ4X4",
      "rookie_year": "2020",
      "city": "Beer Yakov",
      "state": "HaMerkaz",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 8334,
      "name": "Titan Robotics",
      "rookie_year": "2020",
      "city": "Colorado Springs",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8335,
      "name": "CheckMate",
      "rookie_year": "2020",
      "city": "CABA",
      "state": "Ciudad Aut\u00f3noma de Buenos Aires",
      "country": "Argentina",
      "district": ""
    },
    {
      "number": 8336,
      "name": "Wolf Corp. FRC",
      "rookie_year": "2020",
      "city": "Walnut",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8337,
      "name": "Central Creativity Team Wingnuts",
      "rookie_year": "2020",
      "city": "Laurel",
      "state": "Mississippi",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8338,
      "name": "Boucherie Bears",
      "rookie_year": "2020",
      "city": "West Kelowna",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8339,
      "name": "Penticton Robotics",
      "rookie_year": "2020",
      "city": "Penticton",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8340,
      "name": "F.R.A.Y",
      "rookie_year": "2020",
      "city": "YARKA",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 8341,
      "name": "Pizza Byte",
      "rookie_year": "2020",
      "city": "Panama City",
      "state": "Panam\u00e1",
      "country": "Panama",
      "district": ""
    },
    {
      "number": 8342,
      "name": "m(stee) squared",
      "rookie_year": "2020",
      "city": "Manistee",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8343,
      "name": "Team Spring Valley",
      "rookie_year": "2020",
      "city": "Suffern",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8344,
      "name": "OV Robo Birds",
      "rookie_year": "2020",
      "city": "Muskegon",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8345,
      "name": "John McCrae Secondary School",
      "rookie_year": "2020",
      "city": "Nepean",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8346,
      "name": "Brooklyn STEAM Machine",
      "rookie_year": "2020",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8347,
      "name": "Broken Eagles",
      "rookie_year": "2020",
      "city": "New York Mills",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8348,
      "name": "FG1946",
      "rookie_year": "2020",
      "city": "tamra",
      "state": "HaZafon",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 8349,
      "name": "Newbotics",
      "rookie_year": "2020",
      "city": "Newmarket",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8350,
      "name": "TISS Pirates",
      "rookie_year": "2020",
      "city": "Brockville",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8351,
      "name": "Oozma Kappa",
      "rookie_year": "2020",
      "city": "Chihuahua",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8352,
      "name": "Code Gold",
      "rookie_year": "2020",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8353,
      "name": "Botqueros 2 the FUTURE!",
      "rookie_year": "2020",
      "city": "San Diego",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8354,
      "name": "The Prairie People",
      "rookie_year": "2020",
      "city": "BRANDON",
      "state": "Manitoba",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8355,
      "name": "Melanin Minds",
      "rookie_year": "2020",
      "city": "Saint Paul",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8356,
      "name": "Black Rhinos",
      "rookie_year": "2020",
      "city": "Tel Aviv",
      "state": "Tel-Aviv",
      "country": "Israel",
      "district": ""
    },
    {
      "number": 8357,
      "name": "Chrysaora Robotics spr. by P.G. Co. 4-H and NASA",
      "rookie_year": "2020",
      "city": "Clinton",
      "state": "Maryland",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8358,
      "name": "The CITI Pack",
      "rookie_year": "2020",
      "city": "Red Oak",
      "state": "North Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8359,
      "name": "GREENTECH",
      "rookie_year": "2020",
      "city": "KOCAEL\u0130/BA\u015e\u0130SKELE",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8360,
      "name": "Chappa",
      "rookie_year": "2020",
      "city": "Fatih",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8361,
      "name": "Toro Loco",
      "rookie_year": "2020",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8362,
      "name": "Cyber Tigers West",
      "rookie_year": "2020",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8363,
      "name": "Marcellus Wildbots",
      "rookie_year": "2020",
      "city": "Marcellus",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8364,
      "name": "Rising Stars Academy - Nebulas",
      "rookie_year": "2020",
      "city": "Center Line",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8365,
      "name": "Modeltowners",
      "rookie_year": "2020",
      "city": "Gwinn",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8366,
      "name": "Ida Bluestreaks",
      "rookie_year": "2020",
      "city": "Ida",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8367,
      "name": "Godwin Heights High School Robotics",
      "rookie_year": "2020",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8368,
      "name": "Red Eye Robotics",
      "rookie_year": "2020",
      "city": "Flint",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8369,
      "name": "Coyotech Robotics",
      "rookie_year": "2020",
      "city": "Uvalde",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8370,
      "name": "Glow With The Flow",
      "rookie_year": "2020",
      "city": "Katy",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8371,
      "name": "Surgeons of Steel",
      "rookie_year": "2020",
      "city": "Shepherd",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8372,
      "name": "HCN Storm",
      "rookie_year": "2020",
      "city": "Hill City",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8373,
      "name": "The Flying Octopi: 8373 R.R.T.",
      "rookie_year": "2020",
      "city": "Blissfield",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8374,
      "name": "Bongo Bots",
      "rookie_year": "2020",
      "city": "Leslie",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8375,
      "name": "Tech Tigers",
      "rookie_year": "2020",
      "city": "Taylor",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8376,
      "name": "Tech Titans",
      "rookie_year": "2020",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8377,
      "name": "MLHS Mavericks",
      "rookie_year": "2020",
      "city": "Lansing",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8378,
      "name": "Hudson Tigers",
      "rookie_year": "2020",
      "city": "Hudson",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8379,
      "name": "WSA Panthers",
      "rookie_year": "2020",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8380,
      "name": "Clarenceville Trojans",
      "rookie_year": "2020",
      "city": "Livonia",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8381,
      "name": "Rapid River STEM Classroom Team",
      "rookie_year": "2020",
      "city": "Rapid River",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8382,
      "name": "The Pebbles-Robotics of Kingsford",
      "rookie_year": "2020",
      "city": "Kingsford",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8383,
      "name": "Pioneers",
      "rookie_year": "2020",
      "city": "Tijuana",
      "state": "Baja California",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8384,
      "name": "The Internationals",
      "rookie_year": "2020",
      "city": "Brockville",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8385,
      "name": "Metal Madness",
      "rookie_year": "2020",
      "city": "Mount Morris",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8386,
      "name": "Th3_IRON_G0@+$",
      "rookie_year": "2020",
      "city": "Puyallup",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8387,
      "name": "The Thingy Thing Team",
      "rookie_year": "2020",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8388,
      "name": "West Mesquite Robotics 1",
      "rookie_year": "2020",
      "city": "Mesquite",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8389,
      "name": "Team Mustang",
      "rookie_year": "2020",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8390,
      "name": "Panthers",
      "rookie_year": "2020",
      "city": "Climax",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8391,
      "name": "PANAMAFRC2020",
      "rookie_year": "2020",
      "city": "Panama",
      "state": "Panam\u00e1",
      "country": "Panama",
      "district": ""
    },
    {
      "number": 8392,
      "name": "Mac Attack",
      "rookie_year": "2020",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8393,
      "name": "Wildcats2020",
      "rookie_year": "2020",
      "city": "Onsted",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8394,
      "name": "Addison Panthers",
      "rookie_year": "2020",
      "city": "Addison",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8395,
      "name": "Cougar Techs",
      "rookie_year": "2020",
      "city": "Keaau",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8396,
      "name": "Pentbots1",
      "rookie_year": "2020",
      "city": "Pentwater",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8397,
      "name": "Mission Control Robotics",
      "rookie_year": "2020",
      "city": "Grand Rapids",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8398,
      "name": "MandUlorians",
      "rookie_year": "2020",
      "city": "Ferndale",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8399,
      "name": "The Electric Mayhem",
      "rookie_year": "2020",
      "city": "Jackson",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8400,
      "name": "Boyne Falls Loggers",
      "rookie_year": "2020",
      "city": "Boyne Falls",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8401,
      "name": "Saraland Robotics Team",
      "rookie_year": "2020",
      "city": "Saraland",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8402,
      "name": "Star Fusion2",
      "rookie_year": "2020",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8403,
      "name": "Glendale",
      "rookie_year": "2020",
      "city": "Hamilton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8404,
      "name": "SKYWALKERS",
      "rookie_year": "2020",
      "city": "Fremont",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8405,
      "name": "Reaching for the Skynet",
      "rookie_year": "2020",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8406,
      "name": "SyZyGy",
      "rookie_year": "2020",
      "city": "Kyiv",
      "state": "Ky\u00efv",
      "country": "Ukraine",
      "district": ""
    },
    {
      "number": 8407,
      "name": "USTEM Robotics",
      "rookie_year": "2020",
      "city": "Almaty",
      "state": "Almaty",
      "country": "Kazakhstan",
      "district": ""
    },
    {
      "number": 8408,
      "name": "Kiss Kats",
      "rookie_year": "2020",
      "city": "Wink",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8409,
      "name": "Kato Coyote's ",
      "rookie_year": "2020",
      "city": "Mankato",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8410,
      "name": "Oyster River Robotics",
      "rookie_year": "2020",
      "city": "Durham",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8411,
      "name": "4.BOTS",
      "rookie_year": "2020",
      "city": "LERDO ",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8412,
      "name": "Battle Lake Schools",
      "rookie_year": "2020",
      "city": "Battle Lake",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8413,
      "name": "CGLA Mustang Innovators",
      "rookie_year": "2020",
      "city": "Chattanooga",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8414,
      "name": "Science Academy of South Texas",
      "rookie_year": "2020",
      "city": "Mercedes",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8415,
      "name": "Dino Nuggies",
      "rookie_year": "2020",
      "city": "Fort Worth",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8416,
      "name": "Wolfbotics 8416",
      "rookie_year": "2020",
      "city": "Ely",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8417,
      "name": "Rambotics",
      "rookie_year": "2020",
      "city": "Maricopa",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8418,
      "name": "Archbishop Chapelle High School",
      "rookie_year": "2020",
      "city": "Metairie",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8419,
      "name": "D - Mind Breakers",
      "rookie_year": "2020",
      "city": "Mexico City",
      "state": "Distrito Federal",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8420,
      "name": "Almaty Roboman",
      "rookie_year": "2020",
      "city": "Almaty",
      "state": "Almaty",
      "country": "Kazakhstan",
      "district": ""
    },
    {
      "number": 8421,
      "name": "CRUSADERS",
      "rookie_year": "2020",
      "city": "Littleton",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8422,
      "name": "Husky Howlers",
      "rookie_year": "2020",
      "city": "Pillager",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8423,
      "name": "Next Express",
      "rookie_year": "2020",
      "city": "Temperance",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8424,
      "name": "Tractor Technicians Next Gen",
      "rookie_year": "2020",
      "city": "Mason",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8425,
      "name": "Happy Rock Brave Bots",
      "rookie_year": "2020",
      "city": "Gladstone",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8426,
      "name": "Automated Amphibians",
      "rookie_year": "2020",
      "city": "Novi",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8427,
      "name": "Robo Ravens",
      "rookie_year": "2020",
      "city": "Dearborn Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8428,
      "name": "The Outlaws",
      "rookie_year": "2020",
      "city": "Naples",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8429,
      "name": "Valence Robotics",
      "rookie_year": "2020",
      "city": "Durham",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8500,
      "name": "TNT Robotics",
      "rookie_year": "2021",
      "city": "Ankara",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8501,
      "name": "Venus Robotics",
      "rookie_year": "2021",
      "city": "Trabzon",
      "state": "Trabzon",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8503,
      "name": "Raid One",
      "rookie_year": "2021",
      "city": "Taipei City",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8504,
      "name": "YOVi",
      "rookie_year": "2021",
      "city": "Dnipro",
      "state": "Dnipropetrovs'ka Oblast'",
      "country": "Ukraine",
      "district": ""
    },
    {
      "number": 8505,
      "name": "Snowflakes1",
      "rookie_year": "2021",
      "city": "Richmond Hill",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8507,
      "name": "Jaguar Robotics",
      "rookie_year": "2021",
      "city": "Midlothian",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8508,
      "name": "PE-TECH",
      "rookie_year": "2021",
      "city": "Ba\u015fak\u015fehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8509,
      "name": "Scramble",
      "rookie_year": "2021",
      "city": "Seika Town",
      "state": "Ky\u00f4to",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 8510,
      "name": "Giles",
      "rookie_year": "2021",
      "city": "North york",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8511,
      "name": "The Android P0SSE",
      "rookie_year": "2021",
      "city": "Oklahoma City",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8512,
      "name": "Manzano Monarchs",
      "rookie_year": "2021",
      "city": "Albuquerque",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8513,
      "name": "Sisters 1st",
      "rookie_year": "2021",
      "city": "Morristown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8514,
      "name": "Junior Squirrels",
      "rookie_year": "2021",
      "city": "Woodbine",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8515,
      "name": "Photon",
      "rookie_year": "2021",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8516,
      "name": "Wired Up",
      "rookie_year": "2021",
      "city": "Andover",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8517,
      "name": "E-Ville Bounty Hunters",
      "rookie_year": "2021",
      "city": "Essexville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8518,
      "name": "Ripple Robotics",
      "rookie_year": "2021",
      "city": "Oshkosh",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8519,
      "name": "Iron Eagles",
      "rookie_year": "2021",
      "city": "Erie",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8521,
      "name": "CyberLions",
      "rookie_year": "2021",
      "city": "Westminster",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8522,
      "name": "SHS - Robos",
      "rookie_year": "2021",
      "city": "Springport",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8523,
      "name": "Vic8ytes",
      "rookie_year": "2021",
      "city": "Provo",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8524,
      "name": "TalaveraBots",
      "rookie_year": "2021",
      "city": "San Andres Cholula",
      "state": "Puebla",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8525,
      "name": "Hangzhou Wickham International",
      "rookie_year": "2021",
      "city": "Hangzhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 8526,
      "name": "BearsChallengers2021",
      "rookie_year": "2021",
      "city": "San Juan",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8527,
      "name": "ER404",
      "rookie_year": "2021",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8528,
      "name": "AstroChimps",
      "rookie_year": "2021",
      "city": "Alamogordo",
      "state": "New Mexico",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8529,
      "name": "KunPeng",
      "rookie_year": "2021",
      "city": "Zhenjiang",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 8530,
      "name": "Phenyo",
      "rookie_year": "2021",
      "city": "Tzaneen",
      "state": "Limpopo",
      "country": "South Africa",
      "district": ""
    },
    {
      "number": 8531,
      "name": "TermiKnightors",
      "rookie_year": "2021",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8532,
      "name": "Classified",
      "rookie_year": "2021",
      "city": "Umatilla",
      "state": "Oregon",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8533,
      "name": "Rancho Robos FRC",
      "rookie_year": "2021",
      "city": "Camarillo",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8534,
      "name": "Women of technology ",
      "rookie_year": "2021",
      "city": "West Jordan",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8535,
      "name": "The Lion Kings",
      "rookie_year": "2021",
      "city": "Loogootee",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8536,
      "name": "Flames Robotics",
      "rookie_year": "2021",
      "city": "Chatham",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8537,
      "name": "MechanicAnts",
      "rookie_year": "2021",
      "city": "Imperial Beach",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8538,
      "name": "Juniper Robotics",
      "rookie_year": "2021",
      "city": "Cincinnati",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8539,
      "name": "\u00d6ZKO\u00c7 ROBOT\u0130K ",
      "rookie_year": "2021",
      "city": "Istabul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8540,
      "name": " Wall-East",
      "rookie_year": "2021",
      "city": "Singapore",
      "state": "Central Singapore",
      "country": "Singapore",
      "district": ""
    },
    {
      "number": 8542,
      "name": "Go2robots",
      "rookie_year": "2021",
      "city": "Richmond Hill",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8543,
      "name": "Bot Camp",
      "rookie_year": "2021",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8544,
      "name": "Reinforcement",
      "rookie_year": "2021",
      "city": "Sutton",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8545,
      "name": "Scott County Robotics",
      "rookie_year": "2021",
      "city": "Scottsburg",
      "state": "Indiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8546,
      "name": "\\n",
      "rookie_year": "2021",
      "city": "Eagle",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8547,
      "name": "M.E.",
      "rookie_year": "2021",
      "city": "HangZhou",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 8550,
      "name": "The Jackson Alliance",
      "rookie_year": "2021",
      "city": "New Plymouth",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8551,
      "name": "RoNex Sponsored by NASA",
      "rookie_year": "2021",
      "city": "Lewiston",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8552,
      "name": "Malad High School 1",
      "rookie_year": "2021",
      "city": "Malad City",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8553,
      "name": "The Circuit Breakers",
      "rookie_year": "2021",
      "city": "Soda Springs",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8554,
      "name": "Dream Team",
      "rookie_year": "2021",
      "city": "Fengxian",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 8555,
      "name": "BALROB",
      "rookie_year": "2021",
      "city": "BALIKESIR",
      "state": "Balikesir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8556,
      "name": "Lion Robotics",
      "rookie_year": "2021",
      "city": "San Juan",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8557,
      "name": "ConquEra",
      "rookie_year": "2021",
      "city": "Manisa",
      "state": "Manisa",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8558,
      "name": "Tecmilenio - Digital Golden Hawks",
      "rookie_year": "2021",
      "city": "Reynosa",
      "state": "Tamaulipas",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8559,
      "name": "Dragon Robotics",
      "rookie_year": "2021",
      "city": "Brampton",
      "state": "Ontario",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8560,
      "name": "INVENTORS",
      "rookie_year": "2021",
      "city": "Sakarya",
      "state": "Sakarya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8561,
      "name": "Cartesian Robotics",
      "rookie_year": "2021",
      "city": "\u00c7ankaya",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8562,
      "name": "TBD",
      "rookie_year": "2021",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8563,
      "name": "KERNELS",
      "rookie_year": "2021",
      "city": "shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8564,
      "name": "Disco Ducks",
      "rookie_year": "2021",
      "city": "Princeton",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 8565,
      "name": "MACK-BOTS B.I.G.",
      "rookie_year": "2021",
      "city": "Lafayette",
      "state": "Colorado",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8566,
      "name": "REBELBOTS",
      "rookie_year": "2021",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8567,
      "name": "Wellesley Robotics - Team Ultraviolet",
      "rookie_year": "2021",
      "city": "Wellesley",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8568,
      "name": "Cyber Seven",
      "rookie_year": "2021",
      "city": "Webster",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8569,
      "name": "Zhonghe",
      "rookie_year": "2021",
      "city": " New Taipei City",
      "state": "New Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8570,
      "name": "Binary-Bolts",
      "rookie_year": "2021",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 8571,
      "name": "Enignet_0111",
      "rookie_year": "2021",
      "city": "Johannesburg",
      "state": "Gauteng",
      "country": "South Africa",
      "district": ""
    },
    {
      "number": 8572,
      "name": "Tech Inheritors of Al Khwarizmi",
      "rookie_year": "2021",
      "city": "Mazar e Sharif",
      "state": "Balkh",
      "country": "Afghanistan",
      "district": ""
    },
    {
      "number": 8573,
      "name": "Rogue-Rangers LEGACY",
      "rookie_year": "2021",
      "city": "Alton",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8574,
      "name": "Audeamus",
      "rookie_year": "2021",
      "city": "North York",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8575,
      "name": "The Due Westerners",
      "rookie_year": "2021",
      "city": "Due West",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8576,
      "name": "Golden Warriors Robotics",
      "rookie_year": "2021",
      "city": "Fulshear",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8577,
      "name": "Georgia Cyber Academy Champions",
      "rookie_year": "2021",
      "city": "Atlanta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8579,
      "name": "Renegades of Archer Robotics!",
      "rookie_year": "2021",
      "city": "Lawrenceville",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8580,
      "name": "Jayton J-Bots",
      "rookie_year": "2021",
      "city": "Jayton",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8581,
      "name": "PizzaByte Robotics",
      "rookie_year": "2021",
      "city": "Panama",
      "state": "Panam\u00e1",
      "country": "Panama",
      "district": ""
    },
    {
      "number": 8582,
      "name": "Brave-Solders",
      "rookie_year": "2021",
      "city": "Delhi",
      "state": "Delhi",
      "country": "India",
      "district": ""
    },
    {
      "number": 8583,
      "name": "Juggernauts",
      "rookie_year": "2021",
      "city": "GuangZhou",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8584,
      "name": "Infinity Robotics",
      "rookie_year": "2021",
      "city": "Chiayi",
      "state": "Chiayi",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8585,
      "name": "bombax leopard",
      "rookie_year": "2021",
      "city": "Taipei",
      "state": "Taipei Special Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8586,
      "name": "Firebirds Robotics",
      "rookie_year": "2021",
      "city": "Devils Lake",
      "state": "North Dakota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8587,
      "name": "Rick n' Rolls",
      "rookie_year": "2021",
      "city": "Warsaw",
      "state": "Mazowieckie",
      "country": "Poland",
      "district": ""
    },
    {
      "number": 8588,
      "name": "Tech Devils",
      "rookie_year": "2021",
      "city": "Denville",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8589,
      "name": "Quack Pack",
      "rookie_year": "2021",
      "city": "Tuscaloosa",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8590,
      "name": "CAVBOTICS",
      "rookie_year": "2021",
      "city": "Fairfax",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8591,
      "name": "Angels",
      "rookie_year": "2021",
      "city": "Olmito",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8592,
      "name": "Newton Squared",
      "rookie_year": "2021",
      "city": "Fairfax",
      "state": "Virginia",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8593,
      "name": "Team Octabyte",
      "rookie_year": "2021",
      "city": "Prairiewood",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8594,
      "name": "Blitz",
      "rookie_year": "2021",
      "city": "\u5317\u4eac",
      "state": "Beijing",
      "country": "China",
      "district": ""
    },
    {
      "number": 8595,
      "name": "This Is How We Play",
      "rookie_year": "2021",
      "city": "\u65b0\u5317\u5e02",
      "state": "New Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8596,
      "name": "Girl Scouts2",
      "rookie_year": "2021",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8597,
      "name": "TISB TROJAN Bengaluru",
      "rookie_year": "2021",
      "city": "Bengaluru",
      "state": "Karnataka",
      "country": "India",
      "district": ""
    },
    {
      "number": 8598,
      "name": "Electro-Knights",
      "rookie_year": "2021",
      "city": "Mission",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8599,
      "name": "SHARPLINE",
      "rookie_year": "2021",
      "city": "SAMSUN",
      "state": "Samsun",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8600,
      "name": "Kernel Panic",
      "rookie_year": "2021",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8601,
      "name": "CSHS Falcon Robotics",
      "rookie_year": "2021",
      "city": "Cave Creek",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8602,
      "name": "GOLDEN FROGS TEAM COLOMBIA",
      "rookie_year": "2021",
      "city": "Palmira",
      "state": "Valle del Cauca",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 8603,
      "name": "The Discord Droids",
      "rookie_year": "2021",
      "city": "Carmel",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8604,
      "name": "Alpha Centauri",
      "rookie_year": "2021",
      "city": "Lexington",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8605,
      "name": "ASCTE",
      "rookie_year": "2021",
      "city": "Huntsville",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8606,
      "name": "DEVOLT",
      "rookie_year": "2021",
      "city": "Chihuahua",
      "state": "Chihuahua",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8607,
      "name": "Ravens II",
      "rookie_year": "2021",
      "city": "Royal Oak",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8608,
      "name": "Alpha Bots",
      "rookie_year": "2021",
      "city": "Battle Creek",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8609,
      "name": "Salt lake county robotics",
      "rookie_year": "2021",
      "city": "West Jordan",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8610,
      "name": "Lanier Voks",
      "rookie_year": "2021",
      "city": "San Antonio",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8611,
      "name": "Patriots 2022",
      "rookie_year": "2021",
      "city": "Cadillac",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8612,
      "name": "Squires Robotics",
      "rookie_year": "2021",
      "city": "Grandville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8613,
      "name": "Nuts, Bolts & Faults",
      "rookie_year": "2021",
      "city": "THORNLIE",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8614,
      "name": "WA College of Agriculture - Morawa",
      "rookie_year": "2021",
      "city": "Morawa",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8615,
      "name": "SAZANKA Robotics",
      "rookie_year": "2021",
      "city": "Toyosu",
      "state": "T\u00f4ky\u00f4",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 8616,
      "name": "Mad Engineers BIS",
      "rookie_year": "2021",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 8617,
      "name": "G-FORCE",
      "rookie_year": "2021",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 8618,
      "name": "Operation Robotics",
      "rookie_year": "2021",
      "city": "Ann Arbor",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8619,
      "name": "Sanborn Regional High School Robotics",
      "rookie_year": "2021",
      "city": "Kingston",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8620,
      "name": "RoboJays",
      "rookie_year": "2021",
      "city": "Omaha",
      "state": "Nebraska",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8621,
      "name": "KITS Angels FRC Akola Team",
      "rookie_year": "2021",
      "city": "Akola",
      "state": "Maharashtra",
      "country": "India",
      "district": ""
    },
    {
      "number": 8622,
      "name": "The CyBirds",
      "rookie_year": "2021",
      "city": "Gambrills",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8623,
      "name": "Michigan FC",
      "rookie_year": "2021",
      "city": "Dearborn Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8624,
      "name": "Da Pizza Mans",
      "rookie_year": "2021",
      "city": "Andalusia",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8625,
      "name": "MHS Eagles",
      "rookie_year": "2021",
      "city": "Mission",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8626,
      "name": "Cyber Sailors",
      "rookie_year": "2021",
      "city": "Scituate",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8628,
      "name": "Newark School of Global Studies",
      "rookie_year": "2021",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8629,
      "name": "Everest 2",
      "rookie_year": "2021",
      "city": "Rochester",
      "state": "Michigan",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8630,
      "name": "CAP ROBOTICS",
      "rookie_year": "2021",
      "city": "Paterson",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8631,
      "name": "Excelsior360!",
      "rookie_year": "2021",
      "city": "Friday Harbor",
      "state": "Washington",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8632,
      "name": "Master Builders",
      "rookie_year": "2021",
      "city": "Jacksonville",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8634,
      "name": "BOOTSTRAPS!",
      "rookie_year": "2021",
      "city": "Littleton",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8636,
      "name": "Turkistan Robotics",
      "rookie_year": "2021",
      "city": "Turkistan",
      "state": "Ongt\u00fcstik Qazaqstan oblysy",
      "country": "Kazakhstan",
      "district": ""
    },
    {
      "number": 8637,
      "name": "Packer Pelicans",
      "rookie_year": "2021",
      "city": "Brooklyn",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8700,
      "name": "W.I.R.E.D",
      "rookie_year": "2022",
      "city": "Waupaca",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8701,
      "name": "GRAFFITI",
      "rookie_year": "2022",
      "city": "Greendale",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8702,
      "name": "Invincible Tyrannosaurus Warrior",
      "rookie_year": "2022",
      "city": "JiaXing",
      "state": "Zhejiang",
      "country": "China",
      "district": ""
    },
    {
      "number": 8703,
      "name": "New Squirrels",
      "rookie_year": "2022",
      "city": "Woodbine",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8704,
      "name": "Lower Cape May Regional Robotics Team",
      "rookie_year": "2022",
      "city": "Cape May",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8705,
      "name": "Sci Tech FRC",
      "rookie_year": "2022",
      "city": "Pittsburgh",
      "state": "Pennsylvania",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8706,
      "name": "Malcolm X Shabazz Bulldogs",
      "rookie_year": "2022",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8707,
      "name": "The Newark Circuit Breakers",
      "rookie_year": "2022",
      "city": "Newark",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8708,
      "name": "Ov3r1y K0mp13x",
      "rookie_year": "2022",
      "city": "Dunbarton",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8709,
      "name": "Pathfinder Tech",
      "rookie_year": "2022",
      "city": "Palmer",
      "state": "Massachusetts",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8710,
      "name": "BLUM BOBCAT ROBOTICS",
      "rookie_year": "2022",
      "city": "Blum",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8711,
      "name": "The Midnight Ostrich Runners",
      "rookie_year": "2022",
      "city": "Broken Arrow",
      "state": "Oklahoma",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8713,
      "name": "Nordonia Knights 21",
      "rookie_year": "2022",
      "city": "Macedonia",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8714,
      "name": "Mater Dei-namics",
      "rookie_year": "2022",
      "city": "Middletown",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8715,
      "name": "Antilles Pirates 404",
      "rookie_year": "2022",
      "city": "Fort Buchanan",
      "state": "Puerto Rico",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8716,
      "name": "Robowarriors",
      "rookie_year": "2022",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8717,
      "name": "Cyber Vipers",
      "rookie_year": "2022",
      "city": "Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8718,
      "name": "Tigerbotics",
      "rookie_year": "2022",
      "city": "Warren",
      "state": "Ohio",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8719,
      "name": "Oakville Dynamics",
      "rookie_year": "2022",
      "city": "Saint Louis",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8720,
      "name": "Desert Shields Robotics Team",
      "rookie_year": "2022",
      "city": "North Las Vegas",
      "state": "Nevada",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8721,
      "name": "DAIS NAID 8721",
      "rookie_year": "2022",
      "city": "Cape May Court House",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8722,
      "name": "Team Alpha ",
      "rookie_year": "2022",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8723,
      "name": "Woodpanda",
      "rookie_year": "2022",
      "city": "Taoyuan",
      "state": "Taoyuan",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8724,
      "name": "Mayhem",
      "rookie_year": "2022",
      "city": "Bedford",
      "state": "New Hampshire",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8725,
      "name": "MistyPanther",
      "rookie_year": "2022",
      "city": "Zhonghe Dist.",
      "state": "New Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8726,
      "name": "CryptoHawks",
      "rookie_year": "2022",
      "city": "Ijamsville",
      "state": "Maryland",
      "country": "USA",
      "district": "CHS"
    },
    {
      "number": 8727,
      "name": "Glitch 2.0",
      "rookie_year": "2022",
      "city": "Asheville",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8728,
      "name": "Argonauts",
      "rookie_year": "2022",
      "city": "Troy",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8729,
      "name": "Sparkling H2O",
      "rookie_year": "2022",
      "city": "Kanata",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8730,
      "name": "SPECIALS  & +1",
      "rookie_year": "2022",
      "city": "DIDIM",
      "state": "Aydin",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8731,
      "name": "Wild WYRE",
      "rookie_year": "2022",
      "city": "Lindsay",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8732,
      "name": "Trinity Force",
      "rookie_year": "2022",
      "city": "New Orleans",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8733,
      "name": "Renaissance Robotics",
      "rookie_year": "2022",
      "city": "Athens",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8734,
      "name": "Tecmilenio B. A. T. S.",
      "rookie_year": "2022",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8735,
      "name": "Spartans300",
      "rookie_year": "2022",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8736,
      "name": "The Mechanisms",
      "rookie_year": "2022",
      "city": "Marietta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8737,
      "name": "Rocket Rampage",
      "rookie_year": "2022",
      "city": "Eddyville",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8738,
      "name": "Slice",
      "rookie_year": "2022",
      "city": "Fuquay Varina",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8739,
      "name": "Redhawk Robotics",
      "rookie_year": "2022",
      "city": "Ozone Park",
      "state": "New York",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8740,
      "name": "Tecmilenio - Quantum Force",
      "rookie_year": "2022",
      "city": "Monterrey",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8741,
      "name": "Tecmilenio Raccoons",
      "rookie_year": "2022",
      "city": "San nicolas de los Garza",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8742,
      "name": "Argyll Attack",
      "rookie_year": "2022",
      "city": "Fairmount",
      "state": "Indiana",
      "country": "USA",
      "district": "FIN"
    },
    {
      "number": 8743,
      "name": "SYNTAX Robotics",
      "rookie_year": "2022",
      "city": "Ankara",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8744,
      "name": "Pablo Center Robotics",
      "rookie_year": "2022",
      "city": "Eau Claire",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8745,
      "name": "RoBeagles",
      "rookie_year": "2022",
      "city": "Phoenix",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8746,
      "name": "Knights",
      "rookie_year": "2022",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8747,
      "name": "UNYE FEN TEAM",
      "rookie_year": "2022",
      "city": "UNYE",
      "state": "Ordu",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8748,
      "name": "Tecmilenio- DEROS",
      "rookie_year": "2022",
      "city": "Durango",
      "state": "Durango",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8749,
      "name": "Farmersville  Robotics",
      "rookie_year": "2022",
      "city": "Farmersville",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8750,
      "name": "Tarpontron1cs",
      "rookie_year": "2022",
      "city": "Port Isabel",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8751,
      "name": "Miramonte Robotics Club",
      "rookie_year": "2022",
      "city": "Orinda",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8752,
      "name": "STEAMCo",
      "rookie_year": "2022",
      "city": "Palmira",
      "state": "Valle del Cauca",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 8753,
      "name": "Spectre",
      "rookie_year": "2022",
      "city": "Sarasota",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8754,
      "name": "Meister Robotics",
      "rookie_year": "2022",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8755,
      "name": "OrcaBots",
      "rookie_year": "2022",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8756,
      "name": "Idaho Technomancers",
      "rookie_year": "2022",
      "city": "Twin Falls",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8757,
      "name": "GeodeBots",
      "rookie_year": "2022",
      "city": "Greensboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8758,
      "name": "Tar-Robo Turtles",
      "rookie_year": "2022",
      "city": "Tarboro",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8759,
      "name": "ARPEX",
      "rookie_year": "2022",
      "city": "\u0130STANBUL",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8760,
      "name": "SOUND OF DIDYMA",
      "rookie_year": "2022",
      "city": "DIDIM",
      "state": "Aydin",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8761,
      "name": "Tiger8761",
      "rookie_year": "2022",
      "city": "Adairsville",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8762,
      "name": "Anemurium Robotics Team",
      "rookie_year": "2022",
      "city": "turkiye",
      "state": "Mersin",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8763,
      "name": "Technical area ",
      "rookie_year": "2022",
      "city": "Tocancip\u00e1",
      "state": "Cundinamarca",
      "country": "Colombia",
      "district": ""
    },
    {
      "number": 8764,
      "name": "Thunder Robotics",
      "rookie_year": "2022",
      "city": "Thornhill",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8765,
      "name": "Parallel Units",
      "rookie_year": "2022",
      "city": "Stratford",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8766,
      "name": "Panther Robotics",
      "rookie_year": "2022",
      "city": "Packwood",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8767,
      "name": "Dark Horse Robotics",
      "rookie_year": "2022",
      "city": "North Branch",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8768,
      "name": "CTEC Titans",
      "rookie_year": "2022",
      "city": "Fresno",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8769,
      "name": "G.O.R.T.s",
      "rookie_year": "2022",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8770,
      "name": "CC Robotics Nerd Squad",
      "rookie_year": "2022",
      "city": "Charles City",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8771,
      "name": "PioTech",
      "rookie_year": "2022",
      "city": "Wayne",
      "state": "New Jersey",
      "country": "USA",
      "district": "FMA"
    },
    {
      "number": 8772,
      "name": "ASFA",
      "rookie_year": "2022",
      "city": "Birmingham",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8773,
      "name": "Robo Rams1",
      "rookie_year": "2022",
      "city": "Birmingham",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8774,
      "name": "REST Robotics",
      "rookie_year": "2022",
      "city": "Roseville",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8775,
      "name": "Creekside Team 6",
      "rookie_year": "2022",
      "city": "Saint Johns",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8776,
      "name": "Tecmilenio - THE NORTHERN LIZARDS",
      "rookie_year": "2022",
      "city": "Guadalupe",
      "state": "Nuevo Le\u00f3n",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8777,
      "name": "SafranTech",
      "rookie_year": "2022",
      "city": "Safranbolu",
      "state": "Karab\u00fck",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8778,
      "name": "HSUwerx",
      "rookie_year": "2022",
      "city": "Fort Walton Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8779,
      "name": "Messmer High School Bishops",
      "rookie_year": "2022",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8780,
      "name": "TED ROBOTICS",
      "rookie_year": "2022",
      "city": "ANKARA",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8781,
      "name": "ANTALYAMTAL ROBOT KLUBU",
      "rookie_year": "2022",
      "city": "ANTALYA",
      "state": "Antalya",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8782,
      "name": "New Auburn Robotics",
      "rookie_year": "2022",
      "city": "New Auburn",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8783,
      "name": "Apeiron",
      "rookie_year": "2022",
      "city": "Eski\u015fehir",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8784,
      "name": "HEVSEL",
      "rookie_year": "2022",
      "city": "Diyarbak\u0131r",
      "state": "Diyarbakir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8785,
      "name": "AGAT ROBOT\u0130CS",
      "rookie_year": "2022",
      "city": "ANKARA",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8786,
      "name": "Tecmilenio - TRC",
      "rookie_year": "2022",
      "city": "Cualiacan",
      "state": "Sinaloa",
      "country": "Mexico",
      "district": ""
    },
    {
      "number": 8787,
      "name": "Mavericks",
      "rookie_year": "2022",
      "city": "Sherburn",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8788,
      "name": "Special Forces BallistaBots",
      "rookie_year": "2022",
      "city": "Crestview",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8789,
      "name": "The Lost Sockets",
      "rookie_year": "2022",
      "city": "Dorchester",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8790,
      "name": "Departure",
      "rookie_year": "2022",
      "city": "Xinyin",
      "state": "Tainan Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8791,
      "name": "Mighty Patriots",
      "rookie_year": "2022",
      "city": "Hialeah",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8792,
      "name": "Robo Cougars 901",
      "rookie_year": "2022",
      "city": "Memphis",
      "state": "Tennessee",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8793,
      "name": "Pumpkin Bots",
      "rookie_year": "2022",
      "city": "Half Moon Bay",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8794,
      "name": "Black Storm",
      "rookie_year": "2022",
      "city": "ALTINORDU",
      "state": "Ordu",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8795,
      "name": "The Chaotics",
      "rookie_year": "2022",
      "city": "Ankara",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8796,
      "name": "MEF Robotics",
      "rookie_year": "2022",
      "city": "istanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8797,
      "name": "FALCON ROBOTICS",
      "rookie_year": "2022",
      "city": "MERKEZ",
      "state": "Giresun",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8798,
      "name": "DAMAS ROBO",
      "rookie_year": "2022",
      "city": "Sultanbeyli",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8799,
      "name": "IZELMAN ROBOTICS",
      "rookie_year": "2022",
      "city": "Konak",
      "state": "Izmir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8800,
      "name": "INDUSTRY ROBOTIC",
      "rookie_year": "2022",
      "city": "Kocaeli",
      "state": "Kocaeli",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8801,
      "name": "The MidKnight Inventors",
      "rookie_year": "2022",
      "city": "Plainsboro",
      "state": "New Jersey",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8802,
      "name": "Milwaukee United",
      "rookie_year": "2022",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8803,
      "name": "MechaMarines",
      "rookie_year": "2022",
      "city": "Marinette",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8804,
      "name": "Cyber Bears",
      "rookie_year": "2022",
      "city": "Raleigh",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8805,
      "name": "NKST36",
      "rookie_year": "2022",
      "city": "Tainan",
      "state": "Tainan Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8806,
      "name": "Our Lady of Providence Dream League",
      "rookie_year": "2022",
      "city": "New Taipei City",
      "state": "New Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8807,
      "name": "SCREW IT",
      "rookie_year": "2022",
      "city": "Taichung",
      "state": "Taichung Municipality",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8808,
      "name": "Tech Pirates",
      "rookie_year": "2022",
      "city": "Lake Charles",
      "state": "Louisiana",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8809,
      "name": "Precursor",
      "rookie_year": "2022",
      "city": "Nanchang",
      "state": "Jiangxi",
      "country": "China",
      "district": ""
    },
    {
      "number": 8810,
      "name": "Sagitta Snapdragon",
      "rookie_year": "2022",
      "city": "Suzhou",
      "state": "Jiangsu",
      "country": "China",
      "district": ""
    },
    {
      "number": 8811,
      "name": "Yi Zhong Ren",
      "rookie_year": "2022",
      "city": "Guangzhou",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8812,
      "name": "Shenzhen College Of International Education",
      "rookie_year": "2022",
      "city": "shenzhen",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8813,
      "name": "FERRYMAN",
      "rookie_year": "2022",
      "city": "SHANGHAI",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8814,
      "name": "Black Hole",
      "rookie_year": "2022",
      "city": "Shanghai",
      "state": "Shanghai",
      "country": "China",
      "district": ""
    },
    {
      "number": 8815,
      "name": "Bulloch Alliance",
      "rookie_year": "2022",
      "city": "Statesboro",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8816,
      "name": "Coyotronics",
      "rookie_year": "2022",
      "city": "Frisco",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8817,
      "name": "Buccaneer Robotics",
      "rookie_year": "2022",
      "city": "Miami",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8818,
      "name": "The Foe - Foe Engineering Group",
      "rookie_year": "2022",
      "city": "Houston",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8819,
      "name": "The ARC-TECH BEARS",
      "rookie_year": "2022",
      "city": "Austin",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8820,
      "name": "GV ROBOTICS",
      "rookie_year": "2022",
      "city": "Garden Valley",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8821,
      "name": "TVRT-Trojanbots",
      "rookie_year": "2022",
      "city": "JACKSON JUNCTION",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8822,
      "name": "Lc3 Thunderbirds",
      "rookie_year": "2022",
      "city": "Montrose",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8823,
      "name": "A New Hope",
      "rookie_year": "2022",
      "city": "New Hope",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8824,
      "name": "Wapello Royalty",
      "rookie_year": "2022",
      "city": "Wapello",
      "state": "Iowa",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8825,
      "name": "Hunting Eagles",
      "rookie_year": "2022",
      "city": "Kansas City",
      "state": "Missouri",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8826,
      "name": "Parkway Eagles",
      "rookie_year": "2022",
      "city": "Sterling Heights",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8827,
      "name": "Edinburg North Robotics",
      "rookie_year": "2022",
      "city": "Edinburg",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8828,
      "name": "EAL Robotics",
      "rookie_year": "2022",
      "city": "Eski\u015fehir",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8829,
      "name": "Cemberlitas ",
      "rookie_year": "2022",
      "city": "atasehir",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8830,
      "name": "Denby Tars Robotics Team ",
      "rookie_year": "2022",
      "city": "Detroit",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8831,
      "name": "Sa-Hali Secondary Robotics",
      "rookie_year": "2022",
      "city": "Kamloops",
      "state": "British Columbia",
      "country": "Canada",
      "district": ""
    },
    {
      "number": 8832,
      "name": "AutoDawgs",
      "rookie_year": "2022",
      "city": "Petersburg",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8833,
      "name": "Buzz City Robotics",
      "rookie_year": "2022",
      "city": "Charlotte",
      "state": "North Carolina",
      "country": "USA",
      "district": "FNC"
    },
    {
      "number": 8834,
      "name": "Blu Robotics",
      "rookie_year": "2022",
      "city": "Acworth",
      "state": "Georgia",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8835,
      "name": "PNGUoT Robotic Team 1 (PRT1)",
      "rookie_year": "2022",
      "city": "Lae",
      "state": "Morobe",
      "country": "Papua New Guinea",
      "district": ""
    },
    {
      "number": 8836,
      "name": "Wayne Enterprises Inc. #695",
      "rookie_year": "2022",
      "city": "Chisholm",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8837,
      "name": "NIS Kyran",
      "rookie_year": "2022",
      "city": "Almaty",
      "state": "Almaty",
      "country": "Kazakhstan",
      "district": ""
    },
    {
      "number": 8838,
      "name": "GWC Rambotics",
      "rookie_year": "2022",
      "city": "Birmingham",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8839,
      "name": "Shoshone22",
      "rookie_year": "2022",
      "city": "Shoshone",
      "state": "Idaho",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8840,
      "name": "Bay Robotics",
      "rookie_year": "2022",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8841,
      "name": "Red Fins",
      "rookie_year": "2022",
      "city": "Orlando",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8842,
      "name": "SAR",
      "rookie_year": "2022",
      "city": "Santa Anna",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8843,
      "name": "Amal Space and Aviation Maale Adumim",
      "rookie_year": "2022",
      "city": "Maale Adumim",
      "state": "Yerushalayim",
      "country": "Israel",
      "district": "ISR"
    },
    {
      "number": 8844,
      "name": "Flamethrowers",
      "rookie_year": "2022",
      "city": "North Wollongong",
      "state": "New South Wales",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8845,
      "name": "Forest Hill Falcons",
      "rookie_year": "2022",
      "city": "West Palm Beach",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8846,
      "name": "CABLE TIE FIGHTERS",
      "rookie_year": "2022",
      "city": "ATWELL",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8847,
      "name": "Milwaukee Cyber Cheese",
      "rookie_year": "2022",
      "city": "Milwaukee",
      "state": "Wisconsin",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8848,
      "name": "Blu CRU",
      "rookie_year": "2022",
      "city": "Chandler",
      "state": "Arizona",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8849,
      "name": "Storm Robotics",
      "rookie_year": "2022",
      "city": "Alpharetta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8850,
      "name": "Ed Bears",
      "rookie_year": "2022",
      "city": "Scarborough",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8852,
      "name": "Drew Robotics",
      "rookie_year": "2022",
      "city": "San Francisco",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8853,
      "name": "Yukikaze Technology",
      "rookie_year": "2022",
      "city": "Sapporo",
      "state": "Hokkaid\u00f4",
      "country": "Japan",
      "district": ""
    },
    {
      "number": 8854,
      "name": "Pandamonium",
      "rookie_year": "2022",
      "city": "Birmingham",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8855,
      "name": "Socrates",
      "rookie_year": "2022",
      "city": "Kyiv",
      "state": "Ky\u00efv",
      "country": "Ukraine",
      "district": ""
    },
    {
      "number": 8856,
      "name": "Lapis Lazuli",
      "rookie_year": "2022",
      "city": "\u0130stanbul",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8857,
      "name": "Tsinglan FRC",
      "rookie_year": "2022",
      "city": "Dongguan",
      "state": "Guangdong",
      "country": "China",
      "district": ""
    },
    {
      "number": 8858,
      "name": "Atlas",
      "rookie_year": "2022",
      "city": "Wylie",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8859,
      "name": "Bora",
      "rookie_year": "2022",
      "city": "Kartal",
      "state": "Istanbul",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8861,
      "name": "06ANGORA",
      "rookie_year": "2022",
      "city": "ANKARA",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8862,
      "name": "SERCEV ROBOTICS",
      "rookie_year": "2022",
      "city": "ANKARA",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8863,
      "name": "ANATOLIAN DEAF ETERNALS ROBOTICS",
      "rookie_year": "2022",
      "city": "ESKISEHIR",
      "state": "Eskisehir",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8865,
      "name": "Dacula Falcons Robotics",
      "rookie_year": "2022",
      "city": "Dacula",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8866,
      "name": "Innovation Robotics",
      "rookie_year": "2022",
      "city": "Alpharetta",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8867,
      "name": "Yoc",
      "rookie_year": "2022",
      "city": "toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8868,
      "name": "TEAM ATHENA",
      "rookie_year": "2022",
      "city": "Delhi",
      "state": "Delhi",
      "country": "India",
      "district": ""
    },
    {
      "number": 8869,
      "name": "TISB TROJANS",
      "rookie_year": "2022",
      "city": "Bengaluru",
      "state": "Karnataka",
      "country": "India",
      "district": ""
    },
    {
      "number": 8870,
      "name": "RedCards",
      "rookie_year": "2022",
      "city": "San Diego",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8871,
      "name": "Saber Dynamics",
      "rookie_year": "2022",
      "city": "Ewa Beach",
      "state": "Hawaii",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8872,
      "name": "JJSJF Gwinnett-NSBE Jr. FLL",
      "rookie_year": "2022",
      "city": "Snellville",
      "state": "Georgia",
      "country": "USA",
      "district": "PCH"
    },
    {
      "number": 8873,
      "name": "Rockefeller Robotics",
      "rookie_year": "2022",
      "city": "Mount Pleasant",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8874,
      "name": "The Cybirds",
      "rookie_year": "2022",
      "city": "Richardson",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8875,
      "name": "Dangerous Minds",
      "rookie_year": "2022",
      "city": "Bangholme",
      "state": "Victoria",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8876,
      "name": "Lynwood Tech Tips",
      "rookie_year": "2022",
      "city": "Parkwood",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8877,
      "name": "Express Robotic",
      "rookie_year": "2022",
      "city": "Havana",
      "state": "Florida",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8878,
      "name": "ArrowBot",
      "rookie_year": "2022",
      "city": "Ashby",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8879,
      "name": "REDBird Robotics",
      "rookie_year": "2022",
      "city": "Del Valle",
      "state": "Texas",
      "country": "USA",
      "district": "FIT"
    },
    {
      "number": 8880,
      "name": "Terra Cyborg",
      "rookie_year": "2022",
      "city": "Lombard",
      "state": "Illinois",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8881,
      "name": "Y\u00fckselen Intecro Robotics Team",
      "rookie_year": "2022",
      "city": "Ankara",
      "state": "Ankara",
      "country": "Turkey",
      "district": ""
    },
    {
      "number": 8882,
      "name": "Infinity BR",
      "rookie_year": "2022",
      "city": "Goi\u00e2nia",
      "state": "Goi\u00e1s",
      "country": "Brazil",
      "district": ""
    },
    {
      "number": 8883,
      "name": "Green Mountain Gears",
      "rookie_year": "2022",
      "city": "South Burlington",
      "state": "Vermont",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8884,
      "name": "Crimson Revolution",
      "rookie_year": "2022",
      "city": "Toronto",
      "state": "Ontario",
      "country": "Canada",
      "district": "ONT"
    },
    {
      "number": 8885,
      "name": "Maeser Mechatronics",
      "rookie_year": "2022",
      "city": "Lindon",
      "state": "Utah",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8886,
      "name": "Metal Manes",
      "rookie_year": "2022",
      "city": "Loris",
      "state": "South Carolina",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8887,
      "name": "West Central Area Knights 21",
      "rookie_year": "2022",
      "city": "Barrett",
      "state": "Minnesota",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8888,
      "name": "Flying Lions",
      "rookie_year": "2022",
      "city": "Riverside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8889,
      "name": "Project W",
      "rookie_year": "2022",
      "city": "Waterbury",
      "state": "Connecticut",
      "country": "USA",
      "district": "NE"
    },
    {
      "number": 8890,
      "name": "Last Minute",
      "rookie_year": "2022",
      "city": "Ellenbrook",
      "state": "Western Australia",
      "country": "Australia",
      "district": ""
    },
    {
      "number": 8891,
      "name": "Wild Raccoons",
      "rookie_year": "2022",
      "city": "Oceanside",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8893,
      "name": "SCDS Robotics",
      "rookie_year": "2022",
      "city": "Sacramento",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8894,
      "name": "HandShake",
      "rookie_year": "2022",
      "city": "New Taipei",
      "state": "New Taipei",
      "country": "Chinese Taipei",
      "district": ""
    },
    {
      "number": 8895,
      "name": "Redwolves Robotics",
      "rookie_year": "2022",
      "city": "Clinton",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 8896,
      "name": "Wolf Tech Robotics",
      "rookie_year": "2022",
      "city": "Puyallup",
      "state": "Washington",
      "country": "USA",
      "district": "PNW"
    },
    {
      "number": 8897,
      "name": "Meek High School Tigers",
      "rookie_year": "2022",
      "city": "Arley",
      "state": "Alabama",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8898,
      "name": "Royal Rebels Engineering",
      "rookie_year": "2022",
      "city": "Fullerton",
      "state": "California",
      "country": "USA",
      "district": ""
    },
    {
      "number": 8899,
      "name": "Eagles",
      "rookie_year": "2022",
      "city": "Harper Woods",
      "state": "Michigan",
      "country": "USA",
      "district": "FIM"
    },
    {
      "number": 9330,
      "name": "Team 9330",
      "rookie_year": "",
      "city": "",
      "state": "",
      "country": "",
      "district": ""
    },
    {
      "number": 9985,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9986,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9987,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9988,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9989,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9990,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9991,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9992,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9993,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9994,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9995,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9996,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9997,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9998,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    },
    {
      "number": 9999,
      "name": "Off-Season Demo Team",
      "rookie_year": "2022",
      "city": "Manchester",
      "state": "New Hampshire",
      "country": "USA",
      "district": ""
    }
  ]